//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.1.0 (NJsonSchema v11.5.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { FileParameter, FileResponse } from '../../models/file-models';
import { columnMap } from '../../../shared/table/models/column-map.decorator';
import { keyMap } from '../../../shared/table/models/key-map.decorator';
import {
    ApiActivity,
    IApiActivity,
    ApiNamedListItem,
    ApiIdNameItem,
    IApiIdNameItem,
    ApiMemberInfo,
    ApiNote,
    IApiNote,
    ApiFileInfo,
    IApiFileInfo,
    ApiListItemPosition,
    ApiRange,
    ApiText,
    IApiMemberInfo,
    ApiCreateMemberRequest,
    ApiDateRange,
    ApiNoteListItem,
    BackgroundProcessEnum,
    BackgroundProcessStatusEnum,
    BackgroundProcessStepStatus,
    NoteTypeEnum,
    SocialNetworkEnum,
    FileUploadErrorEnum,
    ApiExternalAccountInfo,
    Module,
    Permission,
    ServicesEnum,
    ApiCreatorInfo,
    FileValidationModel,
    TimerTaskType,
    Gender
} from './open-api-clients';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class VersionInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getVersionInfo(): Observable<VersionInfo> {
        let url_ = this.baseUrl + "/api/main/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<VersionInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<VersionInfo>;
        }));
    }

    protected processGetVersionInfo(response: HttpResponseBase): Observable<VersionInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VersionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleCheckNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    doublePrList(titleCheckId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/technical-check/title-check/{titleCheckId}/notes/doublepr-list";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoublePrList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoublePrList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processDoublePrList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    triplePrList(titleCheckId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/technical-check/title-check/{titleCheckId}/notes/triplepr-list";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTriplePrList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTriplePrList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processTriplePrList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleCheckId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/main/technical-check/title-check/{titleCheckId}/notes";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleCheckId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/title-check/{titleCheckId}/notes/{noteId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleCheckId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/title-check/{titleCheckId}/notes/{noteId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlesInProgressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(isArchived: boolean | undefined, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleInProgressListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress?";
        if (isArchived === null)
            throw new Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "isArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleInProgressListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleInProgressListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleInProgressListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleInProgressListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePosition(model: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/update-position";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePosition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    validateFirstCheck(titleCheckId: number): Observable<ApiFirstCheckValidation> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/first-check/validate";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateFirstCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateFirstCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFirstCheckValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFirstCheckValidation>;
        }));
    }

    protected processValidateFirstCheck(response: HttpResponseBase): Observable<ApiFirstCheckValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFirstCheckValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareFirstCheck(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/first-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareFirstCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareFirstCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareFirstCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareDoubleCheck(titleCheckId: number, model: ApiTitleWorkPrepareRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/double-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareDoubleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareDoubleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareDoubleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    doubleCheckReImport(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/double-check/reimport";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDoubleCheckReImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDoubleCheckReImport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDoubleCheckReImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareEnterDb(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/enter-db/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareEnterDb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareEnterDb(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareEnterDb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareReferencesCheck(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/references-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareReferencesCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareReferencesCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareReferencesCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareTripleCheck(titleCheckId: number, model: ApiTitleWorkPrepareRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/triple-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareTripleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareTripleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareTripleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareTocReadCheck(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/toc-read-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareTocReadCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareTocReadCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareTocReadCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    prepareShortReadCheck(titleCheckId: number, model: ApiTitleWorkPrepareRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/short-read-check/prepare";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareShortReadCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareShortReadCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPrepareShortReadCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCompletePreconditions(titleCheckId: number): Observable<ApiTitleCheckCompletePreconditions> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/complete-preconditions";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompletePreconditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompletePreconditions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleCheckCompletePreconditions>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleCheckCompletePreconditions>;
        }));
    }

    protected processGetCompletePreconditions(response: HttpResponseBase): Observable<ApiTitleCheckCompletePreconditions> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleCheckCompletePreconditions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    complete(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/complete";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getStatisticsForTitle(titleId: number): Observable<ApiTitleCheckStatisticsEntry[]> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleId}/statistics";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatisticsForTitle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatisticsForTitle(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleCheckStatisticsEntry[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleCheckStatisticsEntry[]>;
        }));
    }

    protected processGetStatisticsForTitle(response: HttpResponseBase): Observable<ApiTitleCheckStatisticsEntry[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleCheckStatisticsEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckersManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiCheckerListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/checkers?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiCheckerListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiCheckerListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiCheckerListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiCheckerListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(apiModels: ApiCheckerCreate[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checkers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiModel: ApiCheckerUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checkers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checkers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperProcessesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleCheckId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperProcessListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperProcessListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperProcessListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperProcessListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperProcessListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartFirstCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/restart-first-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartFirstCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartFirstCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartFirstCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartEnterDb(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/restart-enter-db/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartEnterDb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartEnterDb(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartEnterDb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartReferencesCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/restart-references-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartReferencesCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartReferencesCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartReferencesCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortFirstCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/abort-first-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortFirstCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortFirstCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortFirstCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortEnterDb(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/abort-enter-db/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortEnterDb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortEnterDb(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortEnterDb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortReferencesCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/paper-processes/abort-references-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortReferencesCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortReferencesCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortReferencesCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StatusDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(titleCheckId: number): Observable<ApiStatusDetails> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiStatusDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiStatusDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiStatusDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiStatusDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateDoublePr(titleCheckId: number): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/generate-double-pr";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateDoublePr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateDoublePr(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processGenerateDoublePr(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateTriplePr(titleCheckId: number): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/generate-triple-pr";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTriplePr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTriplePr(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processGenerateTriplePr(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadDoublePrDocument(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/download-double-pr";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDoublePrDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDoublePrDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDoublePrDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadTriplePrDocument(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/download-triple-pr";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTriplePrDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTriplePrDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTriplePrDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleProcessesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleCheckId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleProcessListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleProcessListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleProcessListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleProcessListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleProcessListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartDoubleCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/restart-double-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartDoubleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartDoubleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartDoubleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartShortRead(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/restart-short-read/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartShortRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartShortRead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartShortRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartTripleCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/restart-triple-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartTripleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartTripleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartTripleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restartTocRead(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/restart-toc-read/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestartTocRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestartTocRead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestartTocRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortDoubleCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/abort-double-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortDoubleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortDoubleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortDoubleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortShortReadCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/abort-short-read/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortShortReadCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortShortReadCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortShortReadCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortTripleCheck(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/abort-triple-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortTripleCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortTripleCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortTripleCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    abortTocRead(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/titles-in-progress/{titleCheckId}/status-details/title-processes/abort-toc-read/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAbortTocRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAbortTocRead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAbortTocRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DoubleCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiSplitCheckWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiSplitCheckWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiSplitCheckWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiSplitCheckWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiSplitCheckWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/complete-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/pause-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/refuse-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperList(titleCheckId: number, workId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiDoubleCheckPaperListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/papers/{workId}?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiDoubleCheckPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiDoubleCheckPaperListItem>;
        }));
    }

    protected processGetPaperList(response: HttpResponseBase): Observable<ApiPageResultOfApiDoubleCheckPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiDoubleCheckPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    returnPaperToFirstCheck(titleCheckId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/double-check/return-paper-to-first-check/{paperId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnPaperToFirstCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnPaperToFirstCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReturnPaperToFirstCheck(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EnterDbClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/enter-db/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperInfo(titleCheckId: number, workId: number): Observable<ApiPaperProxyInfo> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/enter-db/{workId}/paper-info";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperProxyInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperProxyInfo>;
        }));
    }

    protected processGetPaperInfo(response: HttpResponseBase): Observable<ApiPaperProxyInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperProxyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/enter-db/{workId}/complete-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/enter-db/{workId}/pause-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/enter-db/{workId}/refuse-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirstCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/first-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/first-check/{workId}/complete-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/first-check/{workId}/pause-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/first-check/{workId}/refuse-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/reference-check/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/reference-check/{workId}/complete-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/reference-check/{workId}/pause-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/reference-check/{workId}/refuse-paper-work";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShortReadCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiShortReadCheckPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiShortReadCheckPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiShortReadCheckPaperWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiShortReadCheckPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiShortReadCheckPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperWork(titleCheckId: number, workId: number, paperId: number): Observable<ApiPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/paper-work/{workId}/{paperId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperWork>;
        }));
    }

    protected processGetPaperWork(response: HttpResponseBase): Observable<ApiPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperInfo(titleCheckId: number, workId: number, paperId: number): Observable<ApiPaperProxyInfo> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/paper-info/{workId}/{paperId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperProxyInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperProxyInfo>;
        }));
    }

    protected processGetPaperInfo(response: HttpResponseBase): Observable<ApiPaperProxyInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperProxyInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/complete-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/pause-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/refuse-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadShortReadAuthor(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/download-short-read-author";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadShortReadAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadShortReadAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadShortReadAuthor(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadShortReadChecker(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/download-short-read-checker";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadShortReadChecker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadShortReadChecker(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadShortReadChecker(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateShortReadAuthor(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/generate-short-read-author";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateShortReadAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateShortReadAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateShortReadAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateShortReadChecker(titleCheckId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/generate-short-read-checker";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateShortReadChecker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateShortReadChecker(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateShortReadChecker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperList(titleCheckId: number, workId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiShortReadCheckPaperListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/short-read-check/papers/{workId}?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiShortReadCheckPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiShortReadCheckPaperListItem>;
        }));
    }

    protected processGetPaperList(response: HttpResponseBase): Observable<ApiPageResultOfApiShortReadCheckPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiShortReadCheckPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TocReadCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiTocReadCheckPaperWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTocReadCheckPaperWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTocReadCheckPaperWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiTocReadCheckPaperWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTocReadCheckPaperWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/complete-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pauseWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/pause-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPauseWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPauseWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPauseWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refuseWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/refuse-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefuseWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefuseWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefuseWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperList(titleCheckId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiSplitCheckPaperListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/papers?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiSplitCheckPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiSplitCheckPaperListItem>;
        }));
    }

    protected processGetPaperList(response: HttpResponseBase): Observable<ApiPageResultOfApiSplitCheckPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiSplitCheckPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadTocRead(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/download-toc-read";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTocRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTocRead(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTocRead(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadPrepressPrint(titleCheckId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/toc-read-check/download-prepress-print";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPrepressPrint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPrepressPrint(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadPrepressPrint(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TripleCheckClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getWork(titleCheckId: number, workId: number): Observable<ApiSplitCheckWork> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/triple-check/work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiSplitCheckWork>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiSplitCheckWork>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiSplitCheckWork> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiSplitCheckWork.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    completePaperWork(titleCheckId: number, workId: number): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/triple-check/complete-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompletePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompletePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processCompletePaperWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    pausePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/triple-check/pause-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPausePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPausePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processPausePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    refusePaperWork(titleCheckId: number, workId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/triple-check/refuse-paper-work/{workId}";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefusePaperWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefusePaperWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRefusePaperWork(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperList(titleCheckId: number, workId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiSplitCheckPaperListItem> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/{titleCheckId}/triple-check/papers/{workId}?";
        if (titleCheckId === undefined || titleCheckId === null)
            throw new Error("The parameter 'titleCheckId' must be defined.");
        url_ = url_.replace("{titleCheckId}", encodeURIComponent("" + titleCheckId));
        if (workId === undefined || workId === null)
            throw new Error("The parameter 'workId' must be defined.");
        url_ = url_.replace("{workId}", encodeURIComponent("" + workId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiSplitCheckPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiSplitCheckPaperListItem>;
        }));
    }

    protected processGetPaperList(response: HttpResponseBase): Observable<ApiPageResultOfApiSplitCheckPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiSplitCheckPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckerToolHomeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(): Observable<ApiCheckerInfo> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/home";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiCheckerInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTaskStatus(): Observable<CheckerTaskStatusEnum> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/home/task-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaskStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaskStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<CheckerTaskStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<CheckerTaskStatusEnum>;
        }));
    }

    protected processGetTaskStatus(response: HttpResponseBase): Observable<CheckerTaskStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHeader(): Observable<ApiCheckerHeader> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/home/header";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiCheckerHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getStatistics(dateTime: Date | undefined): Observable<ApiCheckerStatistics> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/home/statistics?";
        if (dateTime === null)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else if (dateTime !== undefined)
            url_ += "dateTime=" + encodeURIComponent(dateTime ? "" + dateTime.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerStatistics>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerStatistics>;
        }));
    }

    protected processGetStatistics(response: HttpResponseBase): Observable<ApiCheckerStatistics> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerStatistics.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getWork(): Observable<ApiCheckerWorkResult> {
        let url_ = this.baseUrl + "/api/main/technical-check/checker-tool/home/get-work";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWork(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWork(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCheckerWorkResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCheckerWorkResult>;
        }));
    }

    protected processGetWork(response: HttpResponseBase): Observable<ApiCheckerWorkResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCheckerWorkResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ChaptersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiChapterListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/list?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiChapterListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiChapterListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiChapterListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiChapterListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAll(titleId: number): Observable<ApiChapterItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiChapterItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiChapterItem[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiChapterItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiChapterItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, model: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, chapterId: number, updatedChapter: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/{chapterId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedChapter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, chapterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/{chapterId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/update-pos";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    capitalizeAllNames(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/capitalize";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCapitalizeAllNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCapitalizeAllNames(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCapitalizeAllNames(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleChapterValidation(titleId: number): Observable<ApiTitleChapterValidation> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/chapters/title-chapter-validation";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleChapterValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleChapterValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleChapterValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleChapterValidation>;
        }));
    }

    protected processGetTitleChapterValidation(response: HttpResponseBase): Observable<ApiTitleChapterValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleChapterValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleEpubClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    regenerateEbookEpub(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/epubs";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateEbookEpub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateEbookEpub(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRegenerateEbookEpub(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getEbookEpubFile(titleId: number): Observable<ApiTitleFile> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/epubs";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEbookEpubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEbookEpubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile>;
        }));
    }

    protected processGetEbookEpubFile(response: HttpResponseBase): Observable<ApiTitleFile> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleFile.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadEbookEpubFile(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/epubs/file";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadEbookEpubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadEbookEpubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadEbookEpubFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePapersEpubClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    regenerateAllPapersEpub(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/papers/epubs";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegenerateAllPapersEpub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegenerateAllPapersEpub(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRegenerateAllPapersEpub(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SuggestedJournalsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiSuggestedJournalListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/suggested-journals?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiSuggestedJournalListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiSuggestedJournalListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiSuggestedJournalListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiSuggestedJournalListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSuggestedJournals(titleId: number, journalIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/suggested-journals";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(journalIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSuggestedJournals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSuggestedJournals(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddSuggestedJournals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeSuggestedJournal(titleId: number, journalId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/suggested-journals?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (journalId === null)
            throw new Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSuggestedJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSuggestedJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSuggestedJournal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableJournals(titleId: number): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/suggested-journals/available";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableJournals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableJournals(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetAvailableJournals(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleCataloguesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    generateCatalogue(request: ApiTitleCatalogueGenerateRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/catalogues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCatalogue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCatalogue(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGenerateCatalogue(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleCoverClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCover(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCover(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadCoverUrl(titleId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadCover(titleId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteCover(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateCover(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover/generate";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateCover(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    titleGeneratingDisabled(titleId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover/disabled";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTitleGeneratingDisabled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTitleGeneratingDisabled(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processTitleGeneratingDisabled(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCoverSuggestions(titleId: number): Observable<ApiTitleCoverSuggestion[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover-suggestions";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleCoverSuggestion[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleCoverSuggestion[]>;
        }));
    }

    protected processGetCoverSuggestions(response: HttpResponseBase): Observable<ApiTitleCoverSuggestion[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleCoverSuggestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCoverSuggestionFile(titleId: number, coverSuggestionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover-suggestions/{coverSuggestionId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (coverSuggestionId === undefined || coverSuggestionId === null)
            throw new Error("The parameter 'coverSuggestionId' must be defined.");
        url_ = url_.replace("{coverSuggestionId}", encodeURIComponent("" + coverSuggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverSuggestionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverSuggestionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCoverSuggestionFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteCoverSuggestion(titleId: number, coverSuggestionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/cover-suggestions/{coverSuggestionId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (coverSuggestionId === undefined || coverSuggestionId === null)
            throw new Error("The parameter 'coverSuggestionId' must be defined.");
        url_ = url_.replace("{coverSuggestionId}", encodeURIComponent("" + coverSuggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCoverSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCoverSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCoverSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleEditorChecklistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getChecklist(titleId: number): Observable<ApiTitleEditorChecklist> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/editor-checklist";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleEditorChecklist>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleEditorChecklist>;
        }));
    }

    protected processGetChecklist(response: HttpResponseBase): Observable<ApiTitleEditorChecklist> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleEditorChecklist.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleGeneralClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(titleId: number): Observable<ApiTitle> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitle>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitle>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiTitle> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitle.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMovedFrom(titleId: number): Observable<ApiTitleMoveSummary[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/moved-from";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovedFrom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovedFrom(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleMoveSummary[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleMoveSummary[]>;
        }));
    }

    protected processGetMovedFrom(response: HttpResponseBase): Observable<ApiTitleMoveSummary[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleMoveSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMovedTo(titleId: number): Observable<ApiTitleMoveSummary[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/moved-to";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMovedTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMovedTo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleMoveSummary[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleMoveSummary[]>;
        }));
    }

    protected processGetMovedTo(response: HttpResponseBase): Observable<ApiTitleMoveSummary[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleMoveSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getImportedFrom(titleId: number): Observable<ApiTitleMoveSummary[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/imported-from";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportedFrom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportedFrom(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleMoveSummary[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleMoveSummary[]>;
        }));
    }

    protected processGetImportedFrom(response: HttpResponseBase): Observable<ApiTitleMoveSummary[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleMoveSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getImportedTo(titleId: number): Observable<ApiTitleMoveSummary[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/imported-to";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImportedTo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImportedTo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleMoveSummary[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleMoveSummary[]>;
        }));
    }

    protected processGetImportedTo(response: HttpResponseBase): Observable<ApiTitleMoveSummary[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleMoveSummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDetails(titleId: number, apiModel: ApiTitleDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/details";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDetails(titleId: number): Observable<ApiTitleDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/details";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleDetails>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<ApiTitleDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    discardReadyForScientificCheck(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/discard-ready-for-scientific-check";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardReadyForScientificCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardReadyForScientificCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processDiscardReadyForScientificCheck(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    readyForScientificCheck(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/ready-for-scientific-check";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReadyForScientificCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReadyForScientificCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processReadyForScientificCheck(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    discardScientificCheckCompleted(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/discard-scientific-check-completed";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDiscardScientificCheckCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDiscardScientificCheckCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processDiscardScientificCheckCompleted(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    scientificCheckCompleted(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/scientific-check-completed";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScientificCheckCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScientificCheckCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processScientificCheckCompleted(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    openForEditors(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/open-for-editors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOpenForEditors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOpenForEditors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processOpenForEditors(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    returnToEditors(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/return-to-editors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReturnToEditors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReturnToEditors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processReturnToEditors(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    publishInForthcoming(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/publish-in-forthcoming";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishInForthcoming(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishInForthcoming(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processPublishInForthcoming(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    publishOnline(titleId: number): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/publish-online";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublishOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublishOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processPublishOnline(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    overrideStatus(titleId: number, status: TitleStatusEnum): Observable<TitleStatusEnum> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/override-status/{status}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOverrideStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOverrideStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<TitleStatusEnum>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<TitleStatusEnum>;
        }));
    }

    protected processOverrideStatus(response: HttpResponseBase): Observable<TitleStatusEnum> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getOnlineValidation(titleId: number): Observable<ApiOnlineValidation> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/online-validation";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiOnlineValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiOnlineValidation>;
        }));
    }

    protected processGetOnlineValidation(response: HttpResponseBase): Observable<ApiOnlineValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiOnlineValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleInfoActions(titleId: number): Observable<ApiTitleInfoActions> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/info-actions";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleInfoActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleInfoActions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleInfoActions>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleInfoActions>;
        }));
    }

    protected processGetTitleInfoActions(response: HttpResponseBase): Observable<ApiTitleInfoActions> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleInfoActions.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(titleId: number): Observable<ApiActivity> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/activity";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateJournal(titleId: number, apiModel: ApiTitleJournalEditable): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/journal";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateJournal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    validateVolumeRange(titleId: number, journalId: number, begin: number | undefined, end: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/validate-volume-range/{journalId}?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (journalId === undefined || journalId === null)
            throw new Error("The parameter 'journalId' must be defined.");
        url_ = url_.replace("{journalId}", encodeURIComponent("" + journalId));
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent("" + begin) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVolumeRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVolumeRange(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateVolumeRange(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDescription(titleId: number, apiModel: ApiTitleDescriptions): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/general/description";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleIsbnsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    assignInternalIsbns(titleId: number): Observable<ApiTitleIsbns> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/isbns/internal-isbns";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignInternalIsbns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignInternalIsbns(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleIsbns>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleIsbns>;
        }));
    }

    protected processAssignInternalIsbns(response: HttpResponseBase): Observable<ApiTitleIsbns> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleIsbns.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignExternalIsbns(titleId: number): Observable<ApiTitleIsbns> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/isbns/external-isbns";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignExternalIsbns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignExternalIsbns(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleIsbns>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleIsbns>;
        }));
    }

    protected processAssignExternalIsbns(response: HttpResponseBase): Observable<ApiTitleIsbns> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleIsbns.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignExternalIsbnCd(titleId: number): Observable<ApiTitleIsbn> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/isbns/external-isbn-cd";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignExternalIsbnCd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignExternalIsbnCd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleIsbn>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleIsbn>;
        }));
    }

    protected processAssignExternalIsbnCd(response: HttpResponseBase): Observable<ApiTitleIsbn> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleIsbn.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleKeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/keywords?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPeriodicalKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(titleId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/keywords";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(titleId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/keywords";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    lookupKeywords(titleId: number, query: string | null | undefined, excludeIds: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/keywords/lookup?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processLookupKeywords(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiNoteListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/notes?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiNoteListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/notes";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    listAcceptedPaperNotes(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperNoteListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/notes/accepted-paper?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListAcceptedPaperNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAcceptedPaperNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperNoteListItem>;
        }));
    }

    protected processListAcceptedPaperNotes(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/notes/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/notes/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleOperationsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getOperations(titleId: number): Observable<ApiTitleOperations> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperations(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleOperations>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleOperations>;
        }));
    }

    protected processGetOperations(response: HttpResponseBase): Observable<ApiTitleOperations> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleOperations.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    startTechnicalCheck(titleId: number, priority: TitleTechnicalCheckPriorityEnum | undefined): Observable<ApiTitleTechnicalCheck> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/technical-check?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (priority === null)
            throw new Error("The parameter 'priority' cannot be null.");
        else if (priority !== undefined)
            url_ += "priority=" + encodeURIComponent("" + priority) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTechnicalCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTechnicalCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleTechnicalCheck>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleTechnicalCheck>;
        }));
    }

    protected processStartTechnicalCheck(response: HttpResponseBase): Observable<ApiTitleTechnicalCheck> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleTechnicalCheck.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleTechnicalCheckValidation(titleId: number): Observable<ApiTitleTechnicalCheckValidation> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/technical-check-validation";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleTechnicalCheckValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleTechnicalCheckValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleTechnicalCheckValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleTechnicalCheckValidation>;
        }));
    }

    protected processGetTitleTechnicalCheckValidation(response: HttpResponseBase): Observable<ApiTitleTechnicalCheckValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleTechnicalCheckValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    canRenumber(titleId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/can-renumber";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanRenumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanRenumber(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCanRenumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    renumber(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/renumber";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenumber(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRenumber(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getRenumberReportList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleRenumberReportListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/renumber-reports?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenumberReportList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenumberReportList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleRenumberReportListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleRenumberReportListItem>;
        }));
    }

    protected processGetRenumberReportList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleRenumberReportListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleRenumberReportListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getRenumberReport(titleId: number, renumberReportId: number): Observable<ApiTitleRenumberReport> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/renumber-reports/{renumberReportId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (renumberReportId === undefined || renumberReportId === null)
            throw new Error("The parameter 'renumberReportId' must be defined.");
        url_ = url_.replace("{renumberReportId}", encodeURIComponent("" + renumberReportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRenumberReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRenumberReport(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleRenumberReport>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleRenumberReport>;
        }));
    }

    protected processGetRenumberReport(response: HttpResponseBase): Observable<ApiTitleRenumberReport> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleRenumberReport.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAssignTitlePartsValidation(titleId: number): Observable<ApiAssignTitlePartsValidation> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/assign-title-parts-validation";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignTitlePartsValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignTitlePartsValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAssignTitlePartsValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAssignTitlePartsValidation>;
        }));
    }

    protected processGetAssignTitlePartsValidation(response: HttpResponseBase): Observable<ApiAssignTitlePartsValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAssignTitlePartsValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignTitleParts(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/assign-title-parts";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignTitleParts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignTitleParts(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignTitleParts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setPdfAccessibilityCheck(titleId: number, status: PdfAccessibilityCheck | undefined): Observable<ApiTitleOperations> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/pdf-ua-validation-status?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetPdfAccessibilityCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetPdfAccessibilityCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleOperations>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleOperations>;
        }));
    }

    protected processSetPdfAccessibilityCheck(response: HttpResponseBase): Observable<ApiTitleOperations> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleOperations.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    movePapers(titleId: number, request: ApiMovePapersRequest): Observable<ApiMovePapersResult> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/move-papers";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMovePapers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMovePapers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMovePapersResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMovePapersResult>;
        }));
    }

    protected processMovePapers(response: HttpResponseBase): Observable<ApiMovePapersResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMovePapersResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            importPaperCopiesUrl(titleId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/paper-copies";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    importPaperCopies(titleId: number, file: FileParameter | null | undefined): Observable<ApiImportPaperCopiesResult> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/paper-copies";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportPaperCopies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportPaperCopies(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiImportPaperCopiesResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiImportPaperCopiesResult>;
        }));
    }

    protected processImportPaperCopies(response: HttpResponseBase): Observable<ApiImportPaperCopiesResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiImportPaperCopiesResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadImportPaperCopiesExample(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/operations/paper-copies/example";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportPaperCopiesExample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportPaperCopiesExample(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportPaperCopiesExample(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePapersAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitlePapersAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/papers-authors?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitlePapersAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitlePapersAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitlePapersAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitlePapersAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleAuthorPaperListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/papers-authors/{memberId}/papers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleAuthorPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleAuthorPaperListItem>;
        }));
    }

    protected processGetPaperList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleAuthorPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleAuthorPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePartsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitlePartListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitlePartListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitlePartListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitlePartListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitlePartListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, model: ApiTitlePart): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(titleId: number, titlePartId: number): Observable<ApiTitlePart> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts/{titlePartId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (titlePartId === undefined || titlePartId === null)
            throw new Error("The parameter 'titlePartId' must be defined.");
        url_ = url_.replace("{titlePartId}", encodeURIComponent("" + titlePartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitlePart>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitlePart>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiTitlePart> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitlePart.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, titlePartId: number, model: ApiTitlePart): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts/{titlePartId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (titlePartId === undefined || titlePartId === null)
            throw new Error("The parameter 'titlePartId' must be defined.");
        url_ = url_.replace("{titlePartId}", encodeURIComponent("" + titlePartId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, titlePartId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts/{titlePartId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (titlePartId === undefined || titlePartId === null)
            throw new Error("The parameter 'titlePartId' must be defined.");
        url_ = url_.replace("{titlePartId}", encodeURIComponent("" + titlePartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts/update-pos";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePrintOptions(titleId: number, titlePartId: number, model: ApiPrintOptionsUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-parts/{titlePartId}/print-options";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (titlePartId === undefined || titlePartId === null)
            throw new Error("The parameter 'titlePartId' must be defined.");
        url_ = url_.replace("{titlePartId}", encodeURIComponent("" + titlePartId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrintOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrintOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePrintOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleReasonNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getNoteList(titleId: number, reasonId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/title/{titleId}/reasons/{reasonId}/notes";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNoteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNoteList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetNoteList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNote(titleId: number, reasonId: number, apiModel: ApiNote): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/title/{titleId}/reasons/{reasonId}/notes";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddNote(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateNote(titleId: number, reasonId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/title/{titleId}/reasons/{reasonId}/notes/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteNote(titleId: number, reasonId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/title/{titleId}/reasons/{reasonId}/notes/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reasonId === undefined || reasonId === null)
            throw new Error("The parameter 'reasonId' must be defined.");
        url_ = url_.replace("{reasonId}", encodeURIComponent("" + reasonId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getLastReason(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleReasonListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/reasons/last-reason?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastReason(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastReason(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleReasonListItem>;
        }));
    }

    protected processGetLastReason(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(createRequest: ApiTitleCreateRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/titles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isNameAvailable(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/is-name-available?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findTitles(findRequest: ApiFindTitleRequest): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(findRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindTitles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindTitles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processFindTitles(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHeader(id: number): Observable<ApiTitleHeader> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{id}/header";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiTitleHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperStatistic(id: number): Observable<ApiTitlePaperDetailedStatistic> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{id}/paper-statistic";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperStatistic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperStatistic(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitlePaperDetailedStatistic>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitlePaperDetailedStatistic>;
        }));
    }

    protected processGetPaperStatistic(response: HttpResponseBase): Observable<ApiTitlePaperDetailedStatistic> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitlePaperDetailedStatistic.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    cancel(id: number, apiModel: ApiCancelTitle): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{id}/cancel";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getSettings(titleId: number): Observable<ApiTitleSettings> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/settings";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleSettings>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleSettings>;
        }));
    }

    protected processGetSettings(response: HttpResponseBase): Observable<ApiTitleSettings> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOptions(titleId: number, options: ApiTitleOptions): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/settings/options";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePrintOptions(titleId: number, options: ApiPrintOptionsUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/settings/print-options";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrintOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrintOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePrintOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateEditingToolAccessOptions(titleId: number, options: ApiTitleEditingToolAccessOptions): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/settings/editing-tool-access-options";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(options);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEditingToolAccessOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEditingToolAccessOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEditingToolAccessOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePublishingOptions(titleId: number, apiModel: ApiTitlePublishingOptions): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/settings/publishing-options";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePublishingOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePublishingOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePublishingOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleSubjectCategoriesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleSubjectCategoryListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/subject-categories?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleSubjectCategoryListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleSubjectCategoryListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleSubjectCategoryListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleSubjectCategoryListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(titleId: number, request: ApiTitleSubjectCategoryCreateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/subject-categories";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    replaceThema(titleId: number, request: ApiTitleSubjectCategoryReplaceThemaRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/subject-categories/thema";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceThema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceThema(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReplaceThema(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, subjectCategoryId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/subject-categories/{subjectCategoryId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (subjectCategoryId === undefined || subjectCategoryId === null)
            throw new Error("The parameter 'subjectCategoryId' must be defined.");
        url_ = url_.replace("{subjectCategoryId}", encodeURIComponent("" + subjectCategoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiscountedTitlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiDiscountedTitle> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing/discounted-titles/list?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiDiscountedTitle>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiDiscountedTitle>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiDiscountedTitle> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiDiscountedTitle.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getExcludedDiscountedTitleList(titleId: number): Observable<number[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing/discounted-titles/excluded-titles";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcludedDiscountedTitleList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcludedDiscountedTitleList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number[]>;
        }));
    }

    protected processGetExcludedDiscountedTitleList(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(titleId: number, discountedTitleIdArray: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing/discounted-titles";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(discountedTitleIdArray);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, discountedTitleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing/discounted-titles/{discountedTitleId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (discountedTitleId === undefined || discountedTitleId === null)
            throw new Error("The parameter 'discountedTitleId' must be defined.");
        url_ = url_.replace("{discountedTitleId}", encodeURIComponent("" + discountedTitleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PricingDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing-documents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadUrl(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing-documents/{type}";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (type === undefined || type === null)
                            throw new Error("The parameter 'type' must be defined.");
                        url_ = url_.replace("{type}", encodeURIComponent("" + type));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    upload(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, type: TitleFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/pricing-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/pricing-documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleFeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(titleId: number): Observable<ApiTitleFee> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/fee";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFee>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFee>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiTitleFee> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleFee.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, fee: ApiTitleFee): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/fee";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fee);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePaymentInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(titleId: number): Observable<ApiPaymentInfo> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/payment-info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaymentInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaymentInfo>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaymentInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaymentInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, paymentInfo: ApiPaymentInfo): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/payment-info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentInfo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePricesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getPrices(titleId: number): Observable<ApiTitlePrice[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/prices";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrices(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitlePrice[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitlePrice[]>;
        }));
    }

    protected processGetPrices(response: HttpResponseBase): Observable<ApiTitlePrice[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitlePrice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePrices(titleId: number, prices: ApiTitlePrice[]): Observable<ApiTitlePrice[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/prices";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(prices);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrices(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitlePrice[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitlePrice[]>;
        }));
    }

    protected processUpdatePrices(response: HttpResponseBase): Observable<ApiTitlePrice[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitlePrice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    calculatePrices(titleId: number, printUsdPrice: number | undefined): Observable<ApiTitlePrice[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/prices/calculate-prices?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (printUsdPrice === null)
            throw new Error("The parameter 'printUsdPrice' cannot be null.");
        else if (printUsdPrice !== undefined)
            url_ += "printUsdPrice=" + encodeURIComponent("" + printUsdPrice) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePrices(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitlePrice[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitlePrice[]>;
        }));
    }

    protected processCalculatePrices(response: HttpResponseBase): Observable<ApiTitlePrice[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitlePrice.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleContributorAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(titleId: number, memberId: number): Observable<ApiParticipantAddressDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiParticipantAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(titleId: number, memberId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, memberId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getExistingList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiParticipantAffiliationListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address/existing-list?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiParticipantAffiliationListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiParticipantAffiliationListItem>;
        }));
    }

    protected processGetExistingList(response: HttpResponseBase): Observable<ApiPageResultOfApiParticipantAffiliationListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiParticipantAffiliationListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getSuggestedList(odataQuery: string | undefined): Observable<ApiPageResultOfApiSuggestedAddressListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/participants/contributors/address/suggested-list?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiSuggestedAddressListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiSuggestedAddressListItem>;
        }));
    }

    protected processGetSuggestedList(response: HttpResponseBase): Observable<ApiPageResultOfApiSuggestedAddressListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiSuggestedAddressListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    recentAffiliationList(titleId: number, memberId: number, addressId: number | null | undefined): Observable<ApiParticipantAffiliationListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address/recent-affiliation-list?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId !== undefined && addressId !== null)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecentAffiliationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecentAffiliationList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAffiliationListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAffiliationListItem[]>;
        }));
    }

    protected processRecentAffiliationList(response: HttpResponseBase): Observable<ApiParticipantAffiliationListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiParticipantAffiliationListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExisting(titleId: number, memberId: number, addressId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}/address/add-existing/{addressId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExisting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleContributorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleContributorListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleContributorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleContributorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleContributorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleContributorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addContributors(titleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddContributors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddContributors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddContributors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/update-pos";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableMembers(titleId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/available-members?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processGetAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeContributor(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/contributors/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveContributor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveContributor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveContributor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleCorrespondingAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleCorrespondingAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleCorrespondingAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleCorrespondingAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleCorrespondingAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleCorrespondingAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addAuthors(titleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddAuthors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPapersList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiCorrespondingAuthorPaperListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors/{memberId}/papers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPapersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPapersList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiCorrespondingAuthorPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiCorrespondingAuthorPaperListItem>;
        }));
    }

    protected processGetPapersList(response: HttpResponseBase): Observable<ApiPageResultOfApiCorrespondingAuthorPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiCorrespondingAuthorPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableMembers(titleId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors/available-members?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processGetAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeAuthor(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateLimitUploads(titleId: number, memberId: number, apiModel: ApiAuthorLimitUploads): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/corresponding-authors/{memberId}/limit-uploads";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLimitUploads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLimitUploads(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLimitUploads(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleEditorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleEditorListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/editors?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleEditorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleEditorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleEditorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleEditorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    edit(titleId: number, model: ApiTitleEditorEditRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/editors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addEditors(titleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/editors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddEditors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddEditors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddEditors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableMembers(titleId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/editors/available-members?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processGetAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeEditor(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/editors/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveEditor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveEditor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveEditor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleReviewersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleReviewerListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleReviewerListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleReviewerListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleReviewerListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleReviewerListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addReviewers(titleId: number, memberIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddReviewers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPapersList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleReviewerPaperListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers/{memberId}/papers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPapersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPapersList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleReviewerPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleReviewerPaperListItem>;
        }));
    }

    protected processGetPapersList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleReviewerPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleReviewerPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableMembers(titleId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers/available-members?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processGetAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeReviewer(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveReviewer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateReviewerNote(titleId: number, memberId: number, apiModel: ApiReviewerNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/participants/reviewers/{memberId}/note";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReviewerNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleEbookDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/ebook-documents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/ebook-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, type: TitleFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/ebook-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadUrl(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/ebook-documents/{type}";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (type === undefined || type === null)
                            throw new Error("The parameter 'type' must be defined.");
                        url_ = url_.replace("{type}", encodeURIComponent("" + type));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    upload(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/ebook-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/files/ebook-documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleEditorFilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getDocuments(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleDocument> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/editor-files?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleDocument>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleDocument>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleDocument> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/editor-files";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocumentFile(titleId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/editor-files/{documentId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocumentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteDocument(titleId: number, documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/editor-files/{documentId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleGeneratedFilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateShortDoc(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/short-doc";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateShortDoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateShortDoc(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateShortDoc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateShortDb(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/short-db";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateShortDb(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateShortDb(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateShortDb(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateTableOfContents(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/table-of-contents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTableOfContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTableOfContents(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateTableOfContents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateKeywordIndex(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/keyword-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateKeywordIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateKeywordIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateKeywordIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateHomePrintPage(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/home-print-page";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateHomePrintPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateHomePrintPage(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateHomePrintPage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateAuthorIndexPage(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/author-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAuthorIndexPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAuthorIndexPage(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateAuthorIndexPage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateListOfReviewers(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/generated/list-of-reviewers";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateListOfReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateListOfReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateListOfReviewers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePartPrepressDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiPartTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPartTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPartTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPartTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPartTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generate(titleId: number, partId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (partId === null)
            throw new Error("The parameter 'partId' cannot be null.");
        else if (partId !== undefined)
            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, partId: number | undefined, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents/{type}?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (partId === null)
            throw new Error("The parameter 'partId' cannot be null.");
        else if (partId !== undefined)
            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, partId: number | undefined, type: TitleFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents/{type}?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (partId === null)
            throw new Error("The parameter 'partId' cannot be null.");
        else if (partId !== undefined)
            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadUrl(titleId: number, partId: number | undefined, type: TitleFileType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents/{type}?";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (type === undefined || type === null)
                            throw new Error("The parameter 'type' must be defined.");
                        url_ = url_.replace("{type}", encodeURIComponent("" + type));
                        if (partId === null)
                            throw new Error("The parameter 'partId' cannot be null.");
                        else if (partId !== undefined)
                            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    upload(titleId: number, partId: number | undefined, type: TitleFileType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/part-prepress-documents/{type}?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        if (partId === null)
            throw new Error("The parameter 'partId' cannot be null.");
        else if (partId !== undefined)
            url_ += "partId=" + encodeURIComponent("" + partId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/files/part-prepress-documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePrepressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generate(titleId: number, type: TitleFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitlePrepressDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number): Observable<ApiTitleFile[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress-documents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleFile[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleFile[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiTitleFile[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleFile.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(titleId: number, type: TitleFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, type: TitleFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadUrl(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress-documents/{type}";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (type === undefined || type === null)
                            throw new Error("The parameter 'type' must be defined.");
                        url_ = url_.replace("{type}", encodeURIComponent("" + type));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    upload(titleId: number, type: TitleFileType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/files/prepress-documents/{type}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/files/prepress-documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleDoisClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleDoiListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/title-dois?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleDoiListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleDoiListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleDoiListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleDoiListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleDois(titleId: number): Observable<ApiTitleDoi[]> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-dois";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleDois(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleDois(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleDoi[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleDoi[]>;
        }));
    }

    protected processGetTitleDois(response: HttpResponseBase): Observable<ApiTitleDoi[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleDoi.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    uploadTitleToCrossref(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-dois/upload-to-crossref";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadTitleToCrossref(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadTitleToCrossref(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadTitleToCrossref(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    uploadToCrossref(titleId: number, titleCategory: TitleCategory): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/{titleId}/title-dois/{titleCategory}/upload-to-crossref";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (titleCategory === undefined || titleCategory === null)
            throw new Error("The parameter 'titleCategory' must be defined.");
        url_ = url_.replace("{titleCategory}", encodeURIComponent("" + titleCategory));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadToCrossref(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadToCrossref(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadToCrossref(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ThemaCatalogsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getTree(): Observable<ApiThemaTreeNode[]> {
        let url_ = this.baseUrl + "/api/main/publishing/thema-catalogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTree(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiThemaTreeNode[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiThemaTreeNode[]>;
        }));
    }

    protected processGetTree(response: HttpResponseBase): Observable<ApiThemaTreeNode[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiThemaTreeNode.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadThemaCatalogUrl(themaCatalogFile: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/thema-catalogs";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadThemaCatalog(themaCatalogFile: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/thema-catalogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (themaCatalogFile !== null && themaCatalogFile !== undefined)
            content_.append("themaCatalogFile", themaCatalogFile.data, themaCatalogFile.fileName ? themaCatalogFile.fileName : "themaCatalogFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadThemaCatalog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadThemaCatalog(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadThemaCatalog(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findThemas(query: string | null | undefined): Observable<ApiThema[]> {
        let url_ = this.baseUrl + "/api/main/publishing/thema-catalogs/find-themas?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindThemas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindThemas(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiThema[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiThema[]>;
        }));
    }

    protected processFindThemas(response: HttpResponseBase): Observable<ApiThema[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiThema.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCatalogs(odataQuery: string | undefined): Observable<ApiPageResultOfApiThemaCatalogListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/thema-catalogs/catalogs?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCatalogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCatalogs(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiThemaCatalogListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiThemaCatalogListItem>;
        }));
    }

    protected processGetCatalogs(response: HttpResponseBase): Observable<ApiPageResultOfApiThemaCatalogListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiThemaCatalogListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ThemasClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getTree(): Observable<ApiThemaTreeNode[]> {
        let url_ = this.baseUrl + "/api/main/publishing/themas/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTree(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiThemaTreeNode[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiThemaTreeNode[]>;
        }));
    }

    protected processGetTree(response: HttpResponseBase): Observable<ApiThemaTreeNode[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiThemaTreeNode.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiTopicListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/themas?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTopicListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTopicListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTopicListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTopicListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(topic: ApiTopic): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/themas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topic);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiTopic> {
        let url_ = this.baseUrl + "/api/main/publishing/themas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTopic>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTopic>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiTopic> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTopic.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, topic: ApiTopic): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/themas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(topic);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    archive(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/themas/archive/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchive(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processArchive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    restore(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/themas/restore/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CopyrightDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getPaperCopyrightText(): Observable<ApiPaperCopyrightText> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/copyright-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperCopyrightText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperCopyrightText(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperCopyrightText>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperCopyrightText>;
        }));
    }

    protected processGetPaperCopyrightText(response: HttpResponseBase): Observable<ApiPaperCopyrightText> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperCopyrightText.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePaperCopyrightText(apiModel: ApiPaperCopyrightText): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/copyright-data";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaperCopyrightText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaperCopyrightText(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaperCopyrightText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(): Observable<ApiFileTemplate[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileTemplate[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileTemplate[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiFileTemplate[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiFileTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadUrl(type: FileTemplateType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/{type}";
                        if (type === undefined || type === null)
                            throw new Error("The parameter 'type' must be defined.");
                        url_ = url_.replace("{type}", encodeURIComponent("" + type));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    upload(type: FileTemplateType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(type: FileTemplateType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(type: FileTemplateType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/doc-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetDocValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getImgValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/img-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImgValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImgValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetImgValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getXlsValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/file-templates/xls-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXlsValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXlsValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetXlsValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HtmlTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getTemplates(): Observable<ApiHtmlTemplate[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplates(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiHtmlTemplate[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiHtmlTemplate[]>;
        }));
    }

    protected processGetTemplates(response: HttpResponseBase): Observable<ApiHtmlTemplate[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiHtmlTemplate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateTemplate(templateId: number, apiModel: ApiHtmlTemplate): Observable<ApiHtmlTemplate> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/templates/{templateId}";
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiHtmlTemplate>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiHtmlTemplate>;
        }));
    }

    protected processUpdateTemplate(response: HttpResponseBase): Observable<ApiHtmlTemplate> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiHtmlTemplate.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class KeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/keywords?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiKeywordListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(apiModel: ApiKeywordCreateRequest): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/keywords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(apiModel: ApiKeywordUpdateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/keywords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(keywordId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/keywords?";
        if (keywordId === null)
            throw new Error("The parameter 'keywordId' cannot be null.");
        else if (keywordId !== undefined)
            url_ += "keywordId=" + encodeURIComponent("" + keywordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isKeywordAvailable(keyword: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/keywords/is-keyword-available?";
        if (keyword !== undefined && keyword !== null)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsKeywordAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsKeywordAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsKeywordAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperFootersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperFooterListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperFooterListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperFooterListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperFooterListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperFooterListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(apiModel: ApiPaperFooterUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiPaperFooterDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperFooterDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperFooterDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperFooterDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperFooterDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiModel: ApiPaperFooterUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAll(): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/paper-footers/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PublishingReasonsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiPublishingReasonListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPublishingReasonListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPublishingReasonListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPublishingReasonListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPublishingReasonListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(apiModel: ApiPublishingReasonUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    checkNotExist(query: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/check-not-exist?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNotExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNotExist(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckNotExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiModel: ApiPublishingReasonUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiPublishingReasonDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPublishingReasonDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPublishingReasonDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPublishingReasonDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPublishingReasonDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleReasonUsageList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleReasonUsageListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/{id}/titles-usage?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleReasonUsageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleReasonUsageList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleReasonUsageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleReasonUsageListItem>;
        }));
    }

    protected processGetTitleReasonUsageList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleReasonUsageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleReasonUsageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReasons(type: PublishingReasonTypeEnum | undefined): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/reasons-by-type?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetReasons(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReasonUsageDetails(id: number): Observable<ApiPublishingReasonUsageDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/reasons/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPublishingReasonUsageDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPublishingReasonUsageDetails>;
        }));
    }

    protected processGetReasonUsageDetails(response: HttpResponseBase): Observable<ApiPublishingReasonUsageDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPublishingReasonUsageDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResponsibilitiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number): Observable<ApiResponsibility> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiResponsibility>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiResponsibility>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiResponsibility> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiResponsibility.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiResponsibilityListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiResponsibilityListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiResponsibilityListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiResponsibilityListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiResponsibilityListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createNew(responsibilityModel: ApiResponsibility): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(responsibilityModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateResponsibility(responsibilityModel: ApiResponsibility): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(responsibilityModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateResponsibility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateResponsibility(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateResponsibility(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMemberList(responsibilityId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiResponsibilityMemberListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities/{responsibilityId}/members?";
        if (responsibilityId === undefined || responsibilityId === null)
            throw new Error("The parameter 'responsibilityId' must be defined.");
        url_ = url_.replace("{responsibilityId}", encodeURIComponent("" + responsibilityId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiResponsibilityMemberListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiResponsibilityMemberListItem>;
        }));
    }

    protected processGetMemberList(response: HttpResponseBase): Observable<ApiPageResultOfApiResponsibilityMemberListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiResponsibilityMemberListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isResponsibilityNameAvailable(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities/is-name-available?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsResponsibilityNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsResponsibilityNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsResponsibilityNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(model: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/responsibilities/update-pos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleProgressStatusesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleProgressStatusListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleProgressStatusListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleProgressStatusListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleProgressStatusListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleProgressStatusListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(apiModel: ApiTitleProgressStatusUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAll(): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getUsageDetails(id: number): Observable<ApiTitleProgressStatusUsageDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsageDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsageDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleProgressStatusUsageDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleProgressStatusUsageDetails>;
        }));
    }

    protected processGetUsageDetails(response: HttpResponseBase): Observable<ApiTitleProgressStatusUsageDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleProgressStatusUsageDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiModel: ApiTitleProgressStatusUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTitleUsageList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleProgressStatusTitleUsageListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/settings/title-progress-statuses/{id}/titles?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTitleUsageList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTitleUsageList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleProgressStatusTitleUsageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleProgressStatusTitleUsageListItem>;
        }));
    }

    protected processGetTitleUsageList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleProgressStatusTitleUsageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleProgressStatusTitleUsageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ContributorAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(memberId: number, addressId: number): Observable<ApiParticipantAddressDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/contributors/{memberId}/addresses/{addressId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiParticipantAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiContributorAddressListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/contributors/{memberId}/addresses/list?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiContributorAddressListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiContributorAddressListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiContributorAddressListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiContributorAddressListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setExisting(memberId: number, addressId: number, newAddressId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/contributors/{memberId}/addresses/{addressId}/set-existing/{newAddressId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        if (newAddressId === undefined || newAddressId === null)
            throw new Error("The parameter 'newAddressId' must be defined.");
        url_ = url_.replace("{newAddressId}", encodeURIComponent("" + newAddressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetExisting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(addressId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/contributors/addresses/{addressId}/update";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ParticipantAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(memberId: number, addressId: number): Observable<ApiParticipantAddressDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/participants/{memberId}/addresses/{addressId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiParticipantAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAddressList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiParticipantAddressListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/participants/{memberId}/addresses?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAddressList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAddressList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiParticipantAddressListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiParticipantAddressListItem>;
        }));
    }

    protected processGetAddressList(response: HttpResponseBase): Observable<ApiPageResultOfApiParticipantAddressListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiParticipantAddressListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAffiliationList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiParticipantAffiliationListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/participants/{memberId}/addresses/affiliation-list?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffiliationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffiliationList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiParticipantAffiliationListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiParticipantAffiliationListItem>;
        }));
    }

    protected processGetAffiliationList(response: HttpResponseBase): Observable<ApiPageResultOfApiParticipantAffiliationListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiParticipantAffiliationListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getSuggestedList(odataQuery: string | undefined): Observable<ApiPageResultOfApiSuggestedAddressListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/participant/address/suggested-list?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestedList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiSuggestedAddressListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiSuggestedAddressListItem>;
        }));
    }

    protected processGetSuggestedList(response: HttpResponseBase): Observable<ApiPageResultOfApiSuggestedAddressListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiSuggestedAddressListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setExisting(memberId: number, addressId: number, newAddressId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/participants/{memberId}/addresses/{addressId}/set-existing/{newAddressId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        if (newAddressId === undefined || newAddressId === null)
            throw new Error("The parameter 'newAddressId' must be defined.");
        url_ = url_.replace("{newAddressId}", encodeURIComponent("" + newAddressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetExisting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(addressId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/participant/addresses/{addressId}/update";
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperAuthorAddressesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number, memberId: number): Observable<ApiParticipantAddressDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiParticipantAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(paperId: number, memberId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, memberId: number, apiModel: ApiParticipantAddress): Observable<ApiParticipantAddressManageResult> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAddressManageResult>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAddressManageResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiParticipantAddressManageResult> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiParticipantAddressManageResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(paperId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    recentAffiliationList(paperId: number, memberId: number, addressId: number | null | undefined): Observable<ApiParticipantAffiliationListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address/recent-affiliation-list?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId !== undefined && addressId !== null)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecentAffiliationList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecentAffiliationList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiParticipantAffiliationListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiParticipantAffiliationListItem[]>;
        }));
    }

    protected processRecentAffiliationList(response: HttpResponseBase): Observable<ApiParticipantAffiliationListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiParticipantAffiliationListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExisting(paperId: number, memberId: number, addressId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/address/add-existing/{addressId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExisting(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addAuthors(paperId: number, memberIdList: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddAuthors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeAuthor(paperId: number, memberId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === null)
            throw new Error("The parameter 'memberId' cannot be null.");
        else if (memberId !== undefined)
            url_ += "memberId=" + encodeURIComponent("" + memberId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableMembers(paperId: number, query: string | null | undefined): Observable<ApiMemberInfo[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/available-members?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableMembers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableMembers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo[]>;
        }));
    }

    protected processGetAvailableMembers(response: HttpResponseBase): Observable<ApiMemberInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiMemberInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(paperId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/update-pos";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAuthorFirstName(paperId: number, apiModel: ApiPaperAuthorNameUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/update-first-name";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthorFirstName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthorFirstName(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthorFirstName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAuthorLastName(paperId: number, apiModel: ApiPaperAuthorNameUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/update-last-name";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthorLastName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthorLastName(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthorLastName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAuthorFullName(paperId: number, apiModel: ApiPaperAuthorFullNameUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/update-full-name";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthorFullName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthorFullName(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthorFullName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAuthorEmail(paperId: number, apiModel: ApiPaperAuthorEmailUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/update-email";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthorEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthorEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthorEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setCorrespondingAuthor(paperId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/authors/{memberId}/set-as-corresponding";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCorrespondingAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCorrespondingAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetCorrespondingAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperCopyrightClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCopyrightFile(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/copyright";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCopyrightFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCopyrightFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCopyrightFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperDocumentsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(paperId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/{documentId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createUrl(paperId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/create";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    create(paperId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/create";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createAndParseUrl(paperId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/create-and-parse";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    createAndParse(paperId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/create-and-parse";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndParse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndParse(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateAndParse(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPdfWithPublishingTemplate(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/pdf-publishing-template";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfWithPublishingTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfWithPublishingTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdfWithPublishingTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPdfWithRedBorder(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/pdf-red-border";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfWithRedBorder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfWithRedBorder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdfWithRedBorder(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCurrentDocFile(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/current-doc";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentDocFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentDocFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCurrentDocFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCurrentEpubFile(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/current-epub";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentEpubFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentEpubFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCurrentEpubFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    convertPdfToEpub(paperId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/documents/convert-pdf-to-epub";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConvertPdfToEpub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConvertPdfToEpub(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processConvertPdfToEpub(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperFilesHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getListPdf(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/files-history/pdf?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
        }));
    }

    protected processGetListPdf(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperDocumentsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getListDoc(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/files-history/doc?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListDoc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListDoc(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
        }));
    }

    protected processGetListDoc(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperDocumentsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getListEpub(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/files-history/epub?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListEpub(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListEpub(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperDocumentsListItem>;
        }));
    }

    protected processGetListEpub(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperDocumentsListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperDocumentsListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setCurrent(paperId: number, documentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/files-history?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCurrent(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetCurrent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperInfoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number): Observable<ApiPaper> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaper>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaper>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaper> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaper.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAbstract(paperId: number, newAbstract: ApiText): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/abstract";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newAbstract);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAbstract(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAbstract(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAbstract(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDetails(paperId: number): Observable<ApiPaperDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/details";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperDetails>;
        }));
    }

    protected processGetDetails(response: HttpResponseBase): Observable<ApiPaperDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDetails(paperId: number, apiModel: ApiPaperDetails): Observable<ApiPaperDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/details";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperDetails>;
        }));
    }

    protected processUpdateDetails(response: HttpResponseBase): Observable<ApiPaperDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isPosAvailable(paperId: number, pos: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/is-pos-available?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (pos === null)
            throw new Error("The parameter 'pos' cannot be null.");
        else if (pos !== undefined)
            url_ += "pos=" + encodeURIComponent("" + pos) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPosAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPosAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPosAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    remove(paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(titleId: number | undefined, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number | undefined, apiModel: ApiPublishingPaperCreateRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/papers?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHeader(paperId: number): Observable<ApiPaperHeader> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/header";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiPaperHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createFromFilesUrl(titleId: number | undefined, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/create-from-files?";
                        if (titleId === null)
                            throw new Error("The parameter 'titleId' cannot be null.");
                        else if (titleId !== undefined)
                            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    createFromFiles(titleId: number | undefined, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/create-from-files?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateFromFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createAndParseFromFilesUrl(titleId: number | undefined, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/create-and-parse-from-files?";
                        if (titleId === null)
                            throw new Error("The parameter 'titleId' cannot be null.");
                        else if (titleId !== undefined)
                            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    createAndParseFromFiles(titleId: number | undefined, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/create-and-parse-from-files?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAndParseFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAndParseFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateAndParseFromFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            replaceFromFilesUrl(titleId: number | undefined, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/replace-from-files?";
                        if (titleId === null)
                            throw new Error("The parameter 'titleId' cannot be null.");
                        else if (titleId !== undefined)
                            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    replaceFromFiles(titleId: number | undefined, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/replace-from-files?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplaceFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplaceFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReplaceFromFiles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReplacementValidation(titleId: number | undefined): Observable<ApiPaperReplacementValidation> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/replacement-validation?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReplacementValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReplacementValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperReplacementValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperReplacementValidation>;
        }));
    }

    protected processGetReplacementValidation(response: HttpResponseBase): Observable<ApiPaperReplacementValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperReplacementValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/papers/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    canDownloadAllFiles(titleId: number | undefined): Observable<ApiCanDownloadFiles> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/can-download-all-files?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanDownloadAllFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanDownloadAllFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiCanDownloadFiles>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiCanDownloadFiles>;
        }));
    }

    protected processCanDownloadAllFiles(response: HttpResponseBase): Observable<ApiCanDownloadFiles> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiCanDownloadFiles.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFilteredByDocumentType(titleId: number | undefined, odataQuery: string | undefined): Observable<ApiFilteredByDocumentType> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/get-filtered-by-document-type-count?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilteredByDocumentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilteredByDocumentType(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFilteredByDocumentType>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFilteredByDocumentType>;
        }));
    }

    protected processGetFilteredByDocumentType(response: HttpResponseBase): Observable<ApiFilteredByDocumentType> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFilteredByDocumentType.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadFiles(titleId: number | undefined, odataQuery: string | undefined, apiModel: ApiProcessPaperFiles): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/download-files?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFiles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadCopyrights(titleId: number | undefined, odataQuery: string | undefined, apiModel: ApiProcessPaperCopyrightFiles): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/download-copyrights?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCopyrights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCopyrights(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCopyrights(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    correct(titleId: number | undefined, odataQuery: string | undefined, apiModel: ApiProcessPaperFiles): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/correct?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCorrect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCorrect(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCorrect(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignChaptersByPage(titleId: number | undefined, model: ApiAssignChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/assign-chapter?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignChaptersByPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignChaptersByPage(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignChaptersByPage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getChapters(titleId: number | undefined): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/chapters?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChapters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChapters(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetChapters(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    insertChapterUpload(titleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/insert-chapter-upload?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertChapterUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertChapterUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processInsertChapterUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    insertChapterUploadAvailable(titleId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/insert-chapter-upload-available?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertChapterUploadAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertChapterUploadAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processInsertChapterUploadAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    movePapers(titleId: number | undefined, targetTitleId: number | undefined, paperIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/move?";
        if (titleId === null)
            throw new Error("The parameter 'titleId' cannot be null.");
        else if (titleId !== undefined)
            url_ += "titleId=" + encodeURIComponent("" + titleId) + "&";
        if (targetTitleId === null)
            throw new Error("The parameter 'targetTitleId' cannot be null.");
        else if (targetTitleId !== undefined)
            url_ += "targetTitleId=" + encodeURIComponent("" + targetTitleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paperIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMovePapers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMovePapers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processMovePapers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperKeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/keywords?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPeriodicalKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(paperId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/keywords";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(paperId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/keywords";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    lookupKeywords(paperId: number, query: string | null | undefined, excludeIds: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/keywords/lookup?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processLookupKeywords(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperLegacyHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperLegacyHistoryListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/legacy-history?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperLegacyHistoryListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperLegacyHistoryListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperLegacyHistoryListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperLegacyHistoryListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperNotesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiNoteListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiNoteListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiPaperNote): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCheckerList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiNoteListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/checker-table-list?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckerList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckerList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiNoteListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiNoteListItem>;
        }));
    }

    protected processGetCheckerList(response: HttpResponseBase): Observable<ApiPageResultOfApiNoteListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiNoteListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCheckerDialogList(paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/checker-dialog-list";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCheckerDialogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCheckerDialogList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processGetCheckerDialogList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, noteId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(paperId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    dialogList(paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/dialog-list";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDialogList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDialogList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processDialogList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachment(paperId: number, noteId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/{noteId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addAttachmentUrl(paperId: number, noteId: number, attachment: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/{noteId}/attachment";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        if (noteId === undefined || noteId === null)
                            throw new Error("The parameter 'noteId' must be defined.");
                        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addAttachment(paperId: number, noteId: number, attachment: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/notes/{noteId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment !== null && attachment !== undefined)
            content_.append("attachment", attachment.data, attachment.fileName ? attachment.fileName : "attachment");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/titles/papers/notes/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetAttachmentValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperReferencesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperReferenceListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperReferenceListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperReferenceListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperReferenceListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperReferenceListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, reference: ApiPaperReference): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reference);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(paperId: number, referenceIdList: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referenceIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(paperId: number, referenceId: number): Observable<ApiPaperReference> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/{referenceId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (referenceId === undefined || referenceId === null)
            throw new Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperReference>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperReference>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperReference> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperReference.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, referenceId: number, reference: ApiPaperReference): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/{referenceId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (referenceId === undefined || referenceId === null)
            throw new Error("The parameter 'referenceId' must be defined.");
        url_ = url_.replace("{referenceId}", encodeURIComponent("" + referenceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reference);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateFromDocOrPdf(paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/update-from-doc-or-pdf";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFromDocOrPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFromDocOrPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFromDocOrPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateFromPdf(paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/update-from-pdf";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFromPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFromPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFromPdf(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateFromText(paperId: number, text: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/update-from-text?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (text !== undefined && text !== null)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFromText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFromText(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFromText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAllFromCrossref(paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/update-all-from-crossref";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllFromCrossref(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllFromCrossref(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllFromCrossref(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateFromCrossref(paperId: number, referenceIdList: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/update-from-crossref";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referenceIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFromCrossref(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFromCrossref(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateFromCrossref(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    markAllAsChecked(paperId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/mark-all-as-checked";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllAsChecked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllAsChecked(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkAllAsChecked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    markAsChecked(paperId: number, referenceIdList: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/mark-as-checked";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referenceIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAsChecked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAsChecked(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkAsChecked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    haveAllReferencesChecked(paperId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/references/all-checked";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaveAllReferencesChecked(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaveAllReferencesChecked(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processHaveAllReferencesChecked(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperReviewsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getFirstReview(paperId: number): Observable<ApiPublishingPaperReview> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/reviews/first";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFirstReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFirstReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPublishingPaperReview>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPublishingPaperReview>;
        }));
    }

    protected processGetFirstReview(response: HttpResponseBase): Observable<ApiPublishingPaperReview> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPublishingPaperReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReview(paperId: number, reviewId: number): Observable<ApiPublishingPaperReview> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/reviews/{reviewId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPublishingPaperReview>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPublishingPaperReview>;
        }));
    }

    protected processGetReview(response: HttpResponseBase): Observable<ApiPublishingPaperReview> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPublishingPaperReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReviewReportAttachment(paperId: number, reviewId: number, editorReport: boolean | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/reviews/{reviewId}/attachment?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        if (editorReport === null)
            throw new Error("The parameter 'editorReport' cannot be null.");
        else if (editorReport !== undefined)
            url_ += "editorReport=" + encodeURIComponent("" + editorReport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewReportAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewReportAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetReviewReportAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReviewers(paperId: number): Observable<ApiPublishingPaperReviewer[]> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/reviews/reviewers";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPublishingPaperReviewer[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPublishingPaperReviewer[]>;
        }));
    }

    protected processGetReviewers(response: HttpResponseBase): Observable<ApiPublishingPaperReviewer[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPublishingPaperReviewer.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaperSupplementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperSupplementListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getSupplement(paperId: number, supplementId: number): Observable<ApiPaperSupplement> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/{supplementId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperSupplement>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperSupplement>;
        }));
    }

    protected processGetSupplement(response: HttpResponseBase): Observable<ApiPaperSupplement> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperSupplement.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeSupplement(paperId: number, supplementId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/{supplementId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(paperId: number, supplementId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/{supplementId}/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementFile(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateSupplementFile(paperId: number, supplementId: number | undefined, model: ApiPaperSupplement): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/file?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === null)
            throw new Error("The parameter 'supplementId' cannot be null.");
        else if (supplementId !== undefined)
            url_ += "supplementId=" + encodeURIComponent("" + supplementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSupplementFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementLink(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/link";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateSupplementLink(paperId: number, supplementId: number | undefined, model: ApiPaperSupplement): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/link?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === null)
            throw new Error("The parameter 'supplementId' cannot be null.");
        else if (supplementId !== undefined)
            url_ += "supplementId=" + encodeURIComponent("" + supplementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSupplementLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadSupplementFileUrl(paperId: number, supplementId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/{supplementId}/file-upload";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        if (supplementId === undefined || supplementId === null)
                            throw new Error("The parameter 'supplementId' must be defined.");
                        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadSupplementFile(paperId: number, supplementId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/{paperId}/supplements/{supplementId}/file-upload";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadSupplementFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/papers/supplements/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiAuthorPaperListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/members/{memberId}/author-papers?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiAuthorPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiAuthorPaperListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiAuthorPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiAuthorPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/doc-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetDocValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPdfValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/pdf-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetPdfValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createFromFilesUrl(titleId: number, files: any[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/create-from-files/{titleId}";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    createFromFiles(titleId: number, files: any[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/create-from-files/{titleId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreateFromFiles(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addFilesUrl(paperId: number, files: any[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/add-files";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addFiles(paperId: number, files: any[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/add-files";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddFiles(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperDetails(paperId: number): Observable<ApiEditingToolPaperDetails> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/details";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolPaperDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolPaperDetails>;
        }));
    }

    protected processGetPaperDetails(response: HttpResponseBase): Observable<ApiEditingToolPaperDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditingToolPaperDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePaperDetails(paperId: number, model: ApiEditingToolPaperDetailsUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/update";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaperDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaperDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaperDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getInfo(paperId: number): Observable<ApiEditingToolPaperInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/info";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolPaperInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolPaperInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiEditingToolPaperInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditingToolPaperInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getProgressInfo(paperId: number): Observable<ApiEditingToolPaperProgressInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/progress";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgressInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgressInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolPaperProgressInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolPaperProgressInfo>;
        }));
    }

    protected processGetProgressInfo(response: HttpResponseBase): Observable<ApiEditingToolPaperProgressInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditingToolPaperProgressInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    markProgressStepVisited(paperId: number, step: PaperProgressStepEnum | undefined): Observable<ApiEditingToolPaperProgressInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/progress?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (step === null)
            throw new Error("The parameter 'step' cannot be null.");
        else if (step !== undefined)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkProgressStepVisited(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkProgressStepVisited(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolPaperProgressInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolPaperProgressInfo>;
        }));
    }

    protected processMarkProgressStepVisited(response: HttpResponseBase): Observable<ApiEditingToolPaperProgressInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditingToolPaperProgressInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHistory(paperId: number): Observable<ApiPaperHistoryEntry[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/history";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperHistoryEntry[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperHistoryEntry[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<ApiPaperHistoryEntry[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPaperHistoryEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleMembershipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleMembershipListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/members/{memberId}/title-memberships?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleMembershipListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleMembershipListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleMembershipListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleMembershipListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAssignedKurzels(memberId: number): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/members/{memberId}/title-memberships/kurzels";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedKurzels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedKurzels(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetAssignedKurzels(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MemberProxiesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(id: number): Observable<ApiMemberInfo> {
        let url_ = this.baseUrl + "/api/main/publishing/members/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiMemberInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAcceptableRoleNames(participantType: ParticipantTypeEnum | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/members/roles?";
        if (participantType === null)
            throw new Error("The parameter 'participantType' cannot be null.");
        else if (participantType !== undefined)
            url_ += "participantType=" + encodeURIComponent("" + participantType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAcceptableRoleNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAcceptableRoleNames(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetAcceptableRoleNames(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReviews(memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPublishingPaperReviewListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/members/{memberId}/reviews?";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviews(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPublishingPaperReviewListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPublishingPaperReviewListItem>;
        }));
    }

    protected processGetReviews(response: HttpResponseBase): Observable<ApiPageResultOfApiPublishingPaperReviewListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPublishingPaperReviewListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorialBoardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorialBoardListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/editorial-board?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorialBoardListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorialBoardListItem>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorialBoardListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorialBoardListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(id: number, editorId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/editorial-board?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (editorId === null)
            throw new Error("The parameter 'editorId' cannot be null.");
        else if (editorId !== undefined)
            url_ += "editorId=" + encodeURIComponent("" + editorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(id: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/editorial-board/update-pos";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalFilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getFile(id: number, fileType: JournalFileType): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/files/{fileType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadFileUrl(id: number, fileType: JournalFileType, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/files/{fileType}";
                        if (id === undefined || id === null)
                            throw new Error("The parameter 'id' must be defined.");
                        url_ = url_.replace("{id}", encodeURIComponent("" + id));
                        if (fileType === undefined || fileType === null)
                            throw new Error("The parameter 'fileType' must be defined.");
                        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadFile(id: number, fileType: JournalFileType, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/files/{fileType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteFile(id: number, fileType: JournalFileType): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/files/{fileType}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileType === undefined || fileType === null)
            throw new Error("The parameter 'fileType' must be defined.");
        url_ = url_.replace("{fileType}", encodeURIComponent("" + fileType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalGroupsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number): Observable<ApiJournalGroup> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalGroup>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalGroup>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiJournalGroup> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalGroup.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHeader(id: number): Observable<ApiJournalGroupHeader> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/header";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalGroupHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalGroupHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiJournalGroupHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalGroupHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiJournalGroupListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiJournalGroupListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiJournalGroupListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiJournalGroupListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiJournalGroupListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createNew(apiModel: ApiJournalGroupCreateRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNew(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreateNew(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailable(): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/available";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetAvailable(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(model: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/update-pos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isNameAvailable(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/is-name-available?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isShortNameAvailable(shortName: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/is-short-name-available?";
        if (shortName !== undefined && shortName !== null)
            url_ += "shortName=" + encodeURIComponent("" + shortName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsShortNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsShortNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsShortNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getGroupDetails(id: number): Observable<ApiJournalGroupDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalGroupDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalGroupDetails>;
        }));
    }

    protected processGetGroupDetails(response: HttpResponseBase): Observable<ApiJournalGroupDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalGroupDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateGroupDetails(id: number, apiModel: ApiJournalGroupDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGroupDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGroupDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateGroupDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(id: number): Observable<ApiActivity> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/activity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getJournals(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiJournalGroupJournalListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/journals?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetJournals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetJournals(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiJournalGroupJournalListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiJournalGroupJournalListItem>;
        }));
    }

    protected processGetJournals(response: HttpResponseBase): Observable<ApiPageResultOfApiJournalGroupJournalListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiJournalGroupJournalListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addJournals(id: number, journalIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/journals";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(journalIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddJournals(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddJournals(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddJournals(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeJournal(id: number, journalId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/journals?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (journalId === null)
            throw new Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveJournal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveJournal(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveJournal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateJournalsOrder(id: number, model: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journal-groups/{id}/update-journals-pos";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateJournalsOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateJournalsOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateJournalsOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalPagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiJournalPageListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiJournalPageListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiJournalPageListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiJournalPageListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiJournalPageListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(id: number, apiModel: ApiJournalPageDetails): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number, pageId: number): Observable<ApiJournalPageDetails> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages/{pageId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalPageDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalPageDetails>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiJournalPageDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalPageDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, pageId: number, apiModel: ApiJournalPageDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages/{pageId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number, pageId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages/{pageId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (pageId === undefined || pageId === null)
            throw new Error("The parameter 'pageId' must be defined.");
        url_ = url_.replace("{pageId}", encodeURIComponent("" + pageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(id: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/pages/update-pos";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalReviewerSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(id: number): Observable<ApiJournalReviewerSettings> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalReviewerSettings>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalReviewerSettings>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiJournalReviewerSettings> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalReviewerSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(id: number, apiJournalModel: ApiJournalReviewerSettings): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiJournalModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getListAttachments(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPublishingAttachmentListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings/attachment-list?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetListAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetListAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPublishingAttachmentListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPublishingAttachmentListItem>;
        }));
    }

    protected processGetListAttachments(response: HttpResponseBase): Observable<ApiPageResultOfApiPublishingAttachmentListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPublishingAttachmentListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachment(id: number, attachmentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings/attachment/{attachmentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachment(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadAttachmentsUrl(id: number, files: FileParameter[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings/upload-attachments";
                        if (id === undefined || id === null)
                            throw new Error("The parameter 'id' must be defined.");
                        url_ = url_.replace("{id}", encodeURIComponent("" + id));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadAttachments(id: number, files: FileParameter[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings/upload-attachments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadAttachments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadAttachments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadAttachments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteAttachment(id: number, attachmentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/reviewer-settings/{attachmentId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/reviewer-settings/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getHeader(id: number): Observable<ApiJournalHeader> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/header";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalHeader>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalHeader>;
        }));
    }

    protected processGetHeader(response: HttpResponseBase): Observable<ApiJournalHeader> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournalHeader.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    get(id: number): Observable<ApiJournal> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournal>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournal>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiJournal> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiJournal.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getSpecifications(): Observable<JournalSpecification[]> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/specifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecifications(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<JournalSpecification[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<JournalSpecification[]>;
        }));
    }

    protected processGetSpecifications(response: HttpResponseBase): Observable<JournalSpecification[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JournalSpecification.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiJournalListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journals?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiJournalListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiJournalListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiJournalListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiJournalListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(createRequest: ApiJournalCreateRequest): Observable<number> {
        let url_ = this.baseUrl + "/api/main/publishing/journals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setOnline(id: number, groupId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/set-online/{groupId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOnline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOnline(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetOnline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setOffline(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/set-offline";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetOffline(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetOffline(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetOffline(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setRegisterDoi(id: number, registerDoi: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/register-doi/{registerDoi}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (registerDoi === undefined || registerDoi === null)
            throw new Error("The parameter 'registerDoi' must be defined.");
        url_ = url_.replace("{registerDoi}", encodeURIComponent("" + registerDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRegisterDoi(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRegisterDoi(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetRegisterDoi(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getKurzels(withoutGroup: boolean | undefined, onlyCurrentSerial: boolean | undefined, onlyOnlineJournals: boolean | undefined): Observable<ApiJournalKurzel[]> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/kurzels?";
        if (withoutGroup === null)
            throw new Error("The parameter 'withoutGroup' cannot be null.");
        else if (withoutGroup !== undefined)
            url_ += "withoutGroup=" + encodeURIComponent("" + withoutGroup) + "&";
        if (onlyCurrentSerial === null)
            throw new Error("The parameter 'onlyCurrentSerial' cannot be null.");
        else if (onlyCurrentSerial !== undefined)
            url_ += "onlyCurrentSerial=" + encodeURIComponent("" + onlyCurrentSerial) + "&";
        if (onlyOnlineJournals === null)
            throw new Error("The parameter 'onlyOnlineJournals' cannot be null.");
        else if (onlyOnlineJournals !== undefined)
            url_ += "onlyOnlineJournals=" + encodeURIComponent("" + onlyOnlineJournals) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKurzels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKurzels(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiJournalKurzel[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiJournalKurzel[]>;
        }));
    }

    protected processGetKurzels(response: HttpResponseBase): Observable<ApiJournalKurzel[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiJournalKurzel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isNameAvailable(name: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/is-name-available?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsNameAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsNameAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsNameAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isIssnPrintNotUsed(value: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/is-issn-print-not-used?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsIssnPrintNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsIssnPrintNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsIssnPrintNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isIssnWebNotUsed(value: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/is-issn-web-not-used?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsIssnWebNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsIssnWebNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsIssnWebNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isIssnCdNotUsed(value: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/is-issn-cd-not-used?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsIssnCdNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsIssnCdNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsIssnCdNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isKurzelNotUsed(value: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/is-kurzel-not-used?";
        if (value !== undefined && value !== null)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsKurzelNotUsed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsKurzelNotUsed(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsKurzelNotUsed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getActivity(id: number): Observable<ApiActivity> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/activity";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiActivity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiActivity>;
        }));
    }

    protected processGetActivity(response: HttpResponseBase): Observable<ApiActivity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiActivity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDescription(id: number, apiModel: ApiJournalDescription): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/description";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDetails(id: number, apiModel: ApiJournalDetails): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class JournalTopicsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(id: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPublishingTopicListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/topics?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPublishingTopicListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPublishingTopicListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPublishingTopicListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPublishingTopicListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addTopic(id: number, topicId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/topics/{topicId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTopic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTopic(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddTopic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeTopic(id: number, topicId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/topics/{topicId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (topicId === undefined || topicId === null)
            throw new Error("The parameter 'topicId' must be defined.");
        url_ = url_.replace("{topicId}", encodeURIComponent("" + topicId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTopic(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTopic(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveTopic(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAvailableTopics(id: number, query: string | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/publishing/journals/{id}/topics/get-available-topics?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableTopics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableTopics(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processGetAvailableTopics(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IsbnsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(odataQuery: string | undefined): Observable<ApiPageResultOfApiExternalIsbnSetListItem> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns?";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiExternalIsbnSetListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiExternalIsbnSetListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiExternalIsbnSetListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiExternalIsbnSetListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createIsbnSet(model: ApiExternalIsbnSet): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateIsbnSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateIsbnSet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateIsbnSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getIsbnSetValidity(isbnsFrom: string | null | undefined, isbnsTo: string | null | undefined): Observable<ApiExternalIsbnSetValidity> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns/get-set-validity?";
        if (isbnsFrom !== undefined && isbnsFrom !== null)
            url_ += "isbnsFrom=" + encodeURIComponent("" + isbnsFrom) + "&";
        if (isbnsTo !== undefined && isbnsTo !== null)
            url_ += "isbnsTo=" + encodeURIComponent("" + isbnsTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsbnSetValidity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsbnSetValidity(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiExternalIsbnSetValidity>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiExternalIsbnSetValidity>;
        }));
    }

    protected processGetIsbnSetValidity(response: HttpResponseBase): Observable<ApiExternalIsbnSetValidity> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiExternalIsbnSetValidity.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeIsbnSet(setId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns/{setId}";
        if (setId === undefined || setId === null)
            throw new Error("The parameter 'setId' must be defined.");
        url_ = url_.replace("{setId}", encodeURIComponent("" + setId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveIsbnSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveIsbnSet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveIsbnSet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getIsbnSettings(): Observable<ApiIsbnSettings> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIsbnSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIsbnSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIsbnSettings>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIsbnSettings>;
        }));
    }

    protected processGetIsbnSettings(response: HttpResponseBase): Observable<ApiIsbnSettings> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiIsbnSettings.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateExternalIsbnMinimumNotificationLimit(limit: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns/notification-limit?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExternalIsbnMinimumNotificationLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExternalIsbnMinimumNotificationLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateExternalIsbnMinimumNotificationLimit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateMemo(memo: ApiText): Observable<void> {
        let url_ = this.baseUrl + "/api/main/publishing/isbns/memo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memo);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMemo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMemo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateMemo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    isEmailUnused(email: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/members/is-email-unused?";
        if (email !== undefined && email !== null)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsEmailUnused(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsEmailUnused(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsEmailUnused(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isOrcidIdUnused(orcidId: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/members/is-orcid-id-unused?";
        if (orcidId !== undefined && orcidId !== null)
            url_ += "orcidId=" + encodeURIComponent("" + orcidId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsOrcidIdUnused(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsOrcidIdUnused(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsOrcidIdUnused(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(titleId: number): Observable<ApiReviewerProjectInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/projects/{titleId}/info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerProjectInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerProjectInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiReviewerProjectInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiReviewerProjectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCover(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/projects/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCover(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReviewerReviewsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getReviewsList(titleId: number): Observable<ApiReviewerReviewListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReviewsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReviewsList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerReviewListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerReviewListItem[]>;
        }));
    }

    protected processGetReviewsList(response: HttpResponseBase): Observable<ApiReviewerReviewListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiReviewerReviewListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReview(titleId: number, reviewId: number): Observable<ApiReviewerReview> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerReview>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerReview>;
        }));
    }

    protected processGetReview(response: HttpResponseBase): Observable<ApiReviewerReview> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiReviewerReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateReview(titleId: number, reviewId: number, review: ApiReviewReport): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(review);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadCurrentPdf(titleId: number, reviewId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/download-pdf";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCurrentPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCurrentPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCurrentPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/reviews/attachment/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetAttachmentValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addAttachmentUrl(titleId: number, reviewId: number, attachment: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/attachment";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (reviewId === undefined || reviewId === null)
                            throw new Error("The parameter 'reviewId' must be defined.");
                        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addAttachment(titleId: number, reviewId: number, attachment: FileParameter | null | undefined): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/attachment";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment !== null && attachment !== undefined)
            content_.append("attachment", attachment.data, attachment.fileName ? attachment.fileName : "attachment");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processAddAttachment(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentFile(titleId: number, reviewId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/attachment";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachmentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteAttachment(titleId: number, reviewId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/attachment";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    submitReview(titleId: number, reviewId: number, review: ApiReviewReport): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/project/{titleId}/reviews/{reviewId}/submit";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(review);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSubmitReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReviewersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getProjectsSummary(): Observable<ApiReviewerProjectsSummary> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/projects-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerProjectsSummary>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerProjectsSummary>;
        }));
    }

    protected processGetProjectsSummary(response: HttpResponseBase): Observable<ApiReviewerProjectsSummary> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiReviewerProjectsSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getProjectsInProgress(): Observable<ApiReviewerProject[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/projects-in-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerProject[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerProject[]>;
        }));
    }

    protected processGetProjectsInProgress(response: HttpResponseBase): Observable<ApiReviewerProject[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiReviewerProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPublishedProjects(): Observable<ApiReviewerProject[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/published-projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiReviewerProject[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiReviewerProject[]>;
        }));
    }

    protected processGetPublishedProjects(response: HttpResponseBase): Observable<ApiReviewerProject[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiReviewerProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setFirstReviewerLogin(): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/reviewer/set-first-reviewer-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFirstReviewerLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFirstReviewerLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetFirstReviewerLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorBulkMembersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getXlsValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/xls-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetXlsValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetXlsValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetXlsValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            getBulkMembersValidationUrl(titleId: number, participantType: ParticipantTypeEnum | undefined, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/{titleId}/members-validation?";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (participantType === null)
                            throw new Error("The parameter 'participantType' cannot be null.");
                        else if (participantType !== undefined)
                            url_ += "participantType=" + encodeURIComponent("" + participantType) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    getBulkMembersValidation(titleId: number, participantType: ParticipantTypeEnum | undefined, file: FileParameter | null | undefined): Observable<ApiBulkMembersValidation> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/{titleId}/members-validation?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (participantType === null)
            throw new Error("The parameter 'participantType' cannot be null.");
        else if (participantType !== undefined)
            url_ += "participantType=" + encodeURIComponent("" + participantType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBulkMembersValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBulkMembersValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiBulkMembersValidation>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiBulkMembersValidation>;
        }));
    }

    protected processGetBulkMembersValidation(response: HttpResponseBase): Observable<ApiBulkMembersValidation> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiBulkMembersValidation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            parseXlsBulkFileUrl(file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/parse";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    parseXlsBulkFile(file: FileParameter | null | undefined): Observable<ApiBulkMembers> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/parse";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParseXlsBulkFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParseXlsBulkFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiBulkMembers>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiBulkMembers>;
        }));
    }

    protected processParseXlsBulkFile(response: HttpResponseBase): Observable<ApiBulkMembers> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiBulkMembers.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadBulkExample(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/bulk/example";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBulkExample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBulkExample(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBulkExample(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolPaperAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(paperId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getExistingParsedAuthors(paperId: number): Observable<ApiEditingToolParsedAuthor[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/parsed-authors/existing";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingParsedAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingParsedAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolParsedAuthor[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolParsedAuthor[]>;
        }));
    }

    protected processGetExistingParsedAuthors(response: HttpResponseBase): Observable<ApiEditingToolParsedAuthor[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolParsedAuthor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getNewParsedAuthors(paperId: number): Observable<ApiEditingToolParsedAuthor[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/parsed-authors/new";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewParsedAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewParsedAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolParsedAuthor[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolParsedAuthor[]>;
        }));
    }

    protected processGetNewParsedAuthors(response: HttpResponseBase): Observable<ApiEditingToolParsedAuthor[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolParsedAuthor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteParsedAuthor(paperId: number, parsedAuthorId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/parsed-authors/{parsedAuthorId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (parsedAuthorId === undefined || parsedAuthorId === null)
            throw new Error("The parameter 'parsedAuthorId' must be defined.");
        url_ = url_.replace("{parsedAuthorId}", encodeURIComponent("" + parsedAuthorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExistingParsedAuthor(paperId: number, parsedAuthor: ApiEditingToolExistingParsedAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/parsed-authors/add-existing";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parsedAuthor);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExistingParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExistingParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExistingParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNewParsedAuthor(paperId: number, parsedAuthor: ApiEditingToolParsedAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/parsed-authors/add-new";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parsedAuthor);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddNewParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExistingAuthors(paperId: number, authorIdArray: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/existing-authors";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorIdArray);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExistingAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExistingAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExistingAuthors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createAuthor(paperId: number, apiModel: ApiEditingToolCreateAuthorRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/create-author";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNewAuthor(paperId: number, apiModel: ApiEditingToolPaperAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/add-author";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddNewAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeAuthor(paperId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/{memberId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAffiliation(paperId: number, memberId: number): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/{memberId}/affiliation";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffiliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffiliation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processGetAffiliation(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findAuthors(paperId: number, query: string | null | undefined): Observable<ApiEditingToolFoundMember[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/authors/find-authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolFoundMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolFoundMember[]>;
        }));
    }

    protected processFindAuthors(response: HttpResponseBase): Observable<ApiEditingToolFoundMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolFoundMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperChecklistsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number): Observable<ApiPaperChecklist> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/checklist";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperChecklist>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperChecklist>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperChecklist> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperChecklist.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperCommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/comments/list";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCount(paperId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/comments/count";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/comments";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, noteId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(paperId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperCopyrightClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number): Observable<ApiPaperCopyright> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/copyright";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperCopyright>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperCopyright>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperCopyright> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperCopyright.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCopyrightFile(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/copyright/download";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCopyrightFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCopyrightFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCopyrightFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperEditorCommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/editor-comments/list";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/editor-comments";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, noteId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/editor-comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(paperId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/editor-comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperKeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/keywords?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPeriodicalKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(paperId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/keywords/add";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiKeywordCreateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/keywords/create-and-add";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(paperId: number, keywordId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/keywords/{keywordId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (keywordId === undefined || keywordId === null)
            throw new Error("The parameter 'keywordId' must be defined.");
        url_ = url_.replace("{keywordId}", encodeURIComponent("" + keywordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    lookupKeywords(paperId: number, query: string | null | undefined, excludeIds: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/keywords/lookup?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processLookupKeywords(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperReferencesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolReferenceListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/references?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolReferenceListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolReferenceListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolReferenceListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolReferenceListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, model: ApiEditingToolReferenceListItem): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/references";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/references/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            reUploadUrl(paperId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/references/re-upload";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    reUpload(paperId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/references/re-upload";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperReviewersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    checkHasReviewers(paperId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/reviewers/check-has-reviewers";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHasReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHasReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckHasReviewers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorPaperReviewerListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/reviewers?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorPaperReviewerListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorPaperReviewerListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorPaperReviewerListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorPaperReviewerListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignReviewers(paperId: number, memberIdArray: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/reviewers";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(memberIdArray);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignReviewers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    cancelAssignment(paperId: number, reviewId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/reviewers/{reviewId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCancelAssignment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getUnassignedList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorPaperUnassignedReviewerListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/reviewers/unassigned?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorPaperUnassignedReviewerListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorPaperUnassignedReviewerListItem>;
        }));
    }

    protected processGetUnassignedList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorPaperUnassignedReviewerListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorPaperUnassignedReviewerListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperReviewsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    cancelReview(paperId: number, reviewId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCancelReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getReview(paperId: number, reviewId: number): Observable<ApiEditorReview> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorReview>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorReview>;
        }));
    }

    protected processGetReview(response: HttpResponseBase): Observable<ApiEditorReview> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/reviews/attachment/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetAttachmentValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addAttachmentUrl(paperId: number, reviewId: number, attachment: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/attachment";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        if (reviewId === undefined || reviewId === null)
                            throw new Error("The parameter 'reviewId' must be defined.");
                        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addAttachment(paperId: number, reviewId: number, attachment: FileParameter | null | undefined): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (attachment !== null && attachment !== undefined)
            content_.append("attachment", attachment.data, attachment.fileName ? attachment.fileName : "attachment");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processAddAttachment(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentFile(paperId: number, reviewId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachmentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteAttachment(paperId: number, reviewId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    approveReview(paperId: number, reviewId: number, review: ApiReviewReport): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/approve";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(review);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processApproveReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    sendForReReview(paperId: number, reviewId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/{paperId}/reviews/{reviewId}/send-for-rereview";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendForReReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendForReReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSendForReReview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(paperId: number): Observable<ApiEditingToolPaperInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/info";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolPaperInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolPaperInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiEditingToolPaperInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditingToolPaperInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperDetails(paperId: number): Observable<ApiEditorPaperDetails> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/details";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorPaperDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorPaperDetails>;
        }));
    }

    protected processGetPaperDetails(response: HttpResponseBase): Observable<ApiEditorPaperDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorPaperDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePaperDetails(paperId: number, model: ApiEditorPaperDetailsUpdate): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/update";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaperDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaperDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePaperDetails(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            createFromFilesUrl(titleId: number, files: any[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/create-from-files";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    createFromFiles(titleId: number, files: any[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/create-from-files";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processCreateFromFiles(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addFilesUrl(paperId: number, files: any[] | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/add-files";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addFiles(paperId: number, files: any[] | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/add-files";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.toString()));

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddFiles(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/doc-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetDocValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPdfValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/pdf-validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdfValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdfValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetPdfValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFilesHistory(paperId: number): Observable<ApiPaperDocumentFileInfo[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/files-history";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperDocumentFileInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperDocumentFileInfo[]>;
        }));
    }

    protected processGetFilesHistory(response: HttpResponseBase): Observable<ApiPaperDocumentFileInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPaperDocumentFileInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocument(paperId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/documents/{documentId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getHistory(paperId: number): Observable<ApiPaperHistoryEntry[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/history";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperHistoryEntry[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperHistoryEntry[]>;
        }));
    }

    protected processGetHistory(response: HttpResponseBase): Observable<ApiPaperHistoryEntry[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPaperHistoryEntry.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperSupplementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperSupplementListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateSupplement(paperId: number, supplementId: number | undefined, model: ApiPaperSupplement): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === null)
            throw new Error("The parameter 'supplementId' cannot be null.");
        else if (supplementId !== undefined)
            url_ += "supplementId=" + encodeURIComponent("" + supplementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(paperId: number, supplementId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/{supplementId}/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementFile(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementLink(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/link";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadSupplementFileUrl(paperId: number, supplementId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/{supplementId}/file-upload";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        if (supplementId === undefined || supplementId === null)
                            throw new Error("The parameter 'supplementId' must be defined.");
                        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadSupplementFile(paperId: number, supplementId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/{supplementId}/file-upload";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadSupplementFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeSupplement(paperId: number, supplementId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/{paperId}/supplements/{supplementId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/papers/supplements/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorPaperTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    downloadDocxTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/templates/download-docx-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocxTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocxTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocxTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadLatexTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/templates/download-latex-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLatexTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLatexTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLatexTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getLatexOnOverleafUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/papers/templates/latex-on-overleaf-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatexOnOverleafUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatexOnOverleafUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string>;
        }));
    }

    protected processGetLatexOnOverleafUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectChaptersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorChapterListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters/list?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorChapterListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorChapterListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorChapterListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorChapterListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getChapters(titleId: number): Observable<ApiEditorChapter[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChapters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChapters(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorChapter[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorChapter[]>;
        }));
    }

    protected processGetChapters(response: HttpResponseBase): Observable<ApiEditorChapter[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditorChapter.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, model: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getUnassignedPapersCount(titleId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters/unassigned-papers-count";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedPapersCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedPapersCount(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processGetUnassignedPapersCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters/update-pos";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, chapterId: number, updatedChapter: ApiChapter): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters/{chapterId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updatedChapter);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, chapterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/chapters/{chapterId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectChecklistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getChecklist(titleId: number): Observable<ApiTitleEditorChecklist> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/checklist";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleEditorChecklist>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleEditorChecklist>;
        }));
    }

    protected processGetChecklist(response: HttpResponseBase): Observable<ApiTitleEditorChecklist> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleEditorChecklist.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    submitChecklist(titleId: number, apiModel: ApiTitleEditorChecklist): Observable<ApiTitleEditorChecklist> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/checklist";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitChecklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitChecklist(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleEditorChecklist>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleEditorChecklist>;
        }));
    }

    protected processSubmitChecklist(response: HttpResponseBase): Observable<ApiTitleEditorChecklist> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiTitleEditorChecklist.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectCommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(titleId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/comments/list";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/comments";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(titleId: number, noteId: number, apiModel: ApiNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/comments/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(titleId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/comments/{noteId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectContentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getKeywordIndex(titleId: number): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/keyword-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKeywordIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKeywordIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processGetKeywordIndex(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteKeywordIndex(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/keyword-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteKeywordIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteKeywordIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteKeywordIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateKeywordIndex(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/generate-keyword-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateKeywordIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateKeywordIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateKeywordIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadKeywordIndex(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/download-keyword-index";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadKeywordIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadKeywordIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadKeywordIndex(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getTableOfContents(titleId: number): Observable<ApiFileInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/table-of-contents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTableOfContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableOfContents(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiFileInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiFileInfo>;
        }));
    }

    protected processGetTableOfContents(response: HttpResponseBase): Observable<ApiFileInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiFileInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteTableOfContents(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/table-of-contents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTableOfContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTableOfContents(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTableOfContents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    generateTableOfContents(titleId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/generate-table-of-contents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateTableOfContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateTableOfContents(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processGenerateTableOfContents(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadTableOfContents(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/contents/download-table-of-contents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTableOfContents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTableOfContents(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTableOfContents(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectCorrespondingAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiCorrespondingAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiCorrespondingAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiCorrespondingAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiCorrespondingAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiCorrespondingAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addCorrespondingAuthors(titleId: number, apiModels: ApiAddCorrespondingAuthorRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCorrespondingAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCorrespondingAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddCorrespondingAuthors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findCorrespondingAuthors(titleId: number, query: string | null | undefined): Observable<ApiEditingToolFoundMember[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/find?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindCorrespondingAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindCorrespondingAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolFoundMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolFoundMember[]>;
        }));
    }

    protected processFindCorrespondingAuthors(response: HttpResponseBase): Observable<ApiEditingToolFoundMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolFoundMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addCorrespondingAuthorsBulk(titleId: number, apiModels: ApiAddCorrespondingAuthorRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/add-bulk";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCorrespondingAuthorsBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCorrespondingAuthorsBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddCorrespondingAuthorsBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    hasCorrespondingAuthors(titleId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/has-any";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasCorrespondingAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasCorrespondingAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processHasCorrespondingAuthors(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateAuthorCode(titleId: number, memberId: number, apiModel: ApiAuthorCode): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/{memberId}/code";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAuthorCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAuthorCode(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAuthorCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateLimitUploads(titleId: number, memberId: number, apiModel: ApiAuthorLimitUploads): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/corresponding-authors/{memberId}/limit-uploads";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLimitUploads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLimitUploads(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLimitUploads(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectCoversClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCover(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCover(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectCoverSuggestionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getCoverSuggestions(titleId: number): Observable<ApiTitleCoverSuggestion[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover-suggestions";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverSuggestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverSuggestions(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiTitleCoverSuggestion[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiTitleCoverSuggestion[]>;
        }));
    }

    protected processGetCoverSuggestions(response: HttpResponseBase): Observable<ApiTitleCoverSuggestion[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiTitleCoverSuggestion.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addCoverSuggestionUrl(titleId: number, coverSuggestion: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover-suggestions";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addCoverSuggestion(titleId: number, coverSuggestion: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover-suggestions";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (coverSuggestion !== null && coverSuggestion !== undefined)
            content_.append("coverSuggestion", coverSuggestion.data, coverSuggestion.fileName ? coverSuggestion.fileName : "coverSuggestion");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCoverSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCoverSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddCoverSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCoverSuggestionFile(titleId: number, coverSuggestionId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover-suggestions/{coverSuggestionId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (coverSuggestionId === undefined || coverSuggestionId === null)
            throw new Error("The parameter 'coverSuggestionId' must be defined.");
        url_ = url_.replace("{coverSuggestionId}", encodeURIComponent("" + coverSuggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCoverSuggestionFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCoverSuggestionFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCoverSuggestionFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteCoverSuggestion(titleId: number, coverSuggestionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/cover-suggestions/{coverSuggestionId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (coverSuggestionId === undefined || coverSuggestionId === null)
            throw new Error("The parameter 'coverSuggestionId' must be defined.");
        url_ = url_.replace("{coverSuggestionId}", encodeURIComponent("" + coverSuggestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCoverSuggestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCoverSuggestion(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCoverSuggestion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/cover-suggestions/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getDocuments(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiTitleDocument> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiTitleDocument>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiTitleDocument>;
        }));
    }

    protected processGetDocuments(response: HttpResponseBase): Observable<ApiPageResultOfApiTitleDocument> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiTitleDocument.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            addDocumentUrl(titleId: number, name: string | null | undefined, document: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents?";
                        if (titleId === undefined || titleId === null)
                            throw new Error("The parameter 'titleId' must be defined.");
                        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
                        if (name !== undefined && name !== null)
                            url_ += "name=" + encodeURIComponent("" + name) + "&";
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    addDocument(titleId: number, name: string | null | undefined, document: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (document !== null && document !== undefined)
            content_.append("document", document.data, document.fileName ? document.fileName : "document");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDocumentFile(titleId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents/{documentId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDocumentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDocumentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetDocumentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteDocument(titleId: number, documentId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/documents/{documentId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteDocument(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/documents/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectKeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/keywords?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPeriodicalKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(titleId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/keywords/add";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(titleId: number, apiModel: ApiKeywordCreateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/keywords/create-and-add";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(titleId: number, keywordId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/keywords/{keywordId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (keywordId === undefined || keywordId === null)
            throw new Error("The parameter 'keywordId' must be defined.");
        url_ = url_.replace("{keywordId}", encodeURIComponent("" + keywordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    lookupKeywords(titleId: number, query: string | null | undefined, excludeIds: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/keywords/lookup?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processLookupKeywords(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectPapersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorProjectPaperListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorProjectPaperListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorProjectPaperListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorProjectPaperListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorProjectPaperListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getInfo(titleId: number): Observable<ApiEditorProjectPapersInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProjectPapersInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProjectPapersInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiEditorProjectPapersInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorProjectPapersInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getEditorList(titleId: number): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/editor-list";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditorList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditorList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetEditorList(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getChapterList(titleId: number): Observable<ApiIdNameItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/chapter-list";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChapterList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChapterList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiIdNameItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiIdNameItem[]>;
        }));
    }

    protected processGetChapterList(response: HttpResponseBase): Observable<ApiIdNameItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateStatus(titleId: number, paperId: number, status: PaperStatusEnum): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/{paperId}/update-status/{status}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignChapter(titleId: number, paperId: number, chapterId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/{paperId}/assign-chapter/{chapterId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (chapterId === undefined || chapterId === null)
            throw new Error("The parameter 'chapterId' must be defined.");
        url_ = url_.replace("{chapterId}", encodeURIComponent("" + chapterId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignChapter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignChapter(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignChapter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    unassignChapter(titleId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/{paperId}/unassign-chapter";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignChapter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignChapter(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUnassignChapter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    assignEditor(titleId: number, paperId: number, editorId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/{paperId}/assign-editor/{editorId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (editorId === undefined || editorId === null)
            throw new Error("The parameter 'editorId' must be defined.");
        url_ = url_.replace("{editorId}", encodeURIComponent("" + editorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignEditor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignEditor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignEditor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    unassignEditor(titleId: number, paperId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/{paperId}/unassign-editor";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassignEditor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassignEditor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUnassignEditor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperPositionsList(titleId: number, chapterId: number | null | undefined, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditorPaperPositionListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/positions?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (chapterId !== undefined && chapterId !== null)
            url_ += "chapterId=" + encodeURIComponent("" + chapterId) + "&";
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperPositionsList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperPositionsList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditorPaperPositionListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditorPaperPositionListItem>;
        }));
    }

    protected processGetPaperPositionsList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditorPaperPositionListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditorPaperPositionListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(titleId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/papers/positions";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectReviewersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(titleId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolEditorReviewerListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolEditorReviewerListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolEditorReviewerListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolEditorReviewerListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolEditorReviewerListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addReviewers(titleId: number, apiModels: ApiAddReviewerRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddReviewers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    titleHasReviewers(titleId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/title-has-reviewers";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTitleHasReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTitleHasReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processTitleHasReviewers(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findReviewers(titleId: number, query: string | null | undefined): Observable<ApiEditingToolFoundMember[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/find?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindReviewers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindReviewers(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolFoundMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolFoundMember[]>;
        }));
    }

    protected processFindReviewers(response: HttpResponseBase): Observable<ApiEditingToolFoundMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolFoundMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addReviewersBulk(titleId: number, apiModels: ApiAddReviewerRequest[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/add-bulk";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModels);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddReviewersBulk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddReviewersBulk(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddReviewersBulk(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeReviewer(titleId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveReviewer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveReviewer(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveReviewer(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateReviewerNote(titleId: number, memberId: number, apiModel: ApiReviewerNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/{memberId}/note";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReviewerNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReviewerNote(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateReviewerNote(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorReviewerReviewsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    assignReviews(titleId: number, memberId: number, paperIdArray: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/{memberId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paperIdArray);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignReviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignReviews(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAssignReviews(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAssignedReviewList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolAssignedReviewListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/{memberId}/assigned-reviews?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssignedReviewList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedReviewList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolAssignedReviewListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolAssignedReviewListItem>;
        }));
    }

    protected processGetAssignedReviewList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolAssignedReviewListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolAssignedReviewListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getUnassignedReviewList(titleId: number, memberId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolUnassignedReviewListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/reviewers/{memberId}/unassigned-reviews?";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedReviewList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedReviewList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolUnassignedReviewListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolUnassignedReviewListItem>;
        }));
    }

    protected processGetUnassignedReviewList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolUnassignedReviewListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolUnassignedReviewListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInfo(titleId: number): Observable<ApiEditorProjectInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProjectInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProjectInfo>;
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<ApiEditorProjectInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorProjectInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getDescription(titleId: number): Observable<ApiText> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/description";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiText>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiText>;
        }));
    }

    protected processGetDescription(response: HttpResponseBase): Observable<ApiText> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiText.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateDescription(titleId: number, apiModel: ApiText): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/description";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorProjectSettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getPeriod(titleId: number): Observable<ApiEditorProjectPeriod> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/settings/period";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProjectPeriod>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProjectPeriod>;
        }));
    }

    protected processGetPeriod(response: HttpResponseBase): Observable<ApiEditorProjectPeriod> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorProjectPeriod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updatePeriod(titleId: number, apiModel: ApiEditorProjectPeriod): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/settings/period";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePeriod(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getConferenceInfo(titleId: number): Observable<ApiEditorConferenceInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects/{titleId}/settings/conference-info";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConferenceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConferenceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorConferenceInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorConferenceInfo>;
        }));
    }

    protected processGetConferenceInfo(response: HttpResponseBase): Observable<ApiEditorConferenceInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorConferenceInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EditorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getProjectsSummary(): Observable<ApiEditorProjectsSummary> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProjectsSummary>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProjectsSummary>;
        }));
    }

    protected processGetProjectsSummary(response: HttpResponseBase): Observable<ApiEditorProjectsSummary> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiEditorProjectsSummary.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getProjectsInProgress(): Observable<ApiEditorProject[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/projects-in-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsInProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsInProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProject[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProject[]>;
        }));
    }

    protected processGetProjectsInProgress(response: HttpResponseBase): Observable<ApiEditorProject[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditorProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPublishedProjects(): Observable<ApiEditorProject[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/published-projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditorProject[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditorProject[]>;
        }));
    }

    protected processGetPublishedProjects(response: HttpResponseBase): Observable<ApiEditorProject[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditorProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setFirstEditorLogin(): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/set-first-editor-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFirstEditorLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFirstEditorLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetFirstEditorLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getMemberInfo(memberId: number): Observable<ApiMemberInfo> {
        let url_ = this.baseUrl + "/api/main/editing-tool/editor/member-info/{memberId}";
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberInfo>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberInfo>;
        }));
    }

    protected processGetMemberInfo(response: HttpResponseBase): Observable<ApiMemberInfo> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperAuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolPaperAuthorListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolPaperAuthorListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateOrder(paperId: number, positionData: ApiListItemPosition[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(positionData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateOrder(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getExistingParsedAuthors(paperId: number): Observable<ApiEditingToolParsedAuthor[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/parsed-authors/existing";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExistingParsedAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExistingParsedAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolParsedAuthor[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolParsedAuthor[]>;
        }));
    }

    protected processGetExistingParsedAuthors(response: HttpResponseBase): Observable<ApiEditingToolParsedAuthor[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolParsedAuthor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getNewParsedAuthors(paperId: number): Observable<ApiEditingToolParsedAuthor[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/parsed-authors/new";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewParsedAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewParsedAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolParsedAuthor[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolParsedAuthor[]>;
        }));
    }

    protected processGetNewParsedAuthors(response: HttpResponseBase): Observable<ApiEditingToolParsedAuthor[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolParsedAuthor.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    deleteParsedAuthor(paperId: number, parsedAuthorId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/parsed-authors/{parsedAuthorId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (parsedAuthorId === undefined || parsedAuthorId === null)
            throw new Error("The parameter 'parsedAuthorId' must be defined.");
        url_ = url_.replace("{parsedAuthorId}", encodeURIComponent("" + parsedAuthorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExistingParsedAuthor(paperId: number, parsedAuthor: ApiEditingToolExistingParsedAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/parsed-authors/add-existing";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parsedAuthor);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExistingParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExistingParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExistingParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNewParsedAuthor(paperId: number, parsedAuthor: ApiEditingToolParsedAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/parsed-authors/add-new";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parsedAuthor);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewParsedAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewParsedAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddNewParsedAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addExistingAuthors(paperId: number, authorIdArray: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/existing-authors";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authorIdArray);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddExistingAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddExistingAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddExistingAuthors(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    createAuthor(paperId: number, apiModel: ApiEditingToolCreateAuthorRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/create-author";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreateAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addNewAuthor(paperId: number, apiModel: ApiEditingToolPaperAuthor): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/add-author";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAddNewAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeAuthor(paperId: number, memberId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/{memberId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveAuthor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAffiliation(paperId: number, memberId: number): Observable<ApiMemberAddressDetails> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/{memberId}/affiliation";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (memberId === undefined || memberId === null)
            throw new Error("The parameter 'memberId' must be defined.");
        url_ = url_.replace("{memberId}", encodeURIComponent("" + memberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAffiliation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAffiliation(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiMemberAddressDetails>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiMemberAddressDetails>;
        }));
    }

    protected processGetAffiliation(response: HttpResponseBase): Observable<ApiMemberAddressDetails> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiMemberAddressDetails.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    findAuthors(paperId: number, query: string | null | undefined): Observable<ApiEditingToolFoundMember[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/authors/find-authors?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindAuthors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindAuthors(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiEditingToolFoundMember[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiEditingToolFoundMember[]>;
        }));
    }

    protected processFindAuthors(response: HttpResponseBase): Observable<ApiEditingToolFoundMember[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiEditingToolFoundMember.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperChecklistsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number): Observable<ApiPaperChecklist> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/checklist";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperChecklist>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperChecklist>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperChecklist> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperChecklist.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, items: ApiChecklistItem[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/checklist";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperCommentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number): Observable<ApiNoteListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/comments/list";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNoteListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNoteListItem[]>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiNoteListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCount(paperId: number): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/comments/count";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCount(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processGetCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/comments";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, noteId: number, apiModel: ApiPaperNote): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    delete(paperId: number, noteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/comments/{noteId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (noteId === undefined || noteId === null)
            throw new Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperCopyrightClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number): Observable<ApiPaperCopyright> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/copyright";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperCopyright>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperCopyright>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiPaperCopyright> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPaperCopyright.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, model: ApiPaperCopyrightSubmit): Observable<ApiPaperCopyright> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/copyright";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperCopyright>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperCopyright>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiPaperCopyright> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ApiPaperCopyright.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCopyrightFile(paperId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/copyright/download";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCopyrightFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCopyrightFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCopyrightFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperDocumentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    get(paperId: number, documentId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/documents/{documentId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperFilesHistoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number): Observable<ApiPaperDocumentFileInfo[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/files-history";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPaperDocumentFileInfo[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPaperDocumentFileInfo[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPaperDocumentFileInfo[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiPaperDocumentFileInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperKeywordsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    list(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/keywords?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPeriodicalKeywordListItem>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<ApiPageResultOfApiPeriodicalKeywordListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPeriodicalKeywordListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    add(paperId: number, keywordIds: number[]): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/keywords/add";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keywordIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    create(paperId: number, apiModel: ApiKeywordCreateRequest): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/keywords/create-and-add";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(apiModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    remove(paperId: number, keywordId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/keywords/{keywordId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (keywordId === undefined || keywordId === null)
            throw new Error("The parameter 'keywordId' must be defined.");
        url_ = url_.replace("{keywordId}", encodeURIComponent("" + keywordId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    lookupKeywords(paperId: number, query: string | null | undefined, excludeIds: number[] | null | undefined): Observable<ApiNamedListItem[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/keywords/lookup?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (excludeIds !== undefined && excludeIds !== null)
            excludeIds && excludeIds.forEach(item => { url_ += "excludeIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLookupKeywords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLookupKeywords(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiNamedListItem[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiNamedListItem[]>;
        }));
    }

    protected processLookupKeywords(response: HttpResponseBase): Observable<ApiNamedListItem[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperReferencesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiEditingToolReferenceListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/references?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiEditingToolReferenceListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiEditingToolReferenceListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiEditingToolReferenceListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiEditingToolReferenceListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    update(paperId: number, model: ApiEditingToolReferenceListItem): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/references";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/references/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            reUploadUrl(paperId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/references/re-upload";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    reUpload(paperId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/references/re-upload";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processReUpload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperReviewsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getReview(paperId: number, reviewId: number): Observable<ApiAuthorReview> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/reviews/{reviewId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReview(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorReview>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorReview>;
        }));
    }

    protected processGetReview(response: HttpResponseBase): Observable<ApiAuthorReview> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAuthorReview.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getAttachmentFile(paperId: number, reviewId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/reviews/{reviewId}/attachment";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (reviewId === undefined || reviewId === null)
            throw new Error("The parameter 'reviewId' must be defined.");
        url_ = url_.replace("{reviewId}", encodeURIComponent("" + reviewId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAttachmentFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAttachmentFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAttachmentFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperSupplementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getList(paperId: number, odataQuery: string | undefined): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (odataQuery === null)
            throw new Error("The parameter 'odataQuery' cannot be null.");
        else if (odataQuery !== undefined)
            url_ += odataQuery.replace("?", "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiPageResultOfApiPaperSupplementListItem>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ApiPageResultOfApiPaperSupplementListItem> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiPageResultOfApiPaperSupplementListItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    updateSupplement(paperId: number, supplementId: number | undefined, model: ApiPaperSupplement): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements?";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === null)
            throw new Error("The parameter 'supplementId' cannot be null.");
        else if (supplementId !== undefined)
            url_ += "supplementId=" + encodeURIComponent("" + supplementId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUpdateSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getFile(paperId: number, supplementId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/{supplementId}/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementFile(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/file";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementFile(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    addSupplementLink(paperId: number, model: ApiPaperSupplement): Observable<number> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/link";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddSupplementLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddSupplementLink(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<number>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<number>;
        }));
    }

    protected processAddSupplementLink(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

            uploadSupplementFileUrl(paperId: number, supplementId: number, file: FileParameter | null | undefined): string {
            
            let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/{supplementId}/file-upload";
                        if (paperId === undefined || paperId === null)
                            throw new Error("The parameter 'paperId' must be defined.");
                        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
                        if (supplementId === undefined || supplementId === null)
                            throw new Error("The parameter 'supplementId' must be defined.");
                        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
                        url_ = url_.replace(/[?&]$/, "");

            return url_;
        }

    

    uploadSupplementFile(paperId: number, supplementId: number, file: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/{supplementId}/file-upload";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSupplementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSupplementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processUploadSupplementFile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null as any;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    removeSupplement(paperId: number, supplementId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/{paperId}/supplements/{supplementId}";
        if (paperId === undefined || paperId === null)
            throw new Error("The parameter 'paperId' must be defined.");
        url_ = url_.replace("{paperId}", encodeURIComponent("" + paperId));
        if (supplementId === undefined || supplementId === null)
            throw new Error("The parameter 'supplementId' must be defined.");
        url_ = url_.replace("{supplementId}", encodeURIComponent("" + supplementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveSupplement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveSupplement(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processRemoveSupplement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getValidationRules(): Observable<FileValidationModel> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/supplements/validation-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetValidationRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetValidationRules(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileValidationModel>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileValidationModel>;
        }));
    }

    protected processGetValidationRules(response: HttpResponseBase): Observable<FileValidationModel> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileValidationModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorPaperTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    downloadDocxTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/templates/download-docx-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadDocxTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadDocxTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadDocxTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    downloadLatexTemplate(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/templates/download-latex-template";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadLatexTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadLatexTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadLatexTemplate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getLatexOnOverleafUrl(): Observable<string> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers/templates/latex-on-overleaf-url";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatexOnOverleafUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatexOnOverleafUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<string>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<string>;
        }));
    }

    protected processGetLatexOnOverleafUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getAuthorProjects(): Observable<ApiAuthorProject[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthorProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthorProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorProject[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorProject[]>;
        }));
    }

    protected processGetAuthorProjects(response: HttpResponseBase): Observable<ApiAuthorProject[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuthorProject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getProject(titleId: number): Observable<ApiAuthorProject> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/projects/{titleId}";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProject(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorProject>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorProject>;
        }));
    }

    protected processGetProject(response: HttpResponseBase): Observable<ApiAuthorProject> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAuthorProject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getCover(titleId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/projects/{titleId}/cover";
        if (titleId === undefined || titleId === null)
            throw new Error("The parameter 'titleId' must be defined.");
        url_ = url_.replace("{titleId}", encodeURIComponent("" + titleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCover(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetCover(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AuthorsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: (key: string, value: any) => any = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

        

    getInProgressPapersList(): Observable<ApiAuthorPaper[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/titles/papers-in-progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInProgressPapersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInProgressPapersList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorPaper[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorPaper[]>;
        }));
    }

    protected processGetInProgressPapersList(response: HttpResponseBase): Observable<ApiAuthorPaper[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuthorPaper.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPublishedPapersList(): Observable<ApiAuthorPaper[]> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/titles/papers-published";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPublishedPapersList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPublishedPapersList(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorPaper[]>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorPaper[]>;
        }));
    }

    protected processGetPublishedPapersList(response: HttpResponseBase): Observable<ApiAuthorPaper[]> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiAuthorPaper.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    getPaperCount(): Observable<ApiAuthorPapersCount> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/papers-count";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaperCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaperCount(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<ApiAuthorPapersCount>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<ApiAuthorPapersCount>;
        }));
    }

    protected processGetPaperCount(response: HttpResponseBase): Observable<ApiAuthorPapersCount> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApiAuthorPapersCount.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    setFirstAuthorLogin(): Observable<void> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/set-first-author-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetFirstAuthorLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetFirstAuthorLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<void>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<void>;
        }));
    }

    protected processSetFirstAuthorLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    haveLoggedAsAuthor(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/have-logged-as-author";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHaveLoggedAsAuthor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHaveLoggedAsAuthor(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processHaveLoggedAsAuthor(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

        

    isSubmitAvailable(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/main/editing-tool/author/is-submit-available";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsSubmitAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsSubmitAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(() => e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(() => response_) as any as Observable<boolean>;
        }));
    }

    protected processIsSubmitAvailable(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        let responseBlob;
        if (typeof window === 'undefined') {
             responseBlob =
                response instanceof HttpResponse ? response.body : undefined;
        } else {
            responseBlob =
                response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;
        }

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class VersionInfo implements IVersionInfo {
    version?: string | null;
    buildUri?: string | null;
    commitHash?: string | null;
    commitDate?: Date | null;
    commitMessage?: string | null;

    constructor(data?: IVersionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.buildUri = _data["buildUri"] !== undefined ? _data["buildUri"] : null as any;
            this.commitHash = _data["commitHash"] !== undefined ? _data["commitHash"] : null as any;
            this.commitDate = _data["commitDate"] ? new Date(_data["commitDate"].toString()) : null as any;
            this.commitMessage = _data["commitMessage"] !== undefined ? _data["commitMessage"] : null as any;
        }
    }

    static fromJS(data: any): VersionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new VersionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["buildUri"] = this.buildUri !== undefined ? this.buildUri : null as any;
        data["commitHash"] = this.commitHash !== undefined ? this.commitHash : null as any;
        data["commitDate"] = this.commitDate ? this.commitDate.toISOString() : null as any;
        data["commitMessage"] = this.commitMessage !== undefined ? this.commitMessage : null as any;
        return data;
    }
}

export interface IVersionInfo {
    version?: string | null;
    buildUri?: string | null;
    commitHash?: string | null;
    commitDate?: Date | null;
    commitMessage?: string | null;
}

export class ApiPageResultOfApiTitleInProgressListItem implements IApiPageResultOfApiTitleInProgressListItem {
    items?: ApiTitleInProgressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleInProgressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleInProgressListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleInProgressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleInProgressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleInProgressListItem {
    items?: ApiTitleInProgressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleInProgressListItem implements IApiTitleInProgressListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => ApiTitleInfo)
    details?: ApiTitleInfo | null;
    @columnMap(() => ApiFirstCheckInfo)
    firstCheck?: ApiFirstCheckInfo | null;
    @columnMap(() => ApiDoubleCheckInfo)
    doubleCheck?: ApiDoubleCheckInfo | null;
    @columnMap(() => ApiEnterDbInfo)
    enterDb?: ApiEnterDbInfo | null;
    @columnMap(() => ApiShortReadCheckInfo)
    shortRead?: ApiShortReadCheckInfo | null;
    @columnMap(() => ApiReferencesCheckInfo)
    referencesCheck?: ApiReferencesCheckInfo | null;
    @columnMap(() => ApiTripleCheckInfo)
    tripleCheck?: ApiTripleCheckInfo | null;
    @columnMap(() => ApiTocReadCheckInfo)
    tocReadCheck?: ApiTocReadCheckInfo | null;
    @columnMap(() => String)
    statusDetails?: string | null;
    @columnMap(() => ApiTitleCompletionInfo)
    completeTitle?: ApiTitleCompletionInfo | null;
    completedDate?: Date | null;
    titleId?: number;
    hasNotes?: boolean;
    paperCountChanged?: boolean;

    constructor(data?: IApiTitleInProgressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.details = _data["details"] ? ApiTitleInfo.fromJS(_data["details"]) : null as any;
            this.firstCheck = _data["firstCheck"] ? ApiFirstCheckInfo.fromJS(_data["firstCheck"]) : null as any;
            this.doubleCheck = _data["doubleCheck"] ? ApiDoubleCheckInfo.fromJS(_data["doubleCheck"]) : null as any;
            this.enterDb = _data["enterDb"] ? ApiEnterDbInfo.fromJS(_data["enterDb"]) : null as any;
            this.shortRead = _data["shortRead"] ? ApiShortReadCheckInfo.fromJS(_data["shortRead"]) : null as any;
            this.referencesCheck = _data["referencesCheck"] ? ApiReferencesCheckInfo.fromJS(_data["referencesCheck"]) : null as any;
            this.tripleCheck = _data["tripleCheck"] ? ApiTripleCheckInfo.fromJS(_data["tripleCheck"]) : null as any;
            this.tocReadCheck = _data["tocReadCheck"] ? ApiTocReadCheckInfo.fromJS(_data["tocReadCheck"]) : null as any;
            this.statusDetails = _data["statusDetails"] !== undefined ? _data["statusDetails"] : null as any;
            this.completeTitle = _data["completeTitle"] ? ApiTitleCompletionInfo.fromJS(_data["completeTitle"]) : null as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.hasNotes = _data["hasNotes"] !== undefined ? _data["hasNotes"] : null as any;
            this.paperCountChanged = _data["paperCountChanged"] !== undefined ? _data["paperCountChanged"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleInProgressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleInProgressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        data["firstCheck"] = this.firstCheck ? this.firstCheck.toJSON() : null as any;
        data["doubleCheck"] = this.doubleCheck ? this.doubleCheck.toJSON() : null as any;
        data["enterDb"] = this.enterDb ? this.enterDb.toJSON() : null as any;
        data["shortRead"] = this.shortRead ? this.shortRead.toJSON() : null as any;
        data["referencesCheck"] = this.referencesCheck ? this.referencesCheck.toJSON() : null as any;
        data["tripleCheck"] = this.tripleCheck ? this.tripleCheck.toJSON() : null as any;
        data["tocReadCheck"] = this.tocReadCheck ? this.tocReadCheck.toJSON() : null as any;
        data["statusDetails"] = this.statusDetails !== undefined ? this.statusDetails : null as any;
        data["completeTitle"] = this.completeTitle ? this.completeTitle.toJSON() : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["hasNotes"] = this.hasNotes !== undefined ? this.hasNotes : null as any;
        data["paperCountChanged"] = this.paperCountChanged !== undefined ? this.paperCountChanged : null as any;
        return data;
    }
}

export interface IApiTitleInProgressListItem {
    id?: number;
    pos?: number;
    details?: ApiTitleInfo | null;
    firstCheck?: ApiFirstCheckInfo | null;
    doubleCheck?: ApiDoubleCheckInfo | null;
    enterDb?: ApiEnterDbInfo | null;
    shortRead?: ApiShortReadCheckInfo | null;
    referencesCheck?: ApiReferencesCheckInfo | null;
    tripleCheck?: ApiTripleCheckInfo | null;
    tocReadCheck?: ApiTocReadCheckInfo | null;
    statusDetails?: string | null;
    completeTitle?: ApiTitleCompletionInfo | null;
    completedDate?: Date | null;
    titleId?: number;
    hasNotes?: boolean;
    paperCountChanged?: boolean;
}

export class ApiTitleInfo implements IApiTitleInfo {
    isbnPrint?: string | null;
    kurzel?: string | null;
    volumeBegin?: number | null;
    volumeEnd?: number | null;
    dateWeb?: Date | null;
    paperCount?: number;
    isReplacement?: boolean;

    constructor(data?: IApiTitleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.volumeBegin = _data["volumeBegin"] !== undefined ? _data["volumeBegin"] : null as any;
            this.volumeEnd = _data["volumeEnd"] !== undefined ? _data["volumeEnd"] : null as any;
            this.dateWeb = _data["dateWeb"] ? new Date(_data["dateWeb"].toString()) : null as any;
            this.paperCount = _data["paperCount"] !== undefined ? _data["paperCount"] : null as any;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["volumeBegin"] = this.volumeBegin !== undefined ? this.volumeBegin : null as any;
        data["volumeEnd"] = this.volumeEnd !== undefined ? this.volumeEnd : null as any;
        data["dateWeb"] = this.dateWeb ? this.dateWeb.toISOString() : null as any;
        data["paperCount"] = this.paperCount !== undefined ? this.paperCount : null as any;
        data["isReplacement"] = this.isReplacement !== undefined ? this.isReplacement : null as any;
        return data;
    }
}

export interface IApiTitleInfo {
    isbnPrint?: string | null;
    kurzel?: string | null;
    volumeBegin?: number | null;
    volumeEnd?: number | null;
    dateWeb?: Date | null;
    paperCount?: number;
    isReplacement?: boolean;
}

export abstract class ApiBaseCheckInfo implements IApiBaseCheckInfo {
    canPrepare?: boolean;
    completed?: boolean;
    failed?: boolean;
    prepareInProgress?: boolean;
    inProgress?: boolean;
    pending?: boolean;
    canReImport?: boolean;
    reImportInProgress?: boolean;
    completedItems?: number;
    totalItems?: number;

    constructor(data?: IApiBaseCheckInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canPrepare = _data["canPrepare"] !== undefined ? _data["canPrepare"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.failed = _data["failed"] !== undefined ? _data["failed"] : null as any;
            this.prepareInProgress = _data["prepareInProgress"] !== undefined ? _data["prepareInProgress"] : null as any;
            this.inProgress = _data["inProgress"] !== undefined ? _data["inProgress"] : null as any;
            this.pending = _data["pending"] !== undefined ? _data["pending"] : null as any;
            this.canReImport = _data["canReImport"] !== undefined ? _data["canReImport"] : null as any;
            this.reImportInProgress = _data["reImportInProgress"] !== undefined ? _data["reImportInProgress"] : null as any;
            this.completedItems = _data["completedItems"] !== undefined ? _data["completedItems"] : null as any;
            this.totalItems = _data["totalItems"] !== undefined ? _data["totalItems"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseCheckInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseCheckInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canPrepare"] = this.canPrepare !== undefined ? this.canPrepare : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["failed"] = this.failed !== undefined ? this.failed : null as any;
        data["prepareInProgress"] = this.prepareInProgress !== undefined ? this.prepareInProgress : null as any;
        data["inProgress"] = this.inProgress !== undefined ? this.inProgress : null as any;
        data["pending"] = this.pending !== undefined ? this.pending : null as any;
        data["canReImport"] = this.canReImport !== undefined ? this.canReImport : null as any;
        data["reImportInProgress"] = this.reImportInProgress !== undefined ? this.reImportInProgress : null as any;
        data["completedItems"] = this.completedItems !== undefined ? this.completedItems : null as any;
        data["totalItems"] = this.totalItems !== undefined ? this.totalItems : null as any;
        return data;
    }
}

export interface IApiBaseCheckInfo {
    canPrepare?: boolean;
    completed?: boolean;
    failed?: boolean;
    prepareInProgress?: boolean;
    inProgress?: boolean;
    pending?: boolean;
    canReImport?: boolean;
    reImportInProgress?: boolean;
    completedItems?: number;
    totalItems?: number;
}

export class ApiFirstCheckInfo extends ApiBaseCheckInfo implements IApiFirstCheckInfo {

    constructor(data?: IApiFirstCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiFirstCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFirstCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiFirstCheckInfo extends IApiBaseCheckInfo {
}

export class ApiDoubleCheckInfo extends ApiBaseCheckInfo implements IApiDoubleCheckInfo {
    lastPrNoteDate?: Date | null;
    noteCount?: number;

    constructor(data?: IApiDoubleCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastPrNoteDate = _data["lastPrNoteDate"] ? new Date(_data["lastPrNoteDate"].toString()) : null as any;
            this.noteCount = _data["noteCount"] !== undefined ? _data["noteCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiDoubleCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiDoubleCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastPrNoteDate"] = this.lastPrNoteDate ? this.lastPrNoteDate.toISOString() : null as any;
        data["noteCount"] = this.noteCount !== undefined ? this.noteCount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiDoubleCheckInfo extends IApiBaseCheckInfo {
    lastPrNoteDate?: Date | null;
    noteCount?: number;
}

export class ApiEnterDbInfo extends ApiBaseCheckInfo implements IApiEnterDbInfo {

    constructor(data?: IApiEnterDbInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiEnterDbInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEnterDbInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiEnterDbInfo extends IApiBaseCheckInfo {
}

export class ApiShortReadCheckInfo extends ApiBaseCheckInfo implements IApiShortReadCheckInfo {

    constructor(data?: IApiShortReadCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiShortReadCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiShortReadCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiShortReadCheckInfo extends IApiBaseCheckInfo {
}

export class ApiReferencesCheckInfo extends ApiBaseCheckInfo implements IApiReferencesCheckInfo {

    constructor(data?: IApiReferencesCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiReferencesCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReferencesCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiReferencesCheckInfo extends IApiBaseCheckInfo {
}

export class ApiTripleCheckInfo extends ApiBaseCheckInfo implements IApiTripleCheckInfo {
    hasIncompleteReplacement?: boolean;
    lastPrNoteDate?: Date | null;
    noteCount?: number;

    constructor(data?: IApiTripleCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.hasIncompleteReplacement = _data["hasIncompleteReplacement"] !== undefined ? _data["hasIncompleteReplacement"] : null as any;
            this.lastPrNoteDate = _data["lastPrNoteDate"] ? new Date(_data["lastPrNoteDate"].toString()) : null as any;
            this.noteCount = _data["noteCount"] !== undefined ? _data["noteCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiTripleCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTripleCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasIncompleteReplacement"] = this.hasIncompleteReplacement !== undefined ? this.hasIncompleteReplacement : null as any;
        data["lastPrNoteDate"] = this.lastPrNoteDate ? this.lastPrNoteDate.toISOString() : null as any;
        data["noteCount"] = this.noteCount !== undefined ? this.noteCount : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiTripleCheckInfo extends IApiBaseCheckInfo {
    hasIncompleteReplacement?: boolean;
    lastPrNoteDate?: Date | null;
    noteCount?: number;
}

export class ApiTocReadCheckInfo extends ApiBaseCheckInfo implements IApiTocReadCheckInfo {

    constructor(data?: IApiTocReadCheckInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiTocReadCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTocReadCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiTocReadCheckInfo extends IApiBaseCheckInfo {
}

export class ApiTitleCompletionInfo implements IApiTitleCompletionInfo {
    canComplete?: boolean;

    constructor(data?: IApiTitleCompletionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canComplete = _data["canComplete"] !== undefined ? _data["canComplete"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCompletionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCompletionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canComplete"] = this.canComplete !== undefined ? this.canComplete : null as any;
        return data;
    }
}

export interface IApiTitleCompletionInfo {
    canComplete?: boolean;
}

export class ApiFirstCheckValidation implements IApiFirstCheckValidation {
    titleId?: number;
    papersWithDuplicatePagesFrom?: number[] | null;
    papersWithoutCurrentFiles?: { [key: string]: string[]; } | null;
    hasErrors?: boolean;

    constructor(data?: IApiFirstCheckValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            if (Array.isArray(_data["papersWithDuplicatePagesFrom"])) {
                this.papersWithDuplicatePagesFrom = [] as any;
                for (let item of _data["papersWithDuplicatePagesFrom"])
                    this.papersWithDuplicatePagesFrom!.push(item);
            }
            else {
                this.papersWithDuplicatePagesFrom = null as any;
            }
            if (_data["papersWithoutCurrentFiles"]) {
                this.papersWithoutCurrentFiles = {} as any;
                for (let key in _data["papersWithoutCurrentFiles"]) {
                    if (_data["papersWithoutCurrentFiles"].hasOwnProperty(key))
                        (this.papersWithoutCurrentFiles as any)![key] = _data["papersWithoutCurrentFiles"][key] !== undefined ? _data["papersWithoutCurrentFiles"][key] : [];
                }
            }
            else {
                this.papersWithoutCurrentFiles = null as any;
            }
            this.hasErrors = _data["hasErrors"] !== undefined ? _data["hasErrors"] : null as any;
        }
    }

    static fromJS(data: any): ApiFirstCheckValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFirstCheckValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        if (Array.isArray(this.papersWithDuplicatePagesFrom)) {
            data["papersWithDuplicatePagesFrom"] = [];
            for (let item of this.papersWithDuplicatePagesFrom)
                data["papersWithDuplicatePagesFrom"].push(item);
        }
        if (this.papersWithoutCurrentFiles) {
            data["papersWithoutCurrentFiles"] = {};
            for (let key in this.papersWithoutCurrentFiles) {
                if (this.papersWithoutCurrentFiles.hasOwnProperty(key))
                    (data["papersWithoutCurrentFiles"] as any)[key] = this.papersWithoutCurrentFiles[key] !== undefined ? this.papersWithoutCurrentFiles[key] : null as any;
            }
        }
        data["hasErrors"] = this.hasErrors !== undefined ? this.hasErrors : null as any;
        return data;
    }
}

export interface IApiFirstCheckValidation {
    titleId?: number;
    papersWithDuplicatePagesFrom?: number[] | null;
    papersWithoutCurrentFiles?: { [key: string]: string[]; } | null;
    hasErrors?: boolean;
}

export class ApiTitleWorkPrepareRequest implements IApiTitleWorkPrepareRequest {
    papersPerUnit?: number;

    constructor(data?: IApiTitleWorkPrepareRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.papersPerUnit = _data["papersPerUnit"] !== undefined ? _data["papersPerUnit"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleWorkPrepareRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleWorkPrepareRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["papersPerUnit"] = this.papersPerUnit !== undefined ? this.papersPerUnit : null as any;
        return data;
    }
}

export interface IApiTitleWorkPrepareRequest {
    papersPerUnit?: number;
}

export class TitleCheckCompletePreconditionsResponse implements ITitleCheckCompletePreconditionsResponse {
    hasSubjectCategories?: boolean;
    hasKeywords?: boolean;
    hasPriceInUsd?: boolean;
    hasDatePrint?: boolean;
    hasDateWeb?: boolean;
    hasImageCover?: boolean;
    hasPrepressCover?: boolean;
    hasHomePdf?: boolean;
    hasToc?: boolean;
    hasAuthorIndex?: boolean;
    hasKeywordIndex?: boolean;
    hasValidContributorOrNone?: boolean;
    canComplete?: boolean;

    constructor(data?: ITitleCheckCompletePreconditionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasSubjectCategories = _data["hasSubjectCategories"] !== undefined ? _data["hasSubjectCategories"] : null as any;
            this.hasKeywords = _data["hasKeywords"] !== undefined ? _data["hasKeywords"] : null as any;
            this.hasPriceInUsd = _data["hasPriceInUsd"] !== undefined ? _data["hasPriceInUsd"] : null as any;
            this.hasDatePrint = _data["hasDatePrint"] !== undefined ? _data["hasDatePrint"] : null as any;
            this.hasDateWeb = _data["hasDateWeb"] !== undefined ? _data["hasDateWeb"] : null as any;
            this.hasImageCover = _data["hasImageCover"] !== undefined ? _data["hasImageCover"] : null as any;
            this.hasPrepressCover = _data["hasPrepressCover"] !== undefined ? _data["hasPrepressCover"] : null as any;
            this.hasHomePdf = _data["hasHomePdf"] !== undefined ? _data["hasHomePdf"] : null as any;
            this.hasToc = _data["hasToc"] !== undefined ? _data["hasToc"] : null as any;
            this.hasAuthorIndex = _data["hasAuthorIndex"] !== undefined ? _data["hasAuthorIndex"] : null as any;
            this.hasKeywordIndex = _data["hasKeywordIndex"] !== undefined ? _data["hasKeywordIndex"] : null as any;
            this.hasValidContributorOrNone = _data["hasValidContributorOrNone"] !== undefined ? _data["hasValidContributorOrNone"] : null as any;
            this.canComplete = _data["canComplete"] !== undefined ? _data["canComplete"] : null as any;
        }
    }

    static fromJS(data: any): TitleCheckCompletePreconditionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TitleCheckCompletePreconditionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasSubjectCategories"] = this.hasSubjectCategories !== undefined ? this.hasSubjectCategories : null as any;
        data["hasKeywords"] = this.hasKeywords !== undefined ? this.hasKeywords : null as any;
        data["hasPriceInUsd"] = this.hasPriceInUsd !== undefined ? this.hasPriceInUsd : null as any;
        data["hasDatePrint"] = this.hasDatePrint !== undefined ? this.hasDatePrint : null as any;
        data["hasDateWeb"] = this.hasDateWeb !== undefined ? this.hasDateWeb : null as any;
        data["hasImageCover"] = this.hasImageCover !== undefined ? this.hasImageCover : null as any;
        data["hasPrepressCover"] = this.hasPrepressCover !== undefined ? this.hasPrepressCover : null as any;
        data["hasHomePdf"] = this.hasHomePdf !== undefined ? this.hasHomePdf : null as any;
        data["hasToc"] = this.hasToc !== undefined ? this.hasToc : null as any;
        data["hasAuthorIndex"] = this.hasAuthorIndex !== undefined ? this.hasAuthorIndex : null as any;
        data["hasKeywordIndex"] = this.hasKeywordIndex !== undefined ? this.hasKeywordIndex : null as any;
        data["hasValidContributorOrNone"] = this.hasValidContributorOrNone !== undefined ? this.hasValidContributorOrNone : null as any;
        data["canComplete"] = this.canComplete !== undefined ? this.canComplete : null as any;
        return data;
    }
}

export interface ITitleCheckCompletePreconditionsResponse {
    hasSubjectCategories?: boolean;
    hasKeywords?: boolean;
    hasPriceInUsd?: boolean;
    hasDatePrint?: boolean;
    hasDateWeb?: boolean;
    hasImageCover?: boolean;
    hasPrepressCover?: boolean;
    hasHomePdf?: boolean;
    hasToc?: boolean;
    hasAuthorIndex?: boolean;
    hasKeywordIndex?: boolean;
    hasValidContributorOrNone?: boolean;
    canComplete?: boolean;
}

export class ApiTitleCheckCompletePreconditions extends TitleCheckCompletePreconditionsResponse implements IApiTitleCheckCompletePreconditions {

    constructor(data?: IApiTitleCheckCompletePreconditions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiTitleCheckCompletePreconditions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCheckCompletePreconditions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiTitleCheckCompletePreconditions extends ITitleCheckCompletePreconditionsResponse {
}

export class ApiTitleCheckStatisticsEntry implements IApiTitleCheckStatisticsEntry {
    processType?: TitleCheckProcessTypeEnum;
    checkType?: CheckTypeEnum | null;
    state?: CheckStateEnum | null;
    date?: Date;
    isTitleCompleted?: boolean;

    constructor(data?: IApiTitleCheckStatisticsEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processType = _data["processType"] !== undefined ? _data["processType"] : null as any;
            this.checkType = _data["checkType"] !== undefined ? _data["checkType"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.isTitleCompleted = _data["isTitleCompleted"] !== undefined ? _data["isTitleCompleted"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCheckStatisticsEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCheckStatisticsEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processType"] = this.processType !== undefined ? this.processType : null as any;
        data["checkType"] = this.checkType !== undefined ? this.checkType : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["isTitleCompleted"] = this.isTitleCompleted !== undefined ? this.isTitleCompleted : null as any;
        return data;
    }
}

export interface IApiTitleCheckStatisticsEntry {
    processType?: TitleCheckProcessTypeEnum;
    checkType?: CheckTypeEnum | null;
    state?: CheckStateEnum | null;
    date?: Date;
    isTitleCompleted?: boolean;
}

export enum TitleCheckProcessTypeEnum {
    Check = 0,
    Replacement = 1,
}

export enum CheckTypeEnum {
    FirstCheck = 0,
    DoubleCheck = 1,
    TripleCheck = 2,
    ReferencesCheck = 3,
    EnterDB = 4,
    ShortRead = 5,
    ToCRead = 6,
}

export enum CheckStateEnum {
    None = 0,
    Preparing = 1,
    Failed = 2,
    Pending = 3,
    Active = 4,
    Complete = 5,
    ReImportInProgress = 6,
}

export class ApiPageResultOfApiCheckerListItem implements IApiPageResultOfApiCheckerListItem {
    items?: ApiCheckerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiCheckerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiCheckerListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiCheckerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiCheckerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiCheckerListItem {
    items?: ApiCheckerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiCheckerListItem implements IApiCheckerListItem {
    @keyMap()
    id?: number | null;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => CheckTypeEnum, true)
    checkerAssignments?: CheckTypeEnum[] | null;
    @columnMap(() => Date)
    lastUpdated?: Date | null;

    constructor(data?: IApiCheckerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            if (Array.isArray(_data["checkerAssignments"])) {
                this.checkerAssignments = [] as any;
                for (let item of _data["checkerAssignments"])
                    this.checkerAssignments!.push(item);
            }
            else {
                this.checkerAssignments = null as any;
            }
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        if (Array.isArray(this.checkerAssignments)) {
            data["checkerAssignments"] = [];
            for (let item of this.checkerAssignments)
                data["checkerAssignments"].push(item);
        }
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        return data;
    }
}

export interface IApiCheckerListItem {
    id?: number | null;
    memberDetails?: ApiMemberInfo | null;
    checkerAssignments?: CheckTypeEnum[] | null;
    lastUpdated?: Date | null;
}

export class ApiCheckerUpdate implements IApiCheckerUpdate {
    checkerAssignments?: CheckTypeEnum[] | null;

    constructor(data?: IApiCheckerUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checkerAssignments"])) {
                this.checkerAssignments = [] as any;
                for (let item of _data["checkerAssignments"])
                    this.checkerAssignments!.push(item);
            }
            else {
                this.checkerAssignments = null as any;
            }
        }
    }

    static fromJS(data: any): ApiCheckerUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checkerAssignments)) {
            data["checkerAssignments"] = [];
            for (let item of this.checkerAssignments)
                data["checkerAssignments"].push(item);
        }
        return data;
    }
}

export interface IApiCheckerUpdate {
    checkerAssignments?: CheckTypeEnum[] | null;
}

export class ApiCheckerCreate extends ApiCheckerUpdate implements IApiCheckerCreate {
    memberDetails?: ApiMemberInfo | null;

    constructor(data?: IApiCheckerCreate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerCreate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerCreate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiCheckerCreate extends IApiCheckerUpdate {
    memberDetails?: ApiMemberInfo | null;
}

export class ApiPageResultOfApiPaperProcessListItem implements IApiPageResultOfApiPaperProcessListItem {
    items?: ApiPaperProcessListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperProcessListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperProcessListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperProcessListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperProcessListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperProcessListItem {
    items?: ApiPaperProcessListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperProcessListItem implements IApiPaperProcessListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiPaperProcessAction)
    resetActionInfo?: ApiPaperProcessAction | null;
    @columnMap(() => ApiPaperProcessAction)
    abortActionInfo?: ApiPaperProcessAction | null;
    @columnMap(() => Number)
    page?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => ApiPaperProcessCheckInfo)
    firstCheck?: ApiPaperProcessCheckInfo | null;
    @columnMap(() => ApiPaperProcessCheckInfo)
    enterDb?: ApiPaperProcessCheckInfo | null;
    @columnMap(() => ApiPaperProcessCheckInfo)
    referencesCheck?: ApiPaperProcessCheckInfo | null;
    @columnMap(() => ApiIdNameItem, true)
    attachments?: ApiIdNameItem[] | null;
    notesCount?: number;

    constructor(data?: IApiPaperProcessListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.resetActionInfo = _data["resetActionInfo"] ? ApiPaperProcessAction.fromJS(_data["resetActionInfo"]) : null as any;
            this.abortActionInfo = _data["abortActionInfo"] ? ApiPaperProcessAction.fromJS(_data["abortActionInfo"]) : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.firstCheck = _data["firstCheck"] ? ApiPaperProcessCheckInfo.fromJS(_data["firstCheck"]) : null as any;
            this.enterDb = _data["enterDb"] ? ApiPaperProcessCheckInfo.fromJS(_data["enterDb"]) : null as any;
            this.referencesCheck = _data["referencesCheck"] ? ApiPaperProcessCheckInfo.fromJS(_data["referencesCheck"]) : null as any;
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(ApiIdNameItem.fromJS(item));
            }
            else {
                this.attachments = null as any;
            }
            this.notesCount = _data["notesCount"] !== undefined ? _data["notesCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperProcessListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperProcessListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["resetActionInfo"] = this.resetActionInfo ? this.resetActionInfo.toJSON() : null as any;
        data["abortActionInfo"] = this.abortActionInfo ? this.abortActionInfo.toJSON() : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["firstCheck"] = this.firstCheck ? this.firstCheck.toJSON() : null as any;
        data["enterDb"] = this.enterDb ? this.enterDb.toJSON() : null as any;
        data["referencesCheck"] = this.referencesCheck ? this.referencesCheck.toJSON() : null as any;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item ? item.toJSON() : null as any);
        }
        data["notesCount"] = this.notesCount !== undefined ? this.notesCount : null as any;
        return data;
    }
}

export interface IApiPaperProcessListItem {
    id?: number;
    resetActionInfo?: ApiPaperProcessAction | null;
    abortActionInfo?: ApiPaperProcessAction | null;
    page?: number;
    name?: string | null;
    firstCheck?: ApiPaperProcessCheckInfo | null;
    enterDb?: ApiPaperProcessCheckInfo | null;
    referencesCheck?: ApiPaperProcessCheckInfo | null;
    attachments?: ApiIdNameItem[] | null;
    notesCount?: number;
}

export class ApiPaperProcessAction implements IApiPaperProcessAction {
    canManageFirstCheck?: boolean;
    canManageEnterDb?: boolean;
    canManageReferencesCheck?: boolean;

    constructor(data?: IApiPaperProcessAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canManageFirstCheck = _data["canManageFirstCheck"] !== undefined ? _data["canManageFirstCheck"] : null as any;
            this.canManageEnterDb = _data["canManageEnterDb"] !== undefined ? _data["canManageEnterDb"] : null as any;
            this.canManageReferencesCheck = _data["canManageReferencesCheck"] !== undefined ? _data["canManageReferencesCheck"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperProcessAction {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperProcessAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canManageFirstCheck"] = this.canManageFirstCheck !== undefined ? this.canManageFirstCheck : null as any;
        data["canManageEnterDb"] = this.canManageEnterDb !== undefined ? this.canManageEnterDb : null as any;
        data["canManageReferencesCheck"] = this.canManageReferencesCheck !== undefined ? this.canManageReferencesCheck : null as any;
        return data;
    }
}

export interface IApiPaperProcessAction {
    canManageFirstCheck?: boolean;
    canManageEnterDb?: boolean;
    canManageReferencesCheck?: boolean;
}

export class ApiPaperProcessCheckInfo implements IApiPaperProcessCheckInfo {
    state?: WorkStateEnum;
    workId?: number;
    modifiedDate?: Date | null;
    fullNameAndTitle?: string | null;
    memberId?: number | null;

    constructor(data?: IApiPaperProcessCheckInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.workId = _data["workId"] !== undefined ? _data["workId"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.fullNameAndTitle = _data["fullNameAndTitle"] !== undefined ? _data["fullNameAndTitle"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperProcessCheckInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperProcessCheckInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["workId"] = this.workId !== undefined ? this.workId : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["fullNameAndTitle"] = this.fullNameAndTitle !== undefined ? this.fullNameAndTitle : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        return data;
    }
}

export interface IApiPaperProcessCheckInfo {
    state?: WorkStateEnum;
    workId?: number;
    modifiedDate?: Date | null;
    fullNameAndTitle?: string | null;
    memberId?: number | null;
}

export enum WorkStateEnum {
    ToWork = 0,
    InWork = 1,
    Paused = 2,
    Returned = 3,
    Complete = 4,
}

export class ApiStatusDetails implements IApiStatusDetails {
    titleId?: number;
    titleName?: string | null;
    isbnPrint?: string | null;
    canGenerateDoublePr?: boolean;
    doublePrFile?: ApiFileInfo | null;
    canGenerateTriplePr?: boolean;
    triplePrFile?: ApiFileInfo | null;
    isComplete?: boolean;

    constructor(data?: IApiStatusDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.canGenerateDoublePr = _data["canGenerateDoublePr"] !== undefined ? _data["canGenerateDoublePr"] : null as any;
            this.doublePrFile = _data["doublePrFile"] ? ApiFileInfo.fromJS(_data["doublePrFile"]) : null as any;
            this.canGenerateTriplePr = _data["canGenerateTriplePr"] !== undefined ? _data["canGenerateTriplePr"] : null as any;
            this.triplePrFile = _data["triplePrFile"] ? ApiFileInfo.fromJS(_data["triplePrFile"]) : null as any;
            this.isComplete = _data["isComplete"] !== undefined ? _data["isComplete"] : null as any;
        }
    }

    static fromJS(data: any): ApiStatusDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiStatusDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["canGenerateDoublePr"] = this.canGenerateDoublePr !== undefined ? this.canGenerateDoublePr : null as any;
        data["doublePrFile"] = this.doublePrFile ? this.doublePrFile.toJSON() : null as any;
        data["canGenerateTriplePr"] = this.canGenerateTriplePr !== undefined ? this.canGenerateTriplePr : null as any;
        data["triplePrFile"] = this.triplePrFile ? this.triplePrFile.toJSON() : null as any;
        data["isComplete"] = this.isComplete !== undefined ? this.isComplete : null as any;
        return data;
    }
}

export interface IApiStatusDetails {
    titleId?: number;
    titleName?: string | null;
    isbnPrint?: string | null;
    canGenerateDoublePr?: boolean;
    doublePrFile?: ApiFileInfo | null;
    canGenerateTriplePr?: boolean;
    triplePrFile?: ApiFileInfo | null;
    isComplete?: boolean;
}

export class ApiPageResultOfApiTitleProcessListItem implements IApiPageResultOfApiTitleProcessListItem {
    items?: ApiTitleProcessListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleProcessListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleProcessListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleProcessListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleProcessListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleProcessListItem {
    items?: ApiTitleProcessListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleProcessListItem implements IApiTitleProcessListItem {
    @keyMap()
    id?: number;
    @columnMap(() => TitleProcessEnum)
    process?: TitleProcessEnum;
    @columnMap(() => WorkStateEnum)
    status?: WorkStateEnum;
    @columnMap(() => String, true)
    papers?: string[] | null;
    @columnMap(() => ApiPaperWorkPerformer)
    performer?: ApiPaperWorkPerformer | null;
    @columnMap(() => ApiTitleProcessAction)
    actionButtonInfo?: ApiTitleProcessAction | null;

    constructor(data?: IApiTitleProcessListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.process = _data["process"] !== undefined ? _data["process"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["papers"])) {
                this.papers = [] as any;
                for (let item of _data["papers"])
                    this.papers!.push(item);
            }
            else {
                this.papers = null as any;
            }
            this.performer = _data["performer"] ? ApiPaperWorkPerformer.fromJS(_data["performer"]) : null as any;
            this.actionButtonInfo = _data["actionButtonInfo"] ? ApiTitleProcessAction.fromJS(_data["actionButtonInfo"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProcessListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProcessListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["process"] = this.process !== undefined ? this.process : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.papers)) {
            data["papers"] = [];
            for (let item of this.papers)
                data["papers"].push(item);
        }
        data["performer"] = this.performer ? this.performer.toJSON() : null as any;
        data["actionButtonInfo"] = this.actionButtonInfo ? this.actionButtonInfo.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleProcessListItem {
    id?: number;
    process?: TitleProcessEnum;
    status?: WorkStateEnum;
    papers?: string[] | null;
    performer?: ApiPaperWorkPerformer | null;
    actionButtonInfo?: ApiTitleProcessAction | null;
}

export enum TitleProcessEnum {
    DoubleCheck = 1,
    TripleCheck = 2,
    ShortRead = 5,
    ToCRead = 6,
}

export class ApiPaperWorkPerformer extends ApiIdNameItem implements IApiPaperWorkPerformer {
    modifiedDate?: Date;

    constructor(data?: IApiPaperWorkPerformer) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperWorkPerformer {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperWorkPerformer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiPaperWorkPerformer extends IApiIdNameItem {
    modifiedDate?: Date;
}

export class ApiTitleProcessAction implements IApiTitleProcessAction {
    canAccessRestart?: boolean;
    canAccessAbort?: boolean;

    constructor(data?: IApiTitleProcessAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAccessRestart = _data["canAccessRestart"] !== undefined ? _data["canAccessRestart"] : null as any;
            this.canAccessAbort = _data["canAccessAbort"] !== undefined ? _data["canAccessAbort"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProcessAction {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProcessAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAccessRestart"] = this.canAccessRestart !== undefined ? this.canAccessRestart : null as any;
        data["canAccessAbort"] = this.canAccessAbort !== undefined ? this.canAccessAbort : null as any;
        return data;
    }
}

export interface IApiTitleProcessAction {
    canAccessRestart?: boolean;
    canAccessAbort?: boolean;
}

export class ApiSplitCheckWork implements IApiSplitCheckWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    authorPrepress?: ApiFileInfo | null;
    checkerPrepress?: ApiFileInfo | null;
    completed?: boolean;
    isReplacement?: boolean;

    constructor(data?: IApiSplitCheckWork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.authorPrepress = _data["authorPrepress"] ? ApiFileInfo.fromJS(_data["authorPrepress"]) : null as any;
            this.checkerPrepress = _data["checkerPrepress"] ? ApiFileInfo.fromJS(_data["checkerPrepress"]) : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : null as any;
        }
    }

    static fromJS(data: any): ApiSplitCheckWork {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSplitCheckWork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["authorPrepress"] = this.authorPrepress ? this.authorPrepress.toJSON() : null as any;
        data["checkerPrepress"] = this.checkerPrepress ? this.checkerPrepress.toJSON() : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["isReplacement"] = this.isReplacement !== undefined ? this.isReplacement : null as any;
        return data;
    }
}

export interface IApiSplitCheckWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    authorPrepress?: ApiFileInfo | null;
    checkerPrepress?: ApiFileInfo | null;
    completed?: boolean;
    isReplacement?: boolean;
}

export class ApiCheckerWorkResult implements IApiCheckerWorkResult {
    assignment?: CheckTypeEnum | null;
    titleCheckId?: number | null;
    workId?: number | null;

    constructor(data?: IApiCheckerWorkResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assignment = _data["assignment"] !== undefined ? _data["assignment"] : null as any;
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.workId = _data["workId"] !== undefined ? _data["workId"] : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerWorkResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerWorkResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignment"] = this.assignment !== undefined ? this.assignment : null as any;
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["workId"] = this.workId !== undefined ? this.workId : null as any;
        return data;
    }
}

export interface IApiCheckerWorkResult {
    assignment?: CheckTypeEnum | null;
    titleCheckId?: number | null;
    workId?: number | null;
}

export class ApiPageResultOfApiDoubleCheckPaperListItem implements IApiPageResultOfApiDoubleCheckPaperListItem {
    items?: ApiDoubleCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiDoubleCheckPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiDoubleCheckPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiDoubleCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiDoubleCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiDoubleCheckPaperListItem {
    items?: ApiDoubleCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiSplitCheckPaperListItem implements IApiSplitCheckPaperListItem {
    @keyMap()
    paperId?: number;
    @columnMap(() => Number)
    page?: number;
    titleId?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => ApiSplitCheckPaperNote, true)
    notes?: ApiSplitCheckPaperNote[] | null;

    constructor(data?: IApiSplitCheckPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(ApiSplitCheckPaperNote.fromJS(item));
            }
            else {
                this.notes = null as any;
            }
        }
    }

    static fromJS(data: any): ApiSplitCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSplitCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiSplitCheckPaperListItem {
    paperId?: number;
    page?: number;
    titleId?: number;
    paperName?: string | null;
    notes?: ApiSplitCheckPaperNote[] | null;
}

export class ApiDoubleCheckPaperListItem extends ApiSplitCheckPaperListItem implements IApiDoubleCheckPaperListItem {
    @columnMap(() => Number)
    pdfPageCount?: number;
    @columnMap(() => WorkStateEnum)
    firstCheckState?: WorkStateEnum;

    constructor(data?: IApiDoubleCheckPaperListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pdfPageCount = _data["pdfPageCount"] !== undefined ? _data["pdfPageCount"] : null as any;
            this.firstCheckState = _data["firstCheckState"] !== undefined ? _data["firstCheckState"] : null as any;
        }
    }

    static fromJS(data: any): ApiDoubleCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiDoubleCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdfPageCount"] = this.pdfPageCount !== undefined ? this.pdfPageCount : null as any;
        data["firstCheckState"] = this.firstCheckState !== undefined ? this.firstCheckState : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiDoubleCheckPaperListItem extends IApiSplitCheckPaperListItem {
    pdfPageCount?: number;
    firstCheckState?: WorkStateEnum;
}

export class ApiSplitCheckPaperNote implements IApiSplitCheckPaperNote {
    id?: number;
    description?: string | null;
    attachmentFileName?: string | null;

    constructor(data?: IApiSplitCheckPaperNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.attachmentFileName = _data["attachmentFileName"] !== undefined ? _data["attachmentFileName"] : null as any;
        }
    }

    static fromJS(data: any): ApiSplitCheckPaperNote {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSplitCheckPaperNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["attachmentFileName"] = this.attachmentFileName !== undefined ? this.attachmentFileName : null as any;
        return data;
    }
}

export interface IApiSplitCheckPaperNote {
    id?: number;
    description?: string | null;
    attachmentFileName?: string | null;
}

export class ApiPaperWork implements IApiPaperWork {
    id?: number;
    paperName?: string | null;
    isbnPrint?: string | null;
    titleName?: string | null;
    titleId?: number;
    paperId?: number;
    checkerFiles?: ApiPaperWorkFiles | null;
    completed?: boolean;
    isReplacement?: boolean;

    constructor(data?: IApiPaperWork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.checkerFiles = _data["checkerFiles"] ? ApiPaperWorkFiles.fromJS(_data["checkerFiles"]) : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperWork {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperWork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["checkerFiles"] = this.checkerFiles ? this.checkerFiles.toJSON() : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["isReplacement"] = this.isReplacement !== undefined ? this.isReplacement : null as any;
        return data;
    }
}

export interface IApiPaperWork {
    id?: number;
    paperName?: string | null;
    isbnPrint?: string | null;
    titleName?: string | null;
    titleId?: number;
    paperId?: number;
    checkerFiles?: ApiPaperWorkFiles | null;
    completed?: boolean;
    isReplacement?: boolean;
}

export class ApiPaperWorkFiles implements IApiPaperWorkFiles {
    originalDocFile?: ApiCheckerFileInfo | null;
    originalPdfFile?: ApiCheckerFileInfo | null;
    checkerDocFile?: ApiCheckerFileInfo | null;
    checkerPdfFile?: ApiCheckerFileInfo | null;
    pdfFilePagesCount?: number;
    isOriginalDocFileZip?: boolean;

    constructor(data?: IApiPaperWorkFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalDocFile = _data["originalDocFile"] ? ApiCheckerFileInfo.fromJS(_data["originalDocFile"]) : null as any;
            this.originalPdfFile = _data["originalPdfFile"] ? ApiCheckerFileInfo.fromJS(_data["originalPdfFile"]) : null as any;
            this.checkerDocFile = _data["checkerDocFile"] ? ApiCheckerFileInfo.fromJS(_data["checkerDocFile"]) : null as any;
            this.checkerPdfFile = _data["checkerPdfFile"] ? ApiCheckerFileInfo.fromJS(_data["checkerPdfFile"]) : null as any;
            this.pdfFilePagesCount = _data["pdfFilePagesCount"] !== undefined ? _data["pdfFilePagesCount"] : null as any;
            this.isOriginalDocFileZip = _data["isOriginalDocFileZip"] !== undefined ? _data["isOriginalDocFileZip"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperWorkFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperWorkFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalDocFile"] = this.originalDocFile ? this.originalDocFile.toJSON() : null as any;
        data["originalPdfFile"] = this.originalPdfFile ? this.originalPdfFile.toJSON() : null as any;
        data["checkerDocFile"] = this.checkerDocFile ? this.checkerDocFile.toJSON() : null as any;
        data["checkerPdfFile"] = this.checkerPdfFile ? this.checkerPdfFile.toJSON() : null as any;
        data["pdfFilePagesCount"] = this.pdfFilePagesCount !== undefined ? this.pdfFilePagesCount : null as any;
        data["isOriginalDocFileZip"] = this.isOriginalDocFileZip !== undefined ? this.isOriginalDocFileZip : null as any;
        return data;
    }
}

export interface IApiPaperWorkFiles {
    originalDocFile?: ApiCheckerFileInfo | null;
    originalPdfFile?: ApiCheckerFileInfo | null;
    checkerDocFile?: ApiCheckerFileInfo | null;
    checkerPdfFile?: ApiCheckerFileInfo | null;
    pdfFilePagesCount?: number;
    isOriginalDocFileZip?: boolean;
}

export class ApiCheckerFileInfo extends ApiFileInfo implements IApiCheckerFileInfo {
    documentId?: number;

    constructor(data?: IApiCheckerFileInfo) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId !== undefined ? this.documentId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiCheckerFileInfo extends IApiFileInfo {
    documentId?: number;
}

export class ApiPaperProxyInfo implements IApiPaperProxyInfo {
    paperId?: number;
    titleId?: number;
    abstract?: string | null;
    paperDetails?: ApiTechnicalCheckPaperDetails | null;

    constructor(data?: IApiPaperProxyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
            this.paperDetails = _data["paperDetails"] ? ApiTechnicalCheckPaperDetails.fromJS(_data["paperDetails"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperProxyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperProxyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        data["paperDetails"] = this.paperDetails ? this.paperDetails.toJSON() : null as any;
        return data;
    }
}

export interface IApiPaperProxyInfo {
    paperId?: number;
    titleId?: number;
    abstract?: string | null;
    paperDetails?: ApiTechnicalCheckPaperDetails | null;
}

export class ApiPaperDetails implements IApiPaperDetails {
    status?: PaperStatusEnum;
    name: string;
    pos?: number;
    pageNumberFrom?: number;
    pageNumberTo?: number;
    chapter?: ApiIdNameItem | null;
    chapterUploadPageNumber?: string | null;
    editorialPageNumber?: string | null;
    retractionReason?: string | null;
    type?: PaperTypeEnum;
    openAccess?: boolean;
    canadianPaper?: boolean;
    paperFooterId?: number | null;
    copyrightAgreement?: ApiFileInfo | null;
    copyrightAgreementStatus?: CopyrightStatusEnum;
    tcaSubmissionId?: string | null;
    tcaScore?: number | null;

    constructor(data?: IApiPaperDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.pageNumberFrom = _data["pageNumberFrom"] !== undefined ? _data["pageNumberFrom"] : null as any;
            this.pageNumberTo = _data["pageNumberTo"] !== undefined ? _data["pageNumberTo"] : null as any;
            this.chapter = _data["chapter"] ? ApiIdNameItem.fromJS(_data["chapter"]) : null as any;
            this.chapterUploadPageNumber = _data["chapterUploadPageNumber"] !== undefined ? _data["chapterUploadPageNumber"] : null as any;
            this.editorialPageNumber = _data["editorialPageNumber"] !== undefined ? _data["editorialPageNumber"] : null as any;
            this.retractionReason = _data["retractionReason"] !== undefined ? _data["retractionReason"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.openAccess = _data["openAccess"] !== undefined ? _data["openAccess"] : null as any;
            this.canadianPaper = _data["canadianPaper"] !== undefined ? _data["canadianPaper"] : null as any;
            this.paperFooterId = _data["paperFooterId"] !== undefined ? _data["paperFooterId"] : null as any;
            this.copyrightAgreement = _data["copyrightAgreement"] ? ApiFileInfo.fromJS(_data["copyrightAgreement"]) : null as any;
            this.copyrightAgreementStatus = _data["copyrightAgreementStatus"] !== undefined ? _data["copyrightAgreementStatus"] : null as any;
            this.tcaSubmissionId = _data["tcaSubmissionId"] !== undefined ? _data["tcaSubmissionId"] : null as any;
            this.tcaScore = _data["tcaScore"] !== undefined ? _data["tcaScore"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["pageNumberFrom"] = this.pageNumberFrom !== undefined ? this.pageNumberFrom : null as any;
        data["pageNumberTo"] = this.pageNumberTo !== undefined ? this.pageNumberTo : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        data["chapterUploadPageNumber"] = this.chapterUploadPageNumber !== undefined ? this.chapterUploadPageNumber : null as any;
        data["editorialPageNumber"] = this.editorialPageNumber !== undefined ? this.editorialPageNumber : null as any;
        data["retractionReason"] = this.retractionReason !== undefined ? this.retractionReason : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["openAccess"] = this.openAccess !== undefined ? this.openAccess : null as any;
        data["canadianPaper"] = this.canadianPaper !== undefined ? this.canadianPaper : null as any;
        data["paperFooterId"] = this.paperFooterId !== undefined ? this.paperFooterId : null as any;
        data["copyrightAgreement"] = this.copyrightAgreement ? this.copyrightAgreement.toJSON() : null as any;
        data["copyrightAgreementStatus"] = this.copyrightAgreementStatus !== undefined ? this.copyrightAgreementStatus : null as any;
        data["tcaSubmissionId"] = this.tcaSubmissionId !== undefined ? this.tcaSubmissionId : null as any;
        data["tcaScore"] = this.tcaScore !== undefined ? this.tcaScore : null as any;
        return data;
    }
}

export interface IApiPaperDetails {
    status?: PaperStatusEnum;
    name: string;
    pos?: number;
    pageNumberFrom?: number;
    pageNumberTo?: number;
    chapter?: ApiIdNameItem | null;
    chapterUploadPageNumber?: string | null;
    editorialPageNumber?: string | null;
    retractionReason?: string | null;
    type?: PaperTypeEnum;
    openAccess?: boolean;
    canadianPaper?: boolean;
    paperFooterId?: number | null;
    copyrightAgreement?: ApiFileInfo | null;
    copyrightAgreementStatus?: CopyrightStatusEnum;
    tcaSubmissionId?: string | null;
    tcaScore?: number | null;
}

export class ApiTechnicalCheckPaperDetails extends ApiPaperDetails implements IApiTechnicalCheckPaperDetails {

    constructor(data?: IApiTechnicalCheckPaperDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiTechnicalCheckPaperDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTechnicalCheckPaperDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiTechnicalCheckPaperDetails extends IApiPaperDetails {
}

export enum PaperStatusEnum {
    Uploaded = 0,
    Submitted = 1,
    InReview = 2,
    Editorial = 3,
    Revisions = 4,
    Revised = 5,
    Rejected = 6,
    Accepted = 7,
    Retracted = 8,
}

export enum PaperTypeEnum {
    RegularPaper = 0,
    ChapterUpload = 1,
    ChapterTocOnly = 2,
    Editorial = 3,
}

export enum CopyrightStatusEnum {
    None = 0,
    Uploaded = 1,
    Received = 2,
    Submitted = 3,
}

export class ApiShortReadCheckPaperWork implements IApiShortReadCheckPaperWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    pages?: string | null;
    authorFile?: ApiFileInfo | null;
    checkerFile?: ApiFileInfo | null;
    completed?: boolean;
    isReplacement?: boolean;

    constructor(data?: IApiShortReadCheckPaperWork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.pages = _data["pages"] !== undefined ? _data["pages"] : null as any;
            this.authorFile = _data["authorFile"] ? ApiFileInfo.fromJS(_data["authorFile"]) : null as any;
            this.checkerFile = _data["checkerFile"] ? ApiFileInfo.fromJS(_data["checkerFile"]) : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : null as any;
        }
    }

    static fromJS(data: any): ApiShortReadCheckPaperWork {
        data = typeof data === 'object' ? data : {};
        let result = new ApiShortReadCheckPaperWork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["pages"] = this.pages !== undefined ? this.pages : null as any;
        data["authorFile"] = this.authorFile ? this.authorFile.toJSON() : null as any;
        data["checkerFile"] = this.checkerFile ? this.checkerFile.toJSON() : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        data["isReplacement"] = this.isReplacement !== undefined ? this.isReplacement : null as any;
        return data;
    }
}

export interface IApiShortReadCheckPaperWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    pages?: string | null;
    authorFile?: ApiFileInfo | null;
    checkerFile?: ApiFileInfo | null;
    completed?: boolean;
    isReplacement?: boolean;
}

export class ApiPageResultOfApiShortReadCheckPaperListItem implements IApiPageResultOfApiShortReadCheckPaperListItem {
    items?: ApiShortReadCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiShortReadCheckPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiShortReadCheckPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiShortReadCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiShortReadCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiShortReadCheckPaperListItem {
    items?: ApiShortReadCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiShortReadCheckPaperListItem implements IApiShortReadCheckPaperListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    page?: number;
    @columnMap(() => String)
    paperName?: string | null;

    constructor(data?: IApiShortReadCheckPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
        }
    }

    static fromJS(data: any): ApiShortReadCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiShortReadCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        return data;
    }
}

export interface IApiShortReadCheckPaperListItem {
    id?: number;
    page?: number;
    paperName?: string | null;
}

export class ApiTocReadCheckPaperWork implements IApiTocReadCheckPaperWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    pages?: string | null;
    completed?: boolean;

    constructor(data?: IApiTocReadCheckPaperWork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.pages = _data["pages"] !== undefined ? _data["pages"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
        }
    }

    static fromJS(data: any): ApiTocReadCheckPaperWork {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTocReadCheckPaperWork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["pages"] = this.pages !== undefined ? this.pages : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        return data;
    }
}

export interface IApiTocReadCheckPaperWork {
    titleCheckId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    pages?: string | null;
    completed?: boolean;
}

export class ApiPageResultOfApiSplitCheckPaperListItem implements IApiPageResultOfApiSplitCheckPaperListItem {
    items?: ApiSplitCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiSplitCheckPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiSplitCheckPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiSplitCheckPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiSplitCheckPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiSplitCheckPaperListItem {
    items?: ApiSplitCheckPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiCheckerInfo implements IApiCheckerInfo {
    checkerId?: number;
    taskStatus?: CheckerTaskStatusEnum;
    header?: ApiCheckerHeader | null;
    statistics?: ApiCheckerStatistics | null;

    constructor(data?: IApiCheckerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkerId = _data["checkerId"] !== undefined ? _data["checkerId"] : null as any;
            this.taskStatus = _data["taskStatus"] !== undefined ? _data["taskStatus"] : null as any;
            this.header = _data["header"] ? ApiCheckerHeader.fromJS(_data["header"]) : null as any;
            this.statistics = _data["statistics"] ? ApiCheckerStatistics.fromJS(_data["statistics"]) : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkerId"] = this.checkerId !== undefined ? this.checkerId : null as any;
        data["taskStatus"] = this.taskStatus !== undefined ? this.taskStatus : null as any;
        data["header"] = this.header ? this.header.toJSON() : null as any;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : null as any;
        return data;
    }
}

export interface IApiCheckerInfo {
    checkerId?: number;
    taskStatus?: CheckerTaskStatusEnum;
    header?: ApiCheckerHeader | null;
    statistics?: ApiCheckerStatistics | null;
}

export enum CheckerTaskStatusEnum {
    NothingToDo = 0,
    HasPapersToCheck = 1,
    HasPaperToEnter = 2,
    HasDoubleCheckToProcess = 3,
    HasReferencesToCheck = 4,
    HasTripleCheckToProcess = 5,
    HasTocReadToProcess = 6,
    HasShortReadToProcess = 7,
}

export class ApiCheckerHeader implements IApiCheckerHeader {
    checkerFullName?: string | null;
    firstCheckCompletedPaperCount?: number;
    firstCheckCompletedReturnedPaperCount?: number;
    enterDbCompletedPaperCount?: number;
    doubleCheckCompletedPaperCount?: number;
    shortReadCompletedPaperCount?: number;
    referenceCheckCompletedPaperCount?: number;
    tripleCheckCompletedPaperCount?: number;
    tocReadCompletedPaperCount?: number;

    constructor(data?: IApiCheckerHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkerFullName = _data["checkerFullName"] !== undefined ? _data["checkerFullName"] : null as any;
            this.firstCheckCompletedPaperCount = _data["firstCheckCompletedPaperCount"] !== undefined ? _data["firstCheckCompletedPaperCount"] : null as any;
            this.firstCheckCompletedReturnedPaperCount = _data["firstCheckCompletedReturnedPaperCount"] !== undefined ? _data["firstCheckCompletedReturnedPaperCount"] : null as any;
            this.enterDbCompletedPaperCount = _data["enterDbCompletedPaperCount"] !== undefined ? _data["enterDbCompletedPaperCount"] : null as any;
            this.doubleCheckCompletedPaperCount = _data["doubleCheckCompletedPaperCount"] !== undefined ? _data["doubleCheckCompletedPaperCount"] : null as any;
            this.shortReadCompletedPaperCount = _data["shortReadCompletedPaperCount"] !== undefined ? _data["shortReadCompletedPaperCount"] : null as any;
            this.referenceCheckCompletedPaperCount = _data["referenceCheckCompletedPaperCount"] !== undefined ? _data["referenceCheckCompletedPaperCount"] : null as any;
            this.tripleCheckCompletedPaperCount = _data["tripleCheckCompletedPaperCount"] !== undefined ? _data["tripleCheckCompletedPaperCount"] : null as any;
            this.tocReadCompletedPaperCount = _data["tocReadCompletedPaperCount"] !== undefined ? _data["tocReadCompletedPaperCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkerFullName"] = this.checkerFullName !== undefined ? this.checkerFullName : null as any;
        data["firstCheckCompletedPaperCount"] = this.firstCheckCompletedPaperCount !== undefined ? this.firstCheckCompletedPaperCount : null as any;
        data["firstCheckCompletedReturnedPaperCount"] = this.firstCheckCompletedReturnedPaperCount !== undefined ? this.firstCheckCompletedReturnedPaperCount : null as any;
        data["enterDbCompletedPaperCount"] = this.enterDbCompletedPaperCount !== undefined ? this.enterDbCompletedPaperCount : null as any;
        data["doubleCheckCompletedPaperCount"] = this.doubleCheckCompletedPaperCount !== undefined ? this.doubleCheckCompletedPaperCount : null as any;
        data["shortReadCompletedPaperCount"] = this.shortReadCompletedPaperCount !== undefined ? this.shortReadCompletedPaperCount : null as any;
        data["referenceCheckCompletedPaperCount"] = this.referenceCheckCompletedPaperCount !== undefined ? this.referenceCheckCompletedPaperCount : null as any;
        data["tripleCheckCompletedPaperCount"] = this.tripleCheckCompletedPaperCount !== undefined ? this.tripleCheckCompletedPaperCount : null as any;
        data["tocReadCompletedPaperCount"] = this.tocReadCompletedPaperCount !== undefined ? this.tocReadCompletedPaperCount : null as any;
        return data;
    }
}

export interface IApiCheckerHeader {
    checkerFullName?: string | null;
    firstCheckCompletedPaperCount?: number;
    firstCheckCompletedReturnedPaperCount?: number;
    enterDbCompletedPaperCount?: number;
    doubleCheckCompletedPaperCount?: number;
    shortReadCompletedPaperCount?: number;
    referenceCheckCompletedPaperCount?: number;
    tripleCheckCompletedPaperCount?: number;
    tocReadCompletedPaperCount?: number;
}

export class ApiCheckerStatistics implements IApiCheckerStatistics {
    firstCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    enterDbCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    doubleCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    shortReadStatistics?: ApiCheckerStatisticsEntry[] | null;
    referenceCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    tripleCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    tocReadCheckStatistics?: ApiCheckerStatisticsEntry[] | null;

    constructor(data?: IApiCheckerStatistics) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["firstCheckStatistics"])) {
                this.firstCheckStatistics = [] as any;
                for (let item of _data["firstCheckStatistics"])
                    this.firstCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.firstCheckStatistics = null as any;
            }
            if (Array.isArray(_data["enterDbCheckStatistics"])) {
                this.enterDbCheckStatistics = [] as any;
                for (let item of _data["enterDbCheckStatistics"])
                    this.enterDbCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.enterDbCheckStatistics = null as any;
            }
            if (Array.isArray(_data["doubleCheckStatistics"])) {
                this.doubleCheckStatistics = [] as any;
                for (let item of _data["doubleCheckStatistics"])
                    this.doubleCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.doubleCheckStatistics = null as any;
            }
            if (Array.isArray(_data["shortReadStatistics"])) {
                this.shortReadStatistics = [] as any;
                for (let item of _data["shortReadStatistics"])
                    this.shortReadStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.shortReadStatistics = null as any;
            }
            if (Array.isArray(_data["referenceCheckStatistics"])) {
                this.referenceCheckStatistics = [] as any;
                for (let item of _data["referenceCheckStatistics"])
                    this.referenceCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.referenceCheckStatistics = null as any;
            }
            if (Array.isArray(_data["tripleCheckStatistics"])) {
                this.tripleCheckStatistics = [] as any;
                for (let item of _data["tripleCheckStatistics"])
                    this.tripleCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.tripleCheckStatistics = null as any;
            }
            if (Array.isArray(_data["tocReadCheckStatistics"])) {
                this.tocReadCheckStatistics = [] as any;
                for (let item of _data["tocReadCheckStatistics"])
                    this.tocReadCheckStatistics!.push(ApiCheckerStatisticsEntry.fromJS(item));
            }
            else {
                this.tocReadCheckStatistics = null as any;
            }
        }
    }

    static fromJS(data: any): ApiCheckerStatistics {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerStatistics();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.firstCheckStatistics)) {
            data["firstCheckStatistics"] = [];
            for (let item of this.firstCheckStatistics)
                data["firstCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.enterDbCheckStatistics)) {
            data["enterDbCheckStatistics"] = [];
            for (let item of this.enterDbCheckStatistics)
                data["enterDbCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.doubleCheckStatistics)) {
            data["doubleCheckStatistics"] = [];
            for (let item of this.doubleCheckStatistics)
                data["doubleCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.shortReadStatistics)) {
            data["shortReadStatistics"] = [];
            for (let item of this.shortReadStatistics)
                data["shortReadStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.referenceCheckStatistics)) {
            data["referenceCheckStatistics"] = [];
            for (let item of this.referenceCheckStatistics)
                data["referenceCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tripleCheckStatistics)) {
            data["tripleCheckStatistics"] = [];
            for (let item of this.tripleCheckStatistics)
                data["tripleCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tocReadCheckStatistics)) {
            data["tocReadCheckStatistics"] = [];
            for (let item of this.tocReadCheckStatistics)
                data["tocReadCheckStatistics"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiCheckerStatistics {
    firstCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    enterDbCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    doubleCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    shortReadStatistics?: ApiCheckerStatisticsEntry[] | null;
    referenceCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    tripleCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
    tocReadCheckStatistics?: ApiCheckerStatisticsEntry[] | null;
}

export class ApiCheckerStatisticsEntry implements IApiCheckerStatisticsEntry {
    isbnPrint?: string | null;
    pageFrom?: number;
    splitPaperWork?: boolean;
    titleCheckId?: number;
    workId?: number;
    statisticsTimeEntries?: ApiCheckerStatisticsTimeEntry[] | null;
    checkType?: CheckTypeEnum;
    isReplacement?: boolean;

    constructor(data?: IApiCheckerStatisticsEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
            this.splitPaperWork = _data["splitPaperWork"] !== undefined ? _data["splitPaperWork"] : null as any;
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.workId = _data["workId"] !== undefined ? _data["workId"] : null as any;
            if (Array.isArray(_data["statisticsTimeEntries"])) {
                this.statisticsTimeEntries = [] as any;
                for (let item of _data["statisticsTimeEntries"])
                    this.statisticsTimeEntries!.push(ApiCheckerStatisticsTimeEntry.fromJS(item));
            }
            else {
                this.statisticsTimeEntries = null as any;
            }
            this.checkType = _data["checkType"] !== undefined ? _data["checkType"] : null as any;
            this.isReplacement = _data["isReplacement"] !== undefined ? _data["isReplacement"] : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerStatisticsEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerStatisticsEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        data["splitPaperWork"] = this.splitPaperWork !== undefined ? this.splitPaperWork : null as any;
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["workId"] = this.workId !== undefined ? this.workId : null as any;
        if (Array.isArray(this.statisticsTimeEntries)) {
            data["statisticsTimeEntries"] = [];
            for (let item of this.statisticsTimeEntries)
                data["statisticsTimeEntries"].push(item ? item.toJSON() : null as any);
        }
        data["checkType"] = this.checkType !== undefined ? this.checkType : null as any;
        data["isReplacement"] = this.isReplacement !== undefined ? this.isReplacement : null as any;
        return data;
    }
}

export interface IApiCheckerStatisticsEntry {
    isbnPrint?: string | null;
    pageFrom?: number;
    splitPaperWork?: boolean;
    titleCheckId?: number;
    workId?: number;
    statisticsTimeEntries?: ApiCheckerStatisticsTimeEntry[] | null;
    checkType?: CheckTypeEnum;
    isReplacement?: boolean;
}

export class ApiCheckerStatisticsTimeEntry implements IApiCheckerStatisticsTimeEntry {
    action?: WorkActionEnum;
    actionTime?: Date | null;

    constructor(data?: IApiCheckerStatisticsTimeEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.actionTime = _data["actionTime"] ? new Date(_data["actionTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiCheckerStatisticsTimeEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCheckerStatisticsTimeEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["actionTime"] = this.actionTime ? this.actionTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiCheckerStatisticsTimeEntry {
    action?: WorkActionEnum;
    actionTime?: Date | null;
}

export enum WorkActionEnum {
    Start = 0,
    Pause = 1,
    Refuse = 2,
    Complete = 3,
    Return = 4,
    Resume = 5,
    Restart = 6,
    Abort = 7,
}

export class ApiPageResultOfApiChapterListItem implements IApiPageResultOfApiChapterListItem {
    items?: ApiChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiChapterListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiChapterListItem {
    items?: ApiChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiChapterListItem implements IApiChapterListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    titlePartName?: string | null;
    @columnMap(() => String)
    name?: string | null;
    isAssigned?: boolean;

    constructor(data?: IApiChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.titlePartName = _data["titlePartName"] !== undefined ? _data["titlePartName"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.isAssigned = _data["isAssigned"] !== undefined ? _data["isAssigned"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["titlePartName"] = this.titlePartName !== undefined ? this.titlePartName : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["isAssigned"] = this.isAssigned !== undefined ? this.isAssigned : null as any;
        return data;
    }
}

export interface IApiChapterListItem {
    id?: number;
    pos?: number;
    titlePartName?: string | null;
    name?: string | null;
    isAssigned?: boolean;
}

export class ApiChapterItem implements IApiChapterItem {
    id?: number;
    name?: string | null;
    pos?: number;

    constructor(data?: IApiChapterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapterItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        return data;
    }
}

export interface IApiChapterItem {
    id?: number;
    name?: string | null;
    pos?: number;
}

export class ApiChapter implements IApiChapter {
    name: string;

    constructor(data?: IApiChapter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiChapter {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChapter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiChapter {
    name: string;
}

export class ApiTitleChapterValidation implements IApiTitleChapterValidation {
    titleHasChapters?: boolean;
    papersBelongToTitleChapters?: boolean;
    valid?: boolean;

    constructor(data?: IApiTitleChapterValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleHasChapters = _data["titleHasChapters"] !== undefined ? _data["titleHasChapters"] : null as any;
            this.papersBelongToTitleChapters = _data["papersBelongToTitleChapters"] !== undefined ? _data["papersBelongToTitleChapters"] : null as any;
            this.valid = _data["valid"] !== undefined ? _data["valid"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleChapterValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleChapterValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleHasChapters"] = this.titleHasChapters !== undefined ? this.titleHasChapters : null as any;
        data["papersBelongToTitleChapters"] = this.papersBelongToTitleChapters !== undefined ? this.papersBelongToTitleChapters : null as any;
        data["valid"] = this.valid !== undefined ? this.valid : null as any;
        return data;
    }
}

export interface IApiTitleChapterValidation {
    titleHasChapters?: boolean;
    papersBelongToTitleChapters?: boolean;
    valid?: boolean;
}

export class ApiTitleFile implements IApiTitleFile {
    memberId?: number;
    memberFullName?: string | null;
    file?: ApiFileInfo | null;
    type?: TitleFileType;

    constructor(data?: IApiTitleFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.memberFullName = _data["memberFullName"] !== undefined ? _data["memberFullName"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleFile {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["memberFullName"] = this.memberFullName !== undefined ? this.memberFullName : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiTitleFile {
    memberId?: number;
    memberFullName?: string | null;
    file?: ApiFileInfo | null;
    type?: TitleFileType;
}

export enum TitleFileType {
    HomePageEbookAndCd = 0,
    HomePagePrint = 1,
    TableOfContents = 2,
    AuthorIndex = 3,
    KeywordIndex = 4,
    TitleCover = 6,
    PrepressCover = 8,
    CoverSuggestion = 9,
    Calculation = 10,
    Contract = 11,
    ListOfReviewers = 12,
    CdCover = 13,
    Invoice = 14,
    PartCover = 15,
    EbookAndCdToC = 16,
    EbookAndCdAuthors = 17,
    EbookAndCdKeywords = 18,
    GeneratedHomePagePrint = 100,
    GeneratedAuthorIndex = 101,
    GeneratedTableOfContents = 102,
    GeneratedKeywordIndex = 103,
    GeneratedShortDoc = 104,
    GeneratedShortDb = 105,
    PrepressPrint = 106,
    PrepressEbook = 107,
    PartHomePagePrint = 109,
    PartToC = 110,
    PartAuthorIndex = 111,
    PartPrintPrepress = 112,
    PartKeywordIndex = 113,
    TocReadDoc = 114,
    EditorTableOfContents = 115,
    EditorKeywordIndex = 116,
    EbookEpub = 117,
    GeneratedListOfReviewers = 118,
}

export class ApiPageResultOfApiSuggestedJournalListItem implements IApiPageResultOfApiSuggestedJournalListItem {
    items?: ApiSuggestedJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiSuggestedJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiSuggestedJournalListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiSuggestedJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiSuggestedJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiSuggestedJournalListItem {
    items?: ApiSuggestedJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiSuggestedJournalListItem implements IApiSuggestedJournalListItem {
    @keyMap()
    journalId?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => ApiCreatorInfo)
    addedBy?: ApiCreatorInfo | null;

    constructor(data?: IApiSuggestedJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.addedBy = _data["addedBy"] ? ApiCreatorInfo.fromJS(_data["addedBy"]) : null as any;
        }
    }

    static fromJS(data: any): ApiSuggestedJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSuggestedJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : null as any;
        return data;
    }
}

export interface IApiSuggestedJournalListItem {
    journalId?: number;
    kurzel?: string | null;
    addedBy?: ApiCreatorInfo | null;
}

export class ApiTitleCatalogueGenerateRequest implements IApiTitleCatalogueGenerateRequest {
    periodicalIds?: number[] | null;
    dateType?: TitleCatalogueDateType;
    dateRange?: ApiDateRange | null;

    constructor(data?: IApiTitleCatalogueGenerateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["periodicalIds"])) {
                this.periodicalIds = [] as any;
                for (let item of _data["periodicalIds"])
                    this.periodicalIds!.push(item);
            }
            else {
                this.periodicalIds = null as any;
            }
            this.dateType = _data["dateType"] !== undefined ? _data["dateType"] : null as any;
            this.dateRange = _data["dateRange"] ? ApiDateRange.fromJS(_data["dateRange"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCatalogueGenerateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCatalogueGenerateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.periodicalIds)) {
            data["periodicalIds"] = [];
            for (let item of this.periodicalIds)
                data["periodicalIds"].push(item);
        }
        data["dateType"] = this.dateType !== undefined ? this.dateType : null as any;
        data["dateRange"] = this.dateRange ? this.dateRange.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleCatalogueGenerateRequest {
    periodicalIds?: number[] | null;
    dateType?: TitleCatalogueDateType;
    dateRange?: ApiDateRange | null;
}

export enum TitleCatalogueDateType {
    PrintDate = 0,
    WebDate = 1,
}

export class ApiTitleCoverSuggestion implements IApiTitleCoverSuggestion {
    id?: number;
    file?: ApiFileInfo | null;

    constructor(data?: IApiTitleCoverSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCoverSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCoverSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleCoverSuggestion {
    id?: number;
    file?: ApiFileInfo | null;
}

export class ApiTitleEditorChecklist implements IApiTitleEditorChecklist {
    submitted?: Date;
    papersAcceptedOrRejected?: boolean;
    chapterTitlesHaveBeenAdded?: boolean;
    makePapersOpenAccess?: boolean | null;
    openAccessPapersCount?: number | null;
    orderCopiesOfProceedings?: boolean | null;
    proceedingsPrintedSoftcoverCount?: number | null;
    proceedingsPrintedHardcoverCount?: number | null;
    proceedingsUsbCount?: number | null;
    deliveryOption?: TitleDeliveryOptionEnum | null;
    deliveryAddress?: ApiTitleEditorChecklistAddress | null;
    invoiceAddressSet?: boolean;
    invoiceAddress?: ApiTitleEditorChecklistAddress | null;
    documentsUploaded?: boolean;

    constructor(data?: IApiTitleEditorChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submitted = _data["submitted"] ? new Date(_data["submitted"].toString()) : null as any;
            this.papersAcceptedOrRejected = _data["papersAcceptedOrRejected"] !== undefined ? _data["papersAcceptedOrRejected"] : null as any;
            this.chapterTitlesHaveBeenAdded = _data["chapterTitlesHaveBeenAdded"] !== undefined ? _data["chapterTitlesHaveBeenAdded"] : null as any;
            this.makePapersOpenAccess = _data["makePapersOpenAccess"] !== undefined ? _data["makePapersOpenAccess"] : null as any;
            this.openAccessPapersCount = _data["openAccessPapersCount"] !== undefined ? _data["openAccessPapersCount"] : null as any;
            this.orderCopiesOfProceedings = _data["orderCopiesOfProceedings"] !== undefined ? _data["orderCopiesOfProceedings"] : null as any;
            this.proceedingsPrintedSoftcoverCount = _data["proceedingsPrintedSoftcoverCount"] !== undefined ? _data["proceedingsPrintedSoftcoverCount"] : null as any;
            this.proceedingsPrintedHardcoverCount = _data["proceedingsPrintedHardcoverCount"] !== undefined ? _data["proceedingsPrintedHardcoverCount"] : null as any;
            this.proceedingsUsbCount = _data["proceedingsUsbCount"] !== undefined ? _data["proceedingsUsbCount"] : null as any;
            this.deliveryOption = _data["deliveryOption"] !== undefined ? _data["deliveryOption"] : null as any;
            this.deliveryAddress = _data["deliveryAddress"] ? ApiTitleEditorChecklistAddress.fromJS(_data["deliveryAddress"]) : null as any;
            this.invoiceAddressSet = _data["invoiceAddressSet"] !== undefined ? _data["invoiceAddressSet"] : null as any;
            this.invoiceAddress = _data["invoiceAddress"] ? ApiTitleEditorChecklistAddress.fromJS(_data["invoiceAddress"]) : null as any;
            this.documentsUploaded = _data["documentsUploaded"] !== undefined ? _data["documentsUploaded"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleEditorChecklist {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleEditorChecklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submitted"] = this.submitted ? this.submitted.toISOString() : null as any;
        data["papersAcceptedOrRejected"] = this.papersAcceptedOrRejected !== undefined ? this.papersAcceptedOrRejected : null as any;
        data["chapterTitlesHaveBeenAdded"] = this.chapterTitlesHaveBeenAdded !== undefined ? this.chapterTitlesHaveBeenAdded : null as any;
        data["makePapersOpenAccess"] = this.makePapersOpenAccess !== undefined ? this.makePapersOpenAccess : null as any;
        data["openAccessPapersCount"] = this.openAccessPapersCount !== undefined ? this.openAccessPapersCount : null as any;
        data["orderCopiesOfProceedings"] = this.orderCopiesOfProceedings !== undefined ? this.orderCopiesOfProceedings : null as any;
        data["proceedingsPrintedSoftcoverCount"] = this.proceedingsPrintedSoftcoverCount !== undefined ? this.proceedingsPrintedSoftcoverCount : null as any;
        data["proceedingsPrintedHardcoverCount"] = this.proceedingsPrintedHardcoverCount !== undefined ? this.proceedingsPrintedHardcoverCount : null as any;
        data["proceedingsUsbCount"] = this.proceedingsUsbCount !== undefined ? this.proceedingsUsbCount : null as any;
        data["deliveryOption"] = this.deliveryOption !== undefined ? this.deliveryOption : null as any;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : null as any;
        data["invoiceAddressSet"] = this.invoiceAddressSet !== undefined ? this.invoiceAddressSet : null as any;
        data["invoiceAddress"] = this.invoiceAddress ? this.invoiceAddress.toJSON() : null as any;
        data["documentsUploaded"] = this.documentsUploaded !== undefined ? this.documentsUploaded : null as any;
        return data;
    }
}

export interface IApiTitleEditorChecklist {
    submitted?: Date;
    papersAcceptedOrRejected?: boolean;
    chapterTitlesHaveBeenAdded?: boolean;
    makePapersOpenAccess?: boolean | null;
    openAccessPapersCount?: number | null;
    orderCopiesOfProceedings?: boolean | null;
    proceedingsPrintedSoftcoverCount?: number | null;
    proceedingsPrintedHardcoverCount?: number | null;
    proceedingsUsbCount?: number | null;
    deliveryOption?: TitleDeliveryOptionEnum | null;
    deliveryAddress?: ApiTitleEditorChecklistAddress | null;
    invoiceAddressSet?: boolean;
    invoiceAddress?: ApiTitleEditorChecklistAddress | null;
    documentsUploaded?: boolean;
}

export enum TitleDeliveryOptionEnum {
    InBulk = 0,
    IndividualMailings = 1,
}

export class ApiTitleEditorChecklistAddress implements IApiTitleEditorChecklistAddress {
    company: string;
    contactPerson: string;
    countryId: string;
    email: string;
    city: string;
    phone?: string | null;
    street: string;
    zip: string;
    vat?: string | null;
    vatIsNotApplicable?: boolean | null;
    eori?: string | null;

    constructor(data?: IApiTitleEditorChecklistAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company = _data["company"] !== undefined ? _data["company"] : null as any;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            this.vatIsNotApplicable = _data["vatIsNotApplicable"] !== undefined ? _data["vatIsNotApplicable"] : null as any;
            this.eori = _data["eori"] !== undefined ? _data["eori"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleEditorChecklistAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleEditorChecklistAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company !== undefined ? this.company : null as any;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        data["vatIsNotApplicable"] = this.vatIsNotApplicable !== undefined ? this.vatIsNotApplicable : null as any;
        data["eori"] = this.eori !== undefined ? this.eori : null as any;
        return data;
    }
}

export interface IApiTitleEditorChecklistAddress {
    company: string;
    contactPerson: string;
    countryId: string;
    email: string;
    city: string;
    phone?: string | null;
    street: string;
    zip: string;
    vat?: string | null;
    vatIsNotApplicable?: boolean | null;
    eori?: string | null;
}

export class ApiTitle implements IApiTitle {
    id?: number;
    journal?: ApiTitleJournalDetails | null;
    name?: string | null;
    canDeleteCover?: boolean;
    hasCover?: boolean;
    detailsModel?: ApiTitleDetails | null;
    isbns?: ApiTitleIsbns | null;
    activity?: ApiActivity | null;
    coverValidationRules?: FileValidationModel | null;
    assignedProject?: ApiTitleAssignedProject | null;
    descriptions?: ApiTitleDescriptions | null;

    constructor(data?: IApiTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.journal = _data["journal"] ? ApiTitleJournalDetails.fromJS(_data["journal"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.canDeleteCover = _data["canDeleteCover"] !== undefined ? _data["canDeleteCover"] : null as any;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : null as any;
            this.detailsModel = _data["detailsModel"] ? ApiTitleDetails.fromJS(_data["detailsModel"]) : null as any;
            this.isbns = _data["isbns"] ? ApiTitleIsbns.fromJS(_data["isbns"]) : null as any;
            this.activity = _data["activity"] ? ApiActivity.fromJS(_data["activity"]) : null as any;
            this.coverValidationRules = _data["coverValidationRules"] ? FileValidationModel.fromJS(_data["coverValidationRules"]) : null as any;
            this.assignedProject = _data["assignedProject"] ? ApiTitleAssignedProject.fromJS(_data["assignedProject"]) : null as any;
            this.descriptions = _data["descriptions"] ? ApiTitleDescriptions.fromJS(_data["descriptions"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["journal"] = this.journal ? this.journal.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["canDeleteCover"] = this.canDeleteCover !== undefined ? this.canDeleteCover : null as any;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : null as any;
        data["detailsModel"] = this.detailsModel ? this.detailsModel.toJSON() : null as any;
        data["isbns"] = this.isbns ? this.isbns.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        data["coverValidationRules"] = this.coverValidationRules ? this.coverValidationRules.toJSON() : null as any;
        data["assignedProject"] = this.assignedProject ? this.assignedProject.toJSON() : null as any;
        data["descriptions"] = this.descriptions ? this.descriptions.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitle {
    id?: number;
    journal?: ApiTitleJournalDetails | null;
    name?: string | null;
    canDeleteCover?: boolean;
    hasCover?: boolean;
    detailsModel?: ApiTitleDetails | null;
    isbns?: ApiTitleIsbns | null;
    activity?: ApiActivity | null;
    coverValidationRules?: FileValidationModel | null;
    assignedProject?: ApiTitleAssignedProject | null;
    descriptions?: ApiTitleDescriptions | null;
}

export class ApiTitleJournalEditable implements IApiTitleJournalEditable {
    serialId: number;
    journalId?: number;
    volumeRange?: ApiRange | null;

    constructor(data?: IApiTitleJournalEditable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialId = _data["serialId"] !== undefined ? _data["serialId"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.volumeRange = _data["volumeRange"] ? ApiRange.fromJS(_data["volumeRange"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleJournalEditable {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleJournalEditable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialId"] = this.serialId !== undefined ? this.serialId : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["volumeRange"] = this.volumeRange ? this.volumeRange.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleJournalEditable {
    serialId: number;
    journalId?: number;
    volumeRange?: ApiRange | null;
}

export class ApiTitleJournalDetails extends ApiTitleJournalEditable implements IApiTitleJournalDetails {
    kurzel?: string | null;

    constructor(data?: IApiTitleJournalDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleJournalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleJournalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiTitleJournalDetails extends IApiTitleJournalEditable {
    kurzel?: string | null;
}

export class ApiTitleDetails implements IApiTitleDetails {
    type?: TitleTypeEnum;
    name: string;
    year?: number;
    subtitle?: string | null;
    editors?: string | null;
    volumeTitle: string;
    details?: string | null;
    dateWeb: Date;
    datePrint: Date;
    dateCd?: Date | null;
    finalManuscriptSubmissionDate?: Date | null;
    progressStatus?: ApiIdNameItem | null;

    constructor(data?: IApiTitleDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.subtitle = _data["subtitle"] !== undefined ? _data["subtitle"] : null as any;
            this.editors = _data["editors"] !== undefined ? _data["editors"] : null as any;
            this.volumeTitle = _data["volumeTitle"] !== undefined ? _data["volumeTitle"] : null as any;
            this.details = _data["details"] !== undefined ? _data["details"] : null as any;
            this.dateWeb = _data["dateWeb"] ? new Date(_data["dateWeb"].toString()) : null as any;
            this.datePrint = _data["datePrint"] ? new Date(_data["datePrint"].toString()) : null as any;
            this.dateCd = _data["dateCd"] ? new Date(_data["dateCd"].toString()) : null as any;
            this.finalManuscriptSubmissionDate = _data["finalManuscriptSubmissionDate"] ? new Date(_data["finalManuscriptSubmissionDate"].toString()) : null as any;
            this.progressStatus = _data["progressStatus"] ? ApiIdNameItem.fromJS(_data["progressStatus"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["subtitle"] = this.subtitle !== undefined ? this.subtitle : null as any;
        data["editors"] = this.editors !== undefined ? this.editors : null as any;
        data["volumeTitle"] = this.volumeTitle !== undefined ? this.volumeTitle : null as any;
        data["details"] = this.details !== undefined ? this.details : null as any;
        data["dateWeb"] = this.dateWeb ? this.dateWeb.toISOString() : null as any;
        data["datePrint"] = this.datePrint ? this.datePrint.toISOString() : null as any;
        data["dateCd"] = this.dateCd ? this.dateCd.toISOString() : null as any;
        data["finalManuscriptSubmissionDate"] = this.finalManuscriptSubmissionDate ? this.finalManuscriptSubmissionDate.toISOString() : null as any;
        data["progressStatus"] = this.progressStatus ? this.progressStatus.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleDetails {
    type?: TitleTypeEnum;
    name: string;
    year?: number;
    subtitle?: string | null;
    editors?: string | null;
    volumeTitle: string;
    details?: string | null;
    dateWeb: Date;
    datePrint: Date;
    dateCd?: Date | null;
    finalManuscriptSubmissionDate?: Date | null;
    progressStatus?: ApiIdNameItem | null;
}

export enum TitleTypeEnum {
    ConferenceProceedings = 0,
    SpecialTopic = 1,
    AggregatedBook = 2,
    Monograph = 3,
    JournalVolume = 4,
    AbstractsBook = 5,
}

export class ApiTitleIsbns implements IApiTitleIsbns {
    externalIsbnsAvailable?: boolean;
    isInternal?: boolean;
    isbnPrint?: ApiTitleIsbn | null;
    isbnEbook?: ApiTitleIsbn | null;
    isbnCd?: ApiTitleIsbn | null;
    kisbn?: string | null;

    constructor(data?: IApiTitleIsbns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIsbnsAvailable = _data["externalIsbnsAvailable"] !== undefined ? _data["externalIsbnsAvailable"] : null as any;
            this.isInternal = _data["isInternal"] !== undefined ? _data["isInternal"] : null as any;
            this.isbnPrint = _data["isbnPrint"] ? ApiTitleIsbn.fromJS(_data["isbnPrint"]) : null as any;
            this.isbnEbook = _data["isbnEbook"] ? ApiTitleIsbn.fromJS(_data["isbnEbook"]) : null as any;
            this.isbnCd = _data["isbnCd"] ? ApiTitleIsbn.fromJS(_data["isbnCd"]) : null as any;
            this.kisbn = _data["kisbn"] !== undefined ? _data["kisbn"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleIsbns {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleIsbns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIsbnsAvailable"] = this.externalIsbnsAvailable !== undefined ? this.externalIsbnsAvailable : null as any;
        data["isInternal"] = this.isInternal !== undefined ? this.isInternal : null as any;
        data["isbnPrint"] = this.isbnPrint ? this.isbnPrint.toJSON() : null as any;
        data["isbnEbook"] = this.isbnEbook ? this.isbnEbook.toJSON() : null as any;
        data["isbnCd"] = this.isbnCd ? this.isbnCd.toJSON() : null as any;
        data["kisbn"] = this.kisbn !== undefined ? this.kisbn : null as any;
        return data;
    }
}

export interface IApiTitleIsbns {
    externalIsbnsAvailable?: boolean;
    isInternal?: boolean;
    isbnPrint?: ApiTitleIsbn | null;
    isbnEbook?: ApiTitleIsbn | null;
    isbnCd?: ApiTitleIsbn | null;
    kisbn?: string | null;
}

export class ApiTitleIsbn implements IApiTitleIsbn {
    isbn?: string | null;
    isbnType?: TitleIsbnTypeEnum;

    constructor(data?: IApiTitleIsbn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isbn = _data["isbn"] !== undefined ? _data["isbn"] : null as any;
            this.isbnType = _data["isbnType"] !== undefined ? _data["isbnType"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleIsbn {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleIsbn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isbn"] = this.isbn !== undefined ? this.isbn : null as any;
        data["isbnType"] = this.isbnType !== undefined ? this.isbnType : null as any;
        return data;
    }
}

export interface IApiTitleIsbn {
    isbn?: string | null;
    isbnType?: TitleIsbnTypeEnum;
}

export enum TitleIsbnTypeEnum {
    Internal = 0,
    External = 1,
}

export class ApiTitleAssignedProject implements IApiTitleAssignedProject {
    projectId?: number;
    name?: string | null;
    shortName?: string | null;
    edition?: string | null;
    period?: ApiDateRange | null;
    countryId?: string | null;
    city?: string | null;
    website?: string | null;
    estimatedPublicationsPaperCount?: number | null;
    estimatedPublicationsPageCount?: number | null;
    description?: string | null;

    constructor(data?: IApiTitleAssignedProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.edition = _data["edition"] !== undefined ? _data["edition"] : null as any;
            this.period = _data["period"] ? ApiDateRange.fromJS(_data["period"]) : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.estimatedPublicationsPaperCount = _data["estimatedPublicationsPaperCount"] !== undefined ? _data["estimatedPublicationsPaperCount"] : null as any;
            this.estimatedPublicationsPageCount = _data["estimatedPublicationsPageCount"] !== undefined ? _data["estimatedPublicationsPageCount"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleAssignedProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleAssignedProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["edition"] = this.edition !== undefined ? this.edition : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["estimatedPublicationsPaperCount"] = this.estimatedPublicationsPaperCount !== undefined ? this.estimatedPublicationsPaperCount : null as any;
        data["estimatedPublicationsPageCount"] = this.estimatedPublicationsPageCount !== undefined ? this.estimatedPublicationsPageCount : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IApiTitleAssignedProject {
    projectId?: number;
    name?: string | null;
    shortName?: string | null;
    edition?: string | null;
    period?: ApiDateRange | null;
    countryId?: string | null;
    city?: string | null;
    website?: string | null;
    estimatedPublicationsPaperCount?: number | null;
    estimatedPublicationsPageCount?: number | null;
    description?: string | null;
}

export class ApiTitleDescriptions implements IApiTitleDescriptions {
    shortDescription?: string | null;
    ringgoldSubjects?: string | null;

    constructor(data?: IApiTitleDescriptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
            this.ringgoldSubjects = _data["ringgoldSubjects"] !== undefined ? _data["ringgoldSubjects"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleDescriptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleDescriptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        data["ringgoldSubjects"] = this.ringgoldSubjects !== undefined ? this.ringgoldSubjects : null as any;
        return data;
    }
}

export interface IApiTitleDescriptions {
    shortDescription?: string | null;
    ringgoldSubjects?: string | null;
}

export class ApiTitleMoveSummary implements IApiTitleMoveSummary {
    titleId?: number;
    isbnPrint?: string | null;
    paperCount?: number;

    constructor(data?: IApiTitleMoveSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.paperCount = _data["paperCount"] !== undefined ? _data["paperCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleMoveSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleMoveSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["paperCount"] = this.paperCount !== undefined ? this.paperCount : null as any;
        return data;
    }
}

export interface IApiTitleMoveSummary {
    titleId?: number;
    isbnPrint?: string | null;
    paperCount?: number;
}

export enum TitleStatusEnum {
    New = 0,
    EditorialProcessPending = 1,
    EditorialProcessInWork = 2,
    ReadyForScientificCheck = 3,
    ScientificCheckInWork = 4,
    ScientificCheckCompleted = 5,
    ScientificCheckReturnedToEditors = 6,
    ScientificCheckCanceled = 7,
    TechnicalCheckWaiting = 8,
    TechnicalCheckInWork = 9,
    TechnicalCheckCompleted = 10,
    Forthcoming = 11,
    Online = 12,
    Canceled = 13,
    Undefined = -1,
}

export class ApiOnlineValidation implements IApiOnlineValidation {
    titleMustContainPriceInUSD?: boolean;
    datePrintCantBeEmpty?: boolean;
    dateWebCantBeEmpty?: boolean;
    volumeNumberCantBeEmpty?: boolean;
    titleMustContainSubjectCategories?: boolean;
    weightCantBeZero?: boolean;
    titleMustHaveCover?: boolean;
    papersMustHaveCurrentPdfFile?: boolean;

    constructor(data?: IApiOnlineValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleMustContainPriceInUSD = _data["titleMustContainPriceInUSD"] !== undefined ? _data["titleMustContainPriceInUSD"] : null as any;
            this.datePrintCantBeEmpty = _data["datePrintCantBeEmpty"] !== undefined ? _data["datePrintCantBeEmpty"] : null as any;
            this.dateWebCantBeEmpty = _data["dateWebCantBeEmpty"] !== undefined ? _data["dateWebCantBeEmpty"] : null as any;
            this.volumeNumberCantBeEmpty = _data["volumeNumberCantBeEmpty"] !== undefined ? _data["volumeNumberCantBeEmpty"] : null as any;
            this.titleMustContainSubjectCategories = _data["titleMustContainSubjectCategories"] !== undefined ? _data["titleMustContainSubjectCategories"] : null as any;
            this.weightCantBeZero = _data["weightCantBeZero"] !== undefined ? _data["weightCantBeZero"] : null as any;
            this.titleMustHaveCover = _data["titleMustHaveCover"] !== undefined ? _data["titleMustHaveCover"] : null as any;
            this.papersMustHaveCurrentPdfFile = _data["papersMustHaveCurrentPdfFile"] !== undefined ? _data["papersMustHaveCurrentPdfFile"] : null as any;
        }
    }

    static fromJS(data: any): ApiOnlineValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiOnlineValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleMustContainPriceInUSD"] = this.titleMustContainPriceInUSD !== undefined ? this.titleMustContainPriceInUSD : null as any;
        data["datePrintCantBeEmpty"] = this.datePrintCantBeEmpty !== undefined ? this.datePrintCantBeEmpty : null as any;
        data["dateWebCantBeEmpty"] = this.dateWebCantBeEmpty !== undefined ? this.dateWebCantBeEmpty : null as any;
        data["volumeNumberCantBeEmpty"] = this.volumeNumberCantBeEmpty !== undefined ? this.volumeNumberCantBeEmpty : null as any;
        data["titleMustContainSubjectCategories"] = this.titleMustContainSubjectCategories !== undefined ? this.titleMustContainSubjectCategories : null as any;
        data["weightCantBeZero"] = this.weightCantBeZero !== undefined ? this.weightCantBeZero : null as any;
        data["titleMustHaveCover"] = this.titleMustHaveCover !== undefined ? this.titleMustHaveCover : null as any;
        data["papersMustHaveCurrentPdfFile"] = this.papersMustHaveCurrentPdfFile !== undefined ? this.papersMustHaveCurrentPdfFile : null as any;
        return data;
    }
}

export interface IApiOnlineValidation {
    titleMustContainPriceInUSD?: boolean;
    datePrintCantBeEmpty?: boolean;
    dateWebCantBeEmpty?: boolean;
    volumeNumberCantBeEmpty?: boolean;
    titleMustContainSubjectCategories?: boolean;
    weightCantBeZero?: boolean;
    titleMustHaveCover?: boolean;
    papersMustHaveCurrentPdfFile?: boolean;
}

export class ApiTitleInfoActions implements IApiTitleInfoActions {
    status?: TitleStatusEnum;
    disableInEditingTool?: boolean;
    inActiveEditorPeriod?: boolean;
    publishInForthcoming?: boolean;
    publicationDateHasNotYetArrived?: boolean;
    publicationDateHasArrived?: boolean;

    constructor(data?: IApiTitleInfoActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.disableInEditingTool = _data["disableInEditingTool"] !== undefined ? _data["disableInEditingTool"] : null as any;
            this.inActiveEditorPeriod = _data["inActiveEditorPeriod"] !== undefined ? _data["inActiveEditorPeriod"] : null as any;
            this.publishInForthcoming = _data["publishInForthcoming"] !== undefined ? _data["publishInForthcoming"] : null as any;
            this.publicationDateHasNotYetArrived = _data["publicationDateHasNotYetArrived"] !== undefined ? _data["publicationDateHasNotYetArrived"] : null as any;
            this.publicationDateHasArrived = _data["publicationDateHasArrived"] !== undefined ? _data["publicationDateHasArrived"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleInfoActions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleInfoActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["disableInEditingTool"] = this.disableInEditingTool !== undefined ? this.disableInEditingTool : null as any;
        data["inActiveEditorPeriod"] = this.inActiveEditorPeriod !== undefined ? this.inActiveEditorPeriod : null as any;
        data["publishInForthcoming"] = this.publishInForthcoming !== undefined ? this.publishInForthcoming : null as any;
        data["publicationDateHasNotYetArrived"] = this.publicationDateHasNotYetArrived !== undefined ? this.publicationDateHasNotYetArrived : null as any;
        data["publicationDateHasArrived"] = this.publicationDateHasArrived !== undefined ? this.publicationDateHasArrived : null as any;
        return data;
    }
}

export interface IApiTitleInfoActions {
    status?: TitleStatusEnum;
    disableInEditingTool?: boolean;
    inActiveEditorPeriod?: boolean;
    publishInForthcoming?: boolean;
    publicationDateHasNotYetArrived?: boolean;
    publicationDateHasArrived?: boolean;
}

export class ApiPageResultOfApiPeriodicalKeywordListItem implements IApiPageResultOfApiPeriodicalKeywordListItem {
    items?: ApiPeriodicalKeywordListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPeriodicalKeywordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPeriodicalKeywordListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPeriodicalKeywordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPeriodicalKeywordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPeriodicalKeywordListItem {
    items?: ApiPeriodicalKeywordListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPeriodicalKeywordListItem implements IApiPeriodicalKeywordListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    keyword?: string | null;

    constructor(data?: IApiPeriodicalKeywordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): ApiPeriodicalKeywordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPeriodicalKeywordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

export interface IApiPeriodicalKeywordListItem {
    id?: number;
    keyword?: string | null;
}

export class ApiPageResultOfApiNoteListItem implements IApiPageResultOfApiNoteListItem {
    items?: ApiNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiNoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiNoteListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiNoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiNoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiNoteListItem {
    items?: ApiNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPageResultOfApiPaperNoteListItem implements IApiPageResultOfApiPaperNoteListItem {
    items?: ApiPaperNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperNoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperNoteListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperNoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperNoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperNoteListItem {
    items?: ApiPaperNoteListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperNoteListItem implements IApiPaperNoteListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiPaperInfo)
    paper?: ApiPaperInfo | null;
    @columnMap(() => NoteTypeEnum)
    noteType?: NoteTypeEnum;
    @columnMap(() => String)
    description?: string | null;
    @columnMap(() => ApiFileInfo)
    attachment?: ApiFileInfo | null;
    @columnMap(() => ApiIdNameItem)
    createdBy?: ApiIdNameItem | null;
    @columnMap(() => Date)
    lastUpdated?: Date;
    titleId?: number;

    constructor(data?: IApiPaperNoteListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paper = _data["paper"] ? ApiPaperInfo.fromJS(_data["paper"]) : null as any;
            this.noteType = _data["noteType"] !== undefined ? _data["noteType"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.attachment = _data["attachment"] ? ApiFileInfo.fromJS(_data["attachment"]) : null as any;
            this.createdBy = _data["createdBy"] ? ApiIdNameItem.fromJS(_data["createdBy"]) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperNoteListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperNoteListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paper"] = this.paper ? this.paper.toJSON() : null as any;
        data["noteType"] = this.noteType !== undefined ? this.noteType : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        return data;
    }
}

export interface IApiPaperNoteListItem {
    id?: number;
    paper?: ApiPaperInfo | null;
    noteType?: NoteTypeEnum;
    description?: string | null;
    attachment?: ApiFileInfo | null;
    createdBy?: ApiIdNameItem | null;
    lastUpdated?: Date;
    titleId?: number;
}

export class ApiPaperInfo implements IApiPaperInfo {
    id?: number;
    name?: string | null;
    pageFrom?: number;

    constructor(data?: IApiPaperInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        return data;
    }
}

export interface IApiPaperInfo {
    id?: number;
    name?: string | null;
    pageFrom?: number;
}

export class ApiTitleOperations implements IApiTitleOperations {
    titleId?: number;
    technicalCheck?: ApiTitleTechnicalCheck | null;
    isStartCheckDisabled?: boolean;
    titlePartOperations?: ApiTitlePartOperations | null;
    pdfAccessibilityStatus?: PdfAccessibilityStatus;
    pdfAccessibilityCheck?: PdfAccessibilityCheck;
    isPdfAccessibilityCheckDisabled?: boolean;
    movePapersOperations?: ApiMovePapersOperations | null;
    isImportPaperCopiesDisabled?: boolean;
    hasImportPaperCopiesExample?: boolean;

    constructor(data?: IApiTitleOperations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.technicalCheck = _data["technicalCheck"] ? ApiTitleTechnicalCheck.fromJS(_data["technicalCheck"]) : null as any;
            this.isStartCheckDisabled = _data["isStartCheckDisabled"] !== undefined ? _data["isStartCheckDisabled"] : null as any;
            this.titlePartOperations = _data["titlePartOperations"] ? ApiTitlePartOperations.fromJS(_data["titlePartOperations"]) : null as any;
            this.pdfAccessibilityStatus = _data["pdfAccessibilityStatus"] !== undefined ? _data["pdfAccessibilityStatus"] : null as any;
            this.pdfAccessibilityCheck = _data["pdfAccessibilityCheck"] !== undefined ? _data["pdfAccessibilityCheck"] : null as any;
            this.isPdfAccessibilityCheckDisabled = _data["isPdfAccessibilityCheckDisabled"] !== undefined ? _data["isPdfAccessibilityCheckDisabled"] : null as any;
            this.movePapersOperations = _data["movePapersOperations"] ? ApiMovePapersOperations.fromJS(_data["movePapersOperations"]) : null as any;
            this.isImportPaperCopiesDisabled = _data["isImportPaperCopiesDisabled"] !== undefined ? _data["isImportPaperCopiesDisabled"] : null as any;
            this.hasImportPaperCopiesExample = _data["hasImportPaperCopiesExample"] !== undefined ? _data["hasImportPaperCopiesExample"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleOperations {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleOperations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["technicalCheck"] = this.technicalCheck ? this.technicalCheck.toJSON() : null as any;
        data["isStartCheckDisabled"] = this.isStartCheckDisabled !== undefined ? this.isStartCheckDisabled : null as any;
        data["titlePartOperations"] = this.titlePartOperations ? this.titlePartOperations.toJSON() : null as any;
        data["pdfAccessibilityStatus"] = this.pdfAccessibilityStatus !== undefined ? this.pdfAccessibilityStatus : null as any;
        data["pdfAccessibilityCheck"] = this.pdfAccessibilityCheck !== undefined ? this.pdfAccessibilityCheck : null as any;
        data["isPdfAccessibilityCheckDisabled"] = this.isPdfAccessibilityCheckDisabled !== undefined ? this.isPdfAccessibilityCheckDisabled : null as any;
        data["movePapersOperations"] = this.movePapersOperations ? this.movePapersOperations.toJSON() : null as any;
        data["isImportPaperCopiesDisabled"] = this.isImportPaperCopiesDisabled !== undefined ? this.isImportPaperCopiesDisabled : null as any;
        data["hasImportPaperCopiesExample"] = this.hasImportPaperCopiesExample !== undefined ? this.hasImportPaperCopiesExample : null as any;
        return data;
    }
}

export interface IApiTitleOperations {
    titleId?: number;
    technicalCheck?: ApiTitleTechnicalCheck | null;
    isStartCheckDisabled?: boolean;
    titlePartOperations?: ApiTitlePartOperations | null;
    pdfAccessibilityStatus?: PdfAccessibilityStatus;
    pdfAccessibilityCheck?: PdfAccessibilityCheck;
    isPdfAccessibilityCheckDisabled?: boolean;
    movePapersOperations?: ApiMovePapersOperations | null;
    isImportPaperCopiesDisabled?: boolean;
    hasImportPaperCopiesExample?: boolean;
}

export class ApiTitleTechnicalCheck implements IApiTitleTechnicalCheck {
    id?: number;
    state?: TitleTechnicalCheckStateEnum;
    lastUpdate?: Date;

    constructor(data?: IApiTitleTechnicalCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.lastUpdate = _data["lastUpdate"] ? new Date(_data["lastUpdate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleTechnicalCheck {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleTechnicalCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["lastUpdate"] = this.lastUpdate ? this.lastUpdate.toISOString() : null as any;
        return data;
    }
}

export interface IApiTitleTechnicalCheck {
    id?: number;
    state?: TitleTechnicalCheckStateEnum;
    lastUpdate?: Date;
}

export enum TitleTechnicalCheckStateEnum {
    Waiting = 0,
    InWork = 1,
    Completed = 2,
}

export class ApiTitlePartOperations implements IApiTitlePartOperations {
    hasChapters?: boolean;
    canAddTitleParts?: boolean;
    canAssignTitleParts?: boolean;

    constructor(data?: IApiTitlePartOperations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasChapters = _data["hasChapters"] !== undefined ? _data["hasChapters"] : null as any;
            this.canAddTitleParts = _data["canAddTitleParts"] !== undefined ? _data["canAddTitleParts"] : null as any;
            this.canAssignTitleParts = _data["canAssignTitleParts"] !== undefined ? _data["canAssignTitleParts"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePartOperations {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePartOperations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasChapters"] = this.hasChapters !== undefined ? this.hasChapters : null as any;
        data["canAddTitleParts"] = this.canAddTitleParts !== undefined ? this.canAddTitleParts : null as any;
        data["canAssignTitleParts"] = this.canAssignTitleParts !== undefined ? this.canAssignTitleParts : null as any;
        return data;
    }
}

export interface IApiTitlePartOperations {
    hasChapters?: boolean;
    canAddTitleParts?: boolean;
    canAssignTitleParts?: boolean;
}

export enum PdfAccessibilityStatus {
    None = 0,
    Processing = 1,
    FileNotFound = 2,
    Failed = 3,
    Success = 4,
}

export enum PdfAccessibilityCheck {
    NotChecked = 0,
    Passed = 1,
    Failed = 2,
}

export class ApiMovePapersOperations implements IApiMovePapersOperations {
    hasChapters?: boolean;
    hasTitleParts?: boolean;
    isMoveDisabled?: boolean;

    constructor(data?: IApiMovePapersOperations) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasChapters = _data["hasChapters"] !== undefined ? _data["hasChapters"] : null as any;
            this.hasTitleParts = _data["hasTitleParts"] !== undefined ? _data["hasTitleParts"] : null as any;
            this.isMoveDisabled = _data["isMoveDisabled"] !== undefined ? _data["isMoveDisabled"] : null as any;
        }
    }

    static fromJS(data: any): ApiMovePapersOperations {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMovePapersOperations();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasChapters"] = this.hasChapters !== undefined ? this.hasChapters : null as any;
        data["hasTitleParts"] = this.hasTitleParts !== undefined ? this.hasTitleParts : null as any;
        data["isMoveDisabled"] = this.isMoveDisabled !== undefined ? this.isMoveDisabled : null as any;
        return data;
    }
}

export interface IApiMovePapersOperations {
    hasChapters?: boolean;
    hasTitleParts?: boolean;
    isMoveDisabled?: boolean;
}

export enum TitleTechnicalCheckPriorityEnum {
    Normal = 0,
    High = 1,
}

export class ApiTitleTechnicalCheckValidation implements IApiTitleTechnicalCheckValidation {
    titleId?: number;
    checkAlreadyExists?: boolean;
    titleDoesNotHaveAcceptablePapers?: boolean;
    papersWithDuplicatePagesFrom?: number[] | null;
    papersWithoutCurrentFiles?: { [key: string]: string[]; } | null;
    hasErrors?: boolean;

    constructor(data?: IApiTitleTechnicalCheckValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.checkAlreadyExists = _data["checkAlreadyExists"] !== undefined ? _data["checkAlreadyExists"] : null as any;
            this.titleDoesNotHaveAcceptablePapers = _data["titleDoesNotHaveAcceptablePapers"] !== undefined ? _data["titleDoesNotHaveAcceptablePapers"] : null as any;
            if (Array.isArray(_data["papersWithDuplicatePagesFrom"])) {
                this.papersWithDuplicatePagesFrom = [] as any;
                for (let item of _data["papersWithDuplicatePagesFrom"])
                    this.papersWithDuplicatePagesFrom!.push(item);
            }
            else {
                this.papersWithDuplicatePagesFrom = null as any;
            }
            if (_data["papersWithoutCurrentFiles"]) {
                this.papersWithoutCurrentFiles = {} as any;
                for (let key in _data["papersWithoutCurrentFiles"]) {
                    if (_data["papersWithoutCurrentFiles"].hasOwnProperty(key))
                        (this.papersWithoutCurrentFiles as any)![key] = _data["papersWithoutCurrentFiles"][key] !== undefined ? _data["papersWithoutCurrentFiles"][key] : [];
                }
            }
            else {
                this.papersWithoutCurrentFiles = null as any;
            }
            this.hasErrors = _data["hasErrors"] !== undefined ? _data["hasErrors"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleTechnicalCheckValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleTechnicalCheckValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["checkAlreadyExists"] = this.checkAlreadyExists !== undefined ? this.checkAlreadyExists : null as any;
        data["titleDoesNotHaveAcceptablePapers"] = this.titleDoesNotHaveAcceptablePapers !== undefined ? this.titleDoesNotHaveAcceptablePapers : null as any;
        if (Array.isArray(this.papersWithDuplicatePagesFrom)) {
            data["papersWithDuplicatePagesFrom"] = [];
            for (let item of this.papersWithDuplicatePagesFrom)
                data["papersWithDuplicatePagesFrom"].push(item);
        }
        if (this.papersWithoutCurrentFiles) {
            data["papersWithoutCurrentFiles"] = {};
            for (let key in this.papersWithoutCurrentFiles) {
                if (this.papersWithoutCurrentFiles.hasOwnProperty(key))
                    (data["papersWithoutCurrentFiles"] as any)[key] = this.papersWithoutCurrentFiles[key] !== undefined ? this.papersWithoutCurrentFiles[key] : null as any;
            }
        }
        data["hasErrors"] = this.hasErrors !== undefined ? this.hasErrors : null as any;
        return data;
    }
}

export interface IApiTitleTechnicalCheckValidation {
    titleId?: number;
    checkAlreadyExists?: boolean;
    titleDoesNotHaveAcceptablePapers?: boolean;
    papersWithDuplicatePagesFrom?: number[] | null;
    papersWithoutCurrentFiles?: { [key: string]: string[]; } | null;
    hasErrors?: boolean;
}

export class ApiPageResultOfApiTitleRenumberReportListItem implements IApiPageResultOfApiTitleRenumberReportListItem {
    items?: ApiTitleRenumberReportListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleRenumberReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleRenumberReportListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleRenumberReportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleRenumberReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleRenumberReportListItem {
    items?: ApiTitleRenumberReportListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleRenumberReportListItem implements IApiTitleRenumberReportListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Date)
    lastUpdated?: Date | null;
    @columnMap(() => ApiIdNameItem)
    performer?: ApiIdNameItem | null;

    constructor(data?: IApiTitleRenumberReportListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.performer = _data["performer"] ? ApiIdNameItem.fromJS(_data["performer"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleRenumberReportListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleRenumberReportListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["performer"] = this.performer ? this.performer.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleRenumberReportListItem {
    id?: number;
    lastUpdated?: Date | null;
    performer?: ApiIdNameItem | null;
}

export class ApiTitleRenumberReport implements IApiTitleRenumberReport {
    titleId?: number;
    lastUpdated?: Date | null;
    performer?: ApiIdNameItem | null;
    papers?: ApiTitleRenumberReportPaper[] | null;

    constructor(data?: IApiTitleRenumberReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.performer = _data["performer"] ? ApiIdNameItem.fromJS(_data["performer"]) : null as any;
            if (Array.isArray(_data["papers"])) {
                this.papers = [] as any;
                for (let item of _data["papers"])
                    this.papers!.push(ApiTitleRenumberReportPaper.fromJS(item));
            }
            else {
                this.papers = null as any;
            }
        }
    }

    static fromJS(data: any): ApiTitleRenumberReport {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleRenumberReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["performer"] = this.performer ? this.performer.toJSON() : null as any;
        if (Array.isArray(this.papers)) {
            data["papers"] = [];
            for (let item of this.papers)
                data["papers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiTitleRenumberReport {
    titleId?: number;
    lastUpdated?: Date | null;
    performer?: ApiIdNameItem | null;
    papers?: ApiTitleRenumberReportPaper[] | null;
}

export class ApiTitleRenumberReportPaper implements IApiTitleRenumberReportPaper {
    paperId?: number | null;
    oldPageFrom?: number;
    oldPageTo?: number;
    newPageFrom?: number;
    newPageTo?: number;

    constructor(data?: IApiTitleRenumberReportPaper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.oldPageFrom = _data["oldPageFrom"] !== undefined ? _data["oldPageFrom"] : null as any;
            this.oldPageTo = _data["oldPageTo"] !== undefined ? _data["oldPageTo"] : null as any;
            this.newPageFrom = _data["newPageFrom"] !== undefined ? _data["newPageFrom"] : null as any;
            this.newPageTo = _data["newPageTo"] !== undefined ? _data["newPageTo"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleRenumberReportPaper {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleRenumberReportPaper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["oldPageFrom"] = this.oldPageFrom !== undefined ? this.oldPageFrom : null as any;
        data["oldPageTo"] = this.oldPageTo !== undefined ? this.oldPageTo : null as any;
        data["newPageFrom"] = this.newPageFrom !== undefined ? this.newPageFrom : null as any;
        data["newPageTo"] = this.newPageTo !== undefined ? this.newPageTo : null as any;
        return data;
    }
}

export interface IApiTitleRenumberReportPaper {
    paperId?: number | null;
    oldPageFrom?: number;
    oldPageTo?: number;
    newPageFrom?: number;
    newPageTo?: number;
}

export class ApiAssignTitlePartsValidation implements IApiAssignTitlePartsValidation {
    somePageFromAreNull?: boolean;
    pageFromAreNotAscending?: boolean;
    hasErrors?: boolean;

    constructor(data?: IApiAssignTitlePartsValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.somePageFromAreNull = _data["somePageFromAreNull"] !== undefined ? _data["somePageFromAreNull"] : null as any;
            this.pageFromAreNotAscending = _data["pageFromAreNotAscending"] !== undefined ? _data["pageFromAreNotAscending"] : null as any;
            this.hasErrors = _data["hasErrors"] !== undefined ? _data["hasErrors"] : null as any;
        }
    }

    static fromJS(data: any): ApiAssignTitlePartsValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAssignTitlePartsValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["somePageFromAreNull"] = this.somePageFromAreNull !== undefined ? this.somePageFromAreNull : null as any;
        data["pageFromAreNotAscending"] = this.pageFromAreNotAscending !== undefined ? this.pageFromAreNotAscending : null as any;
        data["hasErrors"] = this.hasErrors !== undefined ? this.hasErrors : null as any;
        return data;
    }
}

export interface IApiAssignTitlePartsValidation {
    somePageFromAreNull?: boolean;
    pageFromAreNotAscending?: boolean;
    hasErrors?: boolean;
}

export class ApiMovePapersResult implements IApiMovePapersResult {
    destinationTitleId?: number;
    movedPaperCount?: number;

    constructor(data?: IApiMovePapersResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationTitleId = _data["destinationTitleId"] !== undefined ? _data["destinationTitleId"] : null as any;
            this.movedPaperCount = _data["movedPaperCount"] !== undefined ? _data["movedPaperCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiMovePapersResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMovePapersResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationTitleId"] = this.destinationTitleId !== undefined ? this.destinationTitleId : null as any;
        data["movedPaperCount"] = this.movedPaperCount !== undefined ? this.movedPaperCount : null as any;
        return data;
    }
}

export interface IApiMovePapersResult {
    destinationTitleId?: number;
    movedPaperCount?: number;
}

export class ApiMovePapersRequest implements IApiMovePapersRequest {
    destinationTitleId?: number;
    operation?: MoveOperation;
    paperStatus?: PaperStatusEnum | null;
    pageFrom?: number | null;
    pageTo?: number | null;
    titlePartIds?: number[] | null;
    chapterIds?: number[] | null;

    constructor(data?: IApiMovePapersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destinationTitleId = _data["destinationTitleId"] !== undefined ? _data["destinationTitleId"] : null as any;
            this.operation = _data["operation"] !== undefined ? _data["operation"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
            this.pageTo = _data["pageTo"] !== undefined ? _data["pageTo"] : null as any;
            if (Array.isArray(_data["titlePartIds"])) {
                this.titlePartIds = [] as any;
                for (let item of _data["titlePartIds"])
                    this.titlePartIds!.push(item);
            }
            else {
                this.titlePartIds = null as any;
            }
            if (Array.isArray(_data["chapterIds"])) {
                this.chapterIds = [] as any;
                for (let item of _data["chapterIds"])
                    this.chapterIds!.push(item);
            }
            else {
                this.chapterIds = null as any;
            }
        }
    }

    static fromJS(data: any): ApiMovePapersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMovePapersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destinationTitleId"] = this.destinationTitleId !== undefined ? this.destinationTitleId : null as any;
        data["operation"] = this.operation !== undefined ? this.operation : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        data["pageTo"] = this.pageTo !== undefined ? this.pageTo : null as any;
        if (Array.isArray(this.titlePartIds)) {
            data["titlePartIds"] = [];
            for (let item of this.titlePartIds)
                data["titlePartIds"].push(item);
        }
        if (Array.isArray(this.chapterIds)) {
            data["chapterIds"] = [];
            for (let item of this.chapterIds)
                data["chapterIds"].push(item);
        }
        return data;
    }
}

export interface IApiMovePapersRequest {
    destinationTitleId?: number;
    operation?: MoveOperation;
    paperStatus?: PaperStatusEnum | null;
    pageFrom?: number | null;
    pageTo?: number | null;
    titlePartIds?: number[] | null;
    chapterIds?: number[] | null;
}

export enum MoveOperation {
    All = 0,
    TitleParts = 1,
    Chapters = 2,
    Pages = 3,
}

export class ApiImportPaperCopiesResult implements IApiImportPaperCopiesResult {
    importedPaperCount?: number;
    skippedPaperIds?: number[] | null;
    notFoundPaperIds?: number[] | null;

    constructor(data?: IApiImportPaperCopiesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importedPaperCount = _data["importedPaperCount"] !== undefined ? _data["importedPaperCount"] : null as any;
            if (Array.isArray(_data["skippedPaperIds"])) {
                this.skippedPaperIds = [] as any;
                for (let item of _data["skippedPaperIds"])
                    this.skippedPaperIds!.push(item);
            }
            else {
                this.skippedPaperIds = null as any;
            }
            if (Array.isArray(_data["notFoundPaperIds"])) {
                this.notFoundPaperIds = [] as any;
                for (let item of _data["notFoundPaperIds"])
                    this.notFoundPaperIds!.push(item);
            }
            else {
                this.notFoundPaperIds = null as any;
            }
        }
    }

    static fromJS(data: any): ApiImportPaperCopiesResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiImportPaperCopiesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importedPaperCount"] = this.importedPaperCount !== undefined ? this.importedPaperCount : null as any;
        if (Array.isArray(this.skippedPaperIds)) {
            data["skippedPaperIds"] = [];
            for (let item of this.skippedPaperIds)
                data["skippedPaperIds"].push(item);
        }
        if (Array.isArray(this.notFoundPaperIds)) {
            data["notFoundPaperIds"] = [];
            for (let item of this.notFoundPaperIds)
                data["notFoundPaperIds"].push(item);
        }
        return data;
    }
}

export interface IApiImportPaperCopiesResult {
    importedPaperCount?: number;
    skippedPaperIds?: number[] | null;
    notFoundPaperIds?: number[] | null;
}

export class ApiPageResultOfApiTitlePapersAuthorListItem implements IApiPageResultOfApiTitlePapersAuthorListItem {
    items?: ApiTitlePapersAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitlePapersAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitlePapersAuthorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitlePapersAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitlePapersAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitlePapersAuthorListItem {
    items?: ApiTitlePapersAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitlePapersAuthorListItem implements IApiTitlePapersAuthorListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => MemberStatusProxyEnum)
    memberStatus?: MemberStatusProxyEnum;
    @columnMap(() => String, true)
    roles?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => Boolean)
    corresponding?: boolean;
    @columnMap(() => Boolean)
    coAuthor?: boolean;
    @columnMap(() => Number)
    papers?: number;

    constructor(data?: IApiTitlePapersAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.corresponding = _data["corresponding"] !== undefined ? _data["corresponding"] : null as any;
            this.coAuthor = _data["coAuthor"] !== undefined ? _data["coAuthor"] : null as any;
            this.papers = _data["papers"] !== undefined ? _data["papers"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePapersAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePapersAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["corresponding"] = this.corresponding !== undefined ? this.corresponding : null as any;
        data["coAuthor"] = this.coAuthor !== undefined ? this.coAuthor : null as any;
        data["papers"] = this.papers !== undefined ? this.papers : null as any;
        return data;
    }
}

export interface IApiTitlePapersAuthorListItem {
    id?: number;
    memberDetails?: ApiMemberInfo | null;
    memberStatus?: MemberStatusProxyEnum;
    roles?: string[] | null;
    country?: ApiNamedListItem | null;
    corresponding?: boolean;
    coAuthor?: boolean;
    papers?: number;
}

export enum MemberStatusProxyEnum {
    Active = 0,
    Deactivated = 1,
    Locked = 2,
    Unverified = 3,
    Pending = 4,
}

export class ApiPageResultOfApiTitleAuthorPaperListItem implements IApiPageResultOfApiTitleAuthorPaperListItem {
    items?: ApiTitleAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleAuthorPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleAuthorPaperListItem {
    items?: ApiTitleAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleAuthorPaperListItem implements IApiTitleAuthorPaperListItem {
    titleId?: number;
    @columnMap(() => Number)
    @keyMap()
    paperId?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => PaperStatusEnum)
    paperStatus?: PaperStatusEnum;
    @columnMap(() => Boolean)
    corresponding?: boolean;
    @columnMap(() => Boolean)
    coAuthor?: boolean;

    constructor(data?: IApiTitleAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.corresponding = _data["corresponding"] !== undefined ? _data["corresponding"] : null as any;
            this.coAuthor = _data["coAuthor"] !== undefined ? _data["coAuthor"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["corresponding"] = this.corresponding !== undefined ? this.corresponding : null as any;
        data["coAuthor"] = this.coAuthor !== undefined ? this.coAuthor : null as any;
        return data;
    }
}

export interface IApiTitleAuthorPaperListItem {
    titleId?: number;
    paperId?: number;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    corresponding?: boolean;
    coAuthor?: boolean;
}

export class ApiPageResultOfApiTitlePartListItem implements IApiPageResultOfApiTitlePartListItem {
    items?: ApiTitlePartListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitlePartListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitlePartListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitlePartListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitlePartListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitlePartListItem {
    items?: ApiTitlePartListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitlePartListItem implements IApiTitlePartListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    partName?: string | null;
    @columnMap(() => String, true)
    chapters?: string[] | null;
    @columnMap(() => Number)
    pageFrom?: number | null;

    constructor(data?: IApiTitlePartListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.partName = _data["partName"] !== undefined ? _data["partName"] : null as any;
            if (Array.isArray(_data["chapters"])) {
                this.chapters = [] as any;
                for (let item of _data["chapters"])
                    this.chapters!.push(item);
            }
            else {
                this.chapters = null as any;
            }
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePartListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePartListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["partName"] = this.partName !== undefined ? this.partName : null as any;
        if (Array.isArray(this.chapters)) {
            data["chapters"] = [];
            for (let item of this.chapters)
                data["chapters"].push(item);
        }
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        return data;
    }
}

export interface IApiTitlePartListItem {
    id?: number;
    pos?: number;
    partName?: string | null;
    chapters?: string[] | null;
    pageFrom?: number | null;
}

export class ApiTitlePart implements IApiTitlePart {
    name: string;
    pageFrom?: number | null;
    chapterIds?: number[] | null;

    constructor(data?: IApiTitlePart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
            if (Array.isArray(_data["chapterIds"])) {
                this.chapterIds = [] as any;
                for (let item of _data["chapterIds"])
                    this.chapterIds!.push(item);
            }
            else {
                this.chapterIds = null as any;
            }
        }
    }

    static fromJS(data: any): ApiTitlePart {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        if (Array.isArray(this.chapterIds)) {
            data["chapterIds"] = [];
            for (let item of this.chapterIds)
                data["chapterIds"].push(item);
        }
        return data;
    }
}

export interface IApiTitlePart {
    name: string;
    pageFrom?: number | null;
    chapterIds?: number[] | null;
}

export class ApiPrintOptionsUpdate implements IApiPrintOptionsUpdate {
    pages?: number;
    binding?: TitleBindingEnum;

    constructor(data?: IApiPrintOptionsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pages = _data["pages"] !== undefined ? _data["pages"] : null as any;
            this.binding = _data["binding"] !== undefined ? _data["binding"] : null as any;
        }
    }

    static fromJS(data: any): ApiPrintOptionsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPrintOptionsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pages"] = this.pages !== undefined ? this.pages : null as any;
        data["binding"] = this.binding !== undefined ? this.binding : null as any;
        return data;
    }
}

export interface IApiPrintOptionsUpdate {
    pages?: number;
    binding?: TitleBindingEnum;
}

export enum TitleBindingEnum {
    Undefined = 0,
    Softcover = 1,
    Hardcover = 2,
}

export class ApiPageResultOfApiTitleReasonListItem implements IApiPageResultOfApiTitleReasonListItem {
    items?: ApiTitleReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleReasonListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleReasonListItem {
    items?: ApiTitleReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export abstract class ApiBaseInternalReasonListItem implements IApiBaseInternalReasonListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    reasonText?: string | null;
    @columnMap(() => String)
    performer?: string | null;
    performerId?: number;
    @columnMap(() => Date)
    lastUpdated?: Date;
    @columnMap(() => Number)
    countOfNotes?: number;

    constructor(data?: IApiBaseInternalReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reasonText = _data["reasonText"] !== undefined ? _data["reasonText"] : null as any;
            this.performer = _data["performer"] !== undefined ? _data["performer"] : null as any;
            this.performerId = _data["performerId"] !== undefined ? _data["performerId"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            this.countOfNotes = _data["countOfNotes"] !== undefined ? _data["countOfNotes"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseInternalReasonListItem {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseInternalReasonListItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reasonText"] = this.reasonText !== undefined ? this.reasonText : null as any;
        data["performer"] = this.performer !== undefined ? this.performer : null as any;
        data["performerId"] = this.performerId !== undefined ? this.performerId : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        data["countOfNotes"] = this.countOfNotes !== undefined ? this.countOfNotes : null as any;
        return data;
    }
}

export interface IApiBaseInternalReasonListItem {
    id?: number;
    reasonText?: string | null;
    performer?: string | null;
    performerId?: number;
    lastUpdated?: Date;
    countOfNotes?: number;
}

export class ApiTitleReasonListItem extends ApiBaseInternalReasonListItem implements IApiTitleReasonListItem {
    @columnMap(() => PublishingReasonTypeEnum)
    eventType?: PublishingReasonTypeEnum;

    constructor(data?: IApiTitleReasonListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.eventType = _data["eventType"] !== undefined ? _data["eventType"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventType"] = this.eventType !== undefined ? this.eventType : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiTitleReasonListItem extends IApiBaseInternalReasonListItem {
    eventType?: PublishingReasonTypeEnum;
}

export enum PublishingReasonTypeEnum {
    CancelTitle = 0,
}

export class ApiPageResultOfApiTitleListItem implements IApiPageResultOfApiTitleListItem {
    items?: ApiTitleListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleListItem {
    items?: ApiTitleListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleListItem implements IApiTitleListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    kisbn?: string | null;
    @columnMap(() => String)
    isbnPrint?: string | null;
    @columnMap(() => String)
    isbnEbook?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    @columnMap(() => TitleStatusEnum)
    status?: TitleStatusEnum;
    journalId?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => TitleTypeEnum)
    type?: TitleTypeEnum;
    @columnMap(() => Number)
    year?: number;
    @columnMap(() => ApiIdNameItem)
    progressStatus?: ApiIdNameItem | null;
    @columnMap(() => Date)
    dateWeb?: Date | null;
    @columnMap(() => Date)
    datePrint?: Date | null;
    @columnMap(() => Number)
    papers?: number;
    @columnMap(() => Date)
    finalManuscriptSubmissionDate?: Date | null;
    @columnMap(() => Date)
    lastUpdated?: Date | null;
    @columnMap(() => String, true)
    keywords?: string[] | null;
    @columnMap(() => Date)
    createdDateTime?: Date;

    constructor(data?: IApiTitleListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.kisbn = _data["kisbn"] !== undefined ? _data["kisbn"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.isbnEbook = _data["isbnEbook"] !== undefined ? _data["isbnEbook"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.progressStatus = _data["progressStatus"] ? ApiIdNameItem.fromJS(_data["progressStatus"]) : null as any;
            this.dateWeb = _data["dateWeb"] ? new Date(_data["dateWeb"].toString()) : null as any;
            this.datePrint = _data["datePrint"] ? new Date(_data["datePrint"].toString()) : null as any;
            this.papers = _data["papers"] !== undefined ? _data["papers"] : null as any;
            this.finalManuscriptSubmissionDate = _data["finalManuscriptSubmissionDate"] ? new Date(_data["finalManuscriptSubmissionDate"].toString()) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(item);
            }
            else {
                this.keywords = null as any;
            }
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["kisbn"] = this.kisbn !== undefined ? this.kisbn : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["isbnEbook"] = this.isbnEbook !== undefined ? this.isbnEbook : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["progressStatus"] = this.progressStatus ? this.progressStatus.toJSON() : null as any;
        data["dateWeb"] = this.dateWeb ? this.dateWeb.toISOString() : null as any;
        data["datePrint"] = this.datePrint ? this.datePrint.toISOString() : null as any;
        data["papers"] = this.papers !== undefined ? this.papers : null as any;
        data["finalManuscriptSubmissionDate"] = this.finalManuscriptSubmissionDate ? this.finalManuscriptSubmissionDate.toISOString() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item);
        }
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiTitleListItem {
    id?: number;
    kisbn?: string | null;
    isbnPrint?: string | null;
    isbnEbook?: string | null;
    titleName?: string | null;
    status?: TitleStatusEnum;
    journalId?: number;
    kurzel?: string | null;
    type?: TitleTypeEnum;
    year?: number;
    progressStatus?: ApiIdNameItem | null;
    dateWeb?: Date | null;
    datePrint?: Date | null;
    papers?: number;
    finalManuscriptSubmissionDate?: Date | null;
    lastUpdated?: Date | null;
    keywords?: string[] | null;
    createdDateTime?: Date;
}

export class ApiFindTitleRequest implements IApiFindTitleRequest {
    query?: string | null;
    excludedTitleIdArray?: number[] | null;
    status?: TitleStatusEnum | null;

    constructor(data?: IApiFindTitleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.query = _data["query"] !== undefined ? _data["query"] : null as any;
            if (Array.isArray(_data["excludedTitleIdArray"])) {
                this.excludedTitleIdArray = [] as any;
                for (let item of _data["excludedTitleIdArray"])
                    this.excludedTitleIdArray!.push(item);
            }
            else {
                this.excludedTitleIdArray = null as any;
            }
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ApiFindTitleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFindTitleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["query"] = this.query !== undefined ? this.query : null as any;
        if (Array.isArray(this.excludedTitleIdArray)) {
            data["excludedTitleIdArray"] = [];
            for (let item of this.excludedTitleIdArray)
                data["excludedTitleIdArray"].push(item);
        }
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IApiFindTitleRequest {
    query?: string | null;
    excludedTitleIdArray?: number[] | null;
    status?: TitleStatusEnum | null;
}

export class ApiTitleCreateRequest implements IApiTitleCreateRequest {
    type: TitleTypeEnum;
    name: string;
    journalId: number;

    constructor(data?: IApiTitleCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        return data;
    }
}

export interface IApiTitleCreateRequest {
    type: TitleTypeEnum;
    name: string;
    journalId: number;
}

export class ApiTitleHeader implements IApiTitleHeader {
    id?: number;
    name?: string | null;
    kurzel?: string | null;
    journalId?: number;
    isbnPrint?: ApiTitleIsbn | null;
    kisbn?: string | null;
    acceptedPaperStatistic?: ApiTitlePaperStatistic | null;
    status?: TitleStatusEnum;

    constructor(data?: IApiTitleHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] ? ApiTitleIsbn.fromJS(_data["isbnPrint"]) : null as any;
            this.kisbn = _data["kisbn"] !== undefined ? _data["kisbn"] : null as any;
            this.acceptedPaperStatistic = _data["acceptedPaperStatistic"] ? ApiTitlePaperStatistic.fromJS(_data["acceptedPaperStatistic"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["isbnPrint"] = this.isbnPrint ? this.isbnPrint.toJSON() : null as any;
        data["kisbn"] = this.kisbn !== undefined ? this.kisbn : null as any;
        data["acceptedPaperStatistic"] = this.acceptedPaperStatistic ? this.acceptedPaperStatistic.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IApiTitleHeader {
    id?: number;
    name?: string | null;
    kurzel?: string | null;
    journalId?: number;
    isbnPrint?: ApiTitleIsbn | null;
    kisbn?: string | null;
    acceptedPaperStatistic?: ApiTitlePaperStatistic | null;
    status?: TitleStatusEnum;
}

export class ApiTitlePaperStatistic implements IApiTitlePaperStatistic {
    paperCount?: number;
    pdfPageCount?: number;
    pageCount?: number;

    constructor(data?: IApiTitlePaperStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperCount = _data["paperCount"] !== undefined ? _data["paperCount"] : null as any;
            this.pdfPageCount = _data["pdfPageCount"] !== undefined ? _data["pdfPageCount"] : null as any;
            this.pageCount = _data["pageCount"] !== undefined ? _data["pageCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePaperStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePaperStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperCount"] = this.paperCount !== undefined ? this.paperCount : null as any;
        data["pdfPageCount"] = this.pdfPageCount !== undefined ? this.pdfPageCount : null as any;
        data["pageCount"] = this.pageCount !== undefined ? this.pageCount : null as any;
        return data;
    }
}

export interface IApiTitlePaperStatistic {
    paperCount?: number;
    pdfPageCount?: number;
    pageCount?: number;
}

export class ApiTitlePaperDetailedStatistic implements IApiTitlePaperDetailedStatistic {
    uploaded?: ApiTitlePaperStatistic | null;
    rejected?: ApiTitlePaperStatistic | null;
    accepted?: ApiTitlePaperStatistic | null;
    total?: ApiTitlePaperStatistic | null;

    constructor(data?: IApiTitlePaperDetailedStatistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploaded = _data["uploaded"] ? ApiTitlePaperStatistic.fromJS(_data["uploaded"]) : null as any;
            this.rejected = _data["rejected"] ? ApiTitlePaperStatistic.fromJS(_data["rejected"]) : null as any;
            this.accepted = _data["accepted"] ? ApiTitlePaperStatistic.fromJS(_data["accepted"]) : null as any;
            this.total = _data["total"] ? ApiTitlePaperStatistic.fromJS(_data["total"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePaperDetailedStatistic {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePaperDetailedStatistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploaded"] = this.uploaded ? this.uploaded.toJSON() : null as any;
        data["rejected"] = this.rejected ? this.rejected.toJSON() : null as any;
        data["accepted"] = this.accepted ? this.accepted.toJSON() : null as any;
        data["total"] = this.total ? this.total.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitlePaperDetailedStatistic {
    uploaded?: ApiTitlePaperStatistic | null;
    rejected?: ApiTitlePaperStatistic | null;
    accepted?: ApiTitlePaperStatistic | null;
    total?: ApiTitlePaperStatistic | null;
}

export class ApiCancelTitle implements IApiCancelTitle {
    reasonId: number;
    note?: string | null;

    constructor(data?: IApiCancelTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"] !== undefined ? _data["reasonId"] : null as any;
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ApiCancelTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCancelTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId !== undefined ? this.reasonId : null as any;
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IApiCancelTitle {
    reasonId: number;
    note?: string | null;
}

export class ApiTitleSettings implements IApiTitleSettings {
    id?: number;
    options?: ApiTitleOptions | null;
    printOptions?: ApiTitlePrintOptions | null;
    editingToolAccessOptions?: ApiTitleEditingToolAccessOptions | null;
    publishingOptions?: ApiTitlePublishingOptions | null;
    titlePartsPrintOptions?: ApiTitlePartPrintOptions[] | null;

    constructor(data?: IApiTitleSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.options = _data["options"] ? ApiTitleOptions.fromJS(_data["options"]) : null as any;
            this.printOptions = _data["printOptions"] ? ApiTitlePrintOptions.fromJS(_data["printOptions"]) : null as any;
            this.editingToolAccessOptions = _data["editingToolAccessOptions"] ? ApiTitleEditingToolAccessOptions.fromJS(_data["editingToolAccessOptions"]) : null as any;
            this.publishingOptions = _data["publishingOptions"] ? ApiTitlePublishingOptions.fromJS(_data["publishingOptions"]) : null as any;
            if (Array.isArray(_data["titlePartsPrintOptions"])) {
                this.titlePartsPrintOptions = [] as any;
                for (let item of _data["titlePartsPrintOptions"])
                    this.titlePartsPrintOptions!.push(ApiTitlePartPrintOptions.fromJS(item));
            }
            else {
                this.titlePartsPrintOptions = null as any;
            }
        }
    }

    static fromJS(data: any): ApiTitleSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["options"] = this.options ? this.options.toJSON() : null as any;
        data["printOptions"] = this.printOptions ? this.printOptions.toJSON() : null as any;
        data["editingToolAccessOptions"] = this.editingToolAccessOptions ? this.editingToolAccessOptions.toJSON() : null as any;
        data["publishingOptions"] = this.publishingOptions ? this.publishingOptions.toJSON() : null as any;
        if (Array.isArray(this.titlePartsPrintOptions)) {
            data["titlePartsPrintOptions"] = [];
            for (let item of this.titlePartsPrintOptions)
                data["titlePartsPrintOptions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiTitleSettings {
    id?: number;
    options?: ApiTitleOptions | null;
    printOptions?: ApiTitlePrintOptions | null;
    editingToolAccessOptions?: ApiTitleEditingToolAccessOptions | null;
    publishingOptions?: ApiTitlePublishingOptions | null;
    titlePartsPrintOptions?: ApiTitlePartPrintOptions[] | null;
}

export class ApiTitleOptions implements IApiTitleOptions {
    printAvailable?: boolean;
    ebookAvailable?: boolean;
    epubEbookAvailable?: boolean;
    publishInForthcoming?: boolean;
    publishInLatest?: boolean;
    ebookOpenAccess?: boolean;
    allPapersOpenAccess?: boolean;
    forReviewerBilling?: boolean;
    isPublic?: boolean;

    constructor(data?: IApiTitleOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.printAvailable = _data["printAvailable"] !== undefined ? _data["printAvailable"] : null as any;
            this.ebookAvailable = _data["ebookAvailable"] !== undefined ? _data["ebookAvailable"] : null as any;
            this.epubEbookAvailable = _data["epubEbookAvailable"] !== undefined ? _data["epubEbookAvailable"] : null as any;
            this.publishInForthcoming = _data["publishInForthcoming"] !== undefined ? _data["publishInForthcoming"] : null as any;
            this.publishInLatest = _data["publishInLatest"] !== undefined ? _data["publishInLatest"] : null as any;
            this.ebookOpenAccess = _data["ebookOpenAccess"] !== undefined ? _data["ebookOpenAccess"] : null as any;
            this.allPapersOpenAccess = _data["allPapersOpenAccess"] !== undefined ? _data["allPapersOpenAccess"] : null as any;
            this.forReviewerBilling = _data["forReviewerBilling"] !== undefined ? _data["forReviewerBilling"] : null as any;
            this.isPublic = _data["isPublic"] !== undefined ? _data["isPublic"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["printAvailable"] = this.printAvailable !== undefined ? this.printAvailable : null as any;
        data["ebookAvailable"] = this.ebookAvailable !== undefined ? this.ebookAvailable : null as any;
        data["epubEbookAvailable"] = this.epubEbookAvailable !== undefined ? this.epubEbookAvailable : null as any;
        data["publishInForthcoming"] = this.publishInForthcoming !== undefined ? this.publishInForthcoming : null as any;
        data["publishInLatest"] = this.publishInLatest !== undefined ? this.publishInLatest : null as any;
        data["ebookOpenAccess"] = this.ebookOpenAccess !== undefined ? this.ebookOpenAccess : null as any;
        data["allPapersOpenAccess"] = this.allPapersOpenAccess !== undefined ? this.allPapersOpenAccess : null as any;
        data["forReviewerBilling"] = this.forReviewerBilling !== undefined ? this.forReviewerBilling : null as any;
        data["isPublic"] = this.isPublic !== undefined ? this.isPublic : null as any;
        return data;
    }
}

export interface IApiTitleOptions {
    printAvailable?: boolean;
    ebookAvailable?: boolean;
    epubEbookAvailable?: boolean;
    publishInForthcoming?: boolean;
    publishInLatest?: boolean;
    ebookOpenAccess?: boolean;
    allPapersOpenAccess?: boolean;
    forReviewerBilling?: boolean;
    isPublic?: boolean;
}

export class ApiTitlePrintOptions implements IApiTitlePrintOptions {
    pages?: number;
    binding?: TitleBindingEnum;
    parts?: number;
    weight?: number;
    spine?: number;

    constructor(data?: IApiTitlePrintOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pages = _data["pages"] !== undefined ? _data["pages"] : null as any;
            this.binding = _data["binding"] !== undefined ? _data["binding"] : null as any;
            this.parts = _data["parts"] !== undefined ? _data["parts"] : null as any;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : null as any;
            this.spine = _data["spine"] !== undefined ? _data["spine"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePrintOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePrintOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pages"] = this.pages !== undefined ? this.pages : null as any;
        data["binding"] = this.binding !== undefined ? this.binding : null as any;
        data["parts"] = this.parts !== undefined ? this.parts : null as any;
        data["weight"] = this.weight !== undefined ? this.weight : null as any;
        data["spine"] = this.spine !== undefined ? this.spine : null as any;
        return data;
    }
}

export interface IApiTitlePrintOptions {
    pages?: number;
    binding?: TitleBindingEnum;
    parts?: number;
    weight?: number;
    spine?: number;
}

export class ApiTitleEditingToolAccessOptions implements IApiTitleEditingToolAccessOptions {
    disabled?: boolean;
    editorPeriod?: ApiDateRange | null;
    authorPeriod?: ApiDateRange | null;
    reviewerPeriod?: ApiDateRange | null;
    revisionPeriod?: ApiDateRange | null;
    authorFreeTitleAccess?: boolean;
    authorFreePaperAccess?: boolean;
    authorFreeEbookAccess?: boolean;
    openAccess?: boolean;

    constructor(data?: IApiTitleEditingToolAccessOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.editorPeriod = _data["editorPeriod"] ? ApiDateRange.fromJS(_data["editorPeriod"]) : null as any;
            this.authorPeriod = _data["authorPeriod"] ? ApiDateRange.fromJS(_data["authorPeriod"]) : null as any;
            this.reviewerPeriod = _data["reviewerPeriod"] ? ApiDateRange.fromJS(_data["reviewerPeriod"]) : null as any;
            this.revisionPeriod = _data["revisionPeriod"] ? ApiDateRange.fromJS(_data["revisionPeriod"]) : null as any;
            this.authorFreeTitleAccess = _data["authorFreeTitleAccess"] !== undefined ? _data["authorFreeTitleAccess"] : null as any;
            this.authorFreePaperAccess = _data["authorFreePaperAccess"] !== undefined ? _data["authorFreePaperAccess"] : null as any;
            this.authorFreeEbookAccess = _data["authorFreeEbookAccess"] !== undefined ? _data["authorFreeEbookAccess"] : null as any;
            this.openAccess = _data["openAccess"] !== undefined ? _data["openAccess"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleEditingToolAccessOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleEditingToolAccessOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["editorPeriod"] = this.editorPeriod ? this.editorPeriod.toJSON() : null as any;
        data["authorPeriod"] = this.authorPeriod ? this.authorPeriod.toJSON() : null as any;
        data["reviewerPeriod"] = this.reviewerPeriod ? this.reviewerPeriod.toJSON() : null as any;
        data["revisionPeriod"] = this.revisionPeriod ? this.revisionPeriod.toJSON() : null as any;
        data["authorFreeTitleAccess"] = this.authorFreeTitleAccess !== undefined ? this.authorFreeTitleAccess : null as any;
        data["authorFreePaperAccess"] = this.authorFreePaperAccess !== undefined ? this.authorFreePaperAccess : null as any;
        data["authorFreeEbookAccess"] = this.authorFreeEbookAccess !== undefined ? this.authorFreeEbookAccess : null as any;
        data["openAccess"] = this.openAccess !== undefined ? this.openAccess : null as any;
        return data;
    }
}

export interface IApiTitleEditingToolAccessOptions {
    disabled?: boolean;
    editorPeriod?: ApiDateRange | null;
    authorPeriod?: ApiDateRange | null;
    reviewerPeriod?: ApiDateRange | null;
    revisionPeriod?: ApiDateRange | null;
    authorFreeTitleAccess?: boolean;
    authorFreePaperAccess?: boolean;
    authorFreeEbookAccess?: boolean;
    openAccess?: boolean;
}

export class ApiTitlePublishingOptions implements IApiTitlePublishingOptions {
    papersOrder?: PapersOrderEnum;
    firstPageNumber?: number;
    pageStartWithOddNumber?: boolean;
    chapterEmptyPage?: boolean;
    showSubmitDate?: boolean;
    showRevisedDate?: boolean;
    showAcceptDate?: boolean;
    planningComment?: string | null;

    constructor(data?: IApiTitlePublishingOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.papersOrder = _data["papersOrder"] !== undefined ? _data["papersOrder"] : null as any;
            this.firstPageNumber = _data["firstPageNumber"] !== undefined ? _data["firstPageNumber"] : null as any;
            this.pageStartWithOddNumber = _data["pageStartWithOddNumber"] !== undefined ? _data["pageStartWithOddNumber"] : null as any;
            this.chapterEmptyPage = _data["chapterEmptyPage"] !== undefined ? _data["chapterEmptyPage"] : null as any;
            this.showSubmitDate = _data["showSubmitDate"] !== undefined ? _data["showSubmitDate"] : null as any;
            this.showRevisedDate = _data["showRevisedDate"] !== undefined ? _data["showRevisedDate"] : null as any;
            this.showAcceptDate = _data["showAcceptDate"] !== undefined ? _data["showAcceptDate"] : null as any;
            this.planningComment = _data["planningComment"] !== undefined ? _data["planningComment"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePublishingOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePublishingOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["papersOrder"] = this.papersOrder !== undefined ? this.papersOrder : null as any;
        data["firstPageNumber"] = this.firstPageNumber !== undefined ? this.firstPageNumber : null as any;
        data["pageStartWithOddNumber"] = this.pageStartWithOddNumber !== undefined ? this.pageStartWithOddNumber : null as any;
        data["chapterEmptyPage"] = this.chapterEmptyPage !== undefined ? this.chapterEmptyPage : null as any;
        data["showSubmitDate"] = this.showSubmitDate !== undefined ? this.showSubmitDate : null as any;
        data["showRevisedDate"] = this.showRevisedDate !== undefined ? this.showRevisedDate : null as any;
        data["showAcceptDate"] = this.showAcceptDate !== undefined ? this.showAcceptDate : null as any;
        data["planningComment"] = this.planningComment !== undefined ? this.planningComment : null as any;
        return data;
    }
}

export interface IApiTitlePublishingOptions {
    papersOrder?: PapersOrderEnum;
    firstPageNumber?: number;
    pageStartWithOddNumber?: boolean;
    chapterEmptyPage?: boolean;
    showSubmitDate?: boolean;
    showRevisedDate?: boolean;
    showAcceptDate?: boolean;
    planningComment?: string | null;
}

export enum PapersOrderEnum {
    Complete = 0,
    ByPosition = 1,
    ByPage = 2,
}

export class ApiTitlePartPrintOptions implements IApiTitlePartPrintOptions {
    titlePartId?: number;
    name?: string | null;
    pages?: number;
    binding?: TitleBindingEnum;
    weight?: number;
    spine?: number;

    constructor(data?: IApiTitlePartPrintOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titlePartId = _data["titlePartId"] !== undefined ? _data["titlePartId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pages = _data["pages"] !== undefined ? _data["pages"] : null as any;
            this.binding = _data["binding"] !== undefined ? _data["binding"] : null as any;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : null as any;
            this.spine = _data["spine"] !== undefined ? _data["spine"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePartPrintOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePartPrintOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titlePartId"] = this.titlePartId !== undefined ? this.titlePartId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pages"] = this.pages !== undefined ? this.pages : null as any;
        data["binding"] = this.binding !== undefined ? this.binding : null as any;
        data["weight"] = this.weight !== undefined ? this.weight : null as any;
        data["spine"] = this.spine !== undefined ? this.spine : null as any;
        return data;
    }
}

export interface IApiTitlePartPrintOptions {
    titlePartId?: number;
    name?: string | null;
    pages?: number;
    binding?: TitleBindingEnum;
    weight?: number;
    spine?: number;
}

export class ApiPageResultOfApiTitleSubjectCategoryListItem implements IApiPageResultOfApiTitleSubjectCategoryListItem {
    items?: ApiTitleSubjectCategoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleSubjectCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleSubjectCategoryListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleSubjectCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleSubjectCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleSubjectCategoryListItem {
    items?: ApiTitleSubjectCategoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleSubjectCategoryListItem implements IApiTitleSubjectCategoryListItem {
    @keyMap()
    id?: number;
    @columnMap(() => SubjectCategoryType)
    subjectCategoryType?: SubjectCategoryType;
    @columnMap(() => String)
    code?: string | null;
    @columnMap(() => String)
    headingText?: string | null;

    constructor(data?: IApiTitleSubjectCategoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.subjectCategoryType = _data["subjectCategoryType"] !== undefined ? _data["subjectCategoryType"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.headingText = _data["headingText"] !== undefined ? _data["headingText"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleSubjectCategoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleSubjectCategoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["subjectCategoryType"] = this.subjectCategoryType !== undefined ? this.subjectCategoryType : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["headingText"] = this.headingText !== undefined ? this.headingText : null as any;
        return data;
    }
}

export interface IApiTitleSubjectCategoryListItem {
    id?: number;
    subjectCategoryType?: SubjectCategoryType;
    code?: string | null;
    headingText?: string | null;
}

export enum SubjectCategoryType {
    BISAC = 0,
    BIC = 1,
    Thema = 2,
    LCSH = 3,
    WGS = 4,
    Topic = 5,
}

export class ApiTitleSubjectCategoryCreateRequest implements IApiTitleSubjectCategoryCreateRequest {
    subjectCategoryType?: SubjectCategoryType;
    code?: string | null;
    headingText?: string | null;

    constructor(data?: IApiTitleSubjectCategoryCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subjectCategoryType = _data["subjectCategoryType"] !== undefined ? _data["subjectCategoryType"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.headingText = _data["headingText"] !== undefined ? _data["headingText"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleSubjectCategoryCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleSubjectCategoryCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subjectCategoryType"] = this.subjectCategoryType !== undefined ? this.subjectCategoryType : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["headingText"] = this.headingText !== undefined ? this.headingText : null as any;
        return data;
    }
}

export interface IApiTitleSubjectCategoryCreateRequest {
    subjectCategoryType?: SubjectCategoryType;
    code?: string | null;
    headingText?: string | null;
}

export class ApiTitleSubjectCategoryReplaceThemaRequest implements IApiTitleSubjectCategoryReplaceThemaRequest {
    subjectCategories?: ApiTitleSubjectCategoryCreateRequest[] | null;

    constructor(data?: IApiTitleSubjectCategoryReplaceThemaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subjectCategories"])) {
                this.subjectCategories = [] as any;
                for (let item of _data["subjectCategories"])
                    this.subjectCategories!.push(ApiTitleSubjectCategoryCreateRequest.fromJS(item));
            }
            else {
                this.subjectCategories = null as any;
            }
        }
    }

    static fromJS(data: any): ApiTitleSubjectCategoryReplaceThemaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleSubjectCategoryReplaceThemaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subjectCategories)) {
            data["subjectCategories"] = [];
            for (let item of this.subjectCategories)
                data["subjectCategories"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiTitleSubjectCategoryReplaceThemaRequest {
    subjectCategories?: ApiTitleSubjectCategoryCreateRequest[] | null;
}

export class ApiPageResultOfApiDiscountedTitle implements IApiPageResultOfApiDiscountedTitle {
    items?: ApiDiscountedTitle[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiDiscountedTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiDiscountedTitle.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiDiscountedTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiDiscountedTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiDiscountedTitle {
    items?: ApiDiscountedTitle[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiDiscountedTitle implements IApiDiscountedTitle {
    @keyMap()
    discountedTitleId?: number;
    titleId?: number;
    @columnMap(() => String)
    isbnPrint?: string | null;
    @columnMap(() => ApiIdNameItem)
    addedBy?: ApiIdNameItem | null;
    @columnMap(() => Date)
    lastUpdated?: Date;

    constructor(data?: IApiDiscountedTitle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.discountedTitleId = _data["discountedTitleId"] !== undefined ? _data["discountedTitleId"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.addedBy = _data["addedBy"] ? ApiIdNameItem.fromJS(_data["addedBy"]) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiDiscountedTitle {
        data = typeof data === 'object' ? data : {};
        let result = new ApiDiscountedTitle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discountedTitleId"] = this.discountedTitleId !== undefined ? this.discountedTitleId : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        return data;
    }
}

export interface IApiDiscountedTitle {
    discountedTitleId?: number;
    titleId?: number;
    isbnPrint?: string | null;
    addedBy?: ApiIdNameItem | null;
    lastUpdated?: Date;
}

export class ApiTitleFee implements IApiTitleFee {
    paperSubmission?: number | null;
    articleProcessing?: number | null;

    constructor(data?: IApiTitleFee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperSubmission = _data["paperSubmission"] !== undefined ? _data["paperSubmission"] : null as any;
            this.articleProcessing = _data["articleProcessing"] !== undefined ? _data["articleProcessing"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleFee {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleFee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSubmission"] = this.paperSubmission !== undefined ? this.paperSubmission : null as any;
        data["articleProcessing"] = this.articleProcessing !== undefined ? this.articleProcessing : null as any;
        return data;
    }
}

export interface IApiTitleFee {
    paperSubmission?: number | null;
    articleProcessing?: number | null;
}

export class ApiPaymentInfo implements IApiPaymentInfo {
    paymentModel?: PaymentModelEnum | null;
    onetimePaymentSum?: number | null;
    onetimePaymentCurrencyCode?: string | null;

    constructor(data?: IApiPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentModel = _data["paymentModel"] !== undefined ? _data["paymentModel"] : null as any;
            this.onetimePaymentSum = _data["onetimePaymentSum"] !== undefined ? _data["onetimePaymentSum"] : null as any;
            this.onetimePaymentCurrencyCode = _data["onetimePaymentCurrencyCode"] !== undefined ? _data["onetimePaymentCurrencyCode"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentModel"] = this.paymentModel !== undefined ? this.paymentModel : null as any;
        data["onetimePaymentSum"] = this.onetimePaymentSum !== undefined ? this.onetimePaymentSum : null as any;
        data["onetimePaymentCurrencyCode"] = this.onetimePaymentCurrencyCode !== undefined ? this.onetimePaymentCurrencyCode : null as any;
        return data;
    }
}

export interface IApiPaymentInfo {
    paymentModel?: PaymentModelEnum | null;
    onetimePaymentSum?: number | null;
    onetimePaymentCurrencyCode?: string | null;
}

export enum PaymentModelEnum {
    Paid = 1,
    OnetimePaymentToEditor = 2,
    FreePublication = 3,
}

export class ApiTitlePrice implements IApiTitlePrice {
    currencyId?: string | null;
    printPrice?: number;
    ebookPrice?: number;
    ebookUnlimitedPrice?: number;
    ebookPlusPrintPrice?: number | null;

    constructor(data?: IApiTitlePrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currencyId = _data["currencyId"] !== undefined ? _data["currencyId"] : null as any;
            this.printPrice = _data["printPrice"] !== undefined ? _data["printPrice"] : null as any;
            this.ebookPrice = _data["ebookPrice"] !== undefined ? _data["ebookPrice"] : null as any;
            this.ebookUnlimitedPrice = _data["ebookUnlimitedPrice"] !== undefined ? _data["ebookUnlimitedPrice"] : null as any;
            this.ebookPlusPrintPrice = _data["ebookPlusPrintPrice"] !== undefined ? _data["ebookPlusPrintPrice"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePrice {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currencyId"] = this.currencyId !== undefined ? this.currencyId : null as any;
        data["printPrice"] = this.printPrice !== undefined ? this.printPrice : null as any;
        data["ebookPrice"] = this.ebookPrice !== undefined ? this.ebookPrice : null as any;
        data["ebookUnlimitedPrice"] = this.ebookUnlimitedPrice !== undefined ? this.ebookUnlimitedPrice : null as any;
        data["ebookPlusPrintPrice"] = this.ebookPlusPrintPrice !== undefined ? this.ebookPlusPrintPrice : null as any;
        return data;
    }
}

export interface IApiTitlePrice {
    currencyId?: string | null;
    printPrice?: number;
    ebookPrice?: number;
    ebookUnlimitedPrice?: number;
    ebookPlusPrintPrice?: number | null;
}

export class ApiParticipantAddress implements IApiParticipantAddress {
    countryId?: string | null;
    gridId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;

    constructor(data?: IApiParticipantAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiParticipantAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiParticipantAddress {
    countryId?: string | null;
    gridId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    websites?: string[] | null;
}

export class ApiParticipantAddressDetails extends ApiParticipantAddress implements IApiParticipantAddressDetails {
    id?: number;

    constructor(data?: IApiParticipantAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ApiParticipantAddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiParticipantAddressDetails extends IApiParticipantAddress {
    id?: number;
}

export class ApiPageResultOfApiParticipantAffiliationListItem implements IApiPageResultOfApiParticipantAffiliationListItem {
    items?: ApiParticipantAffiliationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiParticipantAffiliationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiParticipantAffiliationListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiParticipantAffiliationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiParticipantAffiliationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiParticipantAffiliationListItem {
    items?: ApiParticipantAffiliationListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiParticipantAffiliationListItem implements IApiParticipantAffiliationListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => ApiParticipantAffiliationDetails)
    affiliation?: ApiParticipantAffiliationDetails | null;

    constructor(data?: IApiParticipantAffiliationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.affiliation = _data["affiliation"] ? ApiParticipantAffiliationDetails.fromJS(_data["affiliation"]) : null as any;
        }
    }

    static fromJS(data: any): ApiParticipantAffiliationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAffiliationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["affiliation"] = this.affiliation ? this.affiliation.toJSON() : null as any;
        return data;
    }
}

export interface IApiParticipantAffiliationListItem {
    id?: number;
    affiliation?: ApiParticipantAffiliationDetails | null;
}

export class ApiParticipantAffiliationDetails implements IApiParticipantAffiliationDetails {
    universityOrOrganization?: string | null;
    department?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;

    constructor(data?: IApiParticipantAffiliationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): ApiParticipantAffiliationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAffiliationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        return data;
    }
}

export interface IApiParticipantAffiliationDetails {
    universityOrOrganization?: string | null;
    department?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
}

export class ApiPageResultOfApiSuggestedAddressListItem implements IApiPageResultOfApiSuggestedAddressListItem {
    items?: ApiSuggestedAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiSuggestedAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiSuggestedAddressListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiSuggestedAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiSuggestedAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiSuggestedAddressListItem {
    items?: ApiSuggestedAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiSuggestedAddressListItem implements IApiSuggestedAddressListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    gridId?: string | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;
    @columnMap(() => String)
    department?: string | null;
    @columnMap(() => String)
    addressLine1?: string | null;
    @columnMap(() => String)
    addressLine2?: string | null;
    @columnMap(() => String)
    city?: string | null;
    @columnMap(() => String)
    state?: string | null;
    @columnMap(() => String)
    zip?: string | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String, true)
    websites?: string[] | null;

    constructor(data?: IApiSuggestedAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiSuggestedAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSuggestedAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiSuggestedAddressListItem {
    id?: number;
    gridId?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: ApiNamedListItem | null;
    websites?: string[] | null;
}

export class ApiParticipantAddressManageResult implements IApiParticipantAddressManageResult {
    existingId?: number;

    constructor(data?: IApiParticipantAddressManageResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existingId = _data["existingId"] !== undefined ? _data["existingId"] : null as any;
        }
    }

    static fromJS(data: any): ApiParticipantAddressManageResult {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAddressManageResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existingId"] = this.existingId !== undefined ? this.existingId : null as any;
        return data;
    }
}

export interface IApiParticipantAddressManageResult {
    existingId?: number;
}

export class ApiPageResultOfApiTitleContributorListItem implements IApiPageResultOfApiTitleContributorListItem {
    items?: ApiTitleContributorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleContributorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleContributorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleContributorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleContributorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleContributorListItem {
    items?: ApiTitleContributorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleContributorListItem implements IApiTitleContributorListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number | null;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => ApiParticipantAffiliationDetails)
    affiliation?: ApiParticipantAffiliationDetails | null;
    memberId?: number;
    titleName?: string | null;
    affiliationId?: number | null;

    constructor(data?: IApiTitleContributorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.affiliation = _data["affiliation"] ? ApiParticipantAffiliationDetails.fromJS(_data["affiliation"]) : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.affiliationId = _data["affiliationId"] !== undefined ? _data["affiliationId"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleContributorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleContributorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["affiliation"] = this.affiliation ? this.affiliation.toJSON() : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["affiliationId"] = this.affiliationId !== undefined ? this.affiliationId : null as any;
        return data;
    }
}

export interface IApiTitleContributorListItem {
    id?: number;
    pos?: number | null;
    memberDetails?: ApiMemberInfo | null;
    affiliation?: ApiParticipantAffiliationDetails | null;
    memberId?: number;
    titleName?: string | null;
    affiliationId?: number | null;
}

export class ApiPageResultOfApiTitleCorrespondingAuthorListItem implements IApiPageResultOfApiTitleCorrespondingAuthorListItem {
    items?: ApiTitleCorrespondingAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleCorrespondingAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleCorrespondingAuthorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleCorrespondingAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleCorrespondingAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleCorrespondingAuthorListItem {
    items?: ApiTitleCorrespondingAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleCorrespondingAuthorListItem implements IApiTitleCorrespondingAuthorListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => MemberStatusProxyEnum)
    memberStatus?: MemberStatusProxyEnum;
    @columnMap(() => String, true)
    roles?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String)
    code?: string | null;
    @columnMap(() => Number)
    limitUploads?: number;
    @columnMap(() => Number)
    uploaded?: number;
    isRemovable?: boolean;

    constructor(data?: IApiTitleCorrespondingAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.limitUploads = _data["limitUploads"] !== undefined ? _data["limitUploads"] : null as any;
            this.uploaded = _data["uploaded"] !== undefined ? _data["uploaded"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleCorrespondingAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleCorrespondingAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["limitUploads"] = this.limitUploads !== undefined ? this.limitUploads : null as any;
        data["uploaded"] = this.uploaded !== undefined ? this.uploaded : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiTitleCorrespondingAuthorListItem {
    id?: number;
    memberDetails?: ApiMemberInfo | null;
    memberStatus?: MemberStatusProxyEnum;
    roles?: string[] | null;
    country?: ApiNamedListItem | null;
    code?: string | null;
    limitUploads?: number;
    uploaded?: number;
    isRemovable?: boolean;
}

export class ApiPageResultOfApiCorrespondingAuthorPaperListItem implements IApiPageResultOfApiCorrespondingAuthorPaperListItem {
    items?: ApiCorrespondingAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiCorrespondingAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiCorrespondingAuthorPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiCorrespondingAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiCorrespondingAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiCorrespondingAuthorPaperListItem {
    items?: ApiCorrespondingAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiCorrespondingAuthorPaperListItem implements IApiCorrespondingAuthorPaperListItem {
    titleId?: number;
    @columnMap(() => Number)
    @keyMap()
    paperId?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => PaperStatusEnum)
    paperStatus?: PaperStatusEnum;
    @columnMap(() => Number)
    citations?: number;

    constructor(data?: IApiCorrespondingAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.citations = _data["citations"] !== undefined ? _data["citations"] : null as any;
        }
    }

    static fromJS(data: any): ApiCorrespondingAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCorrespondingAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["citations"] = this.citations !== undefined ? this.citations : null as any;
        return data;
    }
}

export interface IApiCorrespondingAuthorPaperListItem {
    titleId?: number;
    paperId?: number;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    citations?: number;
}

export class ApiAuthorLimitUploads implements IApiAuthorLimitUploads {
    limitUploads?: number;

    constructor(data?: IApiAuthorLimitUploads) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.limitUploads = _data["limitUploads"] !== undefined ? _data["limitUploads"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorLimitUploads {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorLimitUploads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["limitUploads"] = this.limitUploads !== undefined ? this.limitUploads : null as any;
        return data;
    }
}

export interface IApiAuthorLimitUploads {
    limitUploads?: number;
}

export class ApiPageResultOfApiTitleEditorListItem implements IApiPageResultOfApiTitleEditorListItem {
    items?: ApiTitleEditorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleEditorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleEditorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleEditorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleEditorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleEditorListItem {
    items?: ApiTitleEditorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleEditorListItem implements IApiTitleEditorListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => MemberStatusProxyEnum)
    memberStatus?: MemberStatusProxyEnum;
    @columnMap(() => String, true)
    roles?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => Boolean)
    hasAccessToEditingTool?: boolean;
    @columnMap(() => Boolean)
    checklistSubmitted?: boolean;
    titleName?: string | null;
    isRemovable?: boolean;

    constructor(data?: IApiTitleEditorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.hasAccessToEditingTool = _data["hasAccessToEditingTool"] !== undefined ? _data["hasAccessToEditingTool"] : null as any;
            this.checklistSubmitted = _data["checklistSubmitted"] !== undefined ? _data["checklistSubmitted"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleEditorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleEditorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["hasAccessToEditingTool"] = this.hasAccessToEditingTool !== undefined ? this.hasAccessToEditingTool : null as any;
        data["checklistSubmitted"] = this.checklistSubmitted !== undefined ? this.checklistSubmitted : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiTitleEditorListItem {
    id?: number;
    memberDetails?: ApiMemberInfo | null;
    memberStatus?: MemberStatusProxyEnum;
    roles?: string[] | null;
    country?: ApiNamedListItem | null;
    hasAccessToEditingTool?: boolean;
    checklistSubmitted?: boolean;
    titleName?: string | null;
    isRemovable?: boolean;
}

export class ApiTitleEditorEditRequest implements IApiTitleEditorEditRequest {
    memberId?: number;
    hasAccessToEditingTool?: boolean;

    constructor(data?: IApiTitleEditorEditRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.hasAccessToEditingTool = _data["hasAccessToEditingTool"] !== undefined ? _data["hasAccessToEditingTool"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleEditorEditRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleEditorEditRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["hasAccessToEditingTool"] = this.hasAccessToEditingTool !== undefined ? this.hasAccessToEditingTool : null as any;
        return data;
    }
}

export interface IApiTitleEditorEditRequest {
    memberId?: number;
    hasAccessToEditingTool?: boolean;
}

export class ApiPageResultOfApiTitleReviewerListItem implements IApiPageResultOfApiTitleReviewerListItem {
    items?: ApiTitleReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleReviewerListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleReviewerListItem {
    items?: ApiTitleReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleReviewerListItem implements IApiTitleReviewerListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiMemberInfo)
    memberDetails?: ApiMemberInfo | null;
    @columnMap(() => MemberStatusProxyEnum)
    memberStatus?: MemberStatusProxyEnum;
    @columnMap(() => String, true)
    roles?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String)
    reviewerNote?: string | null;
    @columnMap(() => Number)
    papers?: number;
    titleName?: string | null;

    constructor(data?: IApiTitleReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberDetails = _data["memberDetails"] ? ApiMemberInfo.fromJS(_data["memberDetails"]) : null as any;
            this.memberStatus = _data["memberStatus"] !== undefined ? _data["memberStatus"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            this.reviewerNote = _data["reviewerNote"] !== undefined ? _data["reviewerNote"] : null as any;
            this.papers = _data["papers"] !== undefined ? _data["papers"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberDetails"] = this.memberDetails ? this.memberDetails.toJSON() : null as any;
        data["memberStatus"] = this.memberStatus !== undefined ? this.memberStatus : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["reviewerNote"] = this.reviewerNote !== undefined ? this.reviewerNote : null as any;
        data["papers"] = this.papers !== undefined ? this.papers : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        return data;
    }
}

export interface IApiTitleReviewerListItem {
    id?: number;
    memberDetails?: ApiMemberInfo | null;
    memberStatus?: MemberStatusProxyEnum;
    roles?: string[] | null;
    country?: ApiNamedListItem | null;
    reviewerNote?: string | null;
    papers?: number;
    titleName?: string | null;
}

export class ApiPageResultOfApiTitleReviewerPaperListItem implements IApiPageResultOfApiTitleReviewerPaperListItem {
    items?: ApiTitleReviewerPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleReviewerPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleReviewerPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleReviewerPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleReviewerPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleReviewerPaperListItem {
    items?: ApiTitleReviewerPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleReviewerPaperListItem implements IApiTitleReviewerPaperListItem {
    titleId?: number;
    @columnMap(() => Number)
    @keyMap()
    paperId?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => ReviewStatusEnum)
    reviewStatus?: ReviewStatusEnum;
    @columnMap(() => ReviewStatusEnum)
    reReviewStatus?: ReviewStatusEnum | null;

    constructor(data?: IApiTitleReviewerPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.reviewStatus = _data["reviewStatus"] !== undefined ? _data["reviewStatus"] : null as any;
            this.reReviewStatus = _data["reReviewStatus"] !== undefined ? _data["reReviewStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleReviewerPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleReviewerPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["reviewStatus"] = this.reviewStatus !== undefined ? this.reviewStatus : null as any;
        data["reReviewStatus"] = this.reReviewStatus !== undefined ? this.reReviewStatus : null as any;
        return data;
    }
}

export interface IApiTitleReviewerPaperListItem {
    titleId?: number;
    paperId?: number;
    paperName?: string | null;
    reviewStatus?: ReviewStatusEnum;
    reReviewStatus?: ReviewStatusEnum | null;
}

export enum ReviewStatusEnum {
    Assigned = 0,
    Agreed = 1,
    Refused = 2,
    Reviewed = 3,
    Approved = 4,
    Canceled = 5,
}

export class ApiReviewerNote implements IApiReviewerNote {
    note?: string | null;

    constructor(data?: IApiReviewerNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ApiReviewerNote {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null as any;
        return data;
    }
}

export interface IApiReviewerNote {
    note?: string | null;
}

export class ApiPageResultOfApiTitleDocument implements IApiPageResultOfApiTitleDocument {
    items?: ApiTitleDocument[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleDocument.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleDocument {
    items?: ApiTitleDocument[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleDocument implements IApiTitleDocument {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;
    @columnMap(() => ApiCreatorInfo)
    addedBy?: ApiCreatorInfo | null;

    constructor(data?: IApiTitleDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.addedBy = _data["addedBy"] ? ApiCreatorInfo.fromJS(_data["addedBy"]) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleDocument {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["addedBy"] = this.addedBy ? this.addedBy.toJSON() : null as any;
        return data;
    }
}

export interface IApiTitleDocument {
    id?: number;
    pos?: number;
    name?: string | null;
    file?: ApiFileInfo | null;
    addedBy?: ApiCreatorInfo | null;
}

export class ApiPartTitleFile implements IApiPartTitleFile {
    partId?: number;
    partName?: string | null;
    paperCount?: number;
    pagesInPDF?: number;
    titleFile?: ApiTitleFile[] | null;

    constructor(data?: IApiPartTitleFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partId = _data["partId"] !== undefined ? _data["partId"] : null as any;
            this.partName = _data["partName"] !== undefined ? _data["partName"] : null as any;
            this.paperCount = _data["paperCount"] !== undefined ? _data["paperCount"] : null as any;
            this.pagesInPDF = _data["pagesInPDF"] !== undefined ? _data["pagesInPDF"] : null as any;
            if (Array.isArray(_data["titleFile"])) {
                this.titleFile = [] as any;
                for (let item of _data["titleFile"])
                    this.titleFile!.push(ApiTitleFile.fromJS(item));
            }
            else {
                this.titleFile = null as any;
            }
        }
    }

    static fromJS(data: any): ApiPartTitleFile {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPartTitleFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partId"] = this.partId !== undefined ? this.partId : null as any;
        data["partName"] = this.partName !== undefined ? this.partName : null as any;
        data["paperCount"] = this.paperCount !== undefined ? this.paperCount : null as any;
        data["pagesInPDF"] = this.pagesInPDF !== undefined ? this.pagesInPDF : null as any;
        if (Array.isArray(this.titleFile)) {
            data["titleFile"] = [];
            for (let item of this.titleFile)
                data["titleFile"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiPartTitleFile {
    partId?: number;
    partName?: string | null;
    paperCount?: number;
    pagesInPDF?: number;
    titleFile?: ApiTitleFile[] | null;
}

export class ApiPageResultOfApiTitleDoiListItem implements IApiPageResultOfApiTitleDoiListItem {
    items?: ApiTitleDoiListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleDoiListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleDoiListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleDoiListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleDoiListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleDoiListItem {
    items?: ApiTitleDoiListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleDoiListItem implements IApiTitleDoiListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => String)
    isbnPrint?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    @columnMap(() => String)
    volume?: string | null;
    @columnMap(() => Date)
    doiDate?: Date;
    @columnMap(() => String)
    doi?: string | null;
    @columnMap(() => TitleCategory)
    titleCategory?: TitleCategory;
    @columnMap(() => RegistrationStatus)
    status?: RegistrationStatus;
    @columnMap(() => String)
    result?: string | null;

    constructor(data?: IApiTitleDoiListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.volume = _data["volume"] !== undefined ? _data["volume"] : null as any;
            this.doiDate = _data["doiDate"] ? new Date(_data["doiDate"].toString()) : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.titleCategory = _data["titleCategory"] !== undefined ? _data["titleCategory"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleDoiListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleDoiListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["volume"] = this.volume !== undefined ? this.volume : null as any;
        data["doiDate"] = this.doiDate ? this.doiDate.toISOString() : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["titleCategory"] = this.titleCategory !== undefined ? this.titleCategory : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }
}

export interface IApiTitleDoiListItem {
    id?: number;
    kurzel?: string | null;
    isbnPrint?: string | null;
    titleName?: string | null;
    volume?: string | null;
    doiDate?: Date;
    doi?: string | null;
    titleCategory?: TitleCategory;
    status?: RegistrationStatus;
    result?: string | null;
}

export enum TitleCategory {
    Volume = 0,
    Book = 1,
}

export enum RegistrationStatus {
    None = 0,
    Uploaded = 1,
    Deposited = 2,
    DepositedAndReuploaded = 3,
    Failure = 4,
    DepositedAndReuploadFailed = 6,
}

export class ApiTitleDoi implements IApiTitleDoi {
    id?: number;
    doiDate?: Date;
    doi?: string | null;
    titleCategory?: TitleCategory;
    status?: RegistrationStatus;
    result?: string | null;

    constructor(data?: IApiTitleDoi) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.doiDate = _data["doiDate"] ? new Date(_data["doiDate"].toString()) : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.titleCategory = _data["titleCategory"] !== undefined ? _data["titleCategory"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleDoi {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleDoi();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["doiDate"] = this.doiDate ? this.doiDate.toISOString() : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["titleCategory"] = this.titleCategory !== undefined ? this.titleCategory : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }
}

export interface IApiTitleDoi {
    id?: number;
    doiDate?: Date;
    doi?: string | null;
    titleCategory?: TitleCategory;
    status?: RegistrationStatus;
    result?: string | null;
}

export class ApiThemaTreeNode implements IApiThemaTreeNode {
    themaCode?: string | null;
    themaHeading?: string | null;
    inUse?: boolean;
    children?: ApiThemaTreeNode[] | null;

    constructor(data?: IApiThemaTreeNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.themaCode = _data["themaCode"] !== undefined ? _data["themaCode"] : null as any;
            this.themaHeading = _data["themaHeading"] !== undefined ? _data["themaHeading"] : null as any;
            this.inUse = _data["inUse"] !== undefined ? _data["inUse"] : null as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(ApiThemaTreeNode.fromJS(item));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): ApiThemaTreeNode {
        data = typeof data === 'object' ? data : {};
        let result = new ApiThemaTreeNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["themaCode"] = this.themaCode !== undefined ? this.themaCode : null as any;
        data["themaHeading"] = this.themaHeading !== undefined ? this.themaHeading : null as any;
        data["inUse"] = this.inUse !== undefined ? this.inUse : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiThemaTreeNode {
    themaCode?: string | null;
    themaHeading?: string | null;
    inUse?: boolean;
    children?: ApiThemaTreeNode[] | null;
}

export class ApiThema implements IApiThema {
    code: string;
    heading: string;

    constructor(data?: IApiThema) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : null as any;
        }
    }

    static fromJS(data: any): ApiThema {
        data = typeof data === 'object' ? data : {};
        let result = new ApiThema();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["heading"] = this.heading !== undefined ? this.heading : null as any;
        return data;
    }
}

export interface IApiThema {
    code: string;
    heading: string;
}

export class ApiPageResultOfApiThemaCatalogListItem implements IApiPageResultOfApiThemaCatalogListItem {
    items?: ApiThemaCatalogListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiThemaCatalogListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiThemaCatalogListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiThemaCatalogListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiThemaCatalogListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiThemaCatalogListItem {
    items?: ApiThemaCatalogListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiThemaCatalogListItem implements IApiThemaCatalogListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    version?: string | null;
    creatorId?: number;
    @columnMap(() => String)
    performer?: string | null;
    @columnMap(() => Date)
    lastUpdated?: Date;

    constructor(data?: IApiThemaCatalogListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.performer = _data["performer"] !== undefined ? _data["performer"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiThemaCatalogListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiThemaCatalogListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["performer"] = this.performer !== undefined ? this.performer : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        return data;
    }
}

export interface IApiThemaCatalogListItem {
    id?: number;
    version?: string | null;
    creatorId?: number;
    performer?: string | null;
    lastUpdated?: Date;
}

export class ApiPageResultOfApiTopicListItem implements IApiPageResultOfApiTopicListItem {
    items?: ApiTopicListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTopicListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTopicListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTopicListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTopicListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTopicListItem {
    items?: ApiTopicListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTopicListItem implements IApiTopicListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    themaCategoryCode?: string | null;
    @columnMap(() => String)
    themaCategoryName?: string | null;
    @columnMap(() => ApiNamedListItem, true)
    bicCodes?: ApiNamedListItem[] | null;
    @columnMap(() => ApiNamedListItem, true)
    bisacCodes?: ApiNamedListItem[] | null;
    @columnMap(() => ApiNamedListItem, true)
    lcshCodes?: ApiNamedListItem[] | null;
    @columnMap(() => ApiNamedListItem, true)
    topicCodes?: ApiNamedListItem[] | null;
    @columnMap(() => ApiNamedListItem, true)
    wgsCodes?: ApiNamedListItem[] | null;
    @columnMap(() => ApiNamedListItem, true)
    journals?: ApiNamedListItem[] | null;
    @columnMap(() => Boolean)
    archived?: boolean;

    constructor(data?: IApiTopicListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.themaCategoryCode = _data["themaCategoryCode"] !== undefined ? _data["themaCategoryCode"] : null as any;
            this.themaCategoryName = _data["themaCategoryName"] !== undefined ? _data["themaCategoryName"] : null as any;
            if (Array.isArray(_data["bicCodes"])) {
                this.bicCodes = [] as any;
                for (let item of _data["bicCodes"])
                    this.bicCodes!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.bicCodes = null as any;
            }
            if (Array.isArray(_data["bisacCodes"])) {
                this.bisacCodes = [] as any;
                for (let item of _data["bisacCodes"])
                    this.bisacCodes!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.bisacCodes = null as any;
            }
            if (Array.isArray(_data["lcshCodes"])) {
                this.lcshCodes = [] as any;
                for (let item of _data["lcshCodes"])
                    this.lcshCodes!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.lcshCodes = null as any;
            }
            if (Array.isArray(_data["topicCodes"])) {
                this.topicCodes = [] as any;
                for (let item of _data["topicCodes"])
                    this.topicCodes!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.topicCodes = null as any;
            }
            if (Array.isArray(_data["wgsCodes"])) {
                this.wgsCodes = [] as any;
                for (let item of _data["wgsCodes"])
                    this.wgsCodes!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.wgsCodes = null as any;
            }
            if (Array.isArray(_data["journals"])) {
                this.journals = [] as any;
                for (let item of _data["journals"])
                    this.journals!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.journals = null as any;
            }
            this.archived = _data["archived"] !== undefined ? _data["archived"] : null as any;
        }
    }

    static fromJS(data: any): ApiTopicListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTopicListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["themaCategoryCode"] = this.themaCategoryCode !== undefined ? this.themaCategoryCode : null as any;
        data["themaCategoryName"] = this.themaCategoryName !== undefined ? this.themaCategoryName : null as any;
        if (Array.isArray(this.bicCodes)) {
            data["bicCodes"] = [];
            for (let item of this.bicCodes)
                data["bicCodes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.bisacCodes)) {
            data["bisacCodes"] = [];
            for (let item of this.bisacCodes)
                data["bisacCodes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.lcshCodes)) {
            data["lcshCodes"] = [];
            for (let item of this.lcshCodes)
                data["lcshCodes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.topicCodes)) {
            data["topicCodes"] = [];
            for (let item of this.topicCodes)
                data["topicCodes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.wgsCodes)) {
            data["wgsCodes"] = [];
            for (let item of this.wgsCodes)
                data["wgsCodes"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.journals)) {
            data["journals"] = [];
            for (let item of this.journals)
                data["journals"].push(item ? item.toJSON() : null as any);
        }
        data["archived"] = this.archived !== undefined ? this.archived : null as any;
        return data;
    }
}

export interface IApiTopicListItem {
    id?: number;
    themaCategoryCode?: string | null;
    themaCategoryName?: string | null;
    bicCodes?: ApiNamedListItem[] | null;
    bisacCodes?: ApiNamedListItem[] | null;
    lcshCodes?: ApiNamedListItem[] | null;
    topicCodes?: ApiNamedListItem[] | null;
    wgsCodes?: ApiNamedListItem[] | null;
    journals?: ApiNamedListItem[] | null;
    archived?: boolean;
}

export class ApiTopic implements IApiTopic {
    id?: number;
    thema?: ApiThema | null;
    codes?: ApiTopicCode[] | null;

    constructor(data?: IApiTopic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.thema = _data["thema"] ? ApiThema.fromJS(_data["thema"]) : null as any;
            if (Array.isArray(_data["codes"])) {
                this.codes = [] as any;
                for (let item of _data["codes"])
                    this.codes!.push(ApiTopicCode.fromJS(item));
            }
            else {
                this.codes = null as any;
            }
        }
    }

    static fromJS(data: any): ApiTopic {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTopic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["thema"] = this.thema ? this.thema.toJSON() : null as any;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            for (let item of this.codes)
                data["codes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiTopic {
    id?: number;
    thema?: ApiThema | null;
    codes?: ApiTopicCode[] | null;
}

export class ApiTopicCode implements IApiTopicCode {
    code?: string | null;
    name: string;
    type?: SubjectCategoryType;

    constructor(data?: IApiTopicCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiTopicCode {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTopicCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiTopicCode {
    code?: string | null;
    name: string;
    type?: SubjectCategoryType;
}

export class ApiPaperCopyrightText implements IApiPaperCopyrightText {
    publisher?: string | null;
    copyrightSite?: string | null;
    copyrightTextHeader?: string | null;
    copyrightTextFooter?: string | null;
    copyrightTextHeaderOA?: string | null;
    copyrightTextFooterOA?: string | null;
    copyrightTextFooterCanada?: string | null;

    constructor(data?: IApiPaperCopyrightText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publisher = _data["publisher"] !== undefined ? _data["publisher"] : null as any;
            this.copyrightSite = _data["copyrightSite"] !== undefined ? _data["copyrightSite"] : null as any;
            this.copyrightTextHeader = _data["copyrightTextHeader"] !== undefined ? _data["copyrightTextHeader"] : null as any;
            this.copyrightTextFooter = _data["copyrightTextFooter"] !== undefined ? _data["copyrightTextFooter"] : null as any;
            this.copyrightTextHeaderOA = _data["copyrightTextHeaderOA"] !== undefined ? _data["copyrightTextHeaderOA"] : null as any;
            this.copyrightTextFooterOA = _data["copyrightTextFooterOA"] !== undefined ? _data["copyrightTextFooterOA"] : null as any;
            this.copyrightTextFooterCanada = _data["copyrightTextFooterCanada"] !== undefined ? _data["copyrightTextFooterCanada"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperCopyrightText {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperCopyrightText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publisher"] = this.publisher !== undefined ? this.publisher : null as any;
        data["copyrightSite"] = this.copyrightSite !== undefined ? this.copyrightSite : null as any;
        data["copyrightTextHeader"] = this.copyrightTextHeader !== undefined ? this.copyrightTextHeader : null as any;
        data["copyrightTextFooter"] = this.copyrightTextFooter !== undefined ? this.copyrightTextFooter : null as any;
        data["copyrightTextHeaderOA"] = this.copyrightTextHeaderOA !== undefined ? this.copyrightTextHeaderOA : null as any;
        data["copyrightTextFooterOA"] = this.copyrightTextFooterOA !== undefined ? this.copyrightTextFooterOA : null as any;
        data["copyrightTextFooterCanada"] = this.copyrightTextFooterCanada !== undefined ? this.copyrightTextFooterCanada : null as any;
        return data;
    }
}

export interface IApiPaperCopyrightText {
    publisher?: string | null;
    copyrightSite?: string | null;
    copyrightTextHeader?: string | null;
    copyrightTextFooter?: string | null;
    copyrightTextHeaderOA?: string | null;
    copyrightTextFooterOA?: string | null;
    copyrightTextFooterCanada?: string | null;
}

export class ApiFileTemplate implements IApiFileTemplate {
    memberId?: number;
    memberFullName?: string | null;
    file?: ApiFileInfo | null;
    type?: FileTemplateType;

    constructor(data?: IApiFileTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.memberFullName = _data["memberFullName"] !== undefined ? _data["memberFullName"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiFileTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFileTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["memberFullName"] = this.memberFullName !== undefined ? this.memberFullName : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiFileTemplate {
    memberId?: number;
    memberFullName?: string | null;
    file?: ApiFileInfo | null;
    type?: FileTemplateType;
}

export enum FileTemplateType {
    HomePagePrint = 0,
    HomePagePrintJournal = 1,
    DefaultTitleCover = 2,
    Catalogue = 3,
    ImportPaperCopiesExample = 4,
}

export class ApiHtmlTemplate implements IApiHtmlTemplate {
    id?: number;
    name?: string | null;
    template?: string | null;
    lastModifiedDate?: Date | null;
    updatedBy?: ApiMemberInfo | null;

    constructor(data?: IApiHtmlTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.template = _data["template"] !== undefined ? _data["template"] : null as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : null as any;
            this.updatedBy = _data["updatedBy"] ? ApiMemberInfo.fromJS(_data["updatedBy"]) : null as any;
        }
    }

    static fromJS(data: any): ApiHtmlTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiHtmlTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["template"] = this.template !== undefined ? this.template : null as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null as any;
        data["updatedBy"] = this.updatedBy ? this.updatedBy.toJSON() : null as any;
        return data;
    }
}

export interface IApiHtmlTemplate {
    id?: number;
    name?: string | null;
    template?: string | null;
    lastModifiedDate?: Date | null;
    updatedBy?: ApiMemberInfo | null;
}

export class ApiPageResultOfApiKeywordListItem implements IApiPageResultOfApiKeywordListItem {
    items?: ApiKeywordListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiKeywordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiKeywordListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiKeywordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiKeywordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiKeywordListItem {
    items?: ApiKeywordListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiKeywordListItem implements IApiKeywordListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => Number)
    titles?: number;
    @columnMap(() => Number)
    papers?: number;
    isRemovable?: boolean;

    constructor(data?: IApiKeywordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.titles = _data["titles"] !== undefined ? _data["titles"] : null as any;
            this.papers = _data["papers"] !== undefined ? _data["papers"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiKeywordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeywordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["titles"] = this.titles !== undefined ? this.titles : null as any;
        data["papers"] = this.papers !== undefined ? this.papers : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiKeywordListItem {
    id?: number;
    name?: string | null;
    titles?: number;
    papers?: number;
    isRemovable?: boolean;
}

export class ApiKeywordCreateRequest implements IApiKeywordCreateRequest {
    keyword: string;
    splitAndCapitalize?: boolean;

    constructor(data?: IApiKeywordCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
            this.splitAndCapitalize = _data["splitAndCapitalize"] !== undefined ? _data["splitAndCapitalize"] : null as any;
        }
    }

    static fromJS(data: any): ApiKeywordCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeywordCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        data["splitAndCapitalize"] = this.splitAndCapitalize !== undefined ? this.splitAndCapitalize : null as any;
        return data;
    }
}

export interface IApiKeywordCreateRequest {
    keyword: string;
    splitAndCapitalize?: boolean;
}

export class ApiKeywordUpdateRequest implements IApiKeywordUpdateRequest {
    id?: number;
    keyword?: string | null;

    constructor(data?: IApiKeywordUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.keyword = _data["keyword"] !== undefined ? _data["keyword"] : null as any;
        }
    }

    static fromJS(data: any): ApiKeywordUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeywordUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["keyword"] = this.keyword !== undefined ? this.keyword : null as any;
        return data;
    }
}

export interface IApiKeywordUpdateRequest {
    id?: number;
    keyword?: string | null;
}

export class ApiPageResultOfApiPaperFooterListItem implements IApiPageResultOfApiPaperFooterListItem {
    items?: ApiPaperFooterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperFooterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperFooterListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperFooterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperFooterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperFooterListItem {
    items?: ApiPaperFooterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperFooterListItem implements IApiPaperFooterListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    text?: string | null;
    @columnMap(() => Number)
    usageCount?: number;

    constructor(data?: IApiPaperFooterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperFooterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperFooterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        return data;
    }
}

export interface IApiPaperFooterListItem {
    id?: number;
    name?: string | null;
    text?: string | null;
    usageCount?: number;
}

export class ApiPaperFooterDetails implements IApiPaperFooterDetails {
    id?: number;
    name?: string | null;
    text?: string | null;

    constructor(data?: IApiPaperFooterDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperFooterDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperFooterDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IApiPaperFooterDetails {
    id?: number;
    name?: string | null;
    text?: string | null;
}

export class ApiPaperFooterUpdate implements IApiPaperFooterUpdate {
    name: string;
    text: string;

    constructor(data?: IApiPaperFooterUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperFooterUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperFooterUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IApiPaperFooterUpdate {
    name: string;
    text: string;
}

export class ApiPageResultOfApiPublishingReasonListItem implements IApiPageResultOfApiPublishingReasonListItem {
    items?: ApiPublishingReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPublishingReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPublishingReasonListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPublishingReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPublishingReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPublishingReasonListItem {
    items?: ApiPublishingReasonListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export abstract class ApiBaseReasonListItem implements IApiBaseReasonListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    reasonValue?: string | null;
    @columnMap(() => Number)
    usageCount?: number;

    constructor(data?: IApiBaseReasonListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reasonValue = _data["reasonValue"] !== undefined ? _data["reasonValue"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonListItem {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReasonListItem' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reasonValue"] = this.reasonValue !== undefined ? this.reasonValue : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        return data;
    }
}

export interface IApiBaseReasonListItem {
    id?: number;
    reasonValue?: string | null;
    usageCount?: number;
}

export class ApiPublishingReasonListItem extends ApiBaseReasonListItem implements IApiPublishingReasonListItem {
    @columnMap(() => PublishingReasonTypeEnum)
    type?: PublishingReasonTypeEnum;

    constructor(data?: IApiPublishingReasonListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingReasonListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingReasonListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiPublishingReasonListItem extends IApiBaseReasonListItem {
    type?: PublishingReasonTypeEnum;
}

export abstract class ApiBaseReasonUpdate implements IApiBaseReasonUpdate {
    reasonValue: string;

    constructor(data?: IApiBaseReasonUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonValue = _data["reasonValue"] !== undefined ? _data["reasonValue"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonUpdate {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReasonUpdate' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonValue"] = this.reasonValue !== undefined ? this.reasonValue : null as any;
        return data;
    }
}

export interface IApiBaseReasonUpdate {
    reasonValue: string;
}

export class ApiPublishingReasonUpdate extends ApiBaseReasonUpdate implements IApiPublishingReasonUpdate {
    type?: PublishingReasonTypeEnum;

    constructor(data?: IApiPublishingReasonUpdate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingReasonUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingReasonUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiPublishingReasonUpdate extends IApiBaseReasonUpdate {
    type?: PublishingReasonTypeEnum;
}

export class ApiBaseReasonDetails extends ApiBaseReasonUpdate implements IApiBaseReasonDetails {
    id?: number;

    constructor(data?: IApiBaseReasonDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReasonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBaseReasonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiBaseReasonDetails extends IApiBaseReasonUpdate {
    id?: number;
}

export class ApiPublishingReasonDetails extends ApiBaseReasonDetails implements IApiPublishingReasonDetails {
    type?: PublishingReasonTypeEnum;

    constructor(data?: IApiPublishingReasonDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingReasonDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingReasonDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiPublishingReasonDetails extends IApiBaseReasonDetails {
    type?: PublishingReasonTypeEnum;
}

export class ApiPageResultOfApiTitleReasonUsageListItem implements IApiPageResultOfApiTitleReasonUsageListItem {
    items?: ApiTitleReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleReasonUsageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleReasonUsageListItem {
    items?: ApiTitleReasonUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleReasonUsageListItem implements IApiTitleReasonUsageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiTitleShortInfo)
    titleName?: ApiTitleShortInfo | null;
    @columnMap(() => String)
    performerFullName?: string | null;
    @columnMap(() => Date)
    performedDateTime?: Date;
    performerMemberId?: number;

    constructor(data?: IApiTitleReasonUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleName = _data["titleName"] ? ApiTitleShortInfo.fromJS(_data["titleName"]) : null as any;
            this.performerFullName = _data["performerFullName"] !== undefined ? _data["performerFullName"] : null as any;
            this.performedDateTime = _data["performedDateTime"] ? new Date(_data["performedDateTime"].toString()) : null as any;
            this.performerMemberId = _data["performerMemberId"] !== undefined ? _data["performerMemberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleReasonUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleReasonUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleName"] = this.titleName ? this.titleName.toJSON() : null as any;
        data["performerFullName"] = this.performerFullName !== undefined ? this.performerFullName : null as any;
        data["performedDateTime"] = this.performedDateTime ? this.performedDateTime.toISOString() : null as any;
        data["performerMemberId"] = this.performerMemberId !== undefined ? this.performerMemberId : null as any;
        return data;
    }
}

export interface IApiTitleReasonUsageListItem {
    id?: number;
    titleName?: ApiTitleShortInfo | null;
    performerFullName?: string | null;
    performedDateTime?: Date;
    performerMemberId?: number;
}

export class ApiTitleShortInfo implements IApiTitleShortInfo {
    id?: number;
    name?: string | null;

    constructor(data?: IApiTitleShortInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleShortInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleShortInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiTitleShortInfo {
    id?: number;
    name?: string | null;
}

export class ApiPublishingReasonUsageDetails implements IApiPublishingReasonUsageDetails {
    id?: number;
    value?: string | null;
    type?: PublishingReasonTypeEnum;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    updaterFullName?: string | null;
    updaterId?: number;
    lastUpdated?: Date;

    constructor(data?: IApiPublishingReasonUsageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : null as any;
            this.updaterFullName = _data["updaterFullName"] !== undefined ? _data["updaterFullName"] : null as any;
            this.updaterId = _data["updaterId"] !== undefined ? _data["updaterId"] : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingReasonUsageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingReasonUsageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["updaterFullName"] = this.updaterFullName !== undefined ? this.updaterFullName : null as any;
        data["updaterId"] = this.updaterId !== undefined ? this.updaterId : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        return data;
    }
}

export interface IApiPublishingReasonUsageDetails {
    id?: number;
    value?: string | null;
    type?: PublishingReasonTypeEnum;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    updaterFullName?: string | null;
    updaterId?: number;
    lastUpdated?: Date;
}

export class ApiResponsibility implements IApiResponsibility {
    id?: number;
    responsibilityName?: string | null;
    defaultTitleContributor?: boolean;
    canGetMessageFromPublic?: boolean;
    provideJournalAccess?: boolean;
    provideEbookSeriesAccess?: boolean;

    constructor(data?: IApiResponsibility) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.responsibilityName = _data["responsibilityName"] !== undefined ? _data["responsibilityName"] : null as any;
            this.defaultTitleContributor = _data["defaultTitleContributor"] !== undefined ? _data["defaultTitleContributor"] : null as any;
            this.canGetMessageFromPublic = _data["canGetMessageFromPublic"] !== undefined ? _data["canGetMessageFromPublic"] : null as any;
            this.provideJournalAccess = _data["provideJournalAccess"] !== undefined ? _data["provideJournalAccess"] : null as any;
            this.provideEbookSeriesAccess = _data["provideEbookSeriesAccess"] !== undefined ? _data["provideEbookSeriesAccess"] : null as any;
        }
    }

    static fromJS(data: any): ApiResponsibility {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponsibility();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["responsibilityName"] = this.responsibilityName !== undefined ? this.responsibilityName : null as any;
        data["defaultTitleContributor"] = this.defaultTitleContributor !== undefined ? this.defaultTitleContributor : null as any;
        data["canGetMessageFromPublic"] = this.canGetMessageFromPublic !== undefined ? this.canGetMessageFromPublic : null as any;
        data["provideJournalAccess"] = this.provideJournalAccess !== undefined ? this.provideJournalAccess : null as any;
        data["provideEbookSeriesAccess"] = this.provideEbookSeriesAccess !== undefined ? this.provideEbookSeriesAccess : null as any;
        return data;
    }
}

export interface IApiResponsibility {
    id?: number;
    responsibilityName?: string | null;
    defaultTitleContributor?: boolean;
    canGetMessageFromPublic?: boolean;
    provideJournalAccess?: boolean;
    provideEbookSeriesAccess?: boolean;
}

export class ApiPageResultOfApiResponsibilityListItem implements IApiPageResultOfApiResponsibilityListItem {
    items?: ApiResponsibilityListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiResponsibilityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiResponsibilityListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiResponsibilityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiResponsibilityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiResponsibilityListItem {
    items?: ApiResponsibilityListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiResponsibilityListItem implements IApiResponsibilityListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    responsibilityName?: string | null;
    @columnMap(() => Number)
    membersCount?: number;
    @columnMap(() => Boolean)
    defaultTitleContributor?: boolean;
    @columnMap(() => Boolean)
    canGetMessageFromPublic?: boolean;
    @columnMap(() => Boolean)
    provideJournalAccess?: boolean;
    @columnMap(() => Boolean)
    provideEbookSeriesAccess?: boolean;
    isRemovable?: boolean;

    constructor(data?: IApiResponsibilityListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.responsibilityName = _data["responsibilityName"] !== undefined ? _data["responsibilityName"] : null as any;
            this.membersCount = _data["membersCount"] !== undefined ? _data["membersCount"] : null as any;
            this.defaultTitleContributor = _data["defaultTitleContributor"] !== undefined ? _data["defaultTitleContributor"] : null as any;
            this.canGetMessageFromPublic = _data["canGetMessageFromPublic"] !== undefined ? _data["canGetMessageFromPublic"] : null as any;
            this.provideJournalAccess = _data["provideJournalAccess"] !== undefined ? _data["provideJournalAccess"] : null as any;
            this.provideEbookSeriesAccess = _data["provideEbookSeriesAccess"] !== undefined ? _data["provideEbookSeriesAccess"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiResponsibilityListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponsibilityListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["responsibilityName"] = this.responsibilityName !== undefined ? this.responsibilityName : null as any;
        data["membersCount"] = this.membersCount !== undefined ? this.membersCount : null as any;
        data["defaultTitleContributor"] = this.defaultTitleContributor !== undefined ? this.defaultTitleContributor : null as any;
        data["canGetMessageFromPublic"] = this.canGetMessageFromPublic !== undefined ? this.canGetMessageFromPublic : null as any;
        data["provideJournalAccess"] = this.provideJournalAccess !== undefined ? this.provideJournalAccess : null as any;
        data["provideEbookSeriesAccess"] = this.provideEbookSeriesAccess !== undefined ? this.provideEbookSeriesAccess : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiResponsibilityListItem {
    id?: number;
    pos?: number;
    responsibilityName?: string | null;
    membersCount?: number;
    defaultTitleContributor?: boolean;
    canGetMessageFromPublic?: boolean;
    provideJournalAccess?: boolean;
    provideEbookSeriesAccess?: boolean;
    isRemovable?: boolean;
}

export class ApiPageResultOfApiResponsibilityMemberListItem implements IApiPageResultOfApiResponsibilityMemberListItem {
    items?: ApiResponsibilityMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiResponsibilityMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiResponsibilityMemberListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiResponsibilityMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiResponsibilityMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiResponsibilityMemberListItem {
    items?: ApiResponsibilityMemberListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiResponsibilityMemberListItem implements IApiResponsibilityMemberListItem {
    @keyMap()
    memberId?: number;
    journalId?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => ApiMemberInfo)
    member?: ApiMemberInfo | null;
    @columnMap(() => String)
    country?: string | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;

    constructor(data?: IApiResponsibilityMemberListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.member = _data["member"] ? ApiMemberInfo.fromJS(_data["member"]) : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
        }
    }

    static fromJS(data: any): ApiResponsibilityMemberListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiResponsibilityMemberListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["member"] = this.member ? this.member.toJSON() : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        return data;
    }
}

export interface IApiResponsibilityMemberListItem {
    memberId?: number;
    journalId?: number;
    kurzel?: string | null;
    member?: ApiMemberInfo | null;
    country?: string | null;
    universityOrOrganization?: string | null;
}

export class ApiPageResultOfApiTitleProgressStatusListItem implements IApiPageResultOfApiTitleProgressStatusListItem {
    items?: ApiTitleProgressStatusListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleProgressStatusListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleProgressStatusListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleProgressStatusListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleProgressStatusListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleProgressStatusListItem {
    items?: ApiTitleProgressStatusListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleProgressStatusListItem implements IApiTitleProgressStatusListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => Number)
    usageCount?: number;

    constructor(data?: IApiTitleProgressStatusListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.usageCount = _data["usageCount"] !== undefined ? _data["usageCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProgressStatusListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProgressStatusListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["usageCount"] = this.usageCount !== undefined ? this.usageCount : null as any;
        return data;
    }
}

export interface IApiTitleProgressStatusListItem {
    id?: number;
    name?: string | null;
    usageCount?: number;
}

export class ApiTitleProgressStatusUsageDetails implements IApiTitleProgressStatusUsageDetails {
    id?: number;
    name?: string | null;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;

    constructor(data?: IApiTitleProgressStatusUsageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.creatorId = _data["creatorId"] !== undefined ? _data["creatorId"] : null as any;
            this.creatorFullName = _data["creatorFullName"] !== undefined ? _data["creatorFullName"] : null as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : null as any;
            this.modifierId = _data["modifierId"] !== undefined ? _data["modifierId"] : null as any;
            this.modifierFullName = _data["modifierFullName"] !== undefined ? _data["modifierFullName"] : null as any;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProgressStatusUsageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProgressStatusUsageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["creatorId"] = this.creatorId !== undefined ? this.creatorId : null as any;
        data["creatorFullName"] = this.creatorFullName !== undefined ? this.creatorFullName : null as any;
        data["created"] = this.created ? this.created.toISOString() : null as any;
        data["modifierId"] = this.modifierId !== undefined ? this.modifierId : null as any;
        data["modifierFullName"] = this.modifierFullName !== undefined ? this.modifierFullName : null as any;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : null as any;
        return data;
    }
}

export interface IApiTitleProgressStatusUsageDetails {
    id?: number;
    name?: string | null;
    creatorId?: number;
    creatorFullName?: string | null;
    created?: Date;
    modifierId?: number | null;
    modifierFullName?: string | null;
    lastModifiedDate?: Date | null;
}

export class ApiPageResultOfApiTitleProgressStatusTitleUsageListItem implements IApiPageResultOfApiTitleProgressStatusTitleUsageListItem {
    items?: ApiTitleProgressStatusTitleUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleProgressStatusTitleUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleProgressStatusTitleUsageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleProgressStatusTitleUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleProgressStatusTitleUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleProgressStatusTitleUsageListItem {
    items?: ApiTitleProgressStatusTitleUsageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleProgressStatusTitleUsageListItem implements IApiTitleProgressStatusTitleUsageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    name?: string | null;

    constructor(data?: IApiTitleProgressStatusTitleUsageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProgressStatusTitleUsageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProgressStatusTitleUsageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiTitleProgressStatusTitleUsageListItem {
    id?: number;
    name?: string | null;
}

export class ApiTitleProgressStatusUpdate implements IApiTitleProgressStatusUpdate {
    name?: string | null;

    constructor(data?: IApiTitleProgressStatusUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleProgressStatusUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleProgressStatusUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiTitleProgressStatusUpdate {
    name?: string | null;
}

export class ApiPageResultOfApiContributorAddressListItem implements IApiPageResultOfApiContributorAddressListItem {
    items?: ApiContributorAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiContributorAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiContributorAddressListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiContributorAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiContributorAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiContributorAddressListItem {
    items?: ApiContributorAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiContributorAddressListItem implements IApiContributorAddressListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    gridId?: string | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;
    @columnMap(() => String)
    department?: string | null;
    @columnMap(() => String)
    addressLine1?: string | null;
    @columnMap(() => String)
    addressLine2?: string | null;
    @columnMap(() => String)
    city?: string | null;
    @columnMap(() => String)
    state?: string | null;
    @columnMap(() => String)
    zip?: string | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String, true)
    websites?: string[] | null;
    @columnMap(() => Number, true)
    titles?: number[] | null;

    constructor(data?: IApiContributorAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
            if (Array.isArray(_data["titles"])) {
                this.titles = [] as any;
                for (let item of _data["titles"])
                    this.titles!.push(item);
            }
            else {
                this.titles = null as any;
            }
        }
    }

    static fromJS(data: any): ApiContributorAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiContributorAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        if (Array.isArray(this.titles)) {
            data["titles"] = [];
            for (let item of this.titles)
                data["titles"].push(item);
        }
        return data;
    }
}

export interface IApiContributorAddressListItem {
    id?: number;
    gridId?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: ApiNamedListItem | null;
    websites?: string[] | null;
    titles?: number[] | null;
}

export class ApiPageResultOfApiParticipantAddressListItem implements IApiPageResultOfApiParticipantAddressListItem {
    items?: ApiParticipantAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiParticipantAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiParticipantAddressListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiParticipantAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiParticipantAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiParticipantAddressListItem {
    items?: ApiParticipantAddressListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiParticipantAddressListItem implements IApiParticipantAddressListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => String)
    gridId?: string | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;
    @columnMap(() => String)
    department?: string | null;
    @columnMap(() => String)
    addressLine1?: string | null;
    @columnMap(() => String)
    addressLine2?: string | null;
    @columnMap(() => String)
    city?: string | null;
    @columnMap(() => String)
    state?: string | null;
    @columnMap(() => String)
    zip?: string | null;
    @columnMap(() => ApiNamedListItem)
    country?: ApiNamedListItem | null;
    @columnMap(() => String, true)
    websites?: string[] | null;
    @columnMap(() => ApiPaperInfoListItem, true)
    papers?: ApiPaperInfoListItem[] | null;

    constructor(data?: IApiParticipantAddressListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.gridId = _data["gridId"] !== undefined ? _data["gridId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.country = _data["country"] ? ApiNamedListItem.fromJS(_data["country"]) : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
            if (Array.isArray(_data["papers"])) {
                this.papers = [] as any;
                for (let item of _data["papers"])
                    this.papers!.push(ApiPaperInfoListItem.fromJS(item));
            }
            else {
                this.papers = null as any;
            }
        }
    }

    static fromJS(data: any): ApiParticipantAddressListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiParticipantAddressListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["gridId"] = this.gridId !== undefined ? this.gridId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        if (Array.isArray(this.papers)) {
            data["papers"] = [];
            for (let item of this.papers)
                data["papers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiParticipantAddressListItem {
    id?: number;
    gridId?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: ApiNamedListItem | null;
    websites?: string[] | null;
    papers?: ApiPaperInfoListItem[] | null;
}

export class ApiPaperInfoListItem implements IApiPaperInfoListItem {
    titleId?: number;
    paperId?: number;

    constructor(data?: IApiPaperInfoListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperInfoListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperInfoListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        return data;
    }
}

export interface IApiPaperInfoListItem {
    titleId?: number;
    paperId?: number;
}

export class ApiPageResultOfApiPaperAuthorListItem implements IApiPageResultOfApiPaperAuthorListItem {
    items?: ApiPaperAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperAuthorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperAuthorListItem {
    items?: ApiPaperAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperAuthorListItem implements IApiPaperAuthorListItem {
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => Number)
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => ApiParticipantAffiliationDetails)
    affiliation?: ApiParticipantAffiliationDetails | null;
    @columnMap(() => String)
    orcidId?: string | null;
    @columnMap(() => String, true)
    role?: string[] | null;
    @columnMap(() => Boolean)
    corresponding?: boolean;
    affiliationId?: number | null;

    constructor(data?: IApiPaperAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.affiliation = _data["affiliation"] ? ApiParticipantAffiliationDetails.fromJS(_data["affiliation"]) : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            if (Array.isArray(_data["role"])) {
                this.role = [] as any;
                for (let item of _data["role"])
                    this.role!.push(item);
            }
            else {
                this.role = null as any;
            }
            this.corresponding = _data["corresponding"] !== undefined ? _data["corresponding"] : null as any;
            this.affiliationId = _data["affiliationId"] !== undefined ? _data["affiliationId"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["affiliation"] = this.affiliation ? this.affiliation.toJSON() : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        if (Array.isArray(this.role)) {
            data["role"] = [];
            for (let item of this.role)
                data["role"].push(item);
        }
        data["corresponding"] = this.corresponding !== undefined ? this.corresponding : null as any;
        data["affiliationId"] = this.affiliationId !== undefined ? this.affiliationId : null as any;
        return data;
    }
}

export interface IApiPaperAuthorListItem {
    pos?: number;
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    affiliation?: ApiParticipantAffiliationDetails | null;
    orcidId?: string | null;
    role?: string[] | null;
    corresponding?: boolean;
    affiliationId?: number | null;
}

export class ApiPaperAuthorNameUpdate implements IApiPaperAuthorNameUpdate {
    memberId?: number;
    name: string;

    constructor(data?: IApiPaperAuthorNameUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperAuthorNameUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperAuthorNameUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiPaperAuthorNameUpdate {
    memberId?: number;
    name: string;
}

export class ApiPaperAuthorFullNameUpdate implements IApiPaperAuthorFullNameUpdate {
    memberId?: number;
    firstName: string;
    lastName: string;

    constructor(data?: IApiPaperAuthorFullNameUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperAuthorFullNameUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperAuthorFullNameUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

export interface IApiPaperAuthorFullNameUpdate {
    memberId?: number;
    firstName: string;
    lastName: string;
}

export class ApiPaperAuthorEmailUpdate implements IApiPaperAuthorEmailUpdate {
    memberId?: number;
    email: string;

    constructor(data?: IApiPaperAuthorEmailUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperAuthorEmailUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperAuthorEmailUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiPaperAuthorEmailUpdate {
    memberId?: number;
    email: string;
}

export class ApiPageResultOfApiPaperDocumentsListItem implements IApiPageResultOfApiPaperDocumentsListItem {
    items?: ApiPaperDocumentsListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperDocumentsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperDocumentsListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperDocumentsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperDocumentsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperDocumentsListItem {
    items?: ApiPaperDocumentsListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperDocumentsListItem implements IApiPaperDocumentsListItem {
    @keyMap()
    id?: number;
    @columnMap(() => PaperDocumentTypeEnum)
    type?: PaperDocumentTypeEnum;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;
    @columnMap(() => ApiMemberInfo)
    uploadedBy?: ApiMemberInfo | null;
    @columnMap(() => Date)
    added?: Date;
    @columnMap(() => Boolean)
    isCurrent?: boolean;

    constructor(data?: IApiPaperDocumentsListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.uploadedBy = _data["uploadedBy"] ? ApiMemberInfo.fromJS(_data["uploadedBy"]) : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
            this.isCurrent = _data["isCurrent"] !== undefined ? _data["isCurrent"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperDocumentsListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperDocumentsListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        data["isCurrent"] = this.isCurrent !== undefined ? this.isCurrent : null as any;
        return data;
    }
}

export interface IApiPaperDocumentsListItem {
    id?: number;
    type?: PaperDocumentTypeEnum;
    file?: ApiFileInfo | null;
    uploadedBy?: ApiMemberInfo | null;
    added?: Date;
    isCurrent?: boolean;
}

export enum PaperDocumentTypeEnum {
    Pdf = 1,
    Doc = 2,
    Epub = 3,
}

export class ApiPaper implements IApiPaper {
    id?: number;
    titleId?: number;
    abstract?: string | null;
    details?: ApiPaperDetails | null;

    constructor(data?: IApiPaper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
            this.details = _data["details"] ? ApiPaperDetails.fromJS(_data["details"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPaper {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        return data;
    }
}

export interface IApiPaper {
    id?: number;
    titleId?: number;
    abstract?: string | null;
    details?: ApiPaperDetails | null;
}

export class ApiPageResultOfApiPaperLegacyHistoryListItem implements IApiPageResultOfApiPaperLegacyHistoryListItem {
    items?: ApiPaperLegacyHistoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperLegacyHistoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperLegacyHistoryListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperLegacyHistoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperLegacyHistoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperLegacyHistoryListItem {
    items?: ApiPaperLegacyHistoryListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperLegacyHistoryListItem implements IApiPaperLegacyHistoryListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    memberId?: number;
    @columnMap(() => ApiMemberInfo)
    member?: ApiMemberInfo | null;
    @columnMap(() => String)
    description?: string | null;
    @columnMap(() => PaperAction)
    action?: PaperAction;
    @columnMap(() => Date)
    createdDateTime?: Date;

    constructor(data?: IApiPaperLegacyHistoryListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.member = _data["member"] ? ApiMemberInfo.fromJS(_data["member"]) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperLegacyHistoryListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperLegacyHistoryListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["member"] = this.member ? this.member.toJSON() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiPaperLegacyHistoryListItem {
    id?: number;
    memberId?: number;
    member?: ApiMemberInfo | null;
    description?: string | null;
    action?: PaperAction;
    createdDateTime?: Date;
}

export enum PaperAction {
    Created = 1,
    PdfUploaded = 2,
    DocUploaded = 3,
    Updated = 4,
    CopyrightUploaded = 5,
    CopyrightReceived = 6,
    StatusChanged = 7,
    AuthorAdded = 8,
    AuthorDeleted = 9,
    KeywordAdded = 10,
    KeywordDeleted = 11,
    CommentAdded = 12,
    CommentDeleted = 13,
    ReviewerAssigned = 14,
    ReviewerRemoved = 15,
    ReviewAdded = 16,
    EditorApproved = 17,
    CopyrightSubmitted = 18,
    AbstractCreated = 19,
    AbstractSubmitted = 20,
    PaperSubmitted = 21,
    ReviewerRefused = 22,
    Retracted = 23,
    RetractionCanceled = 24,
    SubmissionFeeRequired = 25,
    SubmissionFeePending = 26,
    SubmissionFeeCanceled = 27,
    SubmissionFeePaid = 28,
    PublicationFeeRequired = 29,
    PublicationFeePending = 30,
    PublicationFeeCanceled = 31,
    PublicationFeePaid = 32,
    ReferencesChanged = 33,
    ReferencesApproved = 34,
    OpenAccessEligibilityRequested = 35,
    EpubUploaded = 36,
    Moved = 37,
    FirstCheckCompleted = 38,
    DbEntered = 39,
}

export class ApiPaperNote extends ApiNote implements IApiPaperNote {
    attachmentName?: string | null;

    constructor(data?: IApiPaperNote) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.attachmentName = _data["attachmentName"] !== undefined ? _data["attachmentName"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperNote {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachmentName"] = this.attachmentName !== undefined ? this.attachmentName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiPaperNote extends IApiNote {
    attachmentName?: string | null;
}

export class ApiPageResultOfApiPaperReferenceListItem implements IApiPageResultOfApiPaperReferenceListItem {
    items?: ApiPaperReferenceListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperReferenceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperReferenceListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperReferenceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperReferenceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperReferenceListItem {
    items?: ApiPaperReferenceListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperReferenceListItem implements IApiPaperReferenceListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    displayOrder?: number | null;
    @columnMap(() => Number)
    authorOrder?: number | null;
    @columnMap(() => String)
    reference?: string | null;
    @columnMap(() => String)
    doi?: string | null;
    @columnMap(() => Boolean)
    checked?: boolean;

    constructor(data?: IApiPaperReferenceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayOrder = _data["displayOrder"] !== undefined ? _data["displayOrder"] : null as any;
            this.authorOrder = _data["authorOrder"] !== undefined ? _data["authorOrder"] : null as any;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.checked = _data["checked"] !== undefined ? _data["checked"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperReferenceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperReferenceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : null as any;
        data["authorOrder"] = this.authorOrder !== undefined ? this.authorOrder : null as any;
        data["reference"] = this.reference !== undefined ? this.reference : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["checked"] = this.checked !== undefined ? this.checked : null as any;
        return data;
    }
}

export interface IApiPaperReferenceListItem {
    id?: number;
    displayOrder?: number | null;
    authorOrder?: number | null;
    reference?: string | null;
    doi?: string | null;
    checked?: boolean;
}

export class ApiPaperReference implements IApiPaperReference {
    id?: number;
    authorOrder: number;
    doi?: string | null;
    text: string;

    constructor(data?: IApiPaperReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.authorOrder = _data["authorOrder"] !== undefined ? _data["authorOrder"] : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperReference {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["authorOrder"] = this.authorOrder !== undefined ? this.authorOrder : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        return data;
    }
}

export interface IApiPaperReference {
    id?: number;
    authorOrder: number;
    doi?: string | null;
    text: string;
}

export class ApiPublishingPaperReview implements IApiPublishingPaperReview {
    id?: number;
    status?: ReviewStatusEnum;
    reviewedDate?: Date;
    reviewedBy?: ApiMemberInfo | null;
    approvedDate?: Date | null;
    approvedBy?: ApiMemberInfo | null;
    reviewerReport?: ApiPublishingPaperReviewReport | null;
    editorReport?: ApiPublishingPaperReviewReport | null;

    constructor(data?: IApiPublishingPaperReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.reviewedDate = _data["reviewedDate"] ? new Date(_data["reviewedDate"].toString()) : null as any;
            this.reviewedBy = _data["reviewedBy"] ? ApiMemberInfo.fromJS(_data["reviewedBy"]) : null as any;
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : null as any;
            this.approvedBy = _data["approvedBy"] ? ApiMemberInfo.fromJS(_data["approvedBy"]) : null as any;
            this.reviewerReport = _data["reviewerReport"] ? ApiPublishingPaperReviewReport.fromJS(_data["reviewerReport"]) : null as any;
            this.editorReport = _data["editorReport"] ? ApiPublishingPaperReviewReport.fromJS(_data["editorReport"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingPaperReview {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["reviewedDate"] = this.reviewedDate ? this.reviewedDate.toISOString() : null as any;
        data["reviewedBy"] = this.reviewedBy ? this.reviewedBy.toJSON() : null as any;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : null as any;
        data["approvedBy"] = this.approvedBy ? this.approvedBy.toJSON() : null as any;
        data["reviewerReport"] = this.reviewerReport ? this.reviewerReport.toJSON() : null as any;
        data["editorReport"] = this.editorReport ? this.editorReport.toJSON() : null as any;
        return data;
    }
}

export interface IApiPublishingPaperReview {
    id?: number;
    status?: ReviewStatusEnum;
    reviewedDate?: Date;
    reviewedBy?: ApiMemberInfo | null;
    approvedDate?: Date | null;
    approvedBy?: ApiMemberInfo | null;
    reviewerReport?: ApiPublishingPaperReviewReport | null;
    editorReport?: ApiPublishingPaperReviewReport | null;
}

export class ApiPublishingPaperReviewReport implements IApiPublishingPaperReviewReport {
    recommendation?: ReviewRecommendationEnum;
    highScientificQuality?: ReviewChecklistItemEnum;
    freeFromErrors?: ReviewChecklistItemEnum;
    wellOrganized?: ReviewChecklistItemEnum;
    appropriateTitle?: ReviewChecklistItemEnum;
    adequateReferences?: ReviewChecklistItemEnum;
    satisfactoryEnglish?: ReviewChecklistItemEnum;
    clearFigures?: ReviewChecklistItemEnum;
    clearTables?: ReviewChecklistItemEnum;
    remarks?: string | null;
    attachment?: ApiFileInfo | null;

    constructor(data?: IApiPublishingPaperReviewReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendation = _data["recommendation"] !== undefined ? _data["recommendation"] : null as any;
            this.highScientificQuality = _data["highScientificQuality"] !== undefined ? _data["highScientificQuality"] : null as any;
            this.freeFromErrors = _data["freeFromErrors"] !== undefined ? _data["freeFromErrors"] : null as any;
            this.wellOrganized = _data["wellOrganized"] !== undefined ? _data["wellOrganized"] : null as any;
            this.appropriateTitle = _data["appropriateTitle"] !== undefined ? _data["appropriateTitle"] : null as any;
            this.adequateReferences = _data["adequateReferences"] !== undefined ? _data["adequateReferences"] : null as any;
            this.satisfactoryEnglish = _data["satisfactoryEnglish"] !== undefined ? _data["satisfactoryEnglish"] : null as any;
            this.clearFigures = _data["clearFigures"] !== undefined ? _data["clearFigures"] : null as any;
            this.clearTables = _data["clearTables"] !== undefined ? _data["clearTables"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.attachment = _data["attachment"] ? ApiFileInfo.fromJS(_data["attachment"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingPaperReviewReport {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperReviewReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendation"] = this.recommendation !== undefined ? this.recommendation : null as any;
        data["highScientificQuality"] = this.highScientificQuality !== undefined ? this.highScientificQuality : null as any;
        data["freeFromErrors"] = this.freeFromErrors !== undefined ? this.freeFromErrors : null as any;
        data["wellOrganized"] = this.wellOrganized !== undefined ? this.wellOrganized : null as any;
        data["appropriateTitle"] = this.appropriateTitle !== undefined ? this.appropriateTitle : null as any;
        data["adequateReferences"] = this.adequateReferences !== undefined ? this.adequateReferences : null as any;
        data["satisfactoryEnglish"] = this.satisfactoryEnglish !== undefined ? this.satisfactoryEnglish : null as any;
        data["clearFigures"] = this.clearFigures !== undefined ? this.clearFigures : null as any;
        data["clearTables"] = this.clearTables !== undefined ? this.clearTables : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        return data;
    }
}

export interface IApiPublishingPaperReviewReport {
    recommendation?: ReviewRecommendationEnum;
    highScientificQuality?: ReviewChecklistItemEnum;
    freeFromErrors?: ReviewChecklistItemEnum;
    wellOrganized?: ReviewChecklistItemEnum;
    appropriateTitle?: ReviewChecklistItemEnum;
    adequateReferences?: ReviewChecklistItemEnum;
    satisfactoryEnglish?: ReviewChecklistItemEnum;
    clearFigures?: ReviewChecklistItemEnum;
    clearTables?: ReviewChecklistItemEnum;
    remarks?: string | null;
    attachment?: ApiFileInfo | null;
}

export enum ReviewRecommendationEnum {
    PublishAsIs = 0,
    PublishAfterOptionalRevision = 1,
    PublishAfterMandatoryRevision = 2,
    Reject = 3,
}

export enum ReviewChecklistItemEnum {
    No = 0,
    Yes = 1,
    NotApplicable = 2,
}

export class ApiPublishingPaperReviewer implements IApiPublishingPaperReviewer {
    reviewer?: ApiIdNameItem | null;
    reviews?: ApiPublishingPaperReviewItem[] | null;

    constructor(data?: IApiPublishingPaperReviewer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reviewer = _data["reviewer"] ? ApiIdNameItem.fromJS(_data["reviewer"]) : null as any;
            if (Array.isArray(_data["reviews"])) {
                this.reviews = [] as any;
                for (let item of _data["reviews"])
                    this.reviews!.push(ApiPublishingPaperReviewItem.fromJS(item));
            }
            else {
                this.reviews = null as any;
            }
        }
    }

    static fromJS(data: any): ApiPublishingPaperReviewer {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperReviewer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewer"] = this.reviewer ? this.reviewer.toJSON() : null as any;
        if (Array.isArray(this.reviews)) {
            data["reviews"] = [];
            for (let item of this.reviews)
                data["reviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiPublishingPaperReviewer {
    reviewer?: ApiIdNameItem | null;
    reviews?: ApiPublishingPaperReviewItem[] | null;
}

export class ApiPublishingPaperReviewItem implements IApiPublishingPaperReviewItem {
    id?: number;
    isReReview?: boolean;

    constructor(data?: IApiPublishingPaperReviewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isReReview = _data["isReReview"] !== undefined ? _data["isReReview"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingPaperReviewItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperReviewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isReReview"] = this.isReReview !== undefined ? this.isReReview : null as any;
        return data;
    }
}

export interface IApiPublishingPaperReviewItem {
    id?: number;
    isReReview?: boolean;
}

export class ApiPageResultOfApiPaperListItem implements IApiPageResultOfApiPaperListItem {
    items?: ApiPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperListItem {
    items?: ApiPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperListItem implements IApiPaperListItem {
    @columnMap(() => Number)
    @keyMap()
    id?: number;
    @columnMap(() => ApiFileInfo)
    paperDoc?: ApiFileInfo | null;
    @columnMap(() => ApiFileInfo)
    paperPdf?: ApiFileInfo | null;
    @columnMap(() => ApiFileInfo)
    paperEpub?: ApiFileInfo | null;
    @columnMap(() => ApiFileInfo)
    copyrightAgreement?: ApiFileInfo | null;
    @columnMap(() => ApiTitlePartItem)
    titlePart?: ApiTitlePartItem | null;
    @columnMap(() => ApiChapterItem)
    chapter?: ApiChapterItem | null;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => Number)
    page?: number;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => PaperStatusEnum)
    status?: PaperStatusEnum;
    @columnMap(() => PaperTypeEnum)
    type?: PaperTypeEnum;
    @columnMap(() => String, true)
    authors?: string[] | null;
    @columnMap(() => ApiReviewCounter)
    reviewCounter?: ApiReviewCounter | null;
    @columnMap(() => Boolean)
    openAccess?: boolean;
    isRemovable?: boolean;
    hasNotes?: boolean;
    hasCurrentPdfFile?: boolean;
    notesCount?: number;

    constructor(data?: IApiPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paperDoc = _data["paperDoc"] ? ApiFileInfo.fromJS(_data["paperDoc"]) : null as any;
            this.paperPdf = _data["paperPdf"] ? ApiFileInfo.fromJS(_data["paperPdf"]) : null as any;
            this.paperEpub = _data["paperEpub"] ? ApiFileInfo.fromJS(_data["paperEpub"]) : null as any;
            this.copyrightAgreement = _data["copyrightAgreement"] ? ApiFileInfo.fromJS(_data["copyrightAgreement"]) : null as any;
            this.titlePart = _data["titlePart"] ? ApiTitlePartItem.fromJS(_data["titlePart"]) : null as any;
            this.chapter = _data["chapter"] ? ApiChapterItem.fromJS(_data["chapter"]) : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            if (Array.isArray(_data["authors"])) {
                this.authors = [] as any;
                for (let item of _data["authors"])
                    this.authors!.push(item);
            }
            else {
                this.authors = null as any;
            }
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
            this.openAccess = _data["openAccess"] !== undefined ? _data["openAccess"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
            this.hasNotes = _data["hasNotes"] !== undefined ? _data["hasNotes"] : null as any;
            this.hasCurrentPdfFile = _data["hasCurrentPdfFile"] !== undefined ? _data["hasCurrentPdfFile"] : null as any;
            this.notesCount = _data["notesCount"] !== undefined ? _data["notesCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paperDoc"] = this.paperDoc ? this.paperDoc.toJSON() : null as any;
        data["paperPdf"] = this.paperPdf ? this.paperPdf.toJSON() : null as any;
        data["paperEpub"] = this.paperEpub ? this.paperEpub.toJSON() : null as any;
        data["copyrightAgreement"] = this.copyrightAgreement ? this.copyrightAgreement.toJSON() : null as any;
        data["titlePart"] = this.titlePart ? this.titlePart.toJSON() : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        if (Array.isArray(this.authors)) {
            data["authors"] = [];
            for (let item of this.authors)
                data["authors"].push(item);
        }
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        data["openAccess"] = this.openAccess !== undefined ? this.openAccess : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        data["hasNotes"] = this.hasNotes !== undefined ? this.hasNotes : null as any;
        data["hasCurrentPdfFile"] = this.hasCurrentPdfFile !== undefined ? this.hasCurrentPdfFile : null as any;
        data["notesCount"] = this.notesCount !== undefined ? this.notesCount : null as any;
        return data;
    }
}

export interface IApiPaperListItem {
    id?: number;
    paperDoc?: ApiFileInfo | null;
    paperPdf?: ApiFileInfo | null;
    paperEpub?: ApiFileInfo | null;
    copyrightAgreement?: ApiFileInfo | null;
    titlePart?: ApiTitlePartItem | null;
    chapter?: ApiChapterItem | null;
    pos?: number;
    page?: number;
    paperName?: string | null;
    status?: PaperStatusEnum;
    type?: PaperTypeEnum;
    authors?: string[] | null;
    reviewCounter?: ApiReviewCounter | null;
    openAccess?: boolean;
    isRemovable?: boolean;
    hasNotes?: boolean;
    hasCurrentPdfFile?: boolean;
    notesCount?: number;
}

export class ApiTitlePartItem implements IApiTitlePartItem {
    id?: number;
    name?: string | null;
    pos?: number;

    constructor(data?: IApiTitlePartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitlePartItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitlePartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        return data;
    }
}

export interface IApiTitlePartItem {
    id?: number;
    name?: string | null;
    pos?: number;
}

export class ApiReviewCounter implements IApiReviewCounter {
    assigned?: number;
    reviewed?: number;
    approved?: number;

    constructor(data?: IApiReviewCounter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assigned = _data["assigned"] !== undefined ? _data["assigned"] : null as any;
            this.reviewed = _data["reviewed"] !== undefined ? _data["reviewed"] : null as any;
            this.approved = _data["approved"] !== undefined ? _data["approved"] : null as any;
        }
    }

    static fromJS(data: any): ApiReviewCounter {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewCounter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assigned"] = this.assigned !== undefined ? this.assigned : null as any;
        data["reviewed"] = this.reviewed !== undefined ? this.reviewed : null as any;
        data["approved"] = this.approved !== undefined ? this.approved : null as any;
        return data;
    }
}

export interface IApiReviewCounter {
    assigned?: number;
    reviewed?: number;
    approved?: number;
}

export class ApiPaperHeader implements IApiPaperHeader {
    id?: number;
    status?: PaperStatusEnum;
    name?: string | null;
    doi?: string | null;
    isbnPrint?: string | null;
    title?: ApiNamedListItem | null;
    titlePapers?: ApiHeaderPaperListItem[] | null;
    hasReviews?: boolean;
    isImportedCopy?: boolean;

    constructor(data?: IApiPaperHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.title = _data["title"] ? ApiNamedListItem.fromJS(_data["title"]) : null as any;
            if (Array.isArray(_data["titlePapers"])) {
                this.titlePapers = [] as any;
                for (let item of _data["titlePapers"])
                    this.titlePapers!.push(ApiHeaderPaperListItem.fromJS(item));
            }
            else {
                this.titlePapers = null as any;
            }
            this.hasReviews = _data["hasReviews"] !== undefined ? _data["hasReviews"] : null as any;
            this.isImportedCopy = _data["isImportedCopy"] !== undefined ? _data["isImportedCopy"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["title"] = this.title ? this.title.toJSON() : null as any;
        if (Array.isArray(this.titlePapers)) {
            data["titlePapers"] = [];
            for (let item of this.titlePapers)
                data["titlePapers"].push(item ? item.toJSON() : null as any);
        }
        data["hasReviews"] = this.hasReviews !== undefined ? this.hasReviews : null as any;
        data["isImportedCopy"] = this.isImportedCopy !== undefined ? this.isImportedCopy : null as any;
        return data;
    }
}

export interface IApiPaperHeader {
    id?: number;
    status?: PaperStatusEnum;
    name?: string | null;
    doi?: string | null;
    isbnPrint?: string | null;
    title?: ApiNamedListItem | null;
    titlePapers?: ApiHeaderPaperListItem[] | null;
    hasReviews?: boolean;
    isImportedCopy?: boolean;
}

export class ApiHeaderPaperListItem implements IApiHeaderPaperListItem {
    id?: number;
    pageFrom?: number;
    type?: PaperTypeEnum;

    constructor(data?: IApiHeaderPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pageFrom = _data["pageFrom"] !== undefined ? _data["pageFrom"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiHeaderPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiHeaderPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pageFrom"] = this.pageFrom !== undefined ? this.pageFrom : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiHeaderPaperListItem {
    id?: number;
    pageFrom?: number;
    type?: PaperTypeEnum;
}

export class ApiPublishingPaperCreateRequest implements IApiPublishingPaperCreateRequest {
    name: string;
    type?: PaperTypeEnum;

    constructor(data?: IApiPublishingPaperCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingPaperCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiPublishingPaperCreateRequest {
    name: string;
    type?: PaperTypeEnum;
}

export class ApiPaperReplacementValidation implements IApiPaperReplacementValidation {
    checkDoesNotExist?: boolean;
    checkIsNotInProgress?: boolean;
    cannotStartReplacement?: boolean;
    hasErrors?: boolean;

    constructor(data?: IApiPaperReplacementValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkDoesNotExist = _data["checkDoesNotExist"] !== undefined ? _data["checkDoesNotExist"] : null as any;
            this.checkIsNotInProgress = _data["checkIsNotInProgress"] !== undefined ? _data["checkIsNotInProgress"] : null as any;
            this.cannotStartReplacement = _data["cannotStartReplacement"] !== undefined ? _data["cannotStartReplacement"] : null as any;
            this.hasErrors = _data["hasErrors"] !== undefined ? _data["hasErrors"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperReplacementValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperReplacementValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkDoesNotExist"] = this.checkDoesNotExist !== undefined ? this.checkDoesNotExist : null as any;
        data["checkIsNotInProgress"] = this.checkIsNotInProgress !== undefined ? this.checkIsNotInProgress : null as any;
        data["cannotStartReplacement"] = this.cannotStartReplacement !== undefined ? this.cannotStartReplacement : null as any;
        data["hasErrors"] = this.hasErrors !== undefined ? this.hasErrors : null as any;
        return data;
    }
}

export interface IApiPaperReplacementValidation {
    checkDoesNotExist?: boolean;
    checkIsNotInProgress?: boolean;
    cannotStartReplacement?: boolean;
    hasErrors?: boolean;
}

export class ApiCanDownloadFiles implements IApiCanDownloadFiles {
    canDownloadAllPdfs?: boolean;
    canDownloadAllDocs?: boolean;
    canDownloadAllEpubs?: boolean;
    canDownloadAllCopyrights?: boolean;
    allDocsCount?: number;
    allPdfsCount?: number;
    allEpubsCount?: number;
    allCopyrightsCount?: number;

    constructor(data?: IApiCanDownloadFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canDownloadAllPdfs = _data["canDownloadAllPdfs"] !== undefined ? _data["canDownloadAllPdfs"] : null as any;
            this.canDownloadAllDocs = _data["canDownloadAllDocs"] !== undefined ? _data["canDownloadAllDocs"] : null as any;
            this.canDownloadAllEpubs = _data["canDownloadAllEpubs"] !== undefined ? _data["canDownloadAllEpubs"] : null as any;
            this.canDownloadAllCopyrights = _data["canDownloadAllCopyrights"] !== undefined ? _data["canDownloadAllCopyrights"] : null as any;
            this.allDocsCount = _data["allDocsCount"] !== undefined ? _data["allDocsCount"] : null as any;
            this.allPdfsCount = _data["allPdfsCount"] !== undefined ? _data["allPdfsCount"] : null as any;
            this.allEpubsCount = _data["allEpubsCount"] !== undefined ? _data["allEpubsCount"] : null as any;
            this.allCopyrightsCount = _data["allCopyrightsCount"] !== undefined ? _data["allCopyrightsCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiCanDownloadFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCanDownloadFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canDownloadAllPdfs"] = this.canDownloadAllPdfs !== undefined ? this.canDownloadAllPdfs : null as any;
        data["canDownloadAllDocs"] = this.canDownloadAllDocs !== undefined ? this.canDownloadAllDocs : null as any;
        data["canDownloadAllEpubs"] = this.canDownloadAllEpubs !== undefined ? this.canDownloadAllEpubs : null as any;
        data["canDownloadAllCopyrights"] = this.canDownloadAllCopyrights !== undefined ? this.canDownloadAllCopyrights : null as any;
        data["allDocsCount"] = this.allDocsCount !== undefined ? this.allDocsCount : null as any;
        data["allPdfsCount"] = this.allPdfsCount !== undefined ? this.allPdfsCount : null as any;
        data["allEpubsCount"] = this.allEpubsCount !== undefined ? this.allEpubsCount : null as any;
        data["allCopyrightsCount"] = this.allCopyrightsCount !== undefined ? this.allCopyrightsCount : null as any;
        return data;
    }
}

export interface IApiCanDownloadFiles {
    canDownloadAllPdfs?: boolean;
    canDownloadAllDocs?: boolean;
    canDownloadAllEpubs?: boolean;
    canDownloadAllCopyrights?: boolean;
    allDocsCount?: number;
    allPdfsCount?: number;
    allEpubsCount?: number;
    allCopyrightsCount?: number;
}

export class ApiFilteredByDocumentType implements IApiFilteredByDocumentType {
    filteredPdfCount?: number;
    filteredDocCount?: number;
    filteredEpubCount?: number;
    filteredCopyrightCount?: number;

    constructor(data?: IApiFilteredByDocumentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filteredPdfCount = _data["filteredPdfCount"] !== undefined ? _data["filteredPdfCount"] : null as any;
            this.filteredDocCount = _data["filteredDocCount"] !== undefined ? _data["filteredDocCount"] : null as any;
            this.filteredEpubCount = _data["filteredEpubCount"] !== undefined ? _data["filteredEpubCount"] : null as any;
            this.filteredCopyrightCount = _data["filteredCopyrightCount"] !== undefined ? _data["filteredCopyrightCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiFilteredByDocumentType {
        data = typeof data === 'object' ? data : {};
        let result = new ApiFilteredByDocumentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filteredPdfCount"] = this.filteredPdfCount !== undefined ? this.filteredPdfCount : null as any;
        data["filteredDocCount"] = this.filteredDocCount !== undefined ? this.filteredDocCount : null as any;
        data["filteredEpubCount"] = this.filteredEpubCount !== undefined ? this.filteredEpubCount : null as any;
        data["filteredCopyrightCount"] = this.filteredCopyrightCount !== undefined ? this.filteredCopyrightCount : null as any;
        return data;
    }
}

export interface IApiFilteredByDocumentType {
    filteredPdfCount?: number;
    filteredDocCount?: number;
    filteredEpubCount?: number;
    filteredCopyrightCount?: number;
}

export class ApiProcessPaperFiles implements IApiProcessPaperFiles {
    paperSet?: PaperSet;
    paperIdList?: number[] | null;
    type?: PaperDocumentTypeEnum;

    constructor(data?: IApiProcessPaperFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperSet = _data["paperSet"] !== undefined ? _data["paperSet"] : null as any;
            if (Array.isArray(_data["paperIdList"])) {
                this.paperIdList = [] as any;
                for (let item of _data["paperIdList"])
                    this.paperIdList!.push(item);
            }
            else {
                this.paperIdList = null as any;
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiProcessPaperFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProcessPaperFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSet"] = this.paperSet !== undefined ? this.paperSet : null as any;
        if (Array.isArray(this.paperIdList)) {
            data["paperIdList"] = [];
            for (let item of this.paperIdList)
                data["paperIdList"].push(item);
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiProcessPaperFiles {
    paperSet?: PaperSet;
    paperIdList?: number[] | null;
    type?: PaperDocumentTypeEnum;
}

export enum PaperSet {
    All = 0,
    Selected = 1,
    Filtered = 2,
}

export class ApiProcessPaperCopyrightFiles implements IApiProcessPaperCopyrightFiles {
    paperSet?: PaperSet;
    paperIdList?: number[] | null;

    constructor(data?: IApiProcessPaperCopyrightFiles) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperSet = _data["paperSet"] !== undefined ? _data["paperSet"] : null as any;
            if (Array.isArray(_data["paperIdList"])) {
                this.paperIdList = [] as any;
                for (let item of _data["paperIdList"])
                    this.paperIdList!.push(item);
            }
            else {
                this.paperIdList = null as any;
            }
        }
    }

    static fromJS(data: any): ApiProcessPaperCopyrightFiles {
        data = typeof data === 'object' ? data : {};
        let result = new ApiProcessPaperCopyrightFiles();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperSet"] = this.paperSet !== undefined ? this.paperSet : null as any;
        if (Array.isArray(this.paperIdList)) {
            data["paperIdList"] = [];
            for (let item of this.paperIdList)
                data["paperIdList"].push(item);
        }
        return data;
    }
}

export interface IApiProcessPaperCopyrightFiles {
    paperSet?: PaperSet;
    paperIdList?: number[] | null;
}

export class ApiAssignChapter implements IApiAssignChapter {
    type?: AssignChapterTypeEnum;
    first?: number;
    last?: number;
    chapter: ApiIdNameItem;

    constructor(data?: IApiAssignChapter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.chapter = new ApiIdNameItem();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.first = _data["first"] !== undefined ? _data["first"] : null as any;
            this.last = _data["last"] !== undefined ? _data["last"] : null as any;
            this.chapter = _data["chapter"] ? ApiIdNameItem.fromJS(_data["chapter"]) : new ApiIdNameItem();
        }
    }

    static fromJS(data: any): ApiAssignChapter {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAssignChapter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["first"] = this.first !== undefined ? this.first : null as any;
        data["last"] = this.last !== undefined ? this.last : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        return data;
    }
}

export interface IApiAssignChapter {
    type?: AssignChapterTypeEnum;
    first?: number;
    last?: number;
    chapter: ApiIdNameItem;
}

export enum AssignChapterTypeEnum {
    Page = 0,
    Pos = 1,
}

export class ApiPageResultOfApiPaperSupplementListItem implements IApiPageResultOfApiPaperSupplementListItem {
    items?: ApiPaperSupplementListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPaperSupplementListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPaperSupplementListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPaperSupplementListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPaperSupplementListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPaperSupplementListItem {
    items?: ApiPaperSupplementListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPaperSupplementListItem implements IApiPaperSupplementListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    materials?: string | null;
    @columnMap(() => String)
    description?: string | null;
    isFile?: boolean;
    link?: string | null;
    file?: ApiFileInfo | null;
    @columnMap(() => ApiMemberInfo)
    uploadedBy?: ApiMemberInfo | null;
    @columnMap(() => Date)
    added?: Date;

    constructor(data?: IApiPaperSupplementListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.materials = _data["materials"] !== undefined ? _data["materials"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.isFile = _data["isFile"] !== undefined ? _data["isFile"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.uploadedBy = _data["uploadedBy"] ? ApiMemberInfo.fromJS(_data["uploadedBy"]) : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperSupplementListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperSupplementListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["materials"] = this.materials !== undefined ? this.materials : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["isFile"] = this.isFile !== undefined ? this.isFile : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        return data;
    }
}

export interface IApiPaperSupplementListItem {
    id?: number;
    materials?: string | null;
    description?: string | null;
    isFile?: boolean;
    link?: string | null;
    file?: ApiFileInfo | null;
    uploadedBy?: ApiMemberInfo | null;
    added?: Date;
}

export class ApiPaperSupplement implements IApiPaperSupplement {
    id?: number;
    description?: string | null;
    link?: string | null;
    fileName?: string | null;
    fileSize?: number;

    constructor(data?: IApiPaperSupplement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.link = _data["link"] !== undefined ? _data["link"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileSize = _data["fileSize"] !== undefined ? _data["fileSize"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperSupplement {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperSupplement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["link"] = this.link !== undefined ? this.link : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileSize"] = this.fileSize !== undefined ? this.fileSize : null as any;
        return data;
    }
}

export interface IApiPaperSupplement {
    id?: number;
    description?: string | null;
    link?: string | null;
    fileName?: string | null;
    fileSize?: number;
}

export class ApiPageResultOfApiAuthorPaperListItem implements IApiPageResultOfApiAuthorPaperListItem {
    items?: ApiAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiAuthorPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiAuthorPaperListItem {
    items?: ApiAuthorPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiAuthorPaperListItem implements IApiAuthorPaperListItem {
    titleId?: number;
    @keyMap()
    paperId?: number;
    @columnMap(() => String)
    isbn?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    @columnMap(() => TitleStatusEnum)
    titleStatus?: TitleStatusEnum;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => PaperStatusEnum)
    paperStatus?: PaperStatusEnum;
    @columnMap(() => PaperAssignmentEnum)
    paperAssignment?: PaperAssignmentEnum;

    constructor(data?: IApiAuthorPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.isbn = _data["isbn"] !== undefined ? _data["isbn"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.titleStatus = _data["titleStatus"] !== undefined ? _data["titleStatus"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.paperAssignment = _data["paperAssignment"] !== undefined ? _data["paperAssignment"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["isbn"] = this.isbn !== undefined ? this.isbn : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["titleStatus"] = this.titleStatus !== undefined ? this.titleStatus : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["paperAssignment"] = this.paperAssignment !== undefined ? this.paperAssignment : null as any;
        return data;
    }
}

export interface IApiAuthorPaperListItem {
    titleId?: number;
    paperId?: number;
    isbn?: string | null;
    titleName?: string | null;
    titleStatus?: TitleStatusEnum;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    paperAssignment?: PaperAssignmentEnum;
}

export enum PaperAssignmentEnum {
    Author = 0,
    CoAuthor = 1,
}

export class ApiPageResultOfApiTitleMembershipListItem implements IApiPageResultOfApiTitleMembershipListItem {
    items?: ApiTitleMembershipListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiTitleMembershipListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiTitleMembershipListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiTitleMembershipListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiTitleMembershipListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiTitleMembershipListItem {
    items?: ApiTitleMembershipListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiTitleMembershipListItem implements IApiTitleMembershipListItem {
    @keyMap()
    id?: number;
    titleId?: number;
    @columnMap(() => String)
    isbnPrint?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => String)
    volumeTitle?: string | null;
    @columnMap(() => TitleStatusEnum)
    titleStatus?: TitleStatusEnum;
    @columnMap(() => Date)
    dateWeb?: Date | null;
    @columnMap(() => TitleAssignmentEnum)
    titleAssignment?: TitleAssignmentEnum;
    @columnMap(() => Number)
    submissionsReviews?: number | null;

    constructor(data?: IApiTitleMembershipListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbnPrint = _data["isbnPrint"] !== undefined ? _data["isbnPrint"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.volumeTitle = _data["volumeTitle"] !== undefined ? _data["volumeTitle"] : null as any;
            this.titleStatus = _data["titleStatus"] !== undefined ? _data["titleStatus"] : null as any;
            this.dateWeb = _data["dateWeb"] ? new Date(_data["dateWeb"].toString()) : null as any;
            this.titleAssignment = _data["titleAssignment"] !== undefined ? _data["titleAssignment"] : null as any;
            this.submissionsReviews = _data["submissionsReviews"] !== undefined ? _data["submissionsReviews"] : null as any;
        }
    }

    static fromJS(data: any): ApiTitleMembershipListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTitleMembershipListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbnPrint"] = this.isbnPrint !== undefined ? this.isbnPrint : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["volumeTitle"] = this.volumeTitle !== undefined ? this.volumeTitle : null as any;
        data["titleStatus"] = this.titleStatus !== undefined ? this.titleStatus : null as any;
        data["dateWeb"] = this.dateWeb ? this.dateWeb.toISOString() : null as any;
        data["titleAssignment"] = this.titleAssignment !== undefined ? this.titleAssignment : null as any;
        data["submissionsReviews"] = this.submissionsReviews !== undefined ? this.submissionsReviews : null as any;
        return data;
    }
}

export interface IApiTitleMembershipListItem {
    id?: number;
    titleId?: number;
    isbnPrint?: string | null;
    titleName?: string | null;
    kurzel?: string | null;
    volumeTitle?: string | null;
    titleStatus?: TitleStatusEnum;
    dateWeb?: Date | null;
    titleAssignment?: TitleAssignmentEnum;
    submissionsReviews?: number | null;
}

export enum TitleAssignmentEnum {
    Contributor = 0,
    Editor = 1,
    CorrespondingAuthor = 2,
    Reviewer = 3,
}

export enum ParticipantTypeEnum {
    Editor = 0,
    CorrespondingAuthor = 1,
    Reviewer = 2,
}

export class ApiPageResultOfApiPublishingPaperReviewListItem implements IApiPageResultOfApiPublishingPaperReviewListItem {
    items?: ApiPublishingPaperReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPublishingPaperReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPublishingPaperReviewListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPublishingPaperReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPublishingPaperReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPublishingPaperReviewListItem {
    items?: ApiPublishingPaperReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPublishingPaperReviewListItem implements IApiPublishingPaperReviewListItem {
    @keyMap()
    id?: number;
    titleId?: number;
    @columnMap(() => String)
    isbn?: string | null;
    @columnMap(() => String)
    titleName?: string | null;
    @columnMap(() => TitleStatusEnum)
    titleStatus?: TitleStatusEnum;
    @columnMap(() => String)
    paperName?: string | null;
    @columnMap(() => PaperStatusEnum)
    paperStatus?: PaperStatusEnum;
    @columnMap(() => ReviewStatusEnum)
    reviewStatus?: ReviewStatusEnum;
    @columnMap(() => ReviewStatusEnum)
    reReviewStatus?: ReviewStatusEnum | null;

    constructor(data?: IApiPublishingPaperReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.isbn = _data["isbn"] !== undefined ? _data["isbn"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.titleStatus = _data["titleStatus"] !== undefined ? _data["titleStatus"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.reviewStatus = _data["reviewStatus"] !== undefined ? _data["reviewStatus"] : null as any;
            this.reReviewStatus = _data["reReviewStatus"] !== undefined ? _data["reReviewStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingPaperReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingPaperReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["isbn"] = this.isbn !== undefined ? this.isbn : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["titleStatus"] = this.titleStatus !== undefined ? this.titleStatus : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["reviewStatus"] = this.reviewStatus !== undefined ? this.reviewStatus : null as any;
        data["reReviewStatus"] = this.reReviewStatus !== undefined ? this.reReviewStatus : null as any;
        return data;
    }
}

export interface IApiPublishingPaperReviewListItem {
    id?: number;
    titleId?: number;
    isbn?: string | null;
    titleName?: string | null;
    titleStatus?: TitleStatusEnum;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    reviewStatus?: ReviewStatusEnum;
    reReviewStatus?: ReviewStatusEnum | null;
}

export class ApiPageResultOfApiEditorialBoardListItem implements IApiPageResultOfApiEditorialBoardListItem {
    items?: ApiEditorialBoardListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorialBoardListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorialBoardListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorialBoardListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorialBoardListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorialBoardListItem {
    items?: ApiEditorialBoardListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorialBoardListItem implements IApiEditorialBoardListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    responsibilities?: string | null;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => ApiMemberInfo)
    member?: ApiMemberInfo | null;
    @columnMap(() => String)
    country?: string | null;
    @columnMap(() => String)
    universityOrOrganization?: string | null;
    responsibilityPos?: number;

    constructor(data?: IApiEditorialBoardListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.responsibilities = _data["responsibilities"] !== undefined ? _data["responsibilities"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.member = _data["member"] ? ApiMemberInfo.fromJS(_data["member"]) : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.responsibilityPos = _data["responsibilityPos"] !== undefined ? _data["responsibilityPos"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorialBoardListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorialBoardListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["responsibilities"] = this.responsibilities !== undefined ? this.responsibilities : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["member"] = this.member ? this.member.toJSON() : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["responsibilityPos"] = this.responsibilityPos !== undefined ? this.responsibilityPos : null as any;
        return data;
    }
}

export interface IApiEditorialBoardListItem {
    id?: number;
    responsibilities?: string | null;
    pos?: number;
    member?: ApiMemberInfo | null;
    country?: string | null;
    universityOrOrganization?: string | null;
    responsibilityPos?: number;
}

export enum JournalFileType {
    Cover = 1,
    Details = 2,
    TitleCoverTemplate = 3,
}

export class ApiJournalGroup implements IApiJournalGroup {
    id?: number;
    details?: ApiJournalGroupDetails | null;
    activity?: ApiActivity | null;

    constructor(data?: IApiJournalGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.details = _data["details"] ? ApiJournalGroupDetails.fromJS(_data["details"]) : null as any;
            this.activity = _data["activity"] ? ApiActivity.fromJS(_data["activity"]) : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        return data;
    }
}

export interface IApiJournalGroup {
    id?: number;
    details?: ApiJournalGroupDetails | null;
    activity?: ApiActivity | null;
}

export class ApiJournalGroupDetails implements IApiJournalGroupDetails {
    type?: JournalGroupTypeEnum;
    name: string;
    shortName: string;

    constructor(data?: IApiJournalGroupDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroupDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroupDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        return data;
    }
}

export interface IApiJournalGroupDetails {
    type?: JournalGroupTypeEnum;
    name: string;
    shortName: string;
}

export enum JournalGroupTypeEnum {
    Journals = 0,
    SeriesAndCollections = 1,
}

export class ApiJournalGroupHeader implements IApiJournalGroupHeader {
    id?: number;
    name?: string | null;

    constructor(data?: IApiJournalGroupHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroupHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroupHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiJournalGroupHeader {
    id?: number;
    name?: string | null;
}

export class ApiPageResultOfApiJournalGroupListItem implements IApiPageResultOfApiJournalGroupListItem {
    items?: ApiJournalGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiJournalGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiJournalGroupListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiJournalGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiJournalGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiJournalGroupListItem {
    items?: ApiJournalGroupListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiJournalGroupListItem implements IApiJournalGroupListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    journalGroupName?: string | null;
    @columnMap(() => String)
    shortName?: string | null;
    @columnMap(() => JournalGroupTypeEnum)
    journalGroupType?: JournalGroupTypeEnum;
    @columnMap(() => ApiNamedListItem, true)
    journals?: ApiNamedListItem[] | null;
    isRemovable?: boolean;

    constructor(data?: IApiJournalGroupListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.journalGroupName = _data["journalGroupName"] !== undefined ? _data["journalGroupName"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.journalGroupType = _data["journalGroupType"] !== undefined ? _data["journalGroupType"] : null as any;
            if (Array.isArray(_data["journals"])) {
                this.journals = [] as any;
                for (let item of _data["journals"])
                    this.journals!.push(ApiNamedListItem.fromJS(item));
            }
            else {
                this.journals = null as any;
            }
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroupListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroupListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["journalGroupName"] = this.journalGroupName !== undefined ? this.journalGroupName : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["journalGroupType"] = this.journalGroupType !== undefined ? this.journalGroupType : null as any;
        if (Array.isArray(this.journals)) {
            data["journals"] = [];
            for (let item of this.journals)
                data["journals"].push(item ? item.toJSON() : null as any);
        }
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiJournalGroupListItem {
    id?: number;
    pos?: number;
    journalGroupName?: string | null;
    shortName?: string | null;
    journalGroupType?: JournalGroupTypeEnum;
    journals?: ApiNamedListItem[] | null;
    isRemovable?: boolean;
}

export class ApiJournalGroupCreateRequest implements IApiJournalGroupCreateRequest {
    name: string;
    shortName: string;
    type?: JournalGroupTypeEnum;

    constructor(data?: IApiJournalGroupCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroupCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroupCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

export interface IApiJournalGroupCreateRequest {
    name: string;
    shortName: string;
    type?: JournalGroupTypeEnum;
}

export class ApiPageResultOfApiJournalGroupJournalListItem implements IApiPageResultOfApiJournalGroupJournalListItem {
    items?: ApiJournalGroupJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiJournalGroupJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiJournalGroupJournalListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiJournalGroupJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiJournalGroupJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiJournalGroupJournalListItem {
    items?: ApiJournalGroupJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiJournalGroupJournalListItem implements IApiJournalGroupJournalListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => String)
    journalName?: string | null;
    @columnMap(() => JournalStatusEnum)
    journalStatus?: JournalStatusEnum;

    constructor(data?: IApiJournalGroupJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.journalName = _data["journalName"] !== undefined ? _data["journalName"] : null as any;
            this.journalStatus = _data["journalStatus"] !== undefined ? _data["journalStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalGroupJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalGroupJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["journalName"] = this.journalName !== undefined ? this.journalName : null as any;
        data["journalStatus"] = this.journalStatus !== undefined ? this.journalStatus : null as any;
        return data;
    }
}

export interface IApiJournalGroupJournalListItem {
    id?: number;
    pos?: number;
    kurzel?: string | null;
    journalName?: string | null;
    journalStatus?: JournalStatusEnum;
}

export enum JournalStatusEnum {
    Offline = 0,
    Online = 1,
}

export class ApiPageResultOfApiJournalPageListItem implements IApiPageResultOfApiJournalPageListItem {
    items?: ApiJournalPageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiJournalPageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiJournalPageListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiJournalPageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiJournalPageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiJournalPageListItem {
    items?: ApiJournalPageListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiJournalPageListItem implements IApiJournalPageListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => String)
    slug?: string | null;
    @columnMap(() => Boolean)
    isActive?: boolean;

    constructor(data?: IApiJournalPageListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalPageListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalPageListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }
}

export interface IApiJournalPageListItem {
    id?: number;
    pos?: number;
    name?: string | null;
    slug?: string | null;
    isActive?: boolean;
}

export class ApiJournalPageDetails implements IApiJournalPageDetails {
    name: string;
    slug: string;
    content: string;
    isActive?: boolean;

    constructor(data?: IApiJournalPageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            this.content = _data["content"] !== undefined ? _data["content"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalPageDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalPageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        data["content"] = this.content !== undefined ? this.content : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }
}

export interface IApiJournalPageDetails {
    name: string;
    slug: string;
    content: string;
    isActive?: boolean;
}

export class ApiJournalReviewerSettings implements IApiJournalReviewerSettings {
    isReviewerTabEnabled?: boolean;
    isBecomeReviewerEnabled?: boolean;
    description?: string | null;

    constructor(data?: IApiJournalReviewerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isReviewerTabEnabled = _data["isReviewerTabEnabled"] !== undefined ? _data["isReviewerTabEnabled"] : null as any;
            this.isBecomeReviewerEnabled = _data["isBecomeReviewerEnabled"] !== undefined ? _data["isBecomeReviewerEnabled"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalReviewerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalReviewerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isReviewerTabEnabled"] = this.isReviewerTabEnabled !== undefined ? this.isReviewerTabEnabled : null as any;
        data["isBecomeReviewerEnabled"] = this.isBecomeReviewerEnabled !== undefined ? this.isBecomeReviewerEnabled : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IApiJournalReviewerSettings {
    isReviewerTabEnabled?: boolean;
    isBecomeReviewerEnabled?: boolean;
    description?: string | null;
}

export class ApiPageResultOfApiPublishingAttachmentListItem implements IApiPageResultOfApiPublishingAttachmentListItem {
    items?: ApiPublishingAttachmentListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPublishingAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPublishingAttachmentListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPublishingAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPublishingAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPublishingAttachmentListItem {
    items?: ApiPublishingAttachmentListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiSharedAttachmentListItem implements IApiSharedAttachmentListItem {
    @keyMap()
    id?: number;
    @columnMap(() => ApiFileInfo)
    file?: ApiFileInfo | null;
    @columnMap(() => ApiMemberInfo)
    uploadedBy?: ApiMemberInfo | null;
    @columnMap(() => Date)
    added?: Date;

    constructor(data?: IApiSharedAttachmentListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.uploadedBy = _data["uploadedBy"] ? ApiMemberInfo.fromJS(_data["uploadedBy"]) : null as any;
            this.added = _data["added"] ? new Date(_data["added"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiSharedAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiSharedAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["uploadedBy"] = this.uploadedBy ? this.uploadedBy.toJSON() : null as any;
        data["added"] = this.added ? this.added.toISOString() : null as any;
        return data;
    }
}

export interface IApiSharedAttachmentListItem {
    id?: number;
    file?: ApiFileInfo | null;
    uploadedBy?: ApiMemberInfo | null;
    added?: Date;
}

export class ApiPublishingAttachmentListItem extends ApiSharedAttachmentListItem implements IApiPublishingAttachmentListItem {

    constructor(data?: IApiPublishingAttachmentListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiPublishingAttachmentListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingAttachmentListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiPublishingAttachmentListItem extends IApiSharedAttachmentListItem {
}

export class ApiJournalHeader implements IApiJournalHeader {
    id?: number;
    name?: string | null;
    kurzel?: string | null;
    status?: JournalStatusEnum;
    groupId?: number | null;

    constructor(data?: IApiJournalHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        return data;
    }
}

export interface IApiJournalHeader {
    id?: number;
    name?: string | null;
    kurzel?: string | null;
    status?: JournalStatusEnum;
    groupId?: number | null;
}

export class ApiJournal implements IApiJournal {
    id?: number;
    hasCover?: boolean;
    hasDetails?: boolean;
    hasTitleCoverTemplate?: boolean;
    info?: ApiJournalInfo | null;
    details?: ApiJournalDetails | null;
    description?: ApiJournalDescription | null;
    activity?: ApiActivity | null;
    coverValidationRules?: FileValidationModel | null;
    detailsValidationRules?: FileValidationModel | null;
    coverTemplateValidationRules?: FileValidationModel | null;

    constructor(data?: IApiJournal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : null as any;
            this.hasDetails = _data["hasDetails"] !== undefined ? _data["hasDetails"] : null as any;
            this.hasTitleCoverTemplate = _data["hasTitleCoverTemplate"] !== undefined ? _data["hasTitleCoverTemplate"] : null as any;
            this.info = _data["info"] ? ApiJournalInfo.fromJS(_data["info"]) : null as any;
            this.details = _data["details"] ? ApiJournalDetails.fromJS(_data["details"]) : null as any;
            this.description = _data["description"] ? ApiJournalDescription.fromJS(_data["description"]) : null as any;
            this.activity = _data["activity"] ? ApiActivity.fromJS(_data["activity"]) : null as any;
            this.coverValidationRules = _data["coverValidationRules"] ? FileValidationModel.fromJS(_data["coverValidationRules"]) : null as any;
            this.detailsValidationRules = _data["detailsValidationRules"] ? FileValidationModel.fromJS(_data["detailsValidationRules"]) : null as any;
            this.coverTemplateValidationRules = _data["coverTemplateValidationRules"] ? FileValidationModel.fromJS(_data["coverTemplateValidationRules"]) : null as any;
        }
    }

    static fromJS(data: any): ApiJournal {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : null as any;
        data["hasDetails"] = this.hasDetails !== undefined ? this.hasDetails : null as any;
        data["hasTitleCoverTemplate"] = this.hasTitleCoverTemplate !== undefined ? this.hasTitleCoverTemplate : null as any;
        data["info"] = this.info ? this.info.toJSON() : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        data["description"] = this.description ? this.description.toJSON() : null as any;
        data["activity"] = this.activity ? this.activity.toJSON() : null as any;
        data["coverValidationRules"] = this.coverValidationRules ? this.coverValidationRules.toJSON() : null as any;
        data["detailsValidationRules"] = this.detailsValidationRules ? this.detailsValidationRules.toJSON() : null as any;
        data["coverTemplateValidationRules"] = this.coverTemplateValidationRules ? this.coverTemplateValidationRules.toJSON() : null as any;
        return data;
    }
}

export interface IApiJournal {
    id?: number;
    hasCover?: boolean;
    hasDetails?: boolean;
    hasTitleCoverTemplate?: boolean;
    info?: ApiJournalInfo | null;
    details?: ApiJournalDetails | null;
    description?: ApiJournalDescription | null;
    activity?: ApiActivity | null;
    coverValidationRules?: FileValidationModel | null;
    detailsValidationRules?: FileValidationModel | null;
    coverTemplateValidationRules?: FileValidationModel | null;
}

export class ApiJournalInfo implements IApiJournalInfo {
    group?: ApiNamedListItem | null;
    status?: JournalStatusEnum;
    doi?: string | null;
    registerDoi?: boolean;

    constructor(data?: IApiJournalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"] ? ApiNamedListItem.fromJS(_data["group"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
            this.registerDoi = _data["registerDoi"] !== undefined ? _data["registerDoi"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        data["registerDoi"] = this.registerDoi !== undefined ? this.registerDoi : null as any;
        return data;
    }
}

export interface IApiJournalInfo {
    group?: ApiNamedListItem | null;
    status?: JournalStatusEnum;
    doi?: string | null;
    registerDoi?: boolean;
}

export class ApiJournalDetails implements IApiJournalDetails {
    status?: JournalStatusEnum | null;
    kurzel: string;
    name?: string | null;
    issnPrint: string;
    issnCd?: string | null;
    issnWeb?: string | null;
    type?: JournalTypeEnum;
    allowedPublications?: JournalAllowedPublicationEnum | null;
    submitPaperType?: SubmitPaperType;
    year?: number | null;
    sort?: number | null;

    constructor(data?: IApiJournalDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.issnPrint = _data["issnPrint"] !== undefined ? _data["issnPrint"] : null as any;
            this.issnCd = _data["issnCd"] !== undefined ? _data["issnCd"] : null as any;
            this.issnWeb = _data["issnWeb"] !== undefined ? _data["issnWeb"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.allowedPublications = _data["allowedPublications"] !== undefined ? _data["allowedPublications"] : null as any;
            this.submitPaperType = _data["submitPaperType"] !== undefined ? _data["submitPaperType"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["issnPrint"] = this.issnPrint !== undefined ? this.issnPrint : null as any;
        data["issnCd"] = this.issnCd !== undefined ? this.issnCd : null as any;
        data["issnWeb"] = this.issnWeb !== undefined ? this.issnWeb : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["allowedPublications"] = this.allowedPublications !== undefined ? this.allowedPublications : null as any;
        data["submitPaperType"] = this.submitPaperType !== undefined ? this.submitPaperType : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["sort"] = this.sort !== undefined ? this.sort : null as any;
        return data;
    }
}

export interface IApiJournalDetails {
    status?: JournalStatusEnum | null;
    kurzel: string;
    name?: string | null;
    issnPrint: string;
    issnCd?: string | null;
    issnWeb?: string | null;
    type?: JournalTypeEnum;
    allowedPublications?: JournalAllowedPublicationEnum | null;
    submitPaperType?: SubmitPaperType;
    year?: number | null;
    sort?: number | null;
}

export enum JournalTypeEnum {
    Journal = 1,
    BookSeries = 2,
    BookCollection = 3,
    BookSet = 4,
    ConferenceProceedings = 5,
    BookOfAbstracts = 6,
}

export enum JournalAllowedPublicationEnum {
    Conference = 1,
    SpecialIssue = 2,
    Monograph = 4,
    StandAlone = 8,
}

export enum SubmitPaperType {
    None = 0,
    StandalonePapers = 1,
    OpenAccessPapers = 2,
}

export class ApiJournalDescription implements IApiJournalDescription {
    about?: string | null;
    additionalInfo?: string | null;
    advertisingInformation?: string | null;
    shortDescription?: string | null;

    constructor(data?: IApiJournalDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.about = _data["about"] !== undefined ? _data["about"] : null as any;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : null as any;
            this.advertisingInformation = _data["advertisingInformation"] !== undefined ? _data["advertisingInformation"] : null as any;
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["about"] = this.about !== undefined ? this.about : null as any;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : null as any;
        data["advertisingInformation"] = this.advertisingInformation !== undefined ? this.advertisingInformation : null as any;
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        return data;
    }
}

export interface IApiJournalDescription {
    about?: string | null;
    additionalInfo?: string | null;
    advertisingInformation?: string | null;
    shortDescription?: string | null;
}

export class JournalSpecification implements IJournalSpecification {
    type?: JournalTypeEnum;
    submittedToCrossrefAs?: JournalTypeEnum;
    rssApplicable?: boolean;
    visibleOnVirtualFtpForVolumeType?: boolean;
    metadataAreGeneratedForPapers?: boolean;
    issnApplicable?: boolean;
    showBookDoiForVolume?: boolean;
    showBookLinkForVolume?: boolean;
    showVolumeInSeries?: boolean;
    abstractIsEditable?: boolean;
    isTitleTypeEditable?: boolean;

    constructor(data?: IJournalSpecification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.submittedToCrossrefAs = _data["submittedToCrossrefAs"] !== undefined ? _data["submittedToCrossrefAs"] : null as any;
            this.rssApplicable = _data["rssApplicable"] !== undefined ? _data["rssApplicable"] : null as any;
            this.visibleOnVirtualFtpForVolumeType = _data["visibleOnVirtualFtpForVolumeType"] !== undefined ? _data["visibleOnVirtualFtpForVolumeType"] : null as any;
            this.metadataAreGeneratedForPapers = _data["metadataAreGeneratedForPapers"] !== undefined ? _data["metadataAreGeneratedForPapers"] : null as any;
            this.issnApplicable = _data["issnApplicable"] !== undefined ? _data["issnApplicable"] : null as any;
            this.showBookDoiForVolume = _data["showBookDoiForVolume"] !== undefined ? _data["showBookDoiForVolume"] : null as any;
            this.showBookLinkForVolume = _data["showBookLinkForVolume"] !== undefined ? _data["showBookLinkForVolume"] : null as any;
            this.showVolumeInSeries = _data["showVolumeInSeries"] !== undefined ? _data["showVolumeInSeries"] : null as any;
            this.abstractIsEditable = _data["abstractIsEditable"] !== undefined ? _data["abstractIsEditable"] : null as any;
            this.isTitleTypeEditable = _data["isTitleTypeEditable"] !== undefined ? _data["isTitleTypeEditable"] : null as any;
        }
    }

    static fromJS(data: any): JournalSpecification {
        data = typeof data === 'object' ? data : {};
        let result = new JournalSpecification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["submittedToCrossrefAs"] = this.submittedToCrossrefAs !== undefined ? this.submittedToCrossrefAs : null as any;
        data["rssApplicable"] = this.rssApplicable !== undefined ? this.rssApplicable : null as any;
        data["visibleOnVirtualFtpForVolumeType"] = this.visibleOnVirtualFtpForVolumeType !== undefined ? this.visibleOnVirtualFtpForVolumeType : null as any;
        data["metadataAreGeneratedForPapers"] = this.metadataAreGeneratedForPapers !== undefined ? this.metadataAreGeneratedForPapers : null as any;
        data["issnApplicable"] = this.issnApplicable !== undefined ? this.issnApplicable : null as any;
        data["showBookDoiForVolume"] = this.showBookDoiForVolume !== undefined ? this.showBookDoiForVolume : null as any;
        data["showBookLinkForVolume"] = this.showBookLinkForVolume !== undefined ? this.showBookLinkForVolume : null as any;
        data["showVolumeInSeries"] = this.showVolumeInSeries !== undefined ? this.showVolumeInSeries : null as any;
        data["abstractIsEditable"] = this.abstractIsEditable !== undefined ? this.abstractIsEditable : null as any;
        data["isTitleTypeEditable"] = this.isTitleTypeEditable !== undefined ? this.isTitleTypeEditable : null as any;
        return data;
    }
}

export interface IJournalSpecification {
    type?: JournalTypeEnum;
    submittedToCrossrefAs?: JournalTypeEnum;
    rssApplicable?: boolean;
    visibleOnVirtualFtpForVolumeType?: boolean;
    metadataAreGeneratedForPapers?: boolean;
    issnApplicable?: boolean;
    showBookDoiForVolume?: boolean;
    showBookLinkForVolume?: boolean;
    showVolumeInSeries?: boolean;
    abstractIsEditable?: boolean;
    isTitleTypeEditable?: boolean;
}

export class ApiPageResultOfApiJournalListItem implements IApiPageResultOfApiJournalListItem {
    items?: ApiJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiJournalListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiJournalListItem {
    items?: ApiJournalListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiJournalListItem implements IApiJournalListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    sort?: number;
    @columnMap(() => String)
    kurzel?: string | null;
    @columnMap(() => String)
    journalName?: string | null;
    @columnMap(() => String)
    issnPrint?: string | null;
    @columnMap(() => String)
    issnCd?: string | null;
    @columnMap(() => String)
    issnWeb?: string | null;
    @columnMap(() => JournalStatusEnum)
    status?: JournalStatusEnum;
    @columnMap(() => JournalTypeEnum)
    type?: JournalTypeEnum;
    @columnMap(() => Number)
    titles?: number;
    @columnMap(() => String, true)
    topics?: string[] | null;
    @columnMap(() => ApiNamedListItem)
    journalGroup?: ApiNamedListItem | null;
    isDeletable?: boolean;

    constructor(data?: IApiJournalListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sort = _data["sort"] !== undefined ? _data["sort"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
            this.journalName = _data["journalName"] !== undefined ? _data["journalName"] : null as any;
            this.issnPrint = _data["issnPrint"] !== undefined ? _data["issnPrint"] : null as any;
            this.issnCd = _data["issnCd"] !== undefined ? _data["issnCd"] : null as any;
            this.issnWeb = _data["issnWeb"] !== undefined ? _data["issnWeb"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.titles = _data["titles"] !== undefined ? _data["titles"] : null as any;
            if (Array.isArray(_data["topics"])) {
                this.topics = [] as any;
                for (let item of _data["topics"])
                    this.topics!.push(item);
            }
            else {
                this.topics = null as any;
            }
            this.journalGroup = _data["journalGroup"] ? ApiNamedListItem.fromJS(_data["journalGroup"]) : null as any;
            this.isDeletable = _data["isDeletable"] !== undefined ? _data["isDeletable"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sort"] = this.sort !== undefined ? this.sort : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        data["journalName"] = this.journalName !== undefined ? this.journalName : null as any;
        data["issnPrint"] = this.issnPrint !== undefined ? this.issnPrint : null as any;
        data["issnCd"] = this.issnCd !== undefined ? this.issnCd : null as any;
        data["issnWeb"] = this.issnWeb !== undefined ? this.issnWeb : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["titles"] = this.titles !== undefined ? this.titles : null as any;
        if (Array.isArray(this.topics)) {
            data["topics"] = [];
            for (let item of this.topics)
                data["topics"].push(item);
        }
        data["journalGroup"] = this.journalGroup ? this.journalGroup.toJSON() : null as any;
        data["isDeletable"] = this.isDeletable !== undefined ? this.isDeletable : null as any;
        return data;
    }
}

export interface IApiJournalListItem {
    id?: number;
    sort?: number;
    kurzel?: string | null;
    journalName?: string | null;
    issnPrint?: string | null;
    issnCd?: string | null;
    issnWeb?: string | null;
    status?: JournalStatusEnum;
    type?: JournalTypeEnum;
    titles?: number;
    topics?: string[] | null;
    journalGroup?: ApiNamedListItem | null;
    isDeletable?: boolean;
}

export class ApiJournalKurzel implements IApiJournalKurzel {
    journalId?: number;
    serialId?: number;
    kurzel?: string | null;

    constructor(data?: IApiJournalKurzel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.journalId = _data["journalId"] !== undefined ? _data["journalId"] : null as any;
            this.serialId = _data["serialId"] !== undefined ? _data["serialId"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalKurzel {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalKurzel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["journalId"] = this.journalId !== undefined ? this.journalId : null as any;
        data["serialId"] = this.serialId !== undefined ? this.serialId : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        return data;
    }
}

export interface IApiJournalKurzel {
    journalId?: number;
    serialId?: number;
    kurzel?: string | null;
}

export class ApiJournalCreateRequest implements IApiJournalCreateRequest {
    name: string;
    issnPrint: string;
    issnWeb: string;
    issnCd?: string | null;
    type: JournalTypeEnum;
    kurzel: string;

    constructor(data?: IApiJournalCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.issnPrint = _data["issnPrint"] !== undefined ? _data["issnPrint"] : null as any;
            this.issnWeb = _data["issnWeb"] !== undefined ? _data["issnWeb"] : null as any;
            this.issnCd = _data["issnCd"] !== undefined ? _data["issnCd"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.kurzel = _data["kurzel"] !== undefined ? _data["kurzel"] : null as any;
        }
    }

    static fromJS(data: any): ApiJournalCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiJournalCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["issnPrint"] = this.issnPrint !== undefined ? this.issnPrint : null as any;
        data["issnWeb"] = this.issnWeb !== undefined ? this.issnWeb : null as any;
        data["issnCd"] = this.issnCd !== undefined ? this.issnCd : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["kurzel"] = this.kurzel !== undefined ? this.kurzel : null as any;
        return data;
    }
}

export interface IApiJournalCreateRequest {
    name: string;
    issnPrint: string;
    issnWeb: string;
    issnCd?: string | null;
    type: JournalTypeEnum;
    kurzel: string;
}

export class ApiPageResultOfApiPublishingTopicListItem implements IApiPageResultOfApiPublishingTopicListItem {
    items?: ApiPublishingTopicListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiPublishingTopicListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiPublishingTopicListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiPublishingTopicListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiPublishingTopicListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiPublishingTopicListItem {
    items?: ApiPublishingTopicListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiPublishingTopicListItem implements IApiPublishingTopicListItem {
    @keyMap()
    topicId?: number;
    @columnMap(() => String)
    themaCodeHeading?: string | null;
    @columnMap(() => String, true)
    bicCodes?: string[] | null;
    @columnMap(() => String, true)
    bisacCodes?: string[] | null;
    @columnMap(() => String, true)
    lcshCodes?: string[] | null;
    @columnMap(() => String, true)
    topicCodes?: string[] | null;
    @columnMap(() => String, true)
    wgsCodes?: string[] | null;
    @columnMap(() => Boolean)
    archived?: boolean;

    constructor(data?: IApiPublishingTopicListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.topicId = _data["topicId"] !== undefined ? _data["topicId"] : null as any;
            this.themaCodeHeading = _data["themaCodeHeading"] !== undefined ? _data["themaCodeHeading"] : null as any;
            if (Array.isArray(_data["bicCodes"])) {
                this.bicCodes = [] as any;
                for (let item of _data["bicCodes"])
                    this.bicCodes!.push(item);
            }
            else {
                this.bicCodes = null as any;
            }
            if (Array.isArray(_data["bisacCodes"])) {
                this.bisacCodes = [] as any;
                for (let item of _data["bisacCodes"])
                    this.bisacCodes!.push(item);
            }
            else {
                this.bisacCodes = null as any;
            }
            if (Array.isArray(_data["lcshCodes"])) {
                this.lcshCodes = [] as any;
                for (let item of _data["lcshCodes"])
                    this.lcshCodes!.push(item);
            }
            else {
                this.lcshCodes = null as any;
            }
            if (Array.isArray(_data["topicCodes"])) {
                this.topicCodes = [] as any;
                for (let item of _data["topicCodes"])
                    this.topicCodes!.push(item);
            }
            else {
                this.topicCodes = null as any;
            }
            if (Array.isArray(_data["wgsCodes"])) {
                this.wgsCodes = [] as any;
                for (let item of _data["wgsCodes"])
                    this.wgsCodes!.push(item);
            }
            else {
                this.wgsCodes = null as any;
            }
            this.archived = _data["archived"] !== undefined ? _data["archived"] : null as any;
        }
    }

    static fromJS(data: any): ApiPublishingTopicListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPublishingTopicListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["topicId"] = this.topicId !== undefined ? this.topicId : null as any;
        data["themaCodeHeading"] = this.themaCodeHeading !== undefined ? this.themaCodeHeading : null as any;
        if (Array.isArray(this.bicCodes)) {
            data["bicCodes"] = [];
            for (let item of this.bicCodes)
                data["bicCodes"].push(item);
        }
        if (Array.isArray(this.bisacCodes)) {
            data["bisacCodes"] = [];
            for (let item of this.bisacCodes)
                data["bisacCodes"].push(item);
        }
        if (Array.isArray(this.lcshCodes)) {
            data["lcshCodes"] = [];
            for (let item of this.lcshCodes)
                data["lcshCodes"].push(item);
        }
        if (Array.isArray(this.topicCodes)) {
            data["topicCodes"] = [];
            for (let item of this.topicCodes)
                data["topicCodes"].push(item);
        }
        if (Array.isArray(this.wgsCodes)) {
            data["wgsCodes"] = [];
            for (let item of this.wgsCodes)
                data["wgsCodes"].push(item);
        }
        data["archived"] = this.archived !== undefined ? this.archived : null as any;
        return data;
    }
}

export interface IApiPublishingTopicListItem {
    topicId?: number;
    themaCodeHeading?: string | null;
    bicCodes?: string[] | null;
    bisacCodes?: string[] | null;
    lcshCodes?: string[] | null;
    topicCodes?: string[] | null;
    wgsCodes?: string[] | null;
    archived?: boolean;
}

export class ApiPageResultOfApiExternalIsbnSetListItem implements IApiPageResultOfApiExternalIsbnSetListItem {
    items?: ApiExternalIsbnSetListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiExternalIsbnSetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiExternalIsbnSetListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiExternalIsbnSetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiExternalIsbnSetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiExternalIsbnSetListItem {
    items?: ApiExternalIsbnSetListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiExternalIsbnSetListItem implements IApiExternalIsbnSetListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    isbnsFrom?: string | null;
    @columnMap(() => String)
    isbnsTo?: string | null;
    @columnMap(() => ApiNamedListItem)
    createdBy?: ApiNamedListItem | null;
    @columnMap(() => Date)
    createdDateTime?: Date;
    @columnMap(() => Number)
    totalIsbns?: number;
    @columnMap(() => Number)
    availableISBNs?: number;
    isRemovable?: boolean;

    constructor(data?: IApiExternalIsbnSetListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isbnsFrom = _data["isbnsFrom"] !== undefined ? _data["isbnsFrom"] : null as any;
            this.isbnsTo = _data["isbnsTo"] !== undefined ? _data["isbnsTo"] : null as any;
            this.createdBy = _data["createdBy"] ? ApiNamedListItem.fromJS(_data["createdBy"]) : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
            this.totalIsbns = _data["totalIsbns"] !== undefined ? _data["totalIsbns"] : null as any;
            this.availableISBNs = _data["availableISBNs"] !== undefined ? _data["availableISBNs"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
        }
    }

    static fromJS(data: any): ApiExternalIsbnSetListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiExternalIsbnSetListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isbnsFrom"] = this.isbnsFrom !== undefined ? this.isbnsFrom : null as any;
        data["isbnsTo"] = this.isbnsTo !== undefined ? this.isbnsTo : null as any;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        data["totalIsbns"] = this.totalIsbns !== undefined ? this.totalIsbns : null as any;
        data["availableISBNs"] = this.availableISBNs !== undefined ? this.availableISBNs : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        return data;
    }
}

export interface IApiExternalIsbnSetListItem {
    id?: number;
    isbnsFrom?: string | null;
    isbnsTo?: string | null;
    createdBy?: ApiNamedListItem | null;
    createdDateTime?: Date;
    totalIsbns?: number;
    availableISBNs?: number;
    isRemovable?: boolean;
}

export class ApiExternalIsbnSetValidity implements IApiExternalIsbnSetValidity {
    isbnFromValidity?: ApiIsbnValidity | null;
    isbnToValidity?: ApiIsbnValidity | null;
    isValid?: boolean;
    isIsbnsCountValid?: boolean;

    constructor(data?: IApiExternalIsbnSetValidity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isbnFromValidity = _data["isbnFromValidity"] ? ApiIsbnValidity.fromJS(_data["isbnFromValidity"]) : null as any;
            this.isbnToValidity = _data["isbnToValidity"] ? ApiIsbnValidity.fromJS(_data["isbnToValidity"]) : null as any;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : null as any;
            this.isIsbnsCountValid = _data["isIsbnsCountValid"] !== undefined ? _data["isIsbnsCountValid"] : null as any;
        }
    }

    static fromJS(data: any): ApiExternalIsbnSetValidity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiExternalIsbnSetValidity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isbnFromValidity"] = this.isbnFromValidity ? this.isbnFromValidity.toJSON() : null as any;
        data["isbnToValidity"] = this.isbnToValidity ? this.isbnToValidity.toJSON() : null as any;
        data["isValid"] = this.isValid !== undefined ? this.isValid : null as any;
        data["isIsbnsCountValid"] = this.isIsbnsCountValid !== undefined ? this.isIsbnsCountValid : null as any;
        return data;
    }
}

export interface IApiExternalIsbnSetValidity {
    isbnFromValidity?: ApiIsbnValidity | null;
    isbnToValidity?: ApiIsbnValidity | null;
    isValid?: boolean;
    isIsbnsCountValid?: boolean;
}

export class ApiIsbnValidity implements IApiIsbnValidity {
    isRangeValid?: boolean;
    validChecksum?: string | null;

    constructor(data?: IApiIsbnValidity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isRangeValid = _data["isRangeValid"] !== undefined ? _data["isRangeValid"] : null as any;
            this.validChecksum = _data["validChecksum"] !== undefined ? _data["validChecksum"] : null as any;
        }
    }

    static fromJS(data: any): ApiIsbnValidity {
        data = typeof data === 'object' ? data : {};
        let result = new ApiIsbnValidity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRangeValid"] = this.isRangeValid !== undefined ? this.isRangeValid : null as any;
        data["validChecksum"] = this.validChecksum !== undefined ? this.validChecksum : null as any;
        return data;
    }
}

export interface IApiIsbnValidity {
    isRangeValid?: boolean;
    validChecksum?: string | null;
}

export class ApiExternalIsbnSet implements IApiExternalIsbnSet {
    isbnsFrom?: string | null;
    isbnsTo?: string | null;

    constructor(data?: IApiExternalIsbnSet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isbnsFrom = _data["isbnsFrom"] !== undefined ? _data["isbnsFrom"] : null as any;
            this.isbnsTo = _data["isbnsTo"] !== undefined ? _data["isbnsTo"] : null as any;
        }
    }

    static fromJS(data: any): ApiExternalIsbnSet {
        data = typeof data === 'object' ? data : {};
        let result = new ApiExternalIsbnSet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isbnsFrom"] = this.isbnsFrom !== undefined ? this.isbnsFrom : null as any;
        data["isbnsTo"] = this.isbnsTo !== undefined ? this.isbnsTo : null as any;
        return data;
    }
}

export interface IApiExternalIsbnSet {
    isbnsFrom?: string | null;
    isbnsTo?: string | null;
}

export class ApiIsbnSettings implements IApiIsbnSettings {
    internalStartIsbnNumber?: string | null;
    allAvailableIsbns?: number;
    minimumNotificationLimit?: number;
    memo?: string | null;

    constructor(data?: IApiIsbnSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalStartIsbnNumber = _data["internalStartIsbnNumber"] !== undefined ? _data["internalStartIsbnNumber"] : null as any;
            this.allAvailableIsbns = _data["allAvailableIsbns"] !== undefined ? _data["allAvailableIsbns"] : null as any;
            this.minimumNotificationLimit = _data["minimumNotificationLimit"] !== undefined ? _data["minimumNotificationLimit"] : null as any;
            this.memo = _data["memo"] !== undefined ? _data["memo"] : null as any;
        }
    }

    static fromJS(data: any): ApiIsbnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ApiIsbnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalStartIsbnNumber"] = this.internalStartIsbnNumber !== undefined ? this.internalStartIsbnNumber : null as any;
        data["allAvailableIsbns"] = this.allAvailableIsbns !== undefined ? this.allAvailableIsbns : null as any;
        data["minimumNotificationLimit"] = this.minimumNotificationLimit !== undefined ? this.minimumNotificationLimit : null as any;
        data["memo"] = this.memo !== undefined ? this.memo : null as any;
        return data;
    }
}

export interface IApiIsbnSettings {
    internalStartIsbnNumber?: string | null;
    allAvailableIsbns?: number;
    minimumNotificationLimit?: number;
    memo?: string | null;
}

export class ApiReviewerProjectInfo implements IApiReviewerProjectInfo {
    titleId?: number;
    name?: string | null;
    editPeriod?: ApiEditPeriod | null;

    constructor(data?: IApiReviewerProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.editPeriod = _data["editPeriod"] ? ApiEditPeriod.fromJS(_data["editPeriod"]) : null as any;
        }
    }

    static fromJS(data: any): ApiReviewerProjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["editPeriod"] = this.editPeriod ? this.editPeriod.toJSON() : null as any;
        return data;
    }
}

export interface IApiReviewerProjectInfo {
    titleId?: number;
    name?: string | null;
    editPeriod?: ApiEditPeriod | null;
}

export class ApiEditPeriod implements IApiEditPeriod {
    from?: Date | null;
    to?: Date | null;
    expired?: boolean;

    constructor(data?: IApiEditPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] ? new Date(_data["from"].toString()) : null as any;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : null as any;
            this.expired = _data["expired"] !== undefined ? _data["expired"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toISOString() : null as any;
        data["to"] = this.to ? this.to.toISOString() : null as any;
        data["expired"] = this.expired !== undefined ? this.expired : null as any;
        return data;
    }
}

export interface IApiEditPeriod {
    from?: Date | null;
    to?: Date | null;
    expired?: boolean;
}

export class ApiReviewerReviewListItem implements IApiReviewerReviewListItem {
    id?: number;
    status?: ReviewStatusEnum;
    isReReview?: boolean;
    paperName?: string | null;
    editor?: ApiMemberInfo | null;
    pdfFile?: ApiFileInfo | null;

    constructor(data?: IApiReviewerReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.isReReview = _data["isReReview"] !== undefined ? _data["isReReview"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.editor = _data["editor"] ? ApiMemberInfo.fromJS(_data["editor"]) : null as any;
            this.pdfFile = _data["pdfFile"] ? ApiFileInfo.fromJS(_data["pdfFile"]) : null as any;
        }
    }

    static fromJS(data: any): ApiReviewerReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["isReReview"] = this.isReReview !== undefined ? this.isReReview : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["editor"] = this.editor ? this.editor.toJSON() : null as any;
        data["pdfFile"] = this.pdfFile ? this.pdfFile.toJSON() : null as any;
        return data;
    }
}

export interface IApiReviewerReviewListItem {
    id?: number;
    status?: ReviewStatusEnum;
    isReReview?: boolean;
    paperName?: string | null;
    editor?: ApiMemberInfo | null;
    pdfFile?: ApiFileInfo | null;
}

export abstract class ApiBaseReview implements IApiBaseReview {
    id?: number;
    status?: ReviewStatusEnum;
    paperAuthors?: string[] | null;
    report?: ApiReviewReport | null;

    constructor(data?: IApiBaseReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            if (Array.isArray(_data["paperAuthors"])) {
                this.paperAuthors = [] as any;
                for (let item of _data["paperAuthors"])
                    this.paperAuthors!.push(item);
            }
            else {
                this.paperAuthors = null as any;
            }
            this.report = _data["report"] ? ApiReviewReport.fromJS(_data["report"]) : null as any;
        }
    }

    static fromJS(data: any): ApiBaseReview {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiBaseReview' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        if (Array.isArray(this.paperAuthors)) {
            data["paperAuthors"] = [];
            for (let item of this.paperAuthors)
                data["paperAuthors"].push(item);
        }
        data["report"] = this.report ? this.report.toJSON() : null as any;
        return data;
    }
}

export interface IApiBaseReview {
    id?: number;
    status?: ReviewStatusEnum;
    paperAuthors?: string[] | null;
    report?: ApiReviewReport | null;
}

export class ApiReviewerReview extends ApiBaseReview implements IApiReviewerReview {
    paperName?: string | null;
    editor?: ApiMemberInfo | null;
    pdfFile?: ApiFileInfo | null;
    siblings?: ApiReviewSibling[] | null;

    constructor(data?: IApiReviewerReview) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.editor = _data["editor"] ? ApiMemberInfo.fromJS(_data["editor"]) : null as any;
            this.pdfFile = _data["pdfFile"] ? ApiFileInfo.fromJS(_data["pdfFile"]) : null as any;
            if (Array.isArray(_data["siblings"])) {
                this.siblings = [] as any;
                for (let item of _data["siblings"])
                    this.siblings!.push(ApiReviewSibling.fromJS(item));
            }
            else {
                this.siblings = null as any;
            }
        }
    }

    static fromJS(data: any): ApiReviewerReview {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["editor"] = this.editor ? this.editor.toJSON() : null as any;
        data["pdfFile"] = this.pdfFile ? this.pdfFile.toJSON() : null as any;
        if (Array.isArray(this.siblings)) {
            data["siblings"] = [];
            for (let item of this.siblings)
                data["siblings"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApiReviewerReview extends IApiBaseReview {
    paperName?: string | null;
    editor?: ApiMemberInfo | null;
    pdfFile?: ApiFileInfo | null;
    siblings?: ApiReviewSibling[] | null;
}

export class ApiReviewSibling implements IApiReviewSibling {
    id?: number;
    isReReview?: boolean;

    constructor(data?: IApiReviewSibling) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.isReReview = _data["isReReview"] !== undefined ? _data["isReReview"] : null as any;
        }
    }

    static fromJS(data: any): ApiReviewSibling {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewSibling();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["isReReview"] = this.isReReview !== undefined ? this.isReReview : null as any;
        return data;
    }
}

export interface IApiReviewSibling {
    id?: number;
    isReReview?: boolean;
}

export class ApiReviewReport implements IApiReviewReport {
    recommendation?: ReviewRecommendationEnum | null;
    highScientificQuality?: boolean | null;
    freeFromErrors?: boolean | null;
    wellOrganized?: boolean | null;
    appropriateTitle?: boolean | null;
    adequateReferences?: boolean | null;
    satisfactoryEnglish?: boolean | null;
    clearFigures?: ReviewChecklistItemEnum | null;
    clearTables?: ReviewChecklistItemEnum | null;
    remarks?: string | null;
    attachment?: ApiFileInfo | null;

    constructor(data?: IApiReviewReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recommendation = _data["recommendation"] !== undefined ? _data["recommendation"] : null as any;
            this.highScientificQuality = _data["highScientificQuality"] !== undefined ? _data["highScientificQuality"] : null as any;
            this.freeFromErrors = _data["freeFromErrors"] !== undefined ? _data["freeFromErrors"] : null as any;
            this.wellOrganized = _data["wellOrganized"] !== undefined ? _data["wellOrganized"] : null as any;
            this.appropriateTitle = _data["appropriateTitle"] !== undefined ? _data["appropriateTitle"] : null as any;
            this.adequateReferences = _data["adequateReferences"] !== undefined ? _data["adequateReferences"] : null as any;
            this.satisfactoryEnglish = _data["satisfactoryEnglish"] !== undefined ? _data["satisfactoryEnglish"] : null as any;
            this.clearFigures = _data["clearFigures"] !== undefined ? _data["clearFigures"] : null as any;
            this.clearTables = _data["clearTables"] !== undefined ? _data["clearTables"] : null as any;
            this.remarks = _data["remarks"] !== undefined ? _data["remarks"] : null as any;
            this.attachment = _data["attachment"] ? ApiFileInfo.fromJS(_data["attachment"]) : null as any;
        }
    }

    static fromJS(data: any): ApiReviewReport {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recommendation"] = this.recommendation !== undefined ? this.recommendation : null as any;
        data["highScientificQuality"] = this.highScientificQuality !== undefined ? this.highScientificQuality : null as any;
        data["freeFromErrors"] = this.freeFromErrors !== undefined ? this.freeFromErrors : null as any;
        data["wellOrganized"] = this.wellOrganized !== undefined ? this.wellOrganized : null as any;
        data["appropriateTitle"] = this.appropriateTitle !== undefined ? this.appropriateTitle : null as any;
        data["adequateReferences"] = this.adequateReferences !== undefined ? this.adequateReferences : null as any;
        data["satisfactoryEnglish"] = this.satisfactoryEnglish !== undefined ? this.satisfactoryEnglish : null as any;
        data["clearFigures"] = this.clearFigures !== undefined ? this.clearFigures : null as any;
        data["clearTables"] = this.clearTables !== undefined ? this.clearTables : null as any;
        data["remarks"] = this.remarks !== undefined ? this.remarks : null as any;
        data["attachment"] = this.attachment ? this.attachment.toJSON() : null as any;
        return data;
    }
}

export interface IApiReviewReport {
    recommendation?: ReviewRecommendationEnum | null;
    highScientificQuality?: boolean | null;
    freeFromErrors?: boolean | null;
    wellOrganized?: boolean | null;
    appropriateTitle?: boolean | null;
    adequateReferences?: boolean | null;
    satisfactoryEnglish?: boolean | null;
    clearFigures?: ReviewChecklistItemEnum | null;
    clearTables?: ReviewChecklistItemEnum | null;
    remarks?: string | null;
    attachment?: ApiFileInfo | null;
}

export class ApiReviewerProjectsSummary implements IApiReviewerProjectsSummary {
    inProgressProjectsCount?: number;
    publishedProjectsCount?: number;
    haveLoggedAsReviewer?: boolean;

    constructor(data?: IApiReviewerProjectsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressProjectsCount = _data["inProgressProjectsCount"] !== undefined ? _data["inProgressProjectsCount"] : null as any;
            this.publishedProjectsCount = _data["publishedProjectsCount"] !== undefined ? _data["publishedProjectsCount"] : null as any;
            this.haveLoggedAsReviewer = _data["haveLoggedAsReviewer"] !== undefined ? _data["haveLoggedAsReviewer"] : null as any;
        }
    }

    static fromJS(data: any): ApiReviewerProjectsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerProjectsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressProjectsCount"] = this.inProgressProjectsCount !== undefined ? this.inProgressProjectsCount : null as any;
        data["publishedProjectsCount"] = this.publishedProjectsCount !== undefined ? this.publishedProjectsCount : null as any;
        data["haveLoggedAsReviewer"] = this.haveLoggedAsReviewer !== undefined ? this.haveLoggedAsReviewer : null as any;
        return data;
    }
}

export interface IApiReviewerProjectsSummary {
    inProgressProjectsCount?: number;
    publishedProjectsCount?: number;
    haveLoggedAsReviewer?: boolean;
}

export class ApiReviewerProject implements IApiReviewerProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    hasCover?: boolean;
    editPeriod?: ApiEditPeriod | null;
    isReadOnly?: boolean;

    constructor(data?: IApiReviewerProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : null as any;
            this.editPeriod = _data["editPeriod"] ? ApiEditPeriod.fromJS(_data["editPeriod"]) : null as any;
            this.isReadOnly = _data["isReadOnly"] !== undefined ? _data["isReadOnly"] : null as any;
        }
    }

    static fromJS(data: any): ApiReviewerProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiReviewerProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : null as any;
        data["editPeriod"] = this.editPeriod ? this.editPeriod.toJSON() : null as any;
        data["isReadOnly"] = this.isReadOnly !== undefined ? this.isReadOnly : null as any;
        return data;
    }
}

export interface IApiReviewerProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    hasCover?: boolean;
    editPeriod?: ApiEditPeriod | null;
    isReadOnly?: boolean;
}

export class ApiBulkMembersValidation implements IApiBulkMembersValidation {
    validationEntries?: ApiBulkMembersValidationEntry[] | null;
    existingParticipants?: ApiBulkExistingTitleParticipant[] | null;
    isEmpty?: boolean;

    constructor(data?: IApiBulkMembersValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["validationEntries"])) {
                this.validationEntries = [] as any;
                for (let item of _data["validationEntries"])
                    this.validationEntries!.push(ApiBulkMembersValidationEntry.fromJS(item));
            }
            else {
                this.validationEntries = null as any;
            }
            if (Array.isArray(_data["existingParticipants"])) {
                this.existingParticipants = [] as any;
                for (let item of _data["existingParticipants"])
                    this.existingParticipants!.push(ApiBulkExistingTitleParticipant.fromJS(item));
            }
            else {
                this.existingParticipants = null as any;
            }
            this.isEmpty = _data["isEmpty"] !== undefined ? _data["isEmpty"] : null as any;
        }
    }

    static fromJS(data: any): ApiBulkMembersValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBulkMembersValidation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.validationEntries)) {
            data["validationEntries"] = [];
            for (let item of this.validationEntries)
                data["validationEntries"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.existingParticipants)) {
            data["existingParticipants"] = [];
            for (let item of this.existingParticipants)
                data["existingParticipants"].push(item ? item.toJSON() : null as any);
        }
        data["isEmpty"] = this.isEmpty !== undefined ? this.isEmpty : null as any;
        return data;
    }
}

export interface IApiBulkMembersValidation {
    validationEntries?: ApiBulkMembersValidationEntry[] | null;
    existingParticipants?: ApiBulkExistingTitleParticipant[] | null;
    isEmpty?: boolean;
}

export class ApiBulkMembersValidationEntry implements IApiBulkMembersValidationEntry {
    rowNumber?: number;
    errorEnumList?: ApiBulkMemberErrorEnum[] | null;

    constructor(data?: IApiBulkMembersValidationEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowNumber = _data["rowNumber"] !== undefined ? _data["rowNumber"] : null as any;
            if (Array.isArray(_data["errorEnumList"])) {
                this.errorEnumList = [] as any;
                for (let item of _data["errorEnumList"])
                    this.errorEnumList!.push(item);
            }
            else {
                this.errorEnumList = null as any;
            }
        }
    }

    static fromJS(data: any): ApiBulkMembersValidationEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBulkMembersValidationEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowNumber"] = this.rowNumber !== undefined ? this.rowNumber : null as any;
        if (Array.isArray(this.errorEnumList)) {
            data["errorEnumList"] = [];
            for (let item of this.errorEnumList)
                data["errorEnumList"].push(item);
        }
        return data;
    }
}

export interface IApiBulkMembersValidationEntry {
    rowNumber?: number;
    errorEnumList?: ApiBulkMemberErrorEnum[] | null;
}

export enum ApiBulkMemberErrorEnum {
    EmailMissing = 0,
    FirstNameMissing = 1,
    LastNameMissing = 2,
    FirstNameInvalid = 3,
    LastNameInvalid = 4,
    EmailInvalid = 5,
    CodeInvalid = 6,
    EmailNotUnique = 7,
    EmailLength = 8,
    LastNameLength = 9,
    FirstNameLength = 10,
    CodeLength = 11,
}

export class ApiBulkExistingTitleParticipant implements IApiBulkExistingTitleParticipant {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IApiBulkExistingTitleParticipant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): ApiBulkExistingTitleParticipant {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBulkExistingTitleParticipant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface IApiBulkExistingTitleParticipant {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class ApiBulkMembers implements IApiBulkMembers {
    existingMembers?: ApiBulkMember[] | null;
    newMembers?: ApiBulkMember[] | null;

    constructor(data?: IApiBulkMembers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["existingMembers"])) {
                this.existingMembers = [] as any;
                for (let item of _data["existingMembers"])
                    this.existingMembers!.push(ApiBulkMember.fromJS(item));
            }
            else {
                this.existingMembers = null as any;
            }
            if (Array.isArray(_data["newMembers"])) {
                this.newMembers = [] as any;
                for (let item of _data["newMembers"])
                    this.newMembers!.push(ApiBulkMember.fromJS(item));
            }
            else {
                this.newMembers = null as any;
            }
        }
    }

    static fromJS(data: any): ApiBulkMembers {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBulkMembers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.existingMembers)) {
            data["existingMembers"] = [];
            for (let item of this.existingMembers)
                data["existingMembers"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.newMembers)) {
            data["newMembers"] = [];
            for (let item of this.newMembers)
                data["newMembers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiBulkMembers {
    existingMembers?: ApiBulkMember[] | null;
    newMembers?: ApiBulkMember[] | null;
}

export class ApiBulkMember implements IApiBulkMember {
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    @keyMap()
    email?: string | null;
    @columnMap(() => String)
    code?: string | null;
    memberId?: number;

    constructor(data?: IApiBulkMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiBulkMember {
        data = typeof data === 'object' ? data : {};
        let result = new ApiBulkMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        return data;
    }
}

export interface IApiBulkMember {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    code?: string | null;
    memberId?: number;
}

export class ApiPageResultOfApiEditingToolPaperAuthorListItem implements IApiPageResultOfApiEditingToolPaperAuthorListItem {
    items?: ApiEditingToolPaperAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditingToolPaperAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditingToolPaperAuthorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditingToolPaperAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditingToolPaperAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditingToolPaperAuthorListItem {
    items?: ApiEditingToolPaperAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditingToolPaperAuthorListItem implements IApiEditingToolPaperAuthorListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => ApiPaperAuthorAffiliation)
    affiliation?: ApiPaperAuthorAffiliation | null;
    corresponding?: boolean;

    constructor(data?: IApiEditingToolPaperAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.affiliation = _data["affiliation"] ? ApiPaperAuthorAffiliation.fromJS(_data["affiliation"]) : null as any;
            this.corresponding = _data["corresponding"] !== undefined ? _data["corresponding"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["affiliation"] = this.affiliation ? this.affiliation.toJSON() : null as any;
        data["corresponding"] = this.corresponding !== undefined ? this.corresponding : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperAuthorListItem {
    memberId?: number;
    pos?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    affiliation?: ApiPaperAuthorAffiliation | null;
    corresponding?: boolean;
}

export class ApiPaperAuthorAffiliation implements IApiPaperAuthorAffiliation {

    constructor(data?: IApiPaperAuthorAffiliation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ApiPaperAuthorAffiliation {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperAuthorAffiliation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IApiPaperAuthorAffiliation {
}

export class ApiEditingToolParsedAuthor implements IApiEditingToolParsedAuthor {
    parsedAuthorId?: number;
    memberId?: number;
    email: string;
    lastName: string;
    firstName: string;
    countryId?: string | null;
    universityOrOrganization: string;
    title?: string | null;
    orcidId?: string | null;

    constructor(data?: IApiEditingToolParsedAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parsedAuthorId = _data["parsedAuthorId"] !== undefined ? _data["parsedAuthorId"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolParsedAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolParsedAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parsedAuthorId"] = this.parsedAuthorId !== undefined ? this.parsedAuthorId : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        return data;
    }
}

export interface IApiEditingToolParsedAuthor {
    parsedAuthorId?: number;
    memberId?: number;
    email: string;
    lastName: string;
    firstName: string;
    countryId?: string | null;
    universityOrOrganization: string;
    title?: string | null;
    orcidId?: string | null;
}

export class ApiEditingToolExistingParsedAuthor implements IApiEditingToolExistingParsedAuthor {
    parsedAuthorId?: number;
    memberId?: number;

    constructor(data?: IApiEditingToolExistingParsedAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parsedAuthorId = _data["parsedAuthorId"] !== undefined ? _data["parsedAuthorId"] : null as any;
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolExistingParsedAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolExistingParsedAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parsedAuthorId"] = this.parsedAuthorId !== undefined ? this.parsedAuthorId : null as any;
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        return data;
    }
}

export interface IApiEditingToolExistingParsedAuthor {
    parsedAuthorId?: number;
    memberId?: number;
}

export class ApiEditingToolCreateAuthorRequest implements IApiEditingToolCreateAuthorRequest {
    email: string;
    firstName: string;
    lastName: string;
    title?: string | null;
    countryId: string;
    addressLine1?: string | null;
    city?: string | null;
    zip?: string | null;
    universityOrOrganization: string;
    department?: string | null;
    orcidId?: string | null;

    constructor(data?: IApiEditingToolCreateAuthorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolCreateAuthorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolCreateAuthorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        return data;
    }
}

export interface IApiEditingToolCreateAuthorRequest {
    email: string;
    firstName: string;
    lastName: string;
    title?: string | null;
    countryId: string;
    addressLine1?: string | null;
    city?: string | null;
    zip?: string | null;
    universityOrOrganization: string;
    department?: string | null;
    orcidId?: string | null;
}

export class ApiEditingToolPaperAuthor implements IApiEditingToolPaperAuthor {
    memberId?: number;
    authorId?: number;
    email?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    countryId?: string | null;
    universityOrOrganization?: string | null;
    title?: string | null;

    constructor(data?: IApiEditingToolPaperAuthor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.authorId = _data["authorId"] !== undefined ? _data["authorId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperAuthor {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperAuthor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["authorId"] = this.authorId !== undefined ? this.authorId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperAuthor {
    memberId?: number;
    authorId?: number;
    email?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    countryId?: string | null;
    universityOrOrganization?: string | null;
    title?: string | null;
}

export class ApiAccountAddress implements IApiAccountAddress {
    addressType?: AccountAddressTypeEnum;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    vat?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    websites?: string[] | null;

    constructor(data?: IApiAccountAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressType = _data["addressType"] !== undefined ? _data["addressType"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.addressLine1 = _data["addressLine1"] !== undefined ? _data["addressLine1"] : null as any;
            this.addressLine2 = _data["addressLine2"] !== undefined ? _data["addressLine2"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            this.department = _data["department"] !== undefined ? _data["department"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(item);
            }
            else {
                this.websites = null as any;
            }
        }
    }

    static fromJS(data: any): ApiAccountAddress {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAccountAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressType"] = this.addressType !== undefined ? this.addressType : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["addressLine1"] = this.addressLine1 !== undefined ? this.addressLine1 : null as any;
        data["addressLine2"] = this.addressLine2 !== undefined ? this.addressLine2 : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        data["department"] = this.department !== undefined ? this.department : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item);
        }
        return data;
    }
}

export interface IApiAccountAddress {
    addressType?: AccountAddressTypeEnum;
    countryId?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    universityOrOrganization?: string | null;
    department?: string | null;
    state?: string | null;
    city?: string | null;
    zip?: string | null;
    vat?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    websites?: string[] | null;
}

export abstract class ApiAccountAddressDetails extends ApiAccountAddress implements IApiAccountAddressDetails {
    id?: number;
    accountId?: number;
    countryName?: string | null;
    registeredTime?: Date | null;
    lastUpdated?: Date | null;

    constructor(data?: IApiAccountAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.registeredTime = _data["registeredTime"] ? new Date(_data["registeredTime"].toString()) : null as any;
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiAccountAddressDetails {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ApiAccountAddressDetails' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["registeredTime"] = this.registeredTime ? this.registeredTime.toISOString() : null as any;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAccountAddressDetails extends IApiAccountAddress {
    id?: number;
    accountId?: number;
    countryName?: string | null;
    registeredTime?: Date | null;
    lastUpdated?: Date | null;
}

export class ApiMemberAddressDetails extends ApiAccountAddressDetails implements IApiMemberAddressDetails {

    constructor(data?: IApiMemberAddressDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApiMemberAddressDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiMemberAddressDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApiMemberAddressDetails extends IApiAccountAddressDetails {
}

export enum AccountAddressTypeEnum {
    Main = 0,
    Delivery = 1,
    Billing = 2,
    Shipping = 3,
}

export class ApiEditingToolFoundMember implements IApiEditingToolFoundMember {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    orcidId?: string | null;
    email?: string | null;
    countryId?: string | null;
    countryName?: string | null;
    universityOrOrganization?: string | null;
    authorEmails?: string[] | null;

    constructor(data?: IApiEditingToolFoundMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            if (Array.isArray(_data["authorEmails"])) {
                this.authorEmails = [] as any;
                for (let item of _data["authorEmails"])
                    this.authorEmails!.push(item);
            }
            else {
                this.authorEmails = null as any;
            }
        }
    }

    static fromJS(data: any): ApiEditingToolFoundMember {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolFoundMember();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        if (Array.isArray(this.authorEmails)) {
            data["authorEmails"] = [];
            for (let item of this.authorEmails)
                data["authorEmails"].push(item);
        }
        return data;
    }
}

export interface IApiEditingToolFoundMember {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    orcidId?: string | null;
    email?: string | null;
    countryId?: string | null;
    countryName?: string | null;
    universityOrOrganization?: string | null;
    authorEmails?: string[] | null;
}

export class ApiPaperChecklist implements IApiPaperChecklist {
    paperId?: number;
    createdDateTime?: Date | null;
    canBeSubmitted?: boolean;
    items?: ApiChecklistItem[] | null;

    constructor(data?: IApiPaperChecklist) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
            this.canBeSubmitted = _data["canBeSubmitted"] !== undefined ? _data["canBeSubmitted"] : null as any;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiChecklistItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): ApiPaperChecklist {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperChecklist();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        data["canBeSubmitted"] = this.canBeSubmitted !== undefined ? this.canBeSubmitted : null as any;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IApiPaperChecklist {
    paperId?: number;
    createdDateTime?: Date | null;
    canBeSubmitted?: boolean;
    items?: ApiChecklistItem[] | null;
}

export class ApiChecklistItem implements IApiChecklistItem {
    checked?: boolean;
    templateItem?: ApiTemplateChecklistItem | null;

    constructor(data?: IApiChecklistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checked = _data["checked"] !== undefined ? _data["checked"] : null as any;
            this.templateItem = _data["templateItem"] ? ApiTemplateChecklistItem.fromJS(_data["templateItem"]) : null as any;
        }
    }

    static fromJS(data: any): ApiChecklistItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiChecklistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checked"] = this.checked !== undefined ? this.checked : null as any;
        data["templateItem"] = this.templateItem ? this.templateItem.toJSON() : null as any;
        return data;
    }
}

export interface IApiChecklistItem {
    checked?: boolean;
    templateItem?: ApiTemplateChecklistItem | null;
}

export class ApiTemplateChecklistItem implements IApiTemplateChecklistItem {
    templateChecklistItemId?: number;
    itemText?: string | null;
    isRequired?: boolean;
    pos?: number;

    constructor(data?: IApiTemplateChecklistItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateChecklistItemId = _data["templateChecklistItemId"] !== undefined ? _data["templateChecklistItemId"] : null as any;
            this.itemText = _data["itemText"] !== undefined ? _data["itemText"] : null as any;
            this.isRequired = _data["isRequired"] !== undefined ? _data["isRequired"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
        }
    }

    static fromJS(data: any): ApiTemplateChecklistItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiTemplateChecklistItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateChecklistItemId"] = this.templateChecklistItemId !== undefined ? this.templateChecklistItemId : null as any;
        data["itemText"] = this.itemText !== undefined ? this.itemText : null as any;
        data["isRequired"] = this.isRequired !== undefined ? this.isRequired : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        return data;
    }
}

export interface IApiTemplateChecklistItem {
    templateChecklistItemId?: number;
    itemText?: string | null;
    isRequired?: boolean;
    pos?: number;
}

export class ApiPaperCopyright implements IApiPaperCopyright {
    copyrightStatus?: CopyrightStatusEnum;
    copyrightText?: string | null;
    file?: ApiFileInfo | null;

    constructor(data?: IApiPaperCopyright) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.copyrightStatus = _data["copyrightStatus"] !== undefined ? _data["copyrightStatus"] : null as any;
            this.copyrightText = _data["copyrightText"] !== undefined ? _data["copyrightText"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperCopyright {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperCopyright();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["copyrightStatus"] = this.copyrightStatus !== undefined ? this.copyrightStatus : null as any;
        data["copyrightText"] = this.copyrightText !== undefined ? this.copyrightText : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        return data;
    }
}

export interface IApiPaperCopyright {
    copyrightStatus?: CopyrightStatusEnum;
    copyrightText?: string | null;
    file?: ApiFileInfo | null;
}

export class ApiPageResultOfApiEditingToolReferenceListItem implements IApiPageResultOfApiEditingToolReferenceListItem {
    items?: ApiEditingToolReferenceListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditingToolReferenceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditingToolReferenceListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditingToolReferenceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditingToolReferenceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditingToolReferenceListItem {
    items?: ApiEditingToolReferenceListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditingToolReferenceListItem implements IApiEditingToolReferenceListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    displayOrder?: number | null;
    @columnMap(() => String)
    reference?: string | null;
    @columnMap(() => String)
    doi?: string | null;

    constructor(data?: IApiEditingToolReferenceListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.displayOrder = _data["displayOrder"] !== undefined ? _data["displayOrder"] : null as any;
            this.reference = _data["reference"] !== undefined ? _data["reference"] : null as any;
            this.doi = _data["doi"] !== undefined ? _data["doi"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolReferenceListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolReferenceListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["displayOrder"] = this.displayOrder !== undefined ? this.displayOrder : null as any;
        data["reference"] = this.reference !== undefined ? this.reference : null as any;
        data["doi"] = this.doi !== undefined ? this.doi : null as any;
        return data;
    }
}

export interface IApiEditingToolReferenceListItem {
    id?: number;
    displayOrder?: number | null;
    reference?: string | null;
    doi?: string | null;
}

export class ApiPageResultOfApiEditorPaperReviewerListItem implements IApiPageResultOfApiEditorPaperReviewerListItem {
    items?: ApiEditorPaperReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorPaperReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorPaperReviewerListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorPaperReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorPaperReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorPaperReviewerListItem {
    items?: ApiEditorPaperReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorPaperReviewerListItem implements IApiEditorPaperReviewerListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    reviewer?: string | null;
    @columnMap(() => ReviewTypeEnum)
    type?: ReviewTypeEnum;
    @columnMap(() => ReviewStatusEnum)
    review?: ReviewStatusEnum;
    @columnMap(() => ApiReviewReportStateEnum)
    report?: ApiReviewReportStateEnum;
    @columnMap(() => Date)
    lastModified?: Date;
    paperId?: number;
    canCancel?: boolean;

    constructor(data?: IApiEditorPaperReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reviewer = _data["reviewer"] !== undefined ? _data["reviewer"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.review = _data["review"] !== undefined ? _data["review"] : null as any;
            this.report = _data["report"] !== undefined ? _data["report"] : null as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : null as any;
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.canCancel = _data["canCancel"] !== undefined ? _data["canCancel"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorPaperReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorPaperReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reviewer"] = this.reviewer !== undefined ? this.reviewer : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["review"] = this.review !== undefined ? this.review : null as any;
        data["report"] = this.report !== undefined ? this.report : null as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : null as any;
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["canCancel"] = this.canCancel !== undefined ? this.canCancel : null as any;
        return data;
    }
}

export interface IApiEditorPaperReviewerListItem {
    id?: number;
    reviewer?: string | null;
    type?: ReviewTypeEnum;
    review?: ReviewStatusEnum;
    report?: ApiReviewReportStateEnum;
    lastModified?: Date;
    paperId?: number;
    canCancel?: boolean;
}

export enum ReviewTypeEnum {
    Review = 0,
    ReReview = 1,
}

export enum ApiReviewReportStateEnum {
    None = 0,
    Approved = 1,
    NeedToApprove = 2,
}

export class ApiPageResultOfApiEditorPaperUnassignedReviewerListItem implements IApiPageResultOfApiEditorPaperUnassignedReviewerListItem {
    items?: ApiEditorPaperUnassignedReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorPaperUnassignedReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorPaperUnassignedReviewerListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorPaperUnassignedReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorPaperUnassignedReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorPaperUnassignedReviewerListItem {
    items?: ApiEditorPaperUnassignedReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorPaperUnassignedReviewerListItem implements IApiEditorPaperUnassignedReviewerListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    fullName?: string | null;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => ApiReviewCounter)
    reviewCounter?: ApiReviewCounter | null;

    constructor(data?: IApiEditorPaperUnassignedReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditorPaperUnassignedReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorPaperUnassignedReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditorPaperUnassignedReviewerListItem {
    memberId?: number;
    fullName?: string | null;
    email?: string | null;
    reviewCounter?: ApiReviewCounter | null;
}

export class ApiEditorReview extends ApiBaseReview implements IApiEditorReview {
    reviewer?: ApiMemberInfo | null;
    reviewedDate?: Date;
    canBeApproved?: boolean;
    canBeSentForReReview?: boolean;
    siblings?: ApiReviewSibling[] | null;

    constructor(data?: IApiEditorReview) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reviewer = _data["reviewer"] ? ApiMemberInfo.fromJS(_data["reviewer"]) : null as any;
            this.reviewedDate = _data["reviewedDate"] ? new Date(_data["reviewedDate"].toString()) : null as any;
            this.canBeApproved = _data["canBeApproved"] !== undefined ? _data["canBeApproved"] : null as any;
            this.canBeSentForReReview = _data["canBeSentForReReview"] !== undefined ? _data["canBeSentForReReview"] : null as any;
            if (Array.isArray(_data["siblings"])) {
                this.siblings = [] as any;
                for (let item of _data["siblings"])
                    this.siblings!.push(ApiReviewSibling.fromJS(item));
            }
            else {
                this.siblings = null as any;
            }
        }
    }

    static fromJS(data: any): ApiEditorReview {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reviewer"] = this.reviewer ? this.reviewer.toJSON() : null as any;
        data["reviewedDate"] = this.reviewedDate ? this.reviewedDate.toISOString() : null as any;
        data["canBeApproved"] = this.canBeApproved !== undefined ? this.canBeApproved : null as any;
        data["canBeSentForReReview"] = this.canBeSentForReReview !== undefined ? this.canBeSentForReReview : null as any;
        if (Array.isArray(this.siblings)) {
            data["siblings"] = [];
            for (let item of this.siblings)
                data["siblings"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApiEditorReview extends IApiBaseReview {
    reviewer?: ApiMemberInfo | null;
    reviewedDate?: Date;
    canBeApproved?: boolean;
    canBeSentForReReview?: boolean;
    siblings?: ApiReviewSibling[] | null;
}

export class ApiEditingToolPaperInfo implements IApiEditingToolPaperInfo {
    id?: number;
    header?: ApiEditingToolPaperHeader | null;
    progress?: ApiEditingToolPaperProgressInfo | null;

    constructor(data?: IApiEditingToolPaperInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.header = _data["header"] ? ApiEditingToolPaperHeader.fromJS(_data["header"]) : null as any;
            this.progress = _data["progress"] ? ApiEditingToolPaperProgressInfo.fromJS(_data["progress"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["header"] = this.header ? this.header.toJSON() : null as any;
        data["progress"] = this.progress ? this.progress.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperInfo {
    id?: number;
    header?: ApiEditingToolPaperHeader | null;
    progress?: ApiEditingToolPaperProgressInfo | null;
}

export class ApiEditingToolPaperHeader implements IApiEditingToolPaperHeader {
    id?: number;
    name?: string | null;
    status?: PaperStatusEnum;
    titleId?: number;
    titleName?: string | null;

    constructor(data?: IApiEditingToolPaperHeader) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperHeader {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperHeader();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperHeader {
    id?: number;
    name?: string | null;
    status?: PaperStatusEnum;
    titleId?: number;
    titleName?: string | null;
}

export class ApiEditingToolPaperProgressInfo implements IApiEditingToolPaperProgressInfo {
    project?: ApiEditingToolPaperProgressStepInfo | null;
    templates?: ApiEditingToolPaperProgressStepInfo | null;
    details?: ApiEditingToolPaperProgressStepInfo | null;
    authors?: ApiEditingToolPaperProgressStepInfo | null;
    supplements?: ApiEditingToolPaperProgressStepInfo | null;
    keywords?: ApiEditingToolPaperProgressStepInfo | null;
    references?: ApiEditingToolPaperProgressStepInfo | null;
    copyright?: ApiEditingToolPaperProgressStepInfo | null;
    checklist?: ApiEditingToolPaperProgressStepInfo | null;
    reviewers?: ApiEditingToolPaperProgressStepInfo | null;

    constructor(data?: IApiEditingToolPaperProgressInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.project = _data["project"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["project"]) : null as any;
            this.templates = _data["templates"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["templates"]) : null as any;
            this.details = _data["details"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["details"]) : null as any;
            this.authors = _data["authors"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["authors"]) : null as any;
            this.supplements = _data["supplements"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["supplements"]) : null as any;
            this.keywords = _data["keywords"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["keywords"]) : null as any;
            this.references = _data["references"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["references"]) : null as any;
            this.copyright = _data["copyright"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["copyright"]) : null as any;
            this.checklist = _data["checklist"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["checklist"]) : null as any;
            this.reviewers = _data["reviewers"] ? ApiEditingToolPaperProgressStepInfo.fromJS(_data["reviewers"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperProgressInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperProgressInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : null as any;
        data["templates"] = this.templates ? this.templates.toJSON() : null as any;
        data["details"] = this.details ? this.details.toJSON() : null as any;
        data["authors"] = this.authors ? this.authors.toJSON() : null as any;
        data["supplements"] = this.supplements ? this.supplements.toJSON() : null as any;
        data["keywords"] = this.keywords ? this.keywords.toJSON() : null as any;
        data["references"] = this.references ? this.references.toJSON() : null as any;
        data["copyright"] = this.copyright ? this.copyright.toJSON() : null as any;
        data["checklist"] = this.checklist ? this.checklist.toJSON() : null as any;
        data["reviewers"] = this.reviewers ? this.reviewers.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperProgressInfo {
    project?: ApiEditingToolPaperProgressStepInfo | null;
    templates?: ApiEditingToolPaperProgressStepInfo | null;
    details?: ApiEditingToolPaperProgressStepInfo | null;
    authors?: ApiEditingToolPaperProgressStepInfo | null;
    supplements?: ApiEditingToolPaperProgressStepInfo | null;
    keywords?: ApiEditingToolPaperProgressStepInfo | null;
    references?: ApiEditingToolPaperProgressStepInfo | null;
    copyright?: ApiEditingToolPaperProgressStepInfo | null;
    checklist?: ApiEditingToolPaperProgressStepInfo | null;
    reviewers?: ApiEditingToolPaperProgressStepInfo | null;
}

export class ApiEditingToolPaperProgressStepInfo implements IApiEditingToolPaperProgressStepInfo {
    step?: PaperProgressStepEnum;
    visited?: boolean;
    enabled?: boolean;
    readonly?: boolean;
    completed?: boolean;

    constructor(data?: IApiEditingToolPaperProgressStepInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.step = _data["step"] !== undefined ? _data["step"] : null as any;
            this.visited = _data["visited"] !== undefined ? _data["visited"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.readonly = _data["readonly"] !== undefined ? _data["readonly"] : null as any;
            this.completed = _data["completed"] !== undefined ? _data["completed"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperProgressStepInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperProgressStepInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["step"] = this.step !== undefined ? this.step : null as any;
        data["visited"] = this.visited !== undefined ? this.visited : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["readonly"] = this.readonly !== undefined ? this.readonly : null as any;
        data["completed"] = this.completed !== undefined ? this.completed : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperProgressStepInfo {
    step?: PaperProgressStepEnum;
    visited?: boolean;
    enabled?: boolean;
    readonly?: boolean;
    completed?: boolean;
}

export enum PaperProgressStepEnum {
    Project = 0,
    Templates = 1,
    Details = 2,
    Authors = 3,
    Supplements = 4,
    Keywords = 5,
    References = 6,
    Copyright = 7,
    Checklist = 8,
    Reviewers = 9,
}

export class ApiEditingToolPaperDetails implements IApiEditingToolPaperDetails {
    id?: number;
    name?: string | null;
    abstract?: string | null;
    countOfDocuments?: number;
    doc?: ApiPaperDocumentFileInfo | null;
    pdf?: ApiPaperDocumentFileInfo | null;

    constructor(data?: IApiEditingToolPaperDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
            this.countOfDocuments = _data["countOfDocuments"] !== undefined ? _data["countOfDocuments"] : null as any;
            this.doc = _data["doc"] ? ApiPaperDocumentFileInfo.fromJS(_data["doc"]) : null as any;
            this.pdf = _data["pdf"] ? ApiPaperDocumentFileInfo.fromJS(_data["pdf"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        data["countOfDocuments"] = this.countOfDocuments !== undefined ? this.countOfDocuments : null as any;
        data["doc"] = this.doc ? this.doc.toJSON() : null as any;
        data["pdf"] = this.pdf ? this.pdf.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperDetails {
    id?: number;
    name?: string | null;
    abstract?: string | null;
    countOfDocuments?: number;
    doc?: ApiPaperDocumentFileInfo | null;
    pdf?: ApiPaperDocumentFileInfo | null;
}

export class ApiEditorPaperDetails extends ApiEditingToolPaperDetails implements IApiEditorPaperDetails {
    position?: number;
    chapter?: ApiIdNameItem | null;
    status?: PaperStatusEnum;
    editorName?: string | null;
    authorName?: string | null;

    constructor(data?: IApiEditorPaperDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.chapter = _data["chapter"] ? ApiIdNameItem.fromJS(_data["chapter"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.editorName = _data["editorName"] !== undefined ? _data["editorName"] : null as any;
            this.authorName = _data["authorName"] !== undefined ? _data["authorName"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorPaperDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorPaperDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["editorName"] = this.editorName !== undefined ? this.editorName : null as any;
        data["authorName"] = this.authorName !== undefined ? this.authorName : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiEditorPaperDetails extends IApiEditingToolPaperDetails {
    position?: number;
    chapter?: ApiIdNameItem | null;
    status?: PaperStatusEnum;
    editorName?: string | null;
    authorName?: string | null;
}

export class ApiPaperDocumentFileInfo implements IApiPaperDocumentFileInfo {
    id?: number;
    type?: PaperDocumentTypeEnum;
    file?: ApiFileInfo | null;
    isCurrent?: boolean;

    constructor(data?: IApiPaperDocumentFileInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.file = _data["file"] ? ApiFileInfo.fromJS(_data["file"]) : null as any;
            this.isCurrent = _data["isCurrent"] !== undefined ? _data["isCurrent"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperDocumentFileInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperDocumentFileInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["file"] = this.file ? this.file.toJSON() : null as any;
        data["isCurrent"] = this.isCurrent !== undefined ? this.isCurrent : null as any;
        return data;
    }
}

export interface IApiPaperDocumentFileInfo {
    id?: number;
    type?: PaperDocumentTypeEnum;
    file?: ApiFileInfo | null;
    isCurrent?: boolean;
}

export class ApiEditingToolPaperDetailsUpdate implements IApiEditingToolPaperDetailsUpdate {
    name: string;
    abstract?: string | null;

    constructor(data?: IApiEditingToolPaperDetailsUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.abstract = _data["abstract"] !== undefined ? _data["abstract"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolPaperDetailsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolPaperDetailsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["abstract"] = this.abstract !== undefined ? this.abstract : null as any;
        return data;
    }
}

export interface IApiEditingToolPaperDetailsUpdate {
    name: string;
    abstract?: string | null;
}

export class ApiEditorPaperDetailsUpdate extends ApiEditingToolPaperDetailsUpdate implements IApiEditorPaperDetailsUpdate {
    chapterId?: number | null;

    constructor(data?: IApiEditorPaperDetailsUpdate) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chapterId = _data["chapterId"] !== undefined ? _data["chapterId"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorPaperDetailsUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorPaperDetailsUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chapterId"] = this.chapterId !== undefined ? this.chapterId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiEditorPaperDetailsUpdate extends IApiEditingToolPaperDetailsUpdate {
    chapterId?: number | null;
}

export class ApiPaperHistoryEntry implements IApiPaperHistoryEntry {
    event?: PaperHistoryEventEnum;
    performer?: string | null;
    assignee?: string | null;
    oldStatus?: PaperStatusEnum | null;
    newStatus?: PaperStatusEnum | null;
    createdDateTime?: Date;

    constructor(data?: IApiPaperHistoryEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] !== undefined ? _data["event"] : null as any;
            this.performer = _data["performer"] !== undefined ? _data["performer"] : null as any;
            this.assignee = _data["assignee"] !== undefined ? _data["assignee"] : null as any;
            this.oldStatus = _data["oldStatus"] !== undefined ? _data["oldStatus"] : null as any;
            this.newStatus = _data["newStatus"] !== undefined ? _data["newStatus"] : null as any;
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ApiPaperHistoryEntry {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperHistoryEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event !== undefined ? this.event : null as any;
        data["performer"] = this.performer !== undefined ? this.performer : null as any;
        data["assignee"] = this.assignee !== undefined ? this.assignee : null as any;
        data["oldStatus"] = this.oldStatus !== undefined ? this.oldStatus : null as any;
        data["newStatus"] = this.newStatus !== undefined ? this.newStatus : null as any;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : null as any;
        return data;
    }
}

export interface IApiPaperHistoryEntry {
    event?: PaperHistoryEventEnum;
    performer?: string | null;
    assignee?: string | null;
    oldStatus?: PaperStatusEnum | null;
    newStatus?: PaperStatusEnum | null;
    createdDateTime?: Date;
}

export enum PaperHistoryEventEnum {
    NewPaper = 0,
    DocUploaded = 1,
    PdfUploaded = 2,
    AuthorAdded = 3,
    AuthorRemoved = 4,
    ReferencesReloaded = 5,
    KeywordsAdded = 6,
    KeywordsRemoved = 7,
    CopyrightSubmitted = 8,
    PaperSubmitted = 9,
    ManualStatusChange = 10,
    NoteAdded = 11,
    ReviewerAssigned = 12,
    ReviewerUnassigned = 13,
    ReviewSubmitted = 14,
    ReviewApproved = 15,
    ReviewSentForReReview = 16,
    ReviewerAgreed = 17,
    ReviewerRefused = 18,
    PaperMoved = 19,
    PaperImported = 20,
}

export class ApiPageResultOfApiEditorChapterListItem implements IApiPageResultOfApiEditorChapterListItem {
    items?: ApiEditorChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorChapterListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorChapterListItem {
    items?: ApiEditorChapterListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorChapterListItem implements IApiEditorChapterListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => Number)
    paperCount?: number;

    constructor(data?: IApiEditorChapterListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.paperCount = _data["paperCount"] !== undefined ? _data["paperCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorChapterListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorChapterListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["paperCount"] = this.paperCount !== undefined ? this.paperCount : null as any;
        return data;
    }
}

export interface IApiEditorChapterListItem {
    id?: number;
    pos?: number;
    name?: string | null;
    paperCount?: number;
}

export class ApiEditorChapter implements IApiEditorChapter {
    id?: number;
    pos?: number;
    name?: string | null;

    constructor(data?: IApiEditorChapter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorChapter {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorChapter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IApiEditorChapter {
    id?: number;
    pos?: number;
    name?: string | null;
}

export class ApiPageResultOfApiCorrespondingAuthorListItem implements IApiPageResultOfApiCorrespondingAuthorListItem {
    items?: ApiCorrespondingAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiCorrespondingAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiCorrespondingAuthorListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiCorrespondingAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiCorrespondingAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiCorrespondingAuthorListItem {
    items?: ApiCorrespondingAuthorListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiCorrespondingAuthorListItem implements IApiCorrespondingAuthorListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => Boolean)
    invitationStatus?: boolean;
    @columnMap(() => Number)
    limitUploads?: number;
    @columnMap(() => Number)
    uploadedCount?: number;
    @columnMap(() => String)
    authorCode?: string | null;

    constructor(data?: IApiCorrespondingAuthorListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.invitationStatus = _data["invitationStatus"] !== undefined ? _data["invitationStatus"] : null as any;
            this.limitUploads = _data["limitUploads"] !== undefined ? _data["limitUploads"] : null as any;
            this.uploadedCount = _data["uploadedCount"] !== undefined ? _data["uploadedCount"] : null as any;
            this.authorCode = _data["authorCode"] !== undefined ? _data["authorCode"] : null as any;
        }
    }

    static fromJS(data: any): ApiCorrespondingAuthorListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiCorrespondingAuthorListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["invitationStatus"] = this.invitationStatus !== undefined ? this.invitationStatus : null as any;
        data["limitUploads"] = this.limitUploads !== undefined ? this.limitUploads : null as any;
        data["uploadedCount"] = this.uploadedCount !== undefined ? this.uploadedCount : null as any;
        data["authorCode"] = this.authorCode !== undefined ? this.authorCode : null as any;
        return data;
    }
}

export interface IApiCorrespondingAuthorListItem {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    invitationStatus?: boolean;
    limitUploads?: number;
    uploadedCount?: number;
    authorCode?: string | null;
}

export class ApiAddParticipantRequest implements IApiAddParticipantRequest {
    @keyMap()
    memberId?: number;
    title?: string | null;
    @columnMap(() => String)
    email: string;
    @columnMap(() => String)
    firstName: string;
    @columnMap(() => String)
    lastName: string;
    @columnMap(() => String)
    orcidId?: string | null;
    countryId?: string | null;
    universityOrOrganization?: string | null;
    authorEmails?: string[] | null;

    constructor(data?: IApiAddParticipantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.orcidId = _data["orcidId"] !== undefined ? _data["orcidId"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.universityOrOrganization = _data["universityOrOrganization"] !== undefined ? _data["universityOrOrganization"] : null as any;
            if (Array.isArray(_data["authorEmails"])) {
                this.authorEmails = [] as any;
                for (let item of _data["authorEmails"])
                    this.authorEmails!.push(item);
            }
            else {
                this.authorEmails = null as any;
            }
        }
    }

    static fromJS(data: any): ApiAddParticipantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAddParticipantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["orcidId"] = this.orcidId !== undefined ? this.orcidId : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["universityOrOrganization"] = this.universityOrOrganization !== undefined ? this.universityOrOrganization : null as any;
        if (Array.isArray(this.authorEmails)) {
            data["authorEmails"] = [];
            for (let item of this.authorEmails)
                data["authorEmails"].push(item);
        }
        return data;
    }
}

export interface IApiAddParticipantRequest {
    memberId?: number;
    title?: string | null;
    email: string;
    firstName: string;
    lastName: string;
    orcidId?: string | null;
    countryId?: string | null;
    universityOrOrganization?: string | null;
    authorEmails?: string[] | null;
}

export class ApiAddCorrespondingAuthorRequest extends ApiAddParticipantRequest implements IApiAddCorrespondingAuthorRequest {
    @columnMap(() => String)
    code?: string | null;

    constructor(data?: IApiAddCorrespondingAuthorRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static fromJS(data: any): ApiAddCorrespondingAuthorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAddCorrespondingAuthorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAddCorrespondingAuthorRequest extends IApiAddParticipantRequest {
    code?: string | null;
}

export class ApiAuthorCode implements IApiAuthorCode {
    code: string;

    constructor(data?: IApiAuthorCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorCode {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        return data;
    }
}

export interface IApiAuthorCode {
    code: string;
}

export class ApiPageResultOfApiEditorProjectPaperListItem implements IApiPageResultOfApiEditorProjectPaperListItem {
    items?: ApiEditorProjectPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorProjectPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorProjectPaperListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorProjectPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorProjectPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorProjectPaperListItem {
    items?: ApiEditorProjectPaperListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorProjectPaperListItem implements IApiEditorProjectPaperListItem {
    @keyMap()
    id?: number;
    @columnMap(() => String)
    paperTitle?: string | null;
    @columnMap(() => Date)
    lastModified?: Date | null;
    @columnMap(() => PaperStatusEnum)
    status?: PaperStatusEnum;
    @columnMap(() => ApiReviewCounter)
    reviewCounter?: ApiReviewCounter | null;
    @columnMap(() => String)
    authorFullName?: string | null;
    @columnMap(() => String)
    authorCode?: string | null;
    @columnMap(() => Number)
    comments?: number;
    @columnMap(() => ApiIdNameItem)
    editor?: ApiIdNameItem | null;
    @columnMap(() => ApiIdNameItem)
    chapter?: ApiIdNameItem | null;
    @columnMap(() => Number)
    similarityIndex?: number;
    @columnMap(() => Boolean)
    copyrightAgreement?: boolean;
    authorEmail?: string | null;

    constructor(data?: IApiEditorProjectPaperListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.paperTitle = _data["paperTitle"] !== undefined ? _data["paperTitle"] : null as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
            this.authorFullName = _data["authorFullName"] !== undefined ? _data["authorFullName"] : null as any;
            this.authorCode = _data["authorCode"] !== undefined ? _data["authorCode"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.editor = _data["editor"] ? ApiIdNameItem.fromJS(_data["editor"]) : null as any;
            this.chapter = _data["chapter"] ? ApiIdNameItem.fromJS(_data["chapter"]) : null as any;
            this.similarityIndex = _data["similarityIndex"] !== undefined ? _data["similarityIndex"] : null as any;
            this.copyrightAgreement = _data["copyrightAgreement"] !== undefined ? _data["copyrightAgreement"] : null as any;
            this.authorEmail = _data["authorEmail"] !== undefined ? _data["authorEmail"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProjectPaperListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProjectPaperListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["paperTitle"] = this.paperTitle !== undefined ? this.paperTitle : null as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        data["authorFullName"] = this.authorFullName !== undefined ? this.authorFullName : null as any;
        data["authorCode"] = this.authorCode !== undefined ? this.authorCode : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["editor"] = this.editor ? this.editor.toJSON() : null as any;
        data["chapter"] = this.chapter ? this.chapter.toJSON() : null as any;
        data["similarityIndex"] = this.similarityIndex !== undefined ? this.similarityIndex : null as any;
        data["copyrightAgreement"] = this.copyrightAgreement !== undefined ? this.copyrightAgreement : null as any;
        data["authorEmail"] = this.authorEmail !== undefined ? this.authorEmail : null as any;
        return data;
    }
}

export interface IApiEditorProjectPaperListItem {
    id?: number;
    paperTitle?: string | null;
    lastModified?: Date | null;
    status?: PaperStatusEnum;
    reviewCounter?: ApiReviewCounter | null;
    authorFullName?: string | null;
    authorCode?: string | null;
    comments?: number;
    editor?: ApiIdNameItem | null;
    chapter?: ApiIdNameItem | null;
    similarityIndex?: number;
    copyrightAgreement?: boolean;
    authorEmail?: string | null;
}

export class ApiEditorProjectPapersInfo implements IApiEditorProjectPapersInfo {
    hasAuthorsOrPapers?: boolean;
    hasChapters?: boolean;

    constructor(data?: IApiEditorProjectPapersInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAuthorsOrPapers = _data["hasAuthorsOrPapers"] !== undefined ? _data["hasAuthorsOrPapers"] : null as any;
            this.hasChapters = _data["hasChapters"] !== undefined ? _data["hasChapters"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProjectPapersInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProjectPapersInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAuthorsOrPapers"] = this.hasAuthorsOrPapers !== undefined ? this.hasAuthorsOrPapers : null as any;
        data["hasChapters"] = this.hasChapters !== undefined ? this.hasChapters : null as any;
        return data;
    }
}

export interface IApiEditorProjectPapersInfo {
    hasAuthorsOrPapers?: boolean;
    hasChapters?: boolean;
}

export class ApiPageResultOfApiEditorPaperPositionListItem implements IApiPageResultOfApiEditorPaperPositionListItem {
    items?: ApiEditorPaperPositionListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditorPaperPositionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditorPaperPositionListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditorPaperPositionListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditorPaperPositionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditorPaperPositionListItem {
    items?: ApiEditorPaperPositionListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditorPaperPositionListItem implements IApiEditorPaperPositionListItem {
    @keyMap()
    id?: number;
    @columnMap(() => Number)
    pos?: number;
    @columnMap(() => String)
    name?: string | null;
    @columnMap(() => PaperStatusEnum)
    status?: PaperStatusEnum;

    constructor(data?: IApiEditorPaperPositionListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pos = _data["pos"] !== undefined ? _data["pos"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorPaperPositionListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorPaperPositionListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pos"] = this.pos !== undefined ? this.pos : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }
}

export interface IApiEditorPaperPositionListItem {
    id?: number;
    pos?: number;
    name?: string | null;
    status?: PaperStatusEnum;
}

export class ApiPageResultOfApiEditingToolEditorReviewerListItem implements IApiPageResultOfApiEditingToolEditorReviewerListItem {
    items?: ApiEditingToolEditorReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditingToolEditorReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditingToolEditorReviewerListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditingToolEditorReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditingToolEditorReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditingToolEditorReviewerListItem {
    items?: ApiEditingToolEditorReviewerListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditingToolEditorReviewerListItem implements IApiEditingToolEditorReviewerListItem {
    @keyMap()
    memberId?: number;
    @columnMap(() => String)
    firstName?: string | null;
    @columnMap(() => String)
    lastName?: string | null;
    @columnMap(() => String)
    email?: string | null;
    @columnMap(() => Boolean)
    invitationStatus?: boolean;
    @columnMap(() => String)
    reviewersNote?: string | null;
    @columnMap(() => ApiReviewCounter)
    reviewCounter?: ApiReviewCounter | null;
    isRemovable?: boolean;
    fullName?: string | null;

    constructor(data?: IApiEditingToolEditorReviewerListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberId = _data["memberId"] !== undefined ? _data["memberId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.invitationStatus = _data["invitationStatus"] !== undefined ? _data["invitationStatus"] : null as any;
            this.reviewersNote = _data["reviewersNote"] !== undefined ? _data["reviewersNote"] : null as any;
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolEditorReviewerListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolEditorReviewerListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId !== undefined ? this.memberId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["invitationStatus"] = this.invitationStatus !== undefined ? this.invitationStatus : null as any;
        data["reviewersNote"] = this.reviewersNote !== undefined ? this.reviewersNote : null as any;
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        return data;
    }
}

export interface IApiEditingToolEditorReviewerListItem {
    memberId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    invitationStatus?: boolean;
    reviewersNote?: string | null;
    reviewCounter?: ApiReviewCounter | null;
    isRemovable?: boolean;
    fullName?: string | null;
}

export class ApiAddReviewerRequest extends ApiAddParticipantRequest implements IApiAddReviewerRequest {
    @columnMap(() => String)
    note?: string | null;

    constructor(data?: IApiAddReviewerRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.note = _data["note"] !== undefined ? _data["note"] : null as any;
        }
    }

    static fromJS(data: any): ApiAddReviewerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAddReviewerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note !== undefined ? this.note : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiAddReviewerRequest extends IApiAddParticipantRequest {
    note?: string | null;
}

export class ApiEditorProjectInfo implements IApiEditorProjectInfo {
    titleId?: number;
    name?: string | null;
    type?: TitleTypeEnum;
    isReadonly?: boolean;
    commentsCount?: number;

    constructor(data?: IApiEditorProjectInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.isReadonly = _data["isReadonly"] !== undefined ? _data["isReadonly"] : null as any;
            this.commentsCount = _data["commentsCount"] !== undefined ? _data["commentsCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProjectInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProjectInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["isReadonly"] = this.isReadonly !== undefined ? this.isReadonly : null as any;
        data["commentsCount"] = this.commentsCount !== undefined ? this.commentsCount : null as any;
        return data;
    }
}

export interface IApiEditorProjectInfo {
    titleId?: number;
    name?: string | null;
    type?: TitleTypeEnum;
    isReadonly?: boolean;
    commentsCount?: number;
}

export class ApiEditorProjectPeriod implements IApiEditorProjectPeriod {
    editorPeriod?: ApiDateRange | null;
    authorPeriod?: ApiDateRange | null;
    reviewerPeriod?: ApiDateRange | null;
    revisionPeriod?: ApiDateRange | null;

    constructor(data?: IApiEditorProjectPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editorPeriod = _data["editorPeriod"] ? ApiDateRange.fromJS(_data["editorPeriod"]) : null as any;
            this.authorPeriod = _data["authorPeriod"] ? ApiDateRange.fromJS(_data["authorPeriod"]) : null as any;
            this.reviewerPeriod = _data["reviewerPeriod"] ? ApiDateRange.fromJS(_data["reviewerPeriod"]) : null as any;
            this.revisionPeriod = _data["revisionPeriod"] ? ApiDateRange.fromJS(_data["revisionPeriod"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProjectPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProjectPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editorPeriod"] = this.editorPeriod ? this.editorPeriod.toJSON() : null as any;
        data["authorPeriod"] = this.authorPeriod ? this.authorPeriod.toJSON() : null as any;
        data["reviewerPeriod"] = this.reviewerPeriod ? this.reviewerPeriod.toJSON() : null as any;
        data["revisionPeriod"] = this.revisionPeriod ? this.revisionPeriod.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditorProjectPeriod {
    editorPeriod?: ApiDateRange | null;
    authorPeriod?: ApiDateRange | null;
    reviewerPeriod?: ApiDateRange | null;
    revisionPeriod?: ApiDateRange | null;
}

export class ApiEditorConferenceInfo implements IApiEditorConferenceInfo {
    name?: string | null;
    shortName?: string | null;
    edition?: string | null;
    countryId?: string | null;
    city?: string | null;
    organizer?: string | null;
    website?: string | null;
    description?: string | null;

    constructor(data?: IApiEditorConferenceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : null as any;
            this.edition = _data["edition"] !== undefined ? _data["edition"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.organizer = _data["organizer"] !== undefined ? _data["organizer"] : null as any;
            this.website = _data["website"] !== undefined ? _data["website"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorConferenceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorConferenceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortName"] = this.shortName !== undefined ? this.shortName : null as any;
        data["edition"] = this.edition !== undefined ? this.edition : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["organizer"] = this.organizer !== undefined ? this.organizer : null as any;
        data["website"] = this.website !== undefined ? this.website : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }
}

export interface IApiEditorConferenceInfo {
    name?: string | null;
    shortName?: string | null;
    edition?: string | null;
    countryId?: string | null;
    city?: string | null;
    organizer?: string | null;
    website?: string | null;
    description?: string | null;
}

export class ApiPageResultOfApiEditingToolAssignedReviewListItem implements IApiPageResultOfApiEditingToolAssignedReviewListItem {
    items?: ApiEditingToolAssignedReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditingToolAssignedReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditingToolAssignedReviewListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditingToolAssignedReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditingToolAssignedReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditingToolAssignedReviewListItem {
    items?: ApiEditingToolAssignedReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditingToolReviewListItem implements IApiEditingToolReviewListItem {
    @keyMap()
    paperId?: number;
    @columnMap(() => String)
    paperTitle?: string | null;
    @columnMap(() => String)
    authorFullName?: string | null;
    authorEmail?: string | null;
    @columnMap(() => ApiReviewCounter)
    reviewCounter?: ApiReviewCounter | null;

    constructor(data?: IApiEditingToolReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.paperTitle = _data["paperTitle"] !== undefined ? _data["paperTitle"] : null as any;
            this.authorFullName = _data["authorFullName"] !== undefined ? _data["authorFullName"] : null as any;
            this.authorEmail = _data["authorEmail"] !== undefined ? _data["authorEmail"] : null as any;
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["paperTitle"] = this.paperTitle !== undefined ? this.paperTitle : null as any;
        data["authorFullName"] = this.authorFullName !== undefined ? this.authorFullName : null as any;
        data["authorEmail"] = this.authorEmail !== undefined ? this.authorEmail : null as any;
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditingToolReviewListItem {
    paperId?: number;
    paperTitle?: string | null;
    authorFullName?: string | null;
    authorEmail?: string | null;
    reviewCounter?: ApiReviewCounter | null;
}

export class ApiEditingToolAssignedReviewListItem extends ApiEditingToolReviewListItem implements IApiEditingToolAssignedReviewListItem {
    @columnMap(() => PaperStatusEnum)
    paperStatus?: PaperStatusEnum;
    isRemovable?: boolean;
    reviewId?: number;

    constructor(data?: IApiEditingToolAssignedReviewListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.isRemovable = _data["isRemovable"] !== undefined ? _data["isRemovable"] : null as any;
            this.reviewId = _data["reviewId"] !== undefined ? _data["reviewId"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolAssignedReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolAssignedReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["isRemovable"] = this.isRemovable !== undefined ? this.isRemovable : null as any;
        data["reviewId"] = this.reviewId !== undefined ? this.reviewId : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiEditingToolAssignedReviewListItem extends IApiEditingToolReviewListItem {
    paperStatus?: PaperStatusEnum;
    isRemovable?: boolean;
    reviewId?: number;
}

export class ApiPageResultOfApiEditingToolUnassignedReviewListItem implements IApiPageResultOfApiEditingToolUnassignedReviewListItem {
    items?: ApiEditingToolUnassignedReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;

    constructor(data?: IApiPageResultOfApiEditingToolUnassignedReviewListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApiEditingToolUnassignedReviewListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            if (Array.isArray(_data["selectItems"])) {
                this.selectItems = [] as any;
                for (let item of _data["selectItems"])
                    this.selectItems!.push(item);
            }
            else {
                this.selectItems = null as any;
            }
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.filteredCount = _data["filteredCount"] !== undefined ? _data["filteredCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiPageResultOfApiEditingToolUnassignedReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPageResultOfApiEditingToolUnassignedReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.selectItems)) {
            data["selectItems"] = [];
            for (let item of this.selectItems)
                data["selectItems"].push(item);
        }
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["filteredCount"] = this.filteredCount !== undefined ? this.filteredCount : null as any;
        return data;
    }
}

export interface IApiPageResultOfApiEditingToolUnassignedReviewListItem {
    items?: ApiEditingToolUnassignedReviewListItem[] | null;
    selectItems?: any[] | null;
    count?: number | null;
    filteredCount?: number | null;
}

export class ApiEditingToolUnassignedReviewListItem extends ApiEditingToolReviewListItem implements IApiEditingToolUnassignedReviewListItem {
    @columnMap(() => String)
    chapter?: string | null;

    constructor(data?: IApiEditingToolUnassignedReviewListItem) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chapter = _data["chapter"] !== undefined ? _data["chapter"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditingToolUnassignedReviewListItem {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditingToolUnassignedReviewListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chapter"] = this.chapter !== undefined ? this.chapter : null as any;
        super.toJSON(data);
        return data;
    }
}

export interface IApiEditingToolUnassignedReviewListItem extends IApiEditingToolReviewListItem {
    chapter?: string | null;
}

export class ApiEditorProjectsSummary implements IApiEditorProjectsSummary {
    inProgressProjectsCount?: number;
    publishedProjectsCount?: number;
    haveLoggedAsEditor?: boolean;

    constructor(data?: IApiEditorProjectsSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressProjectsCount = _data["inProgressProjectsCount"] !== undefined ? _data["inProgressProjectsCount"] : null as any;
            this.publishedProjectsCount = _data["publishedProjectsCount"] !== undefined ? _data["publishedProjectsCount"] : null as any;
            this.haveLoggedAsEditor = _data["haveLoggedAsEditor"] !== undefined ? _data["haveLoggedAsEditor"] : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProjectsSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProjectsSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressProjectsCount"] = this.inProgressProjectsCount !== undefined ? this.inProgressProjectsCount : null as any;
        data["publishedProjectsCount"] = this.publishedProjectsCount !== undefined ? this.publishedProjectsCount : null as any;
        data["haveLoggedAsEditor"] = this.haveLoggedAsEditor !== undefined ? this.haveLoggedAsEditor : null as any;
        return data;
    }
}

export interface IApiEditorProjectsSummary {
    inProgressProjectsCount?: number;
    publishedProjectsCount?: number;
    haveLoggedAsEditor?: boolean;
}

export class ApiEditorProject implements IApiEditorProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    hasCover?: boolean;
    isReadOnly?: boolean;
    editPeriod?: ApiEditPeriod | null;

    constructor(data?: IApiEditorProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : null as any;
            this.isReadOnly = _data["isReadOnly"] !== undefined ? _data["isReadOnly"] : null as any;
            this.editPeriod = _data["editPeriod"] ? ApiEditPeriod.fromJS(_data["editPeriod"]) : null as any;
        }
    }

    static fromJS(data: any): ApiEditorProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiEditorProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : null as any;
        data["isReadOnly"] = this.isReadOnly !== undefined ? this.isReadOnly : null as any;
        data["editPeriod"] = this.editPeriod ? this.editPeriod.toJSON() : null as any;
        return data;
    }
}

export interface IApiEditorProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    hasCover?: boolean;
    isReadOnly?: boolean;
    editPeriod?: ApiEditPeriod | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ApiPaperCopyrightSubmit implements IApiPaperCopyrightSubmit {
    workOwner?: WorkOwnerEnum;
    organization?: string | null;

    constructor(data?: IApiPaperCopyrightSubmit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOwner = _data["workOwner"] !== undefined ? _data["workOwner"] : null as any;
            this.organization = _data["organization"] !== undefined ? _data["organization"] : null as any;
        }
    }

    static fromJS(data: any): ApiPaperCopyrightSubmit {
        data = typeof data === 'object' ? data : {};
        let result = new ApiPaperCopyrightSubmit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOwner"] = this.workOwner !== undefined ? this.workOwner : null as any;
        data["organization"] = this.organization !== undefined ? this.organization : null as any;
        return data;
    }
}

export interface IApiPaperCopyrightSubmit {
    workOwner?: WorkOwnerEnum;
    organization?: string | null;
}

export enum WorkOwnerEnum {
    Author = 0,
    Government = 1,
    HiredEmployee = 2,
}

export class ApiAuthorReview extends ApiBaseReview implements IApiAuthorReview {
    siblings?: number[][] | null;

    constructor(data?: IApiAuthorReview) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["siblings"])) {
                this.siblings = [] as any;
                for (let item of _data["siblings"])
                    this.siblings!.push(item);
            }
            else {
                this.siblings = null as any;
            }
        }
    }

    static fromJS(data: any): ApiAuthorReview {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siblings)) {
            data["siblings"] = [];
            for (let item of this.siblings)
                data["siblings"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IApiAuthorReview extends IApiBaseReview {
    siblings?: number[][] | null;
}

export class ApiAuthorProject implements IApiAuthorProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    authorPeriodExpired?: boolean;
    uploadLimitAchieved?: boolean;
    uploadLimit?: number;
    hasCover?: boolean;

    constructor(data?: IApiAuthorProject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleId = _data["titleId"] !== undefined ? _data["titleId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortDescription = _data["shortDescription"] !== undefined ? _data["shortDescription"] : null as any;
            this.authorPeriodExpired = _data["authorPeriodExpired"] !== undefined ? _data["authorPeriodExpired"] : null as any;
            this.uploadLimitAchieved = _data["uploadLimitAchieved"] !== undefined ? _data["uploadLimitAchieved"] : null as any;
            this.uploadLimit = _data["uploadLimit"] !== undefined ? _data["uploadLimit"] : null as any;
            this.hasCover = _data["hasCover"] !== undefined ? _data["hasCover"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorProject {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorProject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleId"] = this.titleId !== undefined ? this.titleId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortDescription"] = this.shortDescription !== undefined ? this.shortDescription : null as any;
        data["authorPeriodExpired"] = this.authorPeriodExpired !== undefined ? this.authorPeriodExpired : null as any;
        data["uploadLimitAchieved"] = this.uploadLimitAchieved !== undefined ? this.uploadLimitAchieved : null as any;
        data["uploadLimit"] = this.uploadLimit !== undefined ? this.uploadLimit : null as any;
        data["hasCover"] = this.hasCover !== undefined ? this.hasCover : null as any;
        return data;
    }
}

export interface IApiAuthorProject {
    titleId?: number;
    name?: string | null;
    shortDescription?: string | null;
    authorPeriodExpired?: boolean;
    uploadLimitAchieved?: boolean;
    uploadLimit?: number;
    hasCover?: boolean;
}

export class ApiAuthorPaper implements IApiAuthorPaper {
    paperId?: number;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    completedStepsCount?: number;
    totalStepsCount?: number;
    commentsCount?: number;
    reviewCounter?: ApiReviewCounter | null;
    reviewId?: number | null;
    lastModified?: Date;
    isReadonly?: boolean;
    titleName?: string | null;
    editPeriod?: ApiEditPeriod | null;
    preliminaryAccepted?: boolean;
    paperInPress?: boolean;

    constructor(data?: IApiAuthorPaper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paperId = _data["paperId"] !== undefined ? _data["paperId"] : null as any;
            this.paperName = _data["paperName"] !== undefined ? _data["paperName"] : null as any;
            this.paperStatus = _data["paperStatus"] !== undefined ? _data["paperStatus"] : null as any;
            this.completedStepsCount = _data["completedStepsCount"] !== undefined ? _data["completedStepsCount"] : null as any;
            this.totalStepsCount = _data["totalStepsCount"] !== undefined ? _data["totalStepsCount"] : null as any;
            this.commentsCount = _data["commentsCount"] !== undefined ? _data["commentsCount"] : null as any;
            this.reviewCounter = _data["reviewCounter"] ? ApiReviewCounter.fromJS(_data["reviewCounter"]) : null as any;
            this.reviewId = _data["reviewId"] !== undefined ? _data["reviewId"] : null as any;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : null as any;
            this.isReadonly = _data["isReadonly"] !== undefined ? _data["isReadonly"] : null as any;
            this.titleName = _data["titleName"] !== undefined ? _data["titleName"] : null as any;
            this.editPeriod = _data["editPeriod"] ? ApiEditPeriod.fromJS(_data["editPeriod"]) : null as any;
            this.preliminaryAccepted = _data["preliminaryAccepted"] !== undefined ? _data["preliminaryAccepted"] : null as any;
            this.paperInPress = _data["paperInPress"] !== undefined ? _data["paperInPress"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorPaper {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorPaper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paperId"] = this.paperId !== undefined ? this.paperId : null as any;
        data["paperName"] = this.paperName !== undefined ? this.paperName : null as any;
        data["paperStatus"] = this.paperStatus !== undefined ? this.paperStatus : null as any;
        data["completedStepsCount"] = this.completedStepsCount !== undefined ? this.completedStepsCount : null as any;
        data["totalStepsCount"] = this.totalStepsCount !== undefined ? this.totalStepsCount : null as any;
        data["commentsCount"] = this.commentsCount !== undefined ? this.commentsCount : null as any;
        data["reviewCounter"] = this.reviewCounter ? this.reviewCounter.toJSON() : null as any;
        data["reviewId"] = this.reviewId !== undefined ? this.reviewId : null as any;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : null as any;
        data["isReadonly"] = this.isReadonly !== undefined ? this.isReadonly : null as any;
        data["titleName"] = this.titleName !== undefined ? this.titleName : null as any;
        data["editPeriod"] = this.editPeriod ? this.editPeriod.toJSON() : null as any;
        data["preliminaryAccepted"] = this.preliminaryAccepted !== undefined ? this.preliminaryAccepted : null as any;
        data["paperInPress"] = this.paperInPress !== undefined ? this.paperInPress : null as any;
        return data;
    }
}

export interface IApiAuthorPaper {
    paperId?: number;
    paperName?: string | null;
    paperStatus?: PaperStatusEnum;
    completedStepsCount?: number;
    totalStepsCount?: number;
    commentsCount?: number;
    reviewCounter?: ApiReviewCounter | null;
    reviewId?: number | null;
    lastModified?: Date;
    isReadonly?: boolean;
    titleName?: string | null;
    editPeriod?: ApiEditPeriod | null;
    preliminaryAccepted?: boolean;
    paperInPress?: boolean;
}

export class ApiAuthorPapersCount implements IApiAuthorPapersCount {
    inProgressPapersCount?: number;
    publishedPapersCount?: number;

    constructor(data?: IApiAuthorPapersCount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inProgressPapersCount = _data["inProgressPapersCount"] !== undefined ? _data["inProgressPapersCount"] : null as any;
            this.publishedPapersCount = _data["publishedPapersCount"] !== undefined ? _data["publishedPapersCount"] : null as any;
        }
    }

    static fromJS(data: any): ApiAuthorPapersCount {
        data = typeof data === 'object' ? data : {};
        let result = new ApiAuthorPapersCount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inProgressPapersCount"] = this.inProgressPapersCount !== undefined ? this.inProgressPapersCount : null as any;
        data["publishedPapersCount"] = this.publishedPapersCount !== undefined ? this.publishedPapersCount : null as any;
        return data;
    }
}

export interface IApiAuthorPapersCount {
    inProgressPapersCount?: number;
    publishedPapersCount?: number;
}

export class ApiWorkStatusChangedMessage implements IApiWorkStatusChangedMessage {
    titleCheckId?: number;
    checkType?: CheckTypeEnum;
    status?: WorkStateEnum;
    checkerId?: number | null;
    unassignedCheckerId?: number | null;

    constructor(data?: IApiWorkStatusChangedMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.titleCheckId = _data["titleCheckId"] !== undefined ? _data["titleCheckId"] : null as any;
            this.checkType = _data["checkType"] !== undefined ? _data["checkType"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.checkerId = _data["checkerId"] !== undefined ? _data["checkerId"] : null as any;
            this.unassignedCheckerId = _data["unassignedCheckerId"] !== undefined ? _data["unassignedCheckerId"] : null as any;
        }
    }

    static fromJS(data: any): ApiWorkStatusChangedMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ApiWorkStatusChangedMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["titleCheckId"] = this.titleCheckId !== undefined ? this.titleCheckId : null as any;
        data["checkType"] = this.checkType !== undefined ? this.checkType : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["checkerId"] = this.checkerId !== undefined ? this.checkerId : null as any;
        data["unassignedCheckerId"] = this.unassignedCheckerId !== undefined ? this.unassignedCheckerId : null as any;
        return data;
    }
}

export interface IApiWorkStatusChangedMessage {
    titleCheckId?: number;
    checkType?: CheckTypeEnum;
    status?: WorkStateEnum;
    checkerId?: number | null;
    unassignedCheckerId?: number | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(() => result);
    else
        return _observableThrow(() => new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<any> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            if (typeof window === 'undefined') {
                observer.next(blob);
                observer.complete();
            } else {
                let reader = new FileReader();
                reader.onload = event => {
                    observer.next((event.target as any).result);
                    observer.complete();
                };
                reader.readAsText(blob);
            }
        }
    });
}

/* tslint:disable */
/* eslint-disable */